(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as JS, getPartnerDevApiHeaders as XS, WidgetContextProvider as ZS, makeExecuteQuery as e0, makeUseLazyQuery as n0, makeUseQuery as t0, makeUseMutation as r0, validateApiHostName as Lb, useTracking as _n, useWidgetContext as pn, hasDownstreamApiForbiddenError as Pm, hasDownstreamApiAuthorizationError as Lm, DisplayErrors as Fn, useCopyWithDelay as or, defaultDateFormat as bt, displayAttributeValue as to, OAuthSettings as Gr, useWidgetSettingsMutations as lo, useWidgetSettingsQuery as co, PartnerSettingsWrapper as uo, handleWidgetSubmit as mo, MisconfigurationBanner as po, WidgetSettingsFormFooter as fo, useData as Vm, PartnerHookFormSecretText as zm, isDownstreamApiNotFoundError as i0, isDownstreamApiAuthorizationError as Vb, KlaviyoSubscribeSetting as a0, isDownstreamApiPermissionError as o0, capitalizeFirstCharacter as zb, humanizeKey as s0, hasDownstreamApiTooManyRequestsError as l0, hasDownstreamApiPermissionError as Ub, hasDownstreamApiNotFoundError as ho, getCountryNameFromCountryCode as c0, IntegrationModal as Mb, useInboundOAuthContext as d0, getWidgetConfigurationByIdQuery as u0, createWidgetConfigurationMutation as m0, updateWidgetConfigurationMutation as p0, deleteWidgetConfigurationMutation as f0 } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import we, { useMemo as Bn, useState as se, useEffect as He, useRef as gi, useCallback as it, useReducer as h0, useLayoutEffect as y0, useContext as Um, createContext as Bb, isValidElement as g0, createElement as v0, Fragment as k0 } from "react";
import { Text as P, FlexBox as b, Spinner as dn, Icon as fe, Tooltip as Ye, List as Ge, Badge as An, Button as Kn, IconButton as nr, Switch as tm, FieldLabel as b0, FieldWrapper as bn, InputText as Nr, InputSelectionList as ei, FormGrid as yt, FormField as Te, Tag as Pn, NavigationButton as It, Select as wr, CollapseCard as mr, Box as Zn, Modal as Et, ModalHead as Tt, ModalBody as $t, ModalFoot as At, Textarea as rm, TagsInput as Bs, Image as Xi, Banner as qs, Divider as Mm, SelectionList as ct, FieldText as pr, FieldTextarea as x0, CopyToClipboardButton as _0, getSelectionListContext as S0, Avatar as Bm, Timestamp as N0, Attachment as j0, EmptyState as xs, Table as Jn, Checkbox as sf, TextWithHighlight as w0, ErrorBoundaryContext as qb, FieldSwitch as Hb } from "@dixa/lib-shared-habla";
import { ApolloLink as qm, Observable as Wb, ApolloClient as C0, InMemoryCache as F0, createHttpLink as I0, ApolloProvider as E0, useApolloClient as T0, ApolloConsumer as $0, NetworkStatus as er, isApolloError as Kb, ApolloError as Gb, gql as Hs, useQuery as D0, useMutation as lf } from "@apollo/client";
import R0 from "cross-fetch";
import { config as ro } from "lib-shared-backend-config";
import at from "classnames";
import Ln from "moment";
import "moment-timezone";
import { __rest as O0, __assign as pl } from "tslib";
import { useLocation as A0 } from "react-router-dom";
function Hm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Io = { exports: {} }, oa = {};
var cf;
function P0() {
  if (cf) return oa;
  cf = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return oa.Fragment = r, oa.jsx = s, oa.jsxs = s, oa;
}
var sa = {};
var df;
function L0() {
  return df || (df = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c, A));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    sa.Fragment = i, sa.jsx = Rn, sa.jsxs = Mn;
  })()), sa;
}
var uf;
function V0() {
  return uf || (uf = 1, process.env.NODE_ENV === "production" ? Io.exports = P0() : Io.exports = L0()), Io.exports;
}
var Ue = V0();
function Yb(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: z0 } = Object.prototype, { getPrototypeOf: Ws } = Object, { iterator: Ks, toStringTag: Qb } = Symbol, Gs = /* @__PURE__ */ ((e) => (n) => {
  const r = z0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Cr = (e) => (e = e.toLowerCase(), (n) => Gs(n) === e), Ys = (e) => (n) => typeof n === e, { isArray: Zi } = Array, Ki = Ys("undefined");
function yo(e) {
  return e !== null && !Ki(e) && e.constructor !== null && !Ki(e.constructor) && Jt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Jb = Cr("ArrayBuffer");
function U0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Jb(e.buffer), n;
}
const M0 = Ys("string"), Jt = Ys("function"), Xb = Ys("number"), go = (e) => e !== null && typeof e == "object", B0 = (e) => e === !0 || e === !1, os = (e) => {
  if (Gs(e) !== "object")
    return !1;
  const n = Ws(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Qb in e) && !(Ks in e);
}, q0 = (e) => {
  if (!go(e) || yo(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, H0 = Cr("Date"), W0 = Cr("File"), K0 = (e) => !!(e && typeof e.uri < "u"), G0 = (e) => e && typeof e.getParts < "u", Y0 = Cr("Blob"), Q0 = Cr("FileList"), J0 = (e) => go(e) && Jt(e.pipe);
function X0() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const mf = X0(), pf = typeof mf.FormData < "u" ? mf.FormData : void 0, Z0 = (e) => {
  if (!e) return !1;
  if (pf && e instanceof pf) return !0;
  const n = Ws(e);
  if (!n || n === Object.prototype || !Jt(e.append)) return !1;
  const r = Gs(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Jt(e.toString) && e.toString() === "[object FormData]";
}, eN = Cr("URLSearchParams"), [nN, tN, rN, iN] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Cr), aN = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function vo(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Zi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (yo(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Zb(e, n) {
  if (yo(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const pi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ex = (e) => !Ki(e) && e !== pi;
function im() {
  const { caseless: e, skipUndefined: n } = ex(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && Zb(r, o) || o;
    os(r[s]) && os(a) ? r[s] = im(r[s], a) : os(a) ? r[s] = im({}, a) : Zi(a) ? r[s] = a.slice() : (!n || !Ki(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && vo(arguments[a], i);
  return r;
}
const oN = (e, n, r, { allOwnKeys: i } = {}) => (vo(
  n,
  (a, o) => {
    r && Jt(a) ? Object.defineProperty(e, o, {
      value: Yb(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), sN = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), lN = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, cN = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ws(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, dN = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, uN = (e) => {
  if (!e) return null;
  if (Zi(e)) return e;
  let n = e.length;
  if (!Xb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, mN = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ws(Uint8Array)), pN = (e, n) => {
  const i = (e && e[Ks]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, fN = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, hN = Cr("HTMLFormElement"), yN = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), ff = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), gN = Cr("RegExp"), nx = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  vo(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, vN = (e) => {
  nx(e, (n, r) => {
    if (Jt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Jt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, kN = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Zi(e) ? i(e) : i(String(e).split(n)), r;
}, bN = () => {
}, xN = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function _N(e) {
  return !!(e && Jt(e.append) && e[Qb] === "FormData" && e[Ks]);
}
const SN = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (go(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (yo(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Zi(i) ? [] : {};
        return vo(i, (s, l) => {
          const d = r(s, a + 1);
          !Ki(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, NN = Cr("AsyncFunction"), jN = (e) => e && (go(e) || Jt(e)) && Jt(e.then) && Jt(e.catch), tx = ((e, n) => e ? setImmediate : n ? ((r, i) => (pi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === pi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), pi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Jt(pi.postMessage)), wN = typeof queueMicrotask < "u" ? queueMicrotask.bind(pi) : typeof process < "u" && process.nextTick || tx, CN = (e) => e != null && Jt(e[Ks]), ke = {
  isArray: Zi,
  isArrayBuffer: Jb,
  isBuffer: yo,
  isFormData: Z0,
  isArrayBufferView: U0,
  isString: M0,
  isNumber: Xb,
  isBoolean: B0,
  isObject: go,
  isPlainObject: os,
  isEmptyObject: q0,
  isReadableStream: nN,
  isRequest: tN,
  isResponse: rN,
  isHeaders: iN,
  isUndefined: Ki,
  isDate: H0,
  isFile: W0,
  isReactNativeBlob: K0,
  isReactNative: G0,
  isBlob: Y0,
  isRegExp: gN,
  isFunction: Jt,
  isStream: J0,
  isURLSearchParams: eN,
  isTypedArray: mN,
  isFileList: Q0,
  forEach: vo,
  merge: im,
  extend: oN,
  trim: aN,
  stripBOM: sN,
  inherits: lN,
  toFlatObject: cN,
  kindOf: Gs,
  kindOfTest: Cr,
  endsWith: dN,
  toArray: uN,
  forEachEntry: pN,
  matchAll: fN,
  isHTMLForm: hN,
  hasOwnProperty: ff,
  hasOwnProp: ff,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: nx,
  freezeMethods: vN,
  toObjectSet: kN,
  toCamelCase: yN,
  noop: bN,
  toFiniteNumber: xN,
  findKey: Zb,
  global: pi,
  isContextDefined: ex,
  isSpecCompliantForm: _N,
  toJSONObject: SN,
  isAsyncFn: NN,
  isThenable: jN,
  setImmediate: tx,
  asap: wN,
  isIterable: CN
};
let hn = class rx extends Error {
  static from(n, r, i, a, o, s) {
    const l = new rx(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ke.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
hn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
hn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
hn.ECONNABORTED = "ECONNABORTED";
hn.ETIMEDOUT = "ETIMEDOUT";
hn.ERR_NETWORK = "ERR_NETWORK";
hn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
hn.ERR_DEPRECATED = "ERR_DEPRECATED";
hn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
hn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
hn.ERR_CANCELED = "ERR_CANCELED";
hn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
hn.ERR_INVALID_URL = "ERR_INVALID_URL";
hn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const FN = null;
function am(e) {
  return ke.isPlainObject(e) || ke.isArray(e);
}
function ix(e) {
  return ke.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function fl(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = ix(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function IN(e) {
  return ke.isArray(e) && !e.some(am);
}
const EN = ke.toFlatObject(ke, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Qs(e, n, r) {
  if (!ke.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ke.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(N, F) {
      return !ke.isUndefined(F[N]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? 100 : r.maxDepth, m = l && ke.isSpecCompliantForm(n);
  if (!ke.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(S) {
    if (S === null) return "";
    if (ke.isDate(S))
      return S.toISOString();
    if (ke.isBoolean(S))
      return S.toString();
    if (!m && ke.isBlob(S))
      throw new hn("Blob is not supported. Use a Buffer instead.");
    return ke.isArrayBuffer(S) || ke.isTypedArray(S) ? m && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function f(S, N, F) {
    let y = S;
    if (ke.isReactNative(n) && ke.isReactNativeBlob(S))
      return n.append(fl(F, N, o), u(S)), !1;
    if (S && !F && typeof S == "object") {
      if (ke.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ke.isArray(S) && IN(S) || (ke.isFileList(S) || ke.endsWith(N, "[]")) && (y = ke.toArray(S)))
        return N = ix(N), y.forEach(function(T, E) {
          !(ke.isUndefined(T) || T === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? fl([N], E, o) : s === null ? N : N + "[]",
            u(T)
          );
        }), !1;
    }
    return am(S) ? !0 : (n.append(fl(F, N, o), u(S)), !1);
  }
  const h = [], v = Object.assign(EN, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: am
  });
  function C(S, N, F = 0) {
    if (!ke.isUndefined(S)) {
      if (F > d)
        throw new hn(
          "Object is too deeply nested (" + F + " levels). Max depth: " + d,
          hn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      h.push(S), ke.forEach(S, function(M, T) {
        (!(ke.isUndefined(M) || M === null) && a.call(n, M, ke.isString(T) ? T.trim() : T, N, v)) === !0 && C(M, N ? N.concat(T) : [T], F + 1);
      }), h.pop();
    }
  }
  if (!ke.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), n;
}
function hf(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Wm(e, n) {
  this._pairs = [], e && Qs(e, this, n);
}
const ax = Wm.prototype;
ax.append = function(n, r) {
  this._pairs.push([n, r]);
};
ax.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, hf);
  } : hf;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function TN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function ox(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || TN, a = ke.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ke.isURLSearchParams(n) ? n.toString() : new Wm(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class yf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ke.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Km = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, $N = typeof URLSearchParams < "u" ? URLSearchParams : Wm, DN = typeof FormData < "u" ? FormData : null, RN = typeof Blob < "u" ? Blob : null, ON = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $N,
    FormData: DN,
    Blob: RN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Gm = typeof window < "u" && typeof document < "u", om = typeof navigator == "object" && navigator || void 0, AN = Gm && (!om || ["ReactNative", "NativeScript", "NS"].indexOf(om.product) < 0), PN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", LN = Gm && window.location.href || "http://localhost", VN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Gm,
  hasStandardBrowserEnv: AN,
  hasStandardBrowserWebWorkerEnv: PN,
  navigator: om,
  origin: LN
}, Symbol.toStringTag, { value: "Module" })), Rt = {
  ...VN,
  ...ON
};
function zN(e, n) {
  return Qs(e, new Rt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Rt.isNode && ke.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function UN(e) {
  return ke.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function MN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function sx(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ke.isArray(a) ? a.length : s, d ? (ke.hasOwnProp(a, s) ? a[s] = ke.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ke.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ke.isArray(a[s]) && (a[s] = MN(a[s])), !l);
  }
  if (ke.isFormData(e) && ke.isFunction(e.entries)) {
    const r = {};
    return ke.forEachEntry(e, (i, a) => {
      n(UN(i), a, r, 0);
    }), r;
  }
  return null;
}
const Fi = (e, n) => e != null && ke.hasOwnProp(e, n) ? e[n] : void 0;
function BN(e, n, r) {
  if (ke.isString(e))
    try {
      return (n || JSON.parse)(e), ke.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const ko = {
  transitional: Km,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ke.isObject(n);
      if (o && ke.isHTMLForm(n) && (n = new FormData(n)), ke.isFormData(n))
        return a ? JSON.stringify(sx(n)) : n;
      if (ke.isArrayBuffer(n) || ke.isBuffer(n) || ke.isStream(n) || ke.isFile(n) || ke.isBlob(n) || ke.isReadableStream(n))
        return n;
      if (ke.isArrayBufferView(n))
        return n.buffer;
      if (ke.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Fi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return zN(n, d).toString();
        if ((l = ke.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Fi(this, "env"), u = m && m.FormData;
          return Qs(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), BN(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Fi(this, "transitional") || ko.transitional, i = r && r.forcedJSONParsing, a = Fi(this, "responseType"), o = a === "json";
      if (ke.isResponse(n) || ke.isReadableStream(n))
        return n;
      if (n && ke.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Fi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? hn.from(d, hn.ERR_BAD_RESPONSE, this, null, Fi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Rt.classes.FormData,
    Blob: Rt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ke.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ko.headers[e] = {};
});
const qN = ke.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), HN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && qN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, gf = Symbol("internals"), WN = /[^\x09\x20-\x7E\x80-\xFF]/g;
function KN(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function la(e) {
  return e && String(e).trim().toLowerCase();
}
function GN(e) {
  return KN(e.replace(WN, ""));
}
function ss(e) {
  return e === !1 || e == null ? e : ke.isArray(e) ? e.map(ss) : GN(String(e));
}
function YN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const QN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function hl(e, n, r, i, a) {
  if (ke.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ke.isString(n)) {
    if (ke.isString(i))
      return n.indexOf(i) !== -1;
    if (ke.isRegExp(i))
      return i.test(n);
  }
}
function JN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function XN(e, n) {
  const r = ke.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Xt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = la(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ke.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = ss(l));
    }
    const s = (l, d) => ke.forEach(l, (m, u) => o(m, u, d));
    if (ke.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ke.isString(n) && (n = n.trim()) && !QN(n))
      s(HN(n), r);
    else if (ke.isObject(n) && ke.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ke.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ke.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = la(n), n) {
      const i = ke.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return YN(a);
        if (ke.isFunction(r))
          return r.call(this, a, i);
        if (ke.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = la(n), n) {
      const i = ke.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || hl(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = la(s), s) {
        const l = ke.findKey(i, s);
        l && (!r || hl(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || hl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ke.forEach(this, (a, o) => {
      const s = ke.findKey(i, o);
      if (s) {
        r[s] = ss(a), delete r[o];
        return;
      }
      const l = n ? JN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = ss(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ke.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ke.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[gf] = this[gf] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = la(s);
      i[l] || (XN(a, s), i[l] = !0);
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Xt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ke.reduceDescriptors(Xt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ke.freezeMethods(Xt);
function yl(e, n) {
  const r = this || ko, i = n || r, a = Xt.from(i.headers);
  let o = i.data;
  return ke.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function lx(e) {
  return !!(e && e.__CANCEL__);
}
let bo = class extends hn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", hn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function cx(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new hn(
      "Request failed with status code " + r.status,
      [hn.ERR_BAD_REQUEST, hn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function ZN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function ej(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function nj(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const _s = (e, n, r = 3) => {
  let i = 0;
  const a = ej(50, 250);
  return nj((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, vf = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, kf = (e) => (...n) => ke.asap(() => e(...n)), tj = Rt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Rt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Rt.origin),
  Rt.navigator && /(msie|trident)/i.test(Rt.navigator.userAgent)
) : () => !0, rj = Rt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ke.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ke.isString(i) && l.push(`path=${i}`), ke.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ke.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ij(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function aj(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function dx(e, n, r) {
  let i = !ij(n);
  return e && (i || r === !1) ? aj(e, n) : n;
}
const bf = (e) => e instanceof Xt ? { ...e } : e;
function _i(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ke.isPlainObject(m) && ke.isPlainObject(u) ? ke.merge.call({ caseless: h }, m, u) : ke.isPlainObject(u) ? ke.merge({}, u) : ke.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ke.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ke.hasOwnProp(n, f))
      return i(m, u);
    if (ke.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(bf(m), bf(u), f, !0)
  };
  return ke.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ke.hasOwnProp(d, u) ? d[u] : a, h = ke.hasOwnProp(e, u) ? e[u] : void 0, v = ke.hasOwnProp(n, u) ? n[u] : void 0, C = f(h, v, u);
    ke.isUndefined(C) && f !== l || (r[u] = C);
  }), r;
}
const ux = (e) => {
  const n = _i({}, e), r = (h) => ke.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Xt.from(l), n.url = ox(
    dx(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ke.isFormData(i)) {
    if (Rt.hasStandardBrowserEnv || Rt.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ke.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), v = ["content-type", "content-length"];
      Object.entries(h).forEach(([C, S]) => {
        v.includes(C.toLowerCase()) && l.set(C, S);
      });
    }
  }
  if (Rt.hasStandardBrowserEnv && (ke.isFunction(a) && (a = a(n)), a === !0 || a == null && tj(n.url))) {
    const v = o && s && rj.read(s);
    v && l.set(o, v);
  }
  return n;
}, oj = typeof XMLHttpRequest < "u", sj = oj && function(e) {
  return new Promise(function(r, i) {
    const a = ux(e);
    let o = a.data;
    const s = Xt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, C;
    function S() {
      v && v(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function F() {
      if (!N)
        return;
      const M = Xt.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), E = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: M,
        config: e,
        request: N
      };
      cx(
        function(B) {
          r(B), S();
        },
        function(B) {
          i(B), S();
        },
        E
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = F : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(F);
    }, N.onabort = function() {
      N && (i(new hn("Request aborted", hn.ECONNABORTED, e, N)), N = null);
    }, N.onerror = function(T) {
      const E = T && T.message ? T.message : "Network Error", D = new hn(E, hn.ERR_NETWORK, e, N);
      D.event = T || null, i(D), N = null;
    }, N.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Km;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(
        new hn(
          T,
          E.clarifyTimeoutError ? hn.ETIMEDOUT : hn.ECONNABORTED,
          e,
          N
        )
      ), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ke.forEach(s.toJSON(), function(T, E) {
      N.setRequestHeader(E, T);
    }), ke.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, C] = _s(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, v] = _s(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (M) => {
      N && (i(!M || M.type ? new bo(null, e, N) : M), N.abort(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = ZN(a.url);
    if (y && Rt.protocols.indexOf(y) === -1) {
      i(
        new hn(
          "Unsupported protocol " + y + ":",
          hn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, lj = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof hn ? u : new bo(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new hn(`timeout of ${n}ms exceeded`, hn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ke.asap(l), d;
  }
}, cj = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, dj = async function* (e, n) {
  for await (const r of uj(e))
    yield* cj(r, n);
}, uj = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, xf = (e, n, r, i) => {
  const a = dj(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, _f = 64 * 1024, { isFunction: Eo } = ke, mj = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ke.global), { ReadableStream: Sf, TextEncoder: Nf } = ke.global, jf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, pj = (e) => {
  e = ke.merge.call(
    {
      skipUndefined: !0
    },
    mj,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? Eo(n) : typeof fetch == "function", o = Eo(r), s = Eo(i);
  if (!a)
    return !1;
  const l = a && Eo(Sf), d = a && (typeof Nf == "function" ? /* @__PURE__ */ ((C) => (S) => C.encode(S))(new Nf()) : async (C) => new Uint8Array(await new r(C).arrayBuffer())), m = o && l && jf(() => {
    let C = !1;
    const S = new r(Rt.origin, {
      body: new Sf(),
      method: "POST",
      get duplex() {
        return C = !0, "half";
      }
    }), N = S.headers.has("Content-Type");
    return S.body != null && S.body.cancel(), C && !N;
  }), u = s && l && jf(() => ke.isReadableStream(new i("").body)), f = {
    stream: u && ((C) => C.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((C) => {
    !f[C] && (f[C] = (S, N) => {
      let F = S && S[C];
      if (F)
        return F.call(S);
      throw new hn(
        `Response type '${C}' is not supported`,
        hn.ERR_NOT_SUPPORT,
        N
      );
    });
  });
  const h = async (C) => {
    if (C == null)
      return 0;
    if (ke.isBlob(C))
      return C.size;
    if (ke.isSpecCompliantForm(C))
      return (await new r(Rt.origin, {
        method: "POST",
        body: C
      }).arrayBuffer()).byteLength;
    if (ke.isArrayBufferView(C) || ke.isArrayBuffer(C))
      return C.byteLength;
    if (ke.isURLSearchParams(C) && (C = C + ""), ke.isString(C))
      return (await d(C)).byteLength;
  }, v = async (C, S) => {
    const N = ke.toFiniteNumber(C.getContentLength());
    return N ?? h(S);
  };
  return async (C) => {
    let {
      url: S,
      method: N,
      data: F,
      signal: y,
      cancelToken: M,
      timeout: T,
      onDownloadProgress: E,
      onUploadProgress: D,
      responseType: B,
      headers: ee,
      withCredentials: X = "same-origin",
      fetchOptions: ae
    } = ux(C), Q = n || fetch;
    B = B ? (B + "").toLowerCase() : "text";
    let z = lj(
      [y, M && M.toAbortSignal()],
      T
    ), O = null;
    const q = z && z.unsubscribe && (() => {
      z.unsubscribe();
    });
    let Z;
    try {
      if (D && m && N !== "get" && N !== "head" && (Z = await v(ee, F)) !== 0) {
        let _e = new r(S, {
          method: "POST",
          body: F,
          duplex: "half"
        }), Ee;
        if (ke.isFormData(F) && (Ee = _e.headers.get("content-type")) && ee.setContentType(Ee), _e.body) {
          const [K, qe] = vf(
            Z,
            _s(kf(D))
          );
          F = xf(_e.body, _f, K, qe);
        }
      }
      ke.isString(X) || (X = X ? "include" : "omit");
      const ve = o && "credentials" in r.prototype;
      if (ke.isFormData(F)) {
        const _e = ee.getContentType();
        _e && /^multipart\/form-data/i.test(_e) && !/boundary=/i.test(_e) && ee.delete("content-type");
      }
      const ce = {
        ...ae,
        signal: z,
        method: N.toUpperCase(),
        headers: ee.normalize().toJSON(),
        body: F,
        duplex: "half",
        credentials: ve ? X : void 0
      };
      O = o && new r(S, ce);
      let le = await (o ? Q(O, ae) : Q(S, ce));
      const me = u && (B === "stream" || B === "response");
      if (u && (E || me && q)) {
        const _e = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          _e[Be] = le[Be];
        });
        const Ee = ke.toFiniteNumber(le.headers.get("content-length")), [K, qe] = E && vf(
          Ee,
          _s(kf(E), !0)
        ) || [];
        le = new i(
          xf(le.body, _f, K, () => {
            qe && qe(), q && q();
          }),
          _e
        );
      }
      B = B || "text";
      let H = await f[ke.findKey(f, B) || "text"](
        le,
        C
      );
      return !me && q && q(), await new Promise((_e, Ee) => {
        cx(_e, Ee, {
          data: H,
          headers: Xt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: C,
          request: O
        });
      });
    } catch (ve) {
      throw q && q(), ve && ve.name === "TypeError" && /Load failed|fetch/i.test(ve.message) ? Object.assign(
        new hn(
          "Network Error",
          hn.ERR_NETWORK,
          C,
          O,
          ve && ve.response
        ),
        {
          cause: ve.cause || ve
        }
      ) : hn.from(ve, ve && ve.code, C, O, ve && ve.response);
    }
  };
}, fj = /* @__PURE__ */ new Map(), mx = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = fj;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : pj(n)), u = m;
  return m;
};
mx();
const Ym = {
  http: FN,
  xhr: sj,
  fetch: {
    get: mx
  }
};
ke.forEach(Ym, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const wf = (e) => `- ${e}`, hj = (e) => ke.isFunction(e) || e === null || e === !1;
function yj(e, n) {
  e = ke.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !hj(i) && (a = Ym[(l = String(i)).toLowerCase()], a === void 0))
      throw new hn(`Unknown adapter '${l}'`);
    if (a && (ke.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(wf).join(`
`) : " " + wf(s[0]) : "as no adapter specified";
    throw new hn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const px = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: yj,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Ym
};
function gl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new bo(null, e);
}
function Cf(e) {
  return gl(e), e.headers = Xt.from(e.headers), e.data = yl.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), px.getAdapter(e.adapter || ko.adapter, e)(e).then(
    function(i) {
      return gl(e), i.data = yl.call(e, e.transformResponse, i), i.headers = Xt.from(i.headers), i;
    },
    function(i) {
      return lx(i) || (gl(e), i && i.response && (i.response.data = yl.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = Xt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const fx = "1.15.2", Js = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Js[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Ff = {};
Js.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + fx + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new hn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        hn.ERR_DEPRECATED
      );
    return r && !Ff[s] && (Ff[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Js.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function gj(e, n, r) {
  if (typeof e != "object")
    throw new hn("options must be an object", hn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new hn(
          "option " + o + " must be " + d,
          hn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new hn("Unknown option " + o, hn.ERR_BAD_OPTION);
  }
}
const ls = {
  assertOptions: gj,
  validators: Js
}, lr = ls.validators;
let vi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new yf(),
      response: new yf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = _i(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && ls.assertOptions(
      i,
      {
        silentJSONParsing: lr.transitional(lr.boolean),
        forcedJSONParsing: lr.transitional(lr.boolean),
        clarifyTimeoutError: lr.transitional(lr.boolean),
        legacyInterceptorReqResOrdering: lr.transitional(lr.boolean)
      },
      !1
    ), a != null && (ke.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : ls.assertOptions(
      a,
      {
        encode: lr.function,
        serialize: lr.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), ls.assertOptions(
      r,
      {
        baseUrl: lr.spelling("baseURL"),
        withXsrfToken: lr.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ke.merge(o.common, o[r.method]);
    o && ke.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (C) => {
      delete o[C];
    }), r.headers = Xt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(r) === !1)
        return;
      d = d && S.synchronous;
      const N = r.transitional || Km;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(S.fulfilled, S.rejected) : l.push(S.fulfilled, S.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [Cf.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const C = l[f++], S = l[f++];
      try {
        v = C(v);
      } catch (N) {
        S.call(this, N);
        break;
      }
    }
    try {
      u = Cf.call(this, v);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = _i(this.defaults, n);
    const r = dx(n.baseURL, n.url, n.allowAbsoluteUrls);
    return ox(r, n.params, n.paramsSerializer);
  }
};
ke.forEach(["delete", "get", "head", "options"], function(n) {
  vi.prototype[n] = function(r, i) {
    return this.request(
      _i(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
ke.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        _i(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  vi.prototype[n] = r(), vi.prototype[n + "Form"] = r(!0);
});
let vj = class hx {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new bo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new hx(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function kj(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function bj(e) {
  return ke.isObject(e) && e.isAxiosError === !0;
}
const sm = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(sm).forEach(([e, n]) => {
  sm[n] = e;
});
function yx(e) {
  const n = new vi(e), r = Yb(vi.prototype.request, n);
  return ke.extend(r, vi.prototype, n, { allOwnKeys: !0 }), ke.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return yx(_i(e, a));
  }, r;
}
const pt = yx(ko);
pt.Axios = vi;
pt.CanceledError = bo;
pt.CancelToken = vj;
pt.isCancel = lx;
pt.VERSION = fx;
pt.toFormData = Qs;
pt.AxiosError = hn;
pt.Cancel = pt.CanceledError;
pt.all = function(n) {
  return Promise.all(n);
};
pt.spread = kj;
pt.isAxiosError = bj;
pt.mergeConfig = _i;
pt.AxiosHeaders = Xt;
pt.formToJSON = (e) => sx(ke.isHTMLForm(e) ? new FormData(e) : e);
pt.getAdapter = px.getAdapter;
pt.HttpStatusCode = sm;
pt.default = pt;
const {
  Axios: gB,
  AxiosError: vB,
  CanceledError: kB,
  isCancel: bB,
  CancelToken: xB,
  VERSION: _B,
  all: SB,
  Cancel: NB,
  isAxiosError: xj,
  spread: jB,
  toFormData: wB,
  AxiosHeaders: CB,
  HttpStatusCode: FB,
  formToJSON: IB,
  getAdapter: EB,
  mergeConfig: TB
} = pt;
class _j {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const If = new _j();
function Sj(e, n) {
  return Ef(e), Ef(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Ef(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const Nj = Object.prototype.toString;
function jj(e, n) {
  return Nj.call(e) === `[object ${n}]`;
}
function wj(e) {
  return jj(e, "Object");
}
function Cj(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Ha = "8.36.0", Kr = globalThis;
function Qm(e, n, r) {
  const i = r || Kr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Ha] = a[Ha] || {};
  return o[e] || (o[e] = n());
}
const gx = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Fj = "Sentry Logger ", Tf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], $f = {};
function vx(e) {
  if (!("console" in Kr))
    return e();
  const n = Kr.console, r = {}, i = Object.keys($f);
  i.forEach((a) => {
    const o = $f[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function Ij() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return gx ? Tf.forEach((r) => {
    n[r] = (...i) => {
      e && vx(() => {
        Kr.console[r](`${Fj}[${r}]:`, ...i);
      });
    };
  }) : Tf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const cs = Qm("logger", Ij);
function Ej(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    gx && cs.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const kx = 1e3;
function Jm() {
  return Date.now() / kx;
}
function Tj() {
  const { performance: e } = Kr;
  if (!e || !e.now)
    return Jm;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / kx;
}
const $j = Tj();
(() => {
  const { performance: e } = Kr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Mi() {
  const e = Kr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Df() {
  return {
    traceId: Mi(),
    spanId: Mi().substring(16)
  };
}
function Xm() {
  return Zm(Kr), Kr;
}
function Zm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Ha, n[Ha] = n[Ha] || {};
}
function Dj(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || $j(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Mi()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const lm = "_sentrySpan";
function Rf(e, n) {
  n ? Ej(e, lm, n) : delete e[lm];
}
function Of(e) {
  return e[lm];
}
const Rj = 100;
class ep {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Df();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new ep();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Rf(n, Of(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Dj(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Gi ? [r.getScopeData(), r.getRequestSession()] : wj(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Rf(this, void 0), this._attachments = [], this._propagationContext = Df(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : Rj;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Jm(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Of(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Mi();
    if (!this._client)
      return cs.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Mi();
    if (!this._client)
      return cs.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Mi();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (cs.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Gi = ep;
function Oj() {
  return Qm("defaultCurrentScope", () => new Gi());
}
function Aj() {
  return Qm("defaultIsolationScope", () => new Gi());
}
class Pj {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Gi();
    let a;
    r ? a = r : a = new Gi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Cj(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Yi() {
  const e = Xm(), n = Zm(e);
  return n.stack = n.stack || new Pj(Oj(), Aj());
}
function Lj(e) {
  return Yi().withScope(e);
}
function Vj(e, n) {
  const r = Yi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Af(e) {
  return Yi().withScope(() => e(Yi().getIsolationScope()));
}
function zj() {
  return {
    withIsolationScope: Af,
    withScope: Lj,
    withSetScope: Vj,
    withSetIsolationScope: (e, n) => Af(n),
    getCurrentScope: () => Yi().getScope(),
    getIsolationScope: () => Yi().getIsolationScope()
  };
}
function bx(e) {
  const n = Zm(e);
  return n.acs ? n.acs : zj();
}
function np() {
  const e = Xm();
  return bx(e).getCurrentScope();
}
function xx() {
  const e = Xm();
  return bx(e).getIsolationScope();
}
function Uj() {
  return np().getClient();
}
function Mj(e) {
  if (e)
    return Bj(e) ? { captureContext: e } : Hj(e) ? {
      captureContext: e
    } : e;
}
function Bj(e) {
  return e instanceof Gi || typeof e == "function";
}
const qj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Hj(e) {
  return Object.keys(e).some((n) => qj.includes(n));
}
function Pf(e, n) {
  return np().captureException(e, Mj(n));
}
function Wj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return np().captureMessage(e, r, i);
}
function Kj(e, n) {
  xx().setContext(e, n);
}
const Gj = 100;
function di(e, n) {
  const r = Uj(), i = xx();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = Gj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Jm(), ...e }, d = a ? vx(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var io;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(io || (io = {}));
function Bi(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const Yj = ro.backendDomain ? {
  "backend-domain": ro.backendDomain
} : void 0;
function ds() {
  const e = new URLSearchParams({
    noToken: "true",
    ...Yj
  }).toString();
  document.location.href = `${ro.url.logIn}?${e}`;
}
const vl = "authData", kl = 30, Qj = 600, bl = 5;
class Jj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= bl || this.clientServerTimeDiff <= -bl ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + Qj, a = Bi(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > bl) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(vl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(vl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(vl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - kl;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Bi(n), i = r.exp - kl;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - kl - this.estimatedServerTime()) * 1e3;
  }
}
const _t = new Jj();
async function Xj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Bi(o).exp : "None", l = await Xs.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Bi(m).exp : "None", h = u ? Bi(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      Kj("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    Wj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: io.Platform,
        domain: n
      }
    });
  }
}
const xl = /* @__PURE__ */ new Map(), Zj = 3;
function ew(e) {
  e.interceptors.response.use((n) => (xl.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case cm.Unauthorized:
          if (!Xs.isRefreshTokenExpired() && n.config) {
            di({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = xl.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= Zj)
              return xl.set(n.config.url, i + 1), e(n.config);
          }
          Xj(n), console.error("401 unauthorized interceptor"), ds();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const _x = pt.create();
ew(_x);
const Vr = console.log;
async function Lf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class nw extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function tw(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const rw = 5;
class iw {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      _t.setAuthData(r);
    else {
      const i = _t.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new nw("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = _t.getAccessToken();
    if (!n)
      return {};
    const r = Bi(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return _t.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = _t.getAuthData();
    return r ? _t.isAccessTokenExpired() ? (di({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && _t.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return _t.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return _t.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return _t.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = _t.getAuthData();
    return n ? _t.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!If.isElectron())
      return !0;
    const n = await If.getVersion();
    return Sj(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = rw) {
    try {
      return await _x.post(`${ro.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Vr("AUTH", "Network connection offline - waiting..."), di({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Lf(5);
    n && (Vr("AUTH", "Network connection restored"), di({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = tw(this.retryCount);
    return Vr("AUTH", `Retrying in ${i} seconds`), await Lf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (_t.isRefreshTokenExpired(r))
      return Vr("AUTH", "Refresh token expired"), di({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), _t.removeAuthData(), ds(), null;
    if (xj(n)) {
      if (n.message === "timeout exceeded")
        return Vr("AUTH", "Timeout exceeded"), di({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Vr("AUTH", "Network error"), di({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Vr("AUTH", "Refresh token invalid (401)"), _t.removeAuthData(), ds(), null;
      Pf(n, {
        level: "error",
        tags: {
          team: io.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Vr("AUTH", "Retries exhausted, logging out"), Pf(n, {
      level: "error",
      tags: {
        team: io.Platform,
        errorSource: "authManager.refresh"
      }
    }), _t.removeAuthData(), ds(), null) : (Vr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return _t.accessTokenExpiresInMs();
  }
}
const Xs = new iw();
var cm;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(cm || (cm = {}));
const aw = new qm((e, n) => new Wb((r) => {
  Xs.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), ow = new qm(
  (e, n) => new Wb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Xs.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...JS(ro.url.partnerIntegrations) && d?.access_token && XS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), sw = new AbortController(), Sx = (e) => new C0({
  queryDeduplication: !1,
  cache: new F0(),
  link: qm.from([
    aw,
    ow,
    I0({
      uri: `${e}/graphql`,
      fetch: R0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: sw.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), lw = ({
  configuration: e,
  children: n
}) => {
  const r = Bn(
    () => Sx(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ue.jsx(E0, { client: r, children: n });
};
function cw() {
  try {
    return T0(), !0;
  } catch {
    return !1;
  }
}
const dw = ({
  configuration: e,
  children: n
}) => cw() ? n : /* @__PURE__ */ Ue.jsx(lw, { configuration: e, children: n }), uw = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ue.jsx($0, { children: (o) => /* @__PURE__ */ Ue.jsx(
  ZS,
  {
    value: {
      useMutation: r0(e, n),
      useQuery: t0(e, n),
      useLazyQuery: n0(e, n),
      executeQuery: e0(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Nx = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ue.jsx(dw, { configuration: r, children: s ? /* @__PURE__ */ Ue.jsx(
    uw,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var _l = { exports: {} }, ca = {}, Vf;
function mw() {
  if (Vf) return ca;
  Vf = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ca.Fragment = r, ca.jsx = s, ca.jsxs = s, ca;
}
var To = {}, zf;
function pw() {
  return zf || (zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    To.Fragment = i, To.jsx = Rn, To.jsxs = Mn;
  })()), To;
}
var Uf;
function fw() {
  return Uf || (Uf = 1, process.env.NODE_ENV === "production" ? _l.exports = mw() : _l.exports = pw()), _l.exports;
}
var oe = fw();
const hw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, yw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, gw = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": hw,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": yw
};
function jx(e) {
  return gw[e] ?? {};
}
const vw = jx(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), kw = jx(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), bw = "_copyIcon_1wjfs_48", xw = "_list_1wjfs_53", _w = "_listItem_1wjfs_63", Sw = "_collapsible_1wjfs_72", Nw = "_collapsibleIsOpen_1wjfs_80", jw = "_collapsibleHeader_1wjfs_83", ww = "_collapsibleIconTrue_1wjfs_86", Cw = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: bw,
  list: xw,
  listItem: _w,
  collapsible: Sw,
  collapsibleIsOpen: Nw,
  collapsibleHeader: jw,
  collapsibleIconTrue: ww,
  collapsibleIconFalse: Cw
}, Fw = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: at(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ge, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(bt) })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(bt) })
          ] }) })
        ] })
      ]
    }
  );
}, Iw = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ oe.jsx(An, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Fw, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Ew = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ oe.jsx(Ge, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ oe.jsx(
      Ge.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: i }),
          to(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Tw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ oe.jsx(Ge, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ge.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            Ye,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  bt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  bt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Ss = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ oe.jsx(Ye, { content: n ? null : l(), children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(fe, { size: 14, name: o(), color: s() }) }) });
}, $w = "_wrapper_1xucg_1", Dw = "_externalLink_1xucg_7", Sl = {
  wrapper: $w,
  externalLink: Dw
}, Rw = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = or(), { isCopied: i, copy: a } = or(), { isCopied: o, copy: s } = or(), { isCopied: l, copy: d } = or(), { isCopied: m, copy: u } = or();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: C,
    home_city: S,
    country: N,
    email: F,
    phone: y,
    dob: M,
    created_at: T,
    email_subscribe: E,
    push_subscribe: D
  } = e, B = 14, ee = `${v || ""} ${C || ""}`.trim() || "A customer has no name", X = `${S ? `${S} /` : ""} ${N || ""}`.trim(), ae = M ? Ln(M).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { className: Sl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Sl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-2", children: ee }),
          ae && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    T && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: Ln(T).format(bt) })
    ] }),
    X && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "map-pin" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: X })
      ] }),
      /* @__PURE__ */ oe.jsx(Ye, { content: "Copy location", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        fe,
        {
          size: B,
          name: o ? "done" : "copy",
          onClick: () => s(X),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    F && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "mail" }),
        /* @__PURE__ */ oe.jsx("span", { className: Sl.externalLink, children: F })
      ] }),
      /* @__PURE__ */ oe.jsx(Ye, { content: "Copy email", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        fe,
        {
          size: B,
          name: n ? "done" : "copy",
          onClick: () => r(F),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "phone" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ oe.jsx(Ye, { content: "Copy phone number", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        fe,
        {
          size: B,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "user" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ oe.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(Ye, { content: "Copy Braze ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        fe,
        {
          size: B,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "tag" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ oe.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(Ye, { content: "Copy External ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        fe,
        {
          size: B,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    E && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "sync" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Ss, { state: E })
    ] }),
    D && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: B, name: "bell" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Ss, { isPush: !0, state: D })
    ] })
  ] }) });
}, Ow = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: at(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ge, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ oe.jsx(
              fe,
              {
                size: a,
                className: at({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ye, { content: "For iOS", children: /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Aw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ oe.jsx(An, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Ow, { device: r, openByDefault: i === 0 }, i))
  ] });
}, da = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, $o = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = _n(), { useMutation: a } = pn(), [o, s] = se(!1), [l] = a(
    kw,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: da[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ oe.jsx(Ye, { content: da[n].tooltipContent, children: /* @__PURE__ */ oe.jsx(
    Kn,
    {
      variant: "secondary",
      color: da[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(
          Ss,
          {
            noTooltip: !0,
            state: da[n].parameter
          }
        ),
        da[n].label
      ] })
    }
  ) });
}, Pw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ oe.jsx(Ge, { className: On.list, children: /* @__PURE__ */ oe.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(fe, { size: 14, name: "sync" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Ss, { state: a })
    ] }) }) }),
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
        /* @__PURE__ */ oe.jsx(
          $o,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ oe.jsx(
          $o,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ oe.jsx(
        $o,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ oe.jsx(
        $o,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Lw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ oe.jsx(Ge, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ge.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            Ye,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  bt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  bt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Vw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = _n(), { useMutation: i } = pn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, F = n.displayDevices ?? !1, y = n.displayApps ?? !1, M = !h && !v && !C && !S && !N, [T, { error: E }] = i(
    vw,
    {
      onError: () => {
      },
      onCompleted: (B) => {
        const ee = B?.Braze?.exportUserDetails?.users?.[0];
        ee ? (o(ee), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    u || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (He(() => {
    async function B() {
      m(!0), await D();
    }
    B().finally(() => m(!1));
  }, [u, f]), E) {
    const B = E.graphQLErrors;
    return Pm({ errors: B }) ? /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Lm({ errors: B }) ? /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ oe.jsx(Fn, { error: E });
  }
  return d ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ oe.jsx(dn, {}) }) : M ? /* @__PURE__ */ oe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ oe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ oe.jsx(Rw, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ oe.jsx(
          Pw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        C && !!a && /* @__PURE__ */ oe.jsx(Ew, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ oe.jsx(Tw, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ oe.jsx(Lw, { customerDetails: a }),
        F && !!a && /* @__PURE__ */ oe.jsx(Aw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ oe.jsx(Iw, { apps: a?.apps })
      ]
    }
  );
}, zw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Lb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Uw() {
  var e = gi(!1), n = it(function() {
    return e.current;
  }, []);
  return He(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Mw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = it(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Bw = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Mf = function(e) {
  return h0(Bw, e);
}, Nl, Bf;
function qw() {
  return Bf || (Bf = 1, Nl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Nl;
}
var jl, qf;
function Hw() {
  if (qf) return jl;
  qf = 1;
  var e = qw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return jl = a, jl;
}
var Ww = Hw();
const Kw = /* @__PURE__ */ Hm(Ww);
var wx = function() {
  var e = Uw(), n = Mw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = it(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = Kw(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function Gw(e, n) {
  n === void 0 && (n = 0);
  var r = gi(!1), i = gi(), a = gi(e), o = it(function() {
    return r.current;
  }, []), s = it(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = it(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return He(function() {
    a.current = e;
  }, [e]), He(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Si(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = Gw(e, n), a = i[0], o = i[1], s = i[2];
  return He(s, r), [a, o];
}
var Yw = function(e) {
  He(e, []);
}, Qw = function(e, n) {
  var r = gi(function() {
  });
  He(function() {
    r.current = e;
  }), He(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, Jw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = Bn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return pl(pl({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = O0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = pl({ get: it(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, Xw = function(e) {
  var n = gi(e);
  n.current = e, Yw(function() {
    return function() {
      return n.current();
    };
  });
}, xo = (e) => e.type === "checkbox", fi = (e) => e instanceof Date, Bt = (e) => e == null;
const Cx = (e) => typeof e == "object";
var dt = (e) => !Bt(e) && !Array.isArray(e) && Cx(e) && !fi(e), Fx = (e) => dt(e) && e.target ? xo(e.target) ? e.target.checked : e.target.value : e, Zw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Ix = (e, n) => e.has(Zw(n)), eC = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return dt(n) && n.hasOwnProperty("isPrototypeOf");
}, tp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function jt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(tp && (e instanceof Blob || i)) && (r || dt(e)))
    if (n = r ? [] : {}, !r && !eC(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = jt(e[a]));
  else
    return e;
  return n;
}
var Zs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ot = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !dt(e))
    return r;
  const i = Zs(n.split(/[,[\].]+?/)).reduce((a, o) => Bt(a) ? a : a[o], e);
  return ot(i) || i === e ? ot(e[n]) ? r : e[n] : i;
}, rr = (e) => typeof e == "boolean", rp = (e) => /^\w*$/.test(e), Ex = (e) => Zs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = rp(n) ? [n] : Ex(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = dt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ns = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, vr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Tx = we.createContext(null), Pr = () => we.useContext(Tx), ip = (e) => {
  const { children: n, ...r } = e;
  return we.createElement(Tx.Provider, { value: r }, n);
};
var $x = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== vr.all && (n._proxyFormState[s] = !i || vr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function nC(e) {
  const n = Pr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = we.useState(r._formState), d = we.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = we.useRef(a);
  return m.current = a, we.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), we.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), we.useMemo(() => $x(s, r, d.current, !1), [s, r]);
}
var Dr = (e) => typeof e == "string", Dx = (e, n, r, i, a) => Dr(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function us(e) {
  const n = Pr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = we.useRef(i), d = we.useRef(a);
  l.current = i, we.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Dx(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = we.useState(r._getWatch(i, a));
  return we.useEffect(() => r._removeUnmounted()), m;
}
function ap(e) {
  const n = Pr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Ix(a._names.array, r), l = us({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = nC({
    control: a,
    name: r,
    exact: !0
  }), m = we.useRef(e), u = we.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...rr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = we.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = we.useCallback((N) => u.current.onChange({
    target: {
      value: Fx(N),
      name: r
    },
    type: Ns.CHANGE
  }), [r]), v = we.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: Ns.BLUR
  }), [r, a._formValues]), C = we.useCallback((N) => {
    const F = Qe(a._fields, r);
    F && N && (F._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = we.useMemo(() => ({
    name: r,
    value: l,
    ...rr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return we.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...rr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, M) => {
      const T = Qe(a._fields, y);
      T && T._f && (T._f.mount = M);
    };
    if (F(r, !0), N) {
      const y = jt(Qe(a._options.defaultValues, r));
      Gn(a._defaultValues, r, y), ot(Qe(a._formValues, r)) && Gn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), we.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), we.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Wt = (e) => e.render(ap(e));
var tC = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Wa = (e) => Array.isArray(e) ? e : [e], Hf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, dm = (e) => Bt(e) || !Cx(e);
function ni(e, n) {
  if (dm(e) || dm(n))
    return e === n;
  if (fi(e) && fi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (fi(o) && fi(s) || dt(o) && dt(s) || Array.isArray(o) && Array.isArray(s) ? !ni(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var zt = (e) => dt(e) && !Object.keys(e).length, op = (e) => e.type === "file", kr = (e) => typeof e == "function", js = (e) => {
  if (!tp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Rx = (e) => e.type === "select-multiple", sp = (e) => e.type === "radio", rC = (e) => sp(e) || xo(e), wl = (e) => js(e) && e.isConnected;
function iC(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ot(e) ? i++ : e[n[i++]];
  return e;
}
function aC(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ot(e[n]))
      return !1;
  return !0;
}
function gt(e, n) {
  const r = Array.isArray(n) ? n : rp(n) ? [n] : Ex(n), i = r.length === 1 ? e : iC(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (dt(i) && zt(i) || Array.isArray(i) && aC(i)) && gt(e, r.slice(0, -1)), e;
}
var Ox = (e) => {
  for (const n in e)
    if (kr(e[n]))
      return !0;
  return !1;
};
function ws(e, n = {}) {
  const r = Array.isArray(e);
  if (dt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || dt(e[i]) && !Ox(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ws(e[i], n[i])) : Bt(e[i]) || (n[i] = !0);
  return n;
}
function Ax(e, n, r) {
  const i = Array.isArray(e);
  if (dt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || dt(e[a]) && !Ox(e[a]) ? ot(n) || dm(r[a]) ? r[a] = Array.isArray(e[a]) ? ws(e[a], []) : { ...ws(e[a]) } : Ax(e[a], Bt(n) ? {} : n[a], r[a]) : r[a] = !ni(e[a], n[a]);
  return r;
}
var ua = (e, n) => Ax(e, n, ws(n));
const Wf = {
  value: !1,
  isValid: !1
}, Kf = { value: !0, isValid: !0 };
var Px = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ot(e[0].attributes.value) ? ot(e[0].value) || e[0].value === "" ? Kf : { value: e[0].value, isValid: !0 } : Kf
    ) : Wf;
  }
  return Wf;
}, Lx = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ot(e) ? e : n ? e === "" ? NaN : e && +e : r && Dr(e) ? new Date(e) : i ? i(e) : e;
const Gf = {
  isValid: !1,
  value: null
};
var Vx = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Gf) : Gf;
function Yf(e) {
  const n = e.ref;
  return op(n) ? n.files : sp(n) ? Vx(e.refs).value : Rx(n) ? [...n.selectedOptions].map(({ value: r }) => r) : xo(n) ? Px(e.refs).value : Lx(ot(n.value) ? e.ref.value : n.value, e);
}
var oC = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Cs = (e) => e instanceof RegExp, ma = (e) => ot(e) ? e : Cs(e) ? e.source : dt(e) ? Cs(e.value) ? e.value.source : e.value : e, Qf = (e) => ({
  isOnSubmit: !e || e === vr.onSubmit,
  isOnBlur: e === vr.onBlur,
  isOnChange: e === vr.onChange,
  isOnAll: e === vr.all,
  isOnTouch: e === vr.onTouched
});
const Jf = "AsyncFunction";
var sC = (e) => !!e && !!e.validate && !!(kr(e.validate) && e.validate.constructor.name === Jf || dt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Jf)), lC = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Xf = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ka = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ka(l, n))
          break;
      } else if (dt(l) && Ka(l, n))
        break;
    }
  }
};
function Zf(e, n, r) {
  const i = Qe(e, r);
  if (i || rp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var cC = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || vr.all));
}, dC = (e, n, r) => !e || !n || e === n || Wa(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), uC = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, mC = (e, n) => !Zs(Qe(e, n)).length && gt(e, n), pC = (e, n, r) => {
  const i = Wa(Qe(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, ms = (e) => Dr(e);
function eh(e, n, r = "validate") {
  if (ms(e) || Array.isArray(e) && e.every(ms) || rr(e) && !e)
    return {
      type: r,
      message: ms(e) ? e : "",
      ref: n
    };
}
var Ii = (e) => dt(e) && !Cs(e) ? e : {
  value: e,
  message: ""
}, nh = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: S, valueAsNumber: N, mount: F } = e._f, y = Qe(r, S);
  if (!F || n.has(S))
    return {};
  const M = l ? l[0] : s, T = (z) => {
    a && M.reportValidity && (M.setCustomValidity(rr(z) ? "" : z || ""), M.reportValidity());
  }, E = {}, D = sp(s), B = xo(s), ee = D || B, X = (N || op(s)) && ot(s.value) && ot(y) || js(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = tC.bind(null, S, i, E), Q = (z, O, q, Z = zr.maxLength, ve = zr.minLength) => {
    const ce = z ? O : q;
    E[S] = {
      type: z ? Z : ve,
      message: ce,
      ref: s,
      ...ae(z ? Z : ve, ce)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!ee && (X || Bt(y)) || rr(y) && !y || B && !Px(l).isValid || D && !Vx(l).isValid)) {
    const { value: z, message: O } = ms(d) ? { value: !!d, message: d } : Ii(d);
    if (z && (E[S] = {
      type: zr.required,
      message: O,
      ref: M,
      ...ae(zr.required, O)
    }, !i))
      return T(O), E;
  }
  if (!X && (!Bt(f) || !Bt(h))) {
    let z, O;
    const q = Ii(h), Z = Ii(f);
    if (!Bt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Bt(q.value) || (z = ve > q.value), Bt(Z.value) || (O = ve < Z.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ce = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), le = s.type == "time", me = s.type == "week";
      Dr(q.value) && y && (z = le ? ce(y) > ce(q.value) : me ? y > q.value : ve > new Date(q.value)), Dr(Z.value) && y && (O = le ? ce(y) < ce(Z.value) : me ? y < Z.value : ve < new Date(Z.value));
    }
    if ((z || O) && (Q(!!z, q.message, Z.message, zr.max, zr.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !X && (Dr(y) || o && Array.isArray(y))) {
    const z = Ii(m), O = Ii(u), q = !Bt(z.value) && y.length > +z.value, Z = !Bt(O.value) && y.length < +O.value;
    if ((q || Z) && (Q(q, z.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !X && Dr(y)) {
    const { value: z, message: O } = Ii(v);
    if (Cs(z) && !y.match(z) && (E[S] = {
      type: zr.pattern,
      message: O,
      ref: s,
      ...ae(zr.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (C) {
    if (kr(C)) {
      const z = await C(y, r), O = eh(z, M);
      if (O && (E[S] = {
        ...O,
        ...ae(zr.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (dt(C)) {
      let z = {};
      for (const O in C) {
        if (!zt(z) && !i)
          break;
        const q = eh(await C[O](y, r), M, O);
        q && (z = {
          ...q,
          ...ae(O, q.message)
        }, T(q.message), i && (E[S] = z));
      }
      if (!zt(z) && (E[S] = {
        ref: M,
        ...z
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const fC = {
  mode: vr.onSubmit,
  reValidateMode: vr.onChange,
  shouldFocusError: !0
};
function hC(e = {}) {
  let n = {
    ...fC,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: kr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = dt(n.defaultValues) || dt(n.values) ? jt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : jt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Hf(),
    state: Hf()
  }, v = Qf(n.mode), C = Qf(n.reValidateMode), S = n.criteriaMode === vr.all, N = (x) => ($) => {
    clearTimeout(m), m = setTimeout(x, $);
  }, F = async (x) => {
    if (!n.disabled && (u.isValid || f.isValid || x)) {
      const $ = n.resolver ? zt((await X()).errors) : await Q(i, !0);
      $ !== r.isValid && h.state.next({
        isValid: $
      });
    }
  }, y = (x, $) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((x || Array.from(l.mount)).forEach((G) => {
      G && ($ ? Gn(r.validatingFields, G, $) : gt(r.validatingFields, G));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !zt(r.validatingFields)
    }));
  }, M = (x, $ = [], G, Y, R = !0, V = !0) => {
    if (Y && G && !n.disabled) {
      if (s.action = !0, V && Array.isArray(Qe(i, x))) {
        const ie = G(Qe(i, x), Y.argA, Y.argB);
        R && Gn(i, x, ie);
      }
      if (V && Array.isArray(Qe(r.errors, x))) {
        const ie = G(Qe(r.errors, x), Y.argA, Y.argB);
        R && Gn(r.errors, x, ie), mC(r.errors, x);
      }
      if ((u.touchedFields || f.touchedFields) && V && Array.isArray(Qe(r.touchedFields, x))) {
        const ie = G(Qe(r.touchedFields, x), Y.argA, Y.argB);
        R && Gn(r.touchedFields, x, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = ua(a, o)), h.state.next({
        name: x,
        isDirty: O(x, $),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, x, $);
  }, T = (x, $) => {
    Gn(r.errors, x, $), h.state.next({
      errors: r.errors
    });
  }, E = (x) => {
    r.errors = x, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (x, $, G, Y) => {
    const R = Qe(i, x);
    if (R) {
      const V = Qe(o, x, ot(G) ? Qe(a, x) : G);
      ot(V) || Y && Y.defaultChecked || $ ? Gn(o, x, $ ? V : Yf(R._f)) : ve(x, V), s.mount && F();
    }
  }, B = (x, $, G, Y, R) => {
    let V = !1, ie = !1;
    const he = {
      name: x
    };
    if (!n.disabled) {
      if (!G || Y) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = he.isDirty = O(), V = ie !== he.isDirty);
        const Ne = ni(Qe(a, x), $);
        ie = !!Qe(r.dirtyFields, x), Ne ? gt(r.dirtyFields, x) : Gn(r.dirtyFields, x, !0), he.dirtyFields = r.dirtyFields, V = V || (u.dirtyFields || f.dirtyFields) && ie !== !Ne;
      }
      if (G) {
        const Ne = Qe(r.touchedFields, x);
        Ne || (Gn(r.touchedFields, x, G), he.touchedFields = r.touchedFields, V = V || (u.touchedFields || f.touchedFields) && Ne !== G);
      }
      V && R && h.state.next(he);
    }
    return V ? he : {};
  }, ee = (x, $, G, Y) => {
    const R = Qe(r.errors, x), V = (u.isValid || f.isValid) && rr($) && r.isValid !== $;
    if (n.delayError && G ? (d = N(() => T(x, G)), d(n.delayError)) : (clearTimeout(m), d = null, G ? Gn(r.errors, x, G) : gt(r.errors, x)), (G ? !ni(R, G) : R) || !zt(Y) || V) {
      const ie = {
        ...Y,
        ...V && rr($) ? { isValid: $ } : {},
        errors: r.errors,
        name: x
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, X = async (x) => {
    y(x, !0);
    const $ = await n.resolver(o, n.context, oC(x || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(x), $;
  }, ae = async (x) => {
    const { errors: $ } = await X(x);
    if (x)
      for (const G of x) {
        const Y = Qe($, G);
        Y ? Gn(r.errors, G, Y) : gt(r.errors, G);
      }
    else
      r.errors = $;
    return $;
  }, Q = async (x, $, G = {
    valid: !0
  }) => {
    for (const Y in x) {
      const R = x[Y];
      if (R) {
        const { _f: V, ...ie } = R;
        if (V) {
          const he = l.array.has(V.name), Ne = R._f && sC(R._f);
          Ne && u.validatingFields && y([Y], !0);
          const nn = await nh(R, l.disabled, o, S, n.shouldUseNativeValidation && !$, he);
          if (Ne && u.validatingFields && y([Y]), nn[V.name] && (G.valid = !1, $))
            break;
          !$ && (Qe(nn, V.name) ? he ? pC(r.errors, nn, V.name) : Gn(r.errors, V.name, nn[V.name]) : gt(r.errors, V.name));
        }
        !zt(ie) && await Q(ie, $, G);
      }
    }
    return G.valid;
  }, z = () => {
    for (const x of l.unMount) {
      const $ = Qe(i, x);
      $ && ($._f.refs ? $._f.refs.every((G) => !wl(G)) : !wl($._f.ref)) && Le(x);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (x, $) => !n.disabled && (x && $ && Gn(o, x, $), !ni(Ee(), a)), q = (x, $, G) => Dx(x, l, {
    ...s.mount ? o : ot($) ? a : Dr(x) ? { [x]: $ } : $
  }, G, $), Z = (x) => Zs(Qe(s.mount ? o : a, x, n.shouldUnregister ? Qe(a, x, []) : [])), ve = (x, $, G = {}) => {
    const Y = Qe(i, x);
    let R = $;
    if (Y) {
      const V = Y._f;
      V && (!V.disabled && Gn(o, x, Lx($, V)), R = js(V.ref) && Bt($) ? "" : $, Rx(V.ref) ? [...V.ref.options].forEach((ie) => ie.selected = R.includes(ie.value)) : V.refs ? xo(V.ref) ? V.refs.length > 1 ? V.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(R) ? !!R.find((he) => he === ie.value) : R === ie.value)) : V.refs[0] && (V.refs[0].checked = !!R) : V.refs.forEach((ie) => ie.checked = ie.value === R) : op(V.ref) ? V.ref.value = "" : (V.ref.value = R, V.ref.type || h.state.next({
        name: x,
        values: jt(o)
      })));
    }
    (G.shouldDirty || G.shouldTouch) && B(x, R, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && _e(x);
  }, ce = (x, $, G) => {
    for (const Y in $) {
      const R = $[Y], V = `${x}.${Y}`, ie = Qe(i, V);
      (l.array.has(x) || dt(R) || ie && !ie._f) && !fi(R) ? ce(V, R, G) : ve(V, R, G);
    }
  }, le = (x, $, G = {}) => {
    const Y = Qe(i, x), R = l.array.has(x), V = jt($);
    Gn(o, x, V), R ? (h.array.next({
      name: x,
      values: jt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && G.shouldDirty && h.state.next({
      name: x,
      dirtyFields: ua(a, o),
      isDirty: O(x, V)
    })) : Y && !Y._f && !Bt(V) ? ce(x, V, G) : ve(x, V, G), Xf(x, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? x : void 0,
      values: jt(o)
    });
  }, me = async (x) => {
    s.mount = !0;
    const $ = x.target;
    let G = $.name, Y = !0;
    const R = Qe(i, G), V = (ie) => {
      Y = Number.isNaN(ie) || fi(ie) && isNaN(ie.getTime()) || ni(ie, Qe(o, G, ie));
    };
    if (R) {
      let ie, he;
      const Ne = $.type ? Yf(R._f) : Fx(x), nn = x.type === Ns.BLUR || x.type === Ns.FOCUS_OUT, mn = !lC(R._f) && !n.resolver && !Qe(r.errors, G) && !R._f.deps || uC(nn, Qe(r.touchedFields, G), r.isSubmitted, C, v), rn = Xf(G, l, nn);
      Gn(o, G, Ne), nn ? (R._f.onBlur && R._f.onBlur(x), d && d(0)) : R._f.onChange && R._f.onChange(x);
      const un = B(G, Ne, nn), fn = !zt(un) || rn;
      if (!nn && h.state.next({
        name: G,
        type: x.type,
        values: jt(o)
      }), mn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? nn && F() : nn || F()), fn && h.state.next({ name: G, ...rn ? {} : un });
      if (!nn && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: cn } = await X([G]);
        if (V(Ne), Y) {
          const xn = Zf(r.errors, i, G), Ze = Zf(cn, i, xn.name || G);
          ie = Ze.error, G = Ze.name, he = zt(cn);
        }
      } else
        y([G], !0), ie = (await nh(R, l.disabled, o, S, n.shouldUseNativeValidation))[G], y([G]), V(Ne), Y && (ie ? he = !1 : (u.isValid || f.isValid) && (he = await Q(i, !0)));
      Y && (R._f.deps && _e(R._f.deps), ee(G, he, ie, un));
    }
  }, H = (x, $) => {
    if (Qe(r.errors, $) && x.focus)
      return x.focus(), 1;
  }, _e = async (x, $ = {}) => {
    let G, Y;
    const R = Wa(x);
    if (n.resolver) {
      const V = await ae(ot(x) ? x : R);
      G = zt(V), Y = x ? !R.some((ie) => Qe(V, ie)) : G;
    } else x ? (Y = (await Promise.all(R.map(async (V) => {
      const ie = Qe(i, V);
      return await Q(ie && ie._f ? { [V]: ie } : ie);
    }))).every(Boolean), !(!Y && !r.isValid) && F()) : Y = G = await Q(i);
    return h.state.next({
      ...!Dr(x) || (u.isValid || f.isValid) && G !== r.isValid ? {} : { name: x },
      ...n.resolver || !x ? { isValid: G } : {},
      errors: r.errors
    }), $.shouldFocus && !Y && Ka(i, H, x ? R : l.mount), Y;
  }, Ee = (x) => {
    const $ = {
      ...s.mount ? o : a
    };
    return ot(x) ? $ : Dr(x) ? Qe($, x) : x.map((G) => Qe($, G));
  }, K = (x, $) => ({
    invalid: !!Qe(($ || r).errors, x),
    isDirty: !!Qe(($ || r).dirtyFields, x),
    error: Qe(($ || r).errors, x),
    isValidating: !!Qe(r.validatingFields, x),
    isTouched: !!Qe(($ || r).touchedFields, x)
  }), qe = (x) => {
    x && Wa(x).forEach(($) => gt(r.errors, $)), h.state.next({
      errors: x ? r.errors : {}
    });
  }, Be = (x, $, G) => {
    const Y = (Qe(i, x, { _f: {} })._f || {}).ref, R = Qe(r.errors, x) || {}, { ref: V, message: ie, type: he, ...Ne } = R;
    Gn(r.errors, x, {
      ...Ne,
      ...$,
      ref: Y
    }), h.state.next({
      name: x,
      errors: r.errors,
      isValid: !1
    }), G && G.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (x, $) => kr(x) ? h.state.subscribe({
    next: (G) => x(q(void 0, $), G)
  }) : q(x, $, !0), Me = (x) => h.state.subscribe({
    next: ($) => {
      dC(x.name, $.name, x.exact) && cC($, x.formState || u, Oe, x.reRenderRoot) && x.callback({
        values: { ...o },
        ...r,
        ...$
      });
    }
  }).unsubscribe, Fe = (x) => (s.mount = !0, f = {
    ...f,
    ...x.formState
  }, Me({
    ...x,
    formState: f
  })), Le = (x, $ = {}) => {
    for (const G of x ? Wa(x) : l.mount)
      l.mount.delete(G), l.array.delete(G), $.keepValue || (gt(i, G), gt(o, G)), !$.keepError && gt(r.errors, G), !$.keepDirty && gt(r.dirtyFields, G), !$.keepTouched && gt(r.touchedFields, G), !$.keepIsValidating && gt(r.validatingFields, G), !n.shouldUnregister && !$.keepDefaultValue && gt(a, G);
    h.state.next({
      values: jt(o)
    }), h.state.next({
      ...r,
      ...$.keepDirty ? { isDirty: O() } : {}
    }), !$.keepIsValid && F();
  }, De = ({ disabled: x, name: $ }) => {
    (rr(x) && s.mount || x || l.disabled.has($)) && (x ? l.disabled.add($) : l.disabled.delete($));
  }, tn = (x, $ = {}) => {
    let G = Qe(i, x);
    const Y = rr($.disabled) || rr(n.disabled);
    return Gn(i, x, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: x } },
        name: x,
        mount: !0,
        ...$
      }
    }), l.mount.add(x), G ? De({
      disabled: rr($.disabled) ? $.disabled : n.disabled,
      name: x
    }) : D(x, !0, $.value), {
      ...Y ? { disabled: $.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!$.required,
        min: ma($.min),
        max: ma($.max),
        minLength: ma($.minLength),
        maxLength: ma($.maxLength),
        pattern: ma($.pattern)
      } : {},
      name: x,
      onChange: me,
      onBlur: me,
      ref: (R) => {
        if (R) {
          tn(x, $), G = Qe(i, x);
          const V = ot(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, ie = rC(V), he = G._f.refs || [];
          if (ie ? he.find((Ne) => Ne === V) : V === G._f.ref)
            return;
          Gn(i, x, {
            _f: {
              ...G._f,
              ...ie ? {
                refs: [
                  ...he.filter(wl),
                  V,
                  ...Array.isArray(Qe(a, x)) ? [{}] : []
                ],
                ref: { type: V.type, name: x }
              } : { ref: V }
            }
          }), D(x, !1, void 0, V);
        } else
          G = Qe(i, x, {}), G._f && (G._f.mount = !1), (n.shouldUnregister || $.shouldUnregister) && !(Ix(l.array, x) && s.action) && l.unMount.add(x);
      }
    };
  }, Ie = () => n.shouldFocusError && Ka(i, H, l.mount), We = (x) => {
    rr(x) && (h.state.next({ disabled: x }), Ka(i, ($, G) => {
      const Y = Qe(i, G);
      Y && ($.disabled = Y._f.disabled || x, Array.isArray(Y._f.refs) && Y._f.refs.forEach((R) => {
        R.disabled = Y._f.disabled || x;
      }));
    }, 0, !1));
  }, en = (x, $) => async (G) => {
    let Y;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let R = jt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: ie } = await X();
      r.errors = V, R = ie;
    } else
      await Q(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        Gn(R, V, void 0);
    if (gt(r.errors, "root"), zt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await x(R, G);
      } catch (V) {
        Y = V;
      }
    } else
      $ && await $({ ...r.errors }, G), Ie(), setTimeout(Ie);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: zt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, ue = (x, $ = {}) => {
    Qe(i, x) && (ot($.defaultValue) ? le(x, jt(Qe(a, x))) : (le(x, $.defaultValue), Gn(a, x, jt($.defaultValue))), $.keepTouched || gt(r.touchedFields, x), $.keepDirty || (gt(r.dirtyFields, x), r.isDirty = $.defaultValue ? O(x, jt(Qe(a, x))) : O()), $.keepError || (gt(r.errors, x), u.isValid && F()), h.state.next({ ...r }));
  }, ye = (x, $ = {}) => {
    const G = x ? jt(x) : a, Y = jt(G), R = zt(x), V = R ? a : Y;
    if ($.keepDefaultValues || (a = G), !$.keepValues) {
      if ($.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(ua(a, o))
        ]);
        for (const he of Array.from(ie))
          Qe(r.dirtyFields, he) ? Gn(V, he, Qe(o, he)) : le(he, Qe(V, he));
      } else {
        if (tp && ot(x))
          for (const ie of l.mount) {
            const he = Qe(i, ie);
            if (he && he._f) {
              const Ne = Array.isArray(he._f.refs) ? he._f.refs[0] : he._f.ref;
              if (js(Ne)) {
                const nn = Ne.closest("form");
                if (nn) {
                  nn.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          le(ie, Qe(V, ie));
      }
      o = jt(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: $.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!$.keepIsValid || !!$.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: $.keepSubmitCount ? r.submitCount : 0,
      isDirty: R ? !1 : $.keepDirty ? r.isDirty : !!($.keepDefaultValues && !ni(x, a)),
      isSubmitted: $.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: R ? {} : $.keepDirtyValues ? $.keepDefaultValues && o ? ua(a, o) : r.dirtyFields : $.keepDefaultValues && x ? ua(a, x) : $.keepDirty ? r.dirtyFields : {},
      touchedFields: $.keepTouched ? r.touchedFields : {},
      errors: $.keepErrors ? r.errors : {},
      isSubmitSuccessful: $.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, $e = (x, $) => ye(kr(x) ? x(o) : x, $), Ve = (x, $ = {}) => {
    const G = Qe(i, x), Y = G && G._f;
    if (Y) {
      const R = Y.refs ? Y.refs[0] : Y.ref;
      R.focus && (R.focus(), $.shouldSelect && kr(R.select) && R.select());
    }
  }, Oe = (x) => {
    r = {
      ...r,
      ...x
    };
  }, w = {
    control: {
      register: tn,
      unregister: Le,
      getFieldState: K,
      handleSubmit: en,
      setError: Be,
      _subscribe: Me,
      _runSchema: X,
      _getWatch: q,
      _getDirty: O,
      _setValid: F,
      _setFieldArray: M,
      _setDisabledField: De,
      _setErrors: E,
      _getFieldArray: Z,
      _reset: ye,
      _resetDefaultValues: () => kr(n.defaultValues) && n.defaultValues().then((x) => {
        $e(x, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: z,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(x) {
        s = x;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(x) {
        l = x;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(x) {
        n = {
          ...n,
          ...x
        };
      }
    },
    subscribe: Fe,
    trigger: _e,
    register: tn,
    handleSubmit: en,
    watch: Pe,
    setValue: le,
    getValues: Ee,
    reset: $e,
    resetField: ue,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ve,
    getFieldState: K
  };
  return {
    ...w,
    formControl: w
  };
}
function Dt(e = {}) {
  const n = we.useRef(void 0), r = we.useRef(void 0), [i, a] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : hC(e),
    formState: i
  }, e.formControl && e.defaultValues && !kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, we.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), we.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), we.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), we.useEffect(() => {
    e.values && !ni(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), we.useEffect(() => {
    e.errors && !zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), we.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), we.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = $x(i, o), n.current;
}
var Do = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function zx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Cl = { exports: {} }, pa = {}, th;
function yC() {
  if (th) return pa;
  th = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return pa.Fragment = r, pa.jsx = s, pa.jsxs = s, pa;
}
var Ro = {}, rh;
function gC() {
  return rh || (rh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ro.Fragment = i, Ro.jsx = Rn, Ro.jsxs = Mn;
  })()), Ro;
}
var ih;
function vC() {
  return ih || (ih = 1, process.env.NODE_ENV === "production" ? Cl.exports = yC() : Cl.exports = gC()), Cl.exports;
}
var ki = vC();
function kC(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Fl, ah;
function ii() {
  if (ah) return Fl;
  ah = 1;
  var e = Array.isArray;
  return Fl = e, Fl;
}
var Il, oh;
function Ux() {
  if (oh) return Il;
  oh = 1;
  var e = typeof Do == "object" && Do && Do.Object === Object && Do;
  return Il = e, Il;
}
var El, sh;
function Lr() {
  if (sh) return El;
  sh = 1;
  var e = Ux(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return El = r, El;
}
var Tl, lh;
function _o() {
  if (lh) return Tl;
  lh = 1;
  var e = Lr(), n = e.Symbol;
  return Tl = n, Tl;
}
var $l, ch;
function bC() {
  if (ch) return $l;
  ch = 1;
  var e = _o(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return $l = o, $l;
}
var Dl, dh;
function xC() {
  if (dh) return Dl;
  dh = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Dl = r, Dl;
}
var Rl, uh;
function ea() {
  if (uh) return Rl;
  uh = 1;
  var e = _o(), n = bC(), r = xC(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Rl = s, Rl;
}
var Ol, mh;
function Ni() {
  if (mh) return Ol;
  mh = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Ol = e, Ol;
}
var Al, ph;
function lp() {
  if (ph) return Al;
  ph = 1;
  var e = ea(), n = Ni(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Al = i, Al;
}
var Pl, fh;
function _C() {
  if (fh) return Pl;
  fh = 1;
  var e = ii(), n = lp(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Pl = a, Pl;
}
var Ll, hh;
function na() {
  if (hh) return Ll;
  hh = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Ll = e, Ll;
}
var Vl, yh;
function Mx() {
  if (yh) return Vl;
  yh = 1;
  var e = ea(), n = na(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Vl = s, Vl;
}
var zl, gh;
function SC() {
  if (gh) return zl;
  gh = 1;
  var e = Lr(), n = e["__core-js_shared__"];
  return zl = n, zl;
}
var Ul, vh;
function NC() {
  if (vh) return Ul;
  vh = 1;
  var e = SC(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Ul = r, Ul;
}
var Ml, kh;
function Bx() {
  if (kh) return Ml;
  kh = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Ml = r, Ml;
}
var Bl, bh;
function jC() {
  if (bh) return Bl;
  bh = 1;
  var e = Mx(), n = NC(), r = na(), i = Bx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return Bl = f, Bl;
}
var ql, xh;
function wC() {
  if (xh) return ql;
  xh = 1;
  function e(n, r) {
    return n?.[r];
  }
  return ql = e, ql;
}
var Hl, _h;
function ji() {
  if (_h) return Hl;
  _h = 1;
  var e = jC(), n = wC();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Hl = r, Hl;
}
var Wl, Sh;
function el() {
  if (Sh) return Wl;
  Sh = 1;
  var e = ji(), n = e(Object, "create");
  return Wl = n, Wl;
}
var Kl, Nh;
function CC() {
  if (Nh) return Kl;
  Nh = 1;
  var e = el();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Kl = n, Kl;
}
var Gl, jh;
function FC() {
  if (jh) return Gl;
  jh = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Gl = e, Gl;
}
var Yl, wh;
function IC() {
  if (wh) return Yl;
  wh = 1;
  var e = el(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Yl = a, Yl;
}
var Ql, Ch;
function EC() {
  if (Ch) return Ql;
  Ch = 1;
  var e = el(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Ql = i, Ql;
}
var Jl, Fh;
function TC() {
  if (Fh) return Jl;
  Fh = 1;
  var e = el(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Jl = r, Jl;
}
var Xl, Ih;
function $C() {
  if (Ih) return Xl;
  Ih = 1;
  var e = CC(), n = FC(), r = IC(), i = EC(), a = TC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Xl = o, Xl;
}
var Zl, Eh;
function DC() {
  if (Eh) return Zl;
  Eh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Zl = e, Zl;
}
var ec, Th;
function qx() {
  if (Th) return ec;
  Th = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return ec = e, ec;
}
var nc, $h;
function nl() {
  if ($h) return nc;
  $h = 1;
  var e = qx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return nc = n, nc;
}
var tc, Dh;
function RC() {
  if (Dh) return tc;
  Dh = 1;
  var e = nl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return tc = i, tc;
}
var rc, Rh;
function OC() {
  if (Rh) return rc;
  Rh = 1;
  var e = nl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return rc = n, rc;
}
var ic, Oh;
function AC() {
  if (Oh) return ic;
  Oh = 1;
  var e = nl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return ic = n, ic;
}
var ac, Ah;
function PC() {
  if (Ah) return ac;
  Ah = 1;
  var e = nl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return ac = n, ac;
}
var oc, Ph;
function tl() {
  if (Ph) return oc;
  Ph = 1;
  var e = DC(), n = RC(), r = OC(), i = AC(), a = PC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, oc = o, oc;
}
var sc, Lh;
function cp() {
  if (Lh) return sc;
  Lh = 1;
  var e = ji(), n = Lr(), r = e(n, "Map");
  return sc = r, sc;
}
var lc, Vh;
function LC() {
  if (Vh) return lc;
  Vh = 1;
  var e = $C(), n = tl(), r = cp();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return lc = i, lc;
}
var cc, zh;
function VC() {
  if (zh) return cc;
  zh = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return cc = e, cc;
}
var dc, Uh;
function rl() {
  if (Uh) return dc;
  Uh = 1;
  var e = VC();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return dc = n, dc;
}
var uc, Mh;
function zC() {
  if (Mh) return uc;
  Mh = 1;
  var e = rl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return uc = n, uc;
}
var mc, Bh;
function UC() {
  if (Bh) return mc;
  Bh = 1;
  var e = rl();
  function n(r) {
    return e(this, r).get(r);
  }
  return mc = n, mc;
}
var pc, qh;
function MC() {
  if (qh) return pc;
  qh = 1;
  var e = rl();
  function n(r) {
    return e(this, r).has(r);
  }
  return pc = n, pc;
}
var fc, Hh;
function BC() {
  if (Hh) return fc;
  Hh = 1;
  var e = rl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return fc = n, fc;
}
var hc, Wh;
function Hx() {
  if (Wh) return hc;
  Wh = 1;
  var e = LC(), n = zC(), r = UC(), i = MC(), a = BC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, hc = o, hc;
}
var yc, Kh;
function qC() {
  if (Kh) return yc;
  Kh = 1;
  var e = Hx(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, yc = r, yc;
}
var gc, Gh;
function HC() {
  if (Gh) return gc;
  Gh = 1;
  var e = qC(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return gc = r, gc;
}
var vc, Yh;
function WC() {
  if (Yh) return vc;
  Yh = 1;
  var e = HC(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return vc = i, vc;
}
var kc, Qh;
function Wx() {
  if (Qh) return kc;
  Qh = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return kc = e, kc;
}
var bc, Jh;
function KC() {
  if (Jh) return bc;
  Jh = 1;
  var e = _o(), n = Wx(), r = ii(), i = lp(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return bc = s, bc;
}
var xc, Xh;
function GC() {
  if (Xh) return xc;
  Xh = 1;
  var e = KC();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return xc = n, xc;
}
var _c, Zh;
function ta() {
  if (Zh) return _c;
  Zh = 1;
  var e = ii(), n = _C(), r = WC(), i = GC();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return _c = a, _c;
}
var Sc, ey;
function il() {
  if (ey) return Sc;
  ey = 1;
  var e = lp();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Sc = n, Sc;
}
var Nc, ny;
function Kx() {
  if (ny) return Nc;
  ny = 1;
  var e = ta(), n = il();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Nc = r, Nc;
}
var jc, ty;
function Gx() {
  if (ty) return jc;
  ty = 1;
  var e = ji(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return jc = n, jc;
}
var wc, ry;
function Yx() {
  if (ry) return wc;
  ry = 1;
  var e = Gx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return wc = n, wc;
}
var Cc, iy;
function dp() {
  if (iy) return Cc;
  iy = 1;
  var e = Yx(), n = qx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Cc = a, Cc;
}
var Fc, ay;
function up() {
  if (ay) return Fc;
  ay = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Fc = r, Fc;
}
var Ic, oy;
function YC() {
  if (oy) return Ic;
  oy = 1;
  var e = dp(), n = ta(), r = up(), i = na(), a = il();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var C = a(l[u]), S = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var N = v[C];
        S = m ? m(N, C, v) : void 0, S === void 0 && (S = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(v, C, S), v = v[C];
    }
    return s;
  }
  return Ic = o, Ic;
}
var Ec, sy;
function QC() {
  if (sy) return Ec;
  sy = 1;
  var e = Kx(), n = YC(), r = ta();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Ec = i, Ec;
}
var Tc, ly;
function JC() {
  if (ly) return Tc;
  ly = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Tc = e, Tc;
}
var $c, cy;
function XC() {
  if (cy) return $c;
  cy = 1;
  var e = ea(), n = Ni(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return $c = i, $c;
}
var Dc, dy;
function mp() {
  if (dy) return Dc;
  dy = 1;
  var e = XC(), n = Ni(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Dc = o, Dc;
}
var Rc, uy;
function pp() {
  if (uy) return Rc;
  uy = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Rc = n, Rc;
}
var Oc, my;
function ZC() {
  if (my) return Oc;
  my = 1;
  var e = ta(), n = mp(), r = ii(), i = up(), a = pp(), o = il();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Oc = s, Oc;
}
var Ac, py;
function e1() {
  if (py) return Ac;
  py = 1;
  var e = JC(), n = ZC();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Ac = r, Ac;
}
var Pc, fy;
function n1() {
  if (fy) return Pc;
  fy = 1;
  var e = QC(), n = e1();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Pc = r, Pc;
}
var Lc, hy;
function fp() {
  if (hy) return Lc;
  hy = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Lc = e, Lc;
}
var Vc, yy;
function t1() {
  if (yy) return Vc;
  yy = 1;
  var e = _o(), n = mp(), r = ii(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Vc = a, Vc;
}
var zc, gy;
function r1() {
  if (gy) return zc;
  gy = 1;
  var e = fp(), n = t1();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return zc = r, zc;
}
var Uc, vy;
function i1() {
  if (vy) return Uc;
  vy = 1;
  var e = r1();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Uc = n, Uc;
}
var Mc, ky;
function a1() {
  if (ky) return Mc;
  ky = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Mc = e, Mc;
}
var Bc, by;
function o1() {
  if (by) return Bc;
  by = 1;
  var e = a1(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Bc = r, Bc;
}
var qc, xy;
function s1() {
  if (xy) return qc;
  xy = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return qc = e, qc;
}
var Hc, _y;
function Qx() {
  if (_y) return Hc;
  _y = 1;
  function e(n) {
    return n;
  }
  return Hc = e, Hc;
}
var Wc, Sy;
function l1() {
  if (Sy) return Wc;
  Sy = 1;
  var e = s1(), n = Gx(), r = Qx(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Wc = i, Wc;
}
var Kc, Ny;
function c1() {
  if (Ny) return Kc;
  Ny = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Kc = i, Kc;
}
var Gc, jy;
function d1() {
  if (jy) return Gc;
  jy = 1;
  var e = l1(), n = c1(), r = n(e);
  return Gc = r, Gc;
}
var Yc, wy;
function Jx() {
  if (wy) return Yc;
  wy = 1;
  var e = i1(), n = o1(), r = d1();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Yc = i, Yc;
}
var Qc, Cy;
function u1() {
  if (Cy) return Qc;
  Cy = 1;
  var e = n1(), n = Jx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Qc = r, Qc;
}
var m1 = u1();
const Xx = /* @__PURE__ */ zx(m1), p1 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function Zx(e) {
  const n = Xx(e, p1);
  return {
    controller: ap(n),
    controllerProps: n
  };
}
const f1 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function e_(e) {
  const { controller: n, controllerProps: r } = Zx(e), i = {
    ...Xx(e, f1),
    required: kC(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Jc, Fy;
function h1() {
  if (Fy) return Jc;
  Fy = 1;
  var e = tl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Jc = n, Jc;
}
var Xc, Iy;
function y1() {
  if (Iy) return Xc;
  Iy = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Xc = e, Xc;
}
var Zc, Ey;
function g1() {
  if (Ey) return Zc;
  Ey = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Zc = e, Zc;
}
var ed, Ty;
function v1() {
  if (Ty) return ed;
  Ty = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return ed = e, ed;
}
var nd, $y;
function k1() {
  if ($y) return nd;
  $y = 1;
  var e = tl(), n = cp(), r = Hx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return nd = a, nd;
}
var td, Dy;
function b1() {
  if (Dy) return td;
  Dy = 1;
  var e = tl(), n = h1(), r = y1(), i = g1(), a = v1(), o = k1();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, td = s, td;
}
var rd, Ry;
function x1() {
  if (Ry) return rd;
  Ry = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return rd = e, rd;
}
var id, Oy;
function So() {
  if (Oy) return id;
  Oy = 1;
  var e = dp(), n = Yx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return id = r, id;
}
var ad, Ay;
function _1() {
  if (Ay) return ad;
  Ay = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return ad = e, ad;
}
var ps = { exports: {} }, od, Py;
function S1() {
  if (Py) return od;
  Py = 1;
  function e() {
    return !1;
  }
  return od = e, od;
}
ps.exports;
var Ly;
function n_() {
  return Ly || (Ly = 1, (function(e, n) {
    var r = Lr(), i = S1(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(ps, ps.exports)), ps.exports;
}
var sd, Vy;
function N1() {
  if (Vy) return sd;
  Vy = 1;
  var e = ea(), n = pp(), r = Ni(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", C = "[object String]", S = "[object WeakMap]", N = "[object ArrayBuffer]", F = "[object DataView]", y = "[object Float32Array]", M = "[object Float64Array]", T = "[object Int8Array]", E = "[object Int16Array]", D = "[object Int32Array]", B = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", X = "[object Uint16Array]", ae = "[object Uint32Array]", Q = {};
  Q[y] = Q[M] = Q[T] = Q[E] = Q[D] = Q[B] = Q[ee] = Q[X] = Q[ae] = !0, Q[i] = Q[a] = Q[N] = Q[o] = Q[F] = Q[s] = Q[l] = Q[d] = Q[m] = Q[u] = Q[f] = Q[h] = Q[v] = Q[C] = Q[S] = !1;
  function z(O) {
    return r(O) && n(O.length) && !!Q[e(O)];
  }
  return sd = z, sd;
}
var ld, zy;
function hp() {
  if (zy) return ld;
  zy = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return ld = e, ld;
}
var fs = { exports: {} };
fs.exports;
var Uy;
function yp() {
  return Uy || (Uy = 1, (function(e, n) {
    var r = Ux(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(fs, fs.exports)), fs.exports;
}
var cd, My;
function j1() {
  if (My) return cd;
  My = 1;
  var e = N1(), n = hp(), r = yp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return cd = a, cd;
}
var dd, By;
function t_() {
  if (By) return dd;
  By = 1;
  var e = _1(), n = mp(), r = ii(), i = n_(), a = up(), o = j1(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), C = !f && !h && !v && o(m), S = f || h || v || C, N = S ? e(m.length, String) : [], F = N.length;
    for (var y in m)
      (u || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, F))) && N.push(y);
    return N;
  }
  return dd = d, dd;
}
var ud, qy;
function gp() {
  if (qy) return ud;
  qy = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return ud = n, ud;
}
var md, Hy;
function r_() {
  if (Hy) return md;
  Hy = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return md = e, md;
}
var pd, Wy;
function w1() {
  if (Wy) return pd;
  Wy = 1;
  var e = r_(), n = e(Object.keys, Object);
  return pd = n, pd;
}
var fd, Ky;
function C1() {
  if (Ky) return fd;
  Ky = 1;
  var e = gp(), n = w1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return fd = a, fd;
}
var hd, Gy;
function i_() {
  if (Gy) return hd;
  Gy = 1;
  var e = Mx(), n = pp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return hd = r, hd;
}
var yd, Yy;
function vp() {
  if (Yy) return yd;
  Yy = 1;
  var e = t_(), n = C1(), r = i_();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return yd = i, yd;
}
var gd, Qy;
function F1() {
  if (Qy) return gd;
  Qy = 1;
  var e = So(), n = vp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return gd = r, gd;
}
var vd, Jy;
function I1() {
  if (Jy) return vd;
  Jy = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return vd = e, vd;
}
var kd, Xy;
function E1() {
  if (Xy) return kd;
  Xy = 1;
  var e = na(), n = gp(), r = I1(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return kd = o, kd;
}
var bd, Zy;
function kp() {
  if (Zy) return bd;
  Zy = 1;
  var e = t_(), n = E1(), r = i_();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return bd = i, bd;
}
var xd, eg;
function T1() {
  if (eg) return xd;
  eg = 1;
  var e = So(), n = kp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return xd = r, xd;
}
var hs = { exports: {} };
hs.exports;
var ng;
function $1() {
  return ng || (ng = 1, (function(e, n) {
    var r = Lr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(hs, hs.exports)), hs.exports;
}
var _d, tg;
function D1() {
  if (tg) return _d;
  tg = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return _d = e, _d;
}
var Sd, rg;
function R1() {
  if (rg) return Sd;
  rg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Sd = e, Sd;
}
var Nd, ig;
function a_() {
  if (ig) return Nd;
  ig = 1;
  function e() {
    return [];
  }
  return Nd = e, Nd;
}
var jd, ag;
function bp() {
  if (ag) return jd;
  ag = 1;
  var e = R1(), n = a_(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return jd = o, jd;
}
var wd, og;
function O1() {
  if (og) return wd;
  og = 1;
  var e = So(), n = bp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return wd = r, wd;
}
var Cd, sg;
function xp() {
  if (sg) return Cd;
  sg = 1;
  var e = r_(), n = e(Object.getPrototypeOf, Object);
  return Cd = n, Cd;
}
var Fd, lg;
function o_() {
  if (lg) return Fd;
  lg = 1;
  var e = fp(), n = xp(), r = bp(), i = a_(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Fd = o, Fd;
}
var Id, cg;
function A1() {
  if (cg) return Id;
  cg = 1;
  var e = So(), n = o_();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Id = r, Id;
}
var Ed, dg;
function s_() {
  if (dg) return Ed;
  dg = 1;
  var e = fp(), n = ii();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Ed = r, Ed;
}
var Td, ug;
function P1() {
  if (ug) return Td;
  ug = 1;
  var e = s_(), n = bp(), r = vp();
  function i(a) {
    return e(a, r, n);
  }
  return Td = i, Td;
}
var $d, mg;
function l_() {
  if (mg) return $d;
  mg = 1;
  var e = s_(), n = o_(), r = kp();
  function i(a) {
    return e(a, r, n);
  }
  return $d = i, $d;
}
var Dd, pg;
function L1() {
  if (pg) return Dd;
  pg = 1;
  var e = ji(), n = Lr(), r = e(n, "DataView");
  return Dd = r, Dd;
}
var Rd, fg;
function V1() {
  if (fg) return Rd;
  fg = 1;
  var e = ji(), n = Lr(), r = e(n, "Promise");
  return Rd = r, Rd;
}
var Od, hg;
function z1() {
  if (hg) return Od;
  hg = 1;
  var e = ji(), n = Lr(), r = e(n, "Set");
  return Od = r, Od;
}
var Ad, yg;
function U1() {
  if (yg) return Ad;
  yg = 1;
  var e = ji(), n = Lr(), r = e(n, "WeakMap");
  return Ad = r, Ad;
}
var Pd, gg;
function _p() {
  if (gg) return Pd;
  gg = 1;
  var e = L1(), n = cp(), r = V1(), i = z1(), a = U1(), o = ea(), s = Bx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), C = s(n), S = s(r), N = s(i), F = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(M) {
    var T = o(M), E = T == d ? M.constructor : void 0, D = E ? s(E) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case C:
          return l;
        case S:
          return m;
        case N:
          return u;
        case F:
          return f;
      }
    return T;
  }), Pd = y, Pd;
}
var Ld, vg;
function M1() {
  if (vg) return Ld;
  vg = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Ld = r, Ld;
}
var Vd, kg;
function B1() {
  if (kg) return Vd;
  kg = 1;
  var e = Lr(), n = e.Uint8Array;
  return Vd = n, Vd;
}
var zd, bg;
function Sp() {
  if (bg) return zd;
  bg = 1;
  var e = B1();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return zd = n, zd;
}
var Ud, xg;
function q1() {
  if (xg) return Ud;
  xg = 1;
  var e = Sp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Ud = n, Ud;
}
var Md, _g;
function H1() {
  if (_g) return Md;
  _g = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Md = n, Md;
}
var Bd, Sg;
function W1() {
  if (Sg) return Bd;
  Sg = 1;
  var e = _o(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Bd = i, Bd;
}
var qd, Ng;
function K1() {
  if (Ng) return qd;
  Ng = 1;
  var e = Sp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return qd = n, qd;
}
var Hd, jg;
function G1() {
  if (jg) return Hd;
  jg = 1;
  var e = Sp(), n = q1(), r = H1(), i = W1(), a = K1(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", C = "[object DataView]", S = "[object Float32Array]", N = "[object Float64Array]", F = "[object Int8Array]", y = "[object Int16Array]", M = "[object Int32Array]", T = "[object Uint8Array]", E = "[object Uint8ClampedArray]", D = "[object Uint16Array]", B = "[object Uint32Array]";
  function ee(X, ae, Q) {
    var z = X.constructor;
    switch (ae) {
      case v:
        return e(X);
      case o:
      case s:
        return new z(+X);
      case C:
        return n(X, Q);
      case S:
      case N:
      case F:
      case y:
      case M:
      case T:
      case E:
      case D:
      case B:
        return a(X, Q);
      case l:
        return new z();
      case d:
      case f:
        return new z(X);
      case m:
        return r(X);
      case u:
        return new z();
      case h:
        return i(X);
    }
  }
  return Hd = ee, Hd;
}
var Wd, wg;
function Y1() {
  if (wg) return Wd;
  wg = 1;
  var e = na(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Wd = r, Wd;
}
var Kd, Cg;
function Q1() {
  if (Cg) return Kd;
  Cg = 1;
  var e = Y1(), n = xp(), r = gp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Kd = i, Kd;
}
var Gd, Fg;
function J1() {
  if (Fg) return Gd;
  Fg = 1;
  var e = _p(), n = Ni(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Gd = i, Gd;
}
var Yd, Ig;
function X1() {
  if (Ig) return Yd;
  Ig = 1;
  var e = J1(), n = hp(), r = yp(), i = r && r.isMap, a = i ? n(i) : e;
  return Yd = a, Yd;
}
var Qd, Eg;
function Z1() {
  if (Eg) return Qd;
  Eg = 1;
  var e = _p(), n = Ni(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Qd = i, Qd;
}
var Jd, Tg;
function eF() {
  if (Tg) return Jd;
  Tg = 1;
  var e = Z1(), n = hp(), r = yp(), i = r && r.isSet, a = i ? n(i) : e;
  return Jd = a, Jd;
}
var Xd, $g;
function nF() {
  if ($g) return Xd;
  $g = 1;
  var e = b1(), n = x1(), r = dp(), i = F1(), a = T1(), o = $1(), s = D1(), l = O1(), d = A1(), m = P1(), u = l_(), f = _p(), h = M1(), v = G1(), C = Q1(), S = ii(), N = n_(), F = X1(), y = na(), M = eF(), T = vp(), E = kp(), D = 1, B = 2, ee = 4, X = "[object Arguments]", ae = "[object Array]", Q = "[object Boolean]", z = "[object Date]", O = "[object Error]", q = "[object Function]", Z = "[object GeneratorFunction]", ve = "[object Map]", ce = "[object Number]", le = "[object Object]", me = "[object RegExp]", H = "[object Set]", _e = "[object String]", Ee = "[object Symbol]", K = "[object WeakMap]", qe = "[object ArrayBuffer]", Be = "[object DataView]", Pe = "[object Float32Array]", Me = "[object Float64Array]", Fe = "[object Int8Array]", Le = "[object Int16Array]", De = "[object Int32Array]", tn = "[object Uint8Array]", Ie = "[object Uint8ClampedArray]", We = "[object Uint16Array]", en = "[object Uint32Array]", ue = {};
  ue[X] = ue[ae] = ue[qe] = ue[Be] = ue[Q] = ue[z] = ue[Pe] = ue[Me] = ue[Fe] = ue[Le] = ue[De] = ue[ve] = ue[ce] = ue[le] = ue[me] = ue[H] = ue[_e] = ue[Ee] = ue[tn] = ue[Ie] = ue[We] = ue[en] = !0, ue[O] = ue[q] = ue[K] = !1;
  function ye($e, Ve, Oe, ln, w, x) {
    var $, G = Ve & D, Y = Ve & B, R = Ve & ee;
    if (Oe && ($ = w ? Oe($e, ln, w, x) : Oe($e)), $ !== void 0)
      return $;
    if (!y($e))
      return $e;
    var V = S($e);
    if (V) {
      if ($ = h($e), !G)
        return s($e, $);
    } else {
      var ie = f($e), he = ie == q || ie == Z;
      if (N($e))
        return o($e, G);
      if (ie == le || ie == X || he && !w) {
        if ($ = Y || he ? {} : C($e), !G)
          return Y ? d($e, a($, $e)) : l($e, i($, $e));
      } else {
        if (!ue[ie])
          return w ? $e : {};
        $ = v($e, ie, G);
      }
    }
    x || (x = new e());
    var Ne = x.get($e);
    if (Ne)
      return Ne;
    x.set($e, $), M($e) ? $e.forEach(function(rn) {
      $.add(ye(rn, Ve, Oe, rn, $e, x));
    }) : F($e) && $e.forEach(function(rn, un) {
      $.set(un, ye(rn, Ve, Oe, un, $e, x));
    });
    var nn = R ? Y ? u : m : Y ? E : T, mn = V ? void 0 : nn($e);
    return n(mn || $e, function(rn, un) {
      mn && (un = rn, rn = $e[un]), r($, un, ye(rn, Ve, Oe, un, $e, x));
    }), $;
  }
  return Xd = ye, Xd;
}
var Zd, Dg;
function tF() {
  if (Dg) return Zd;
  Dg = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Zd = e, Zd;
}
var eu, Rg;
function rF() {
  if (Rg) return eu;
  Rg = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return eu = e, eu;
}
var nu, Og;
function iF() {
  if (Og) return nu;
  Og = 1;
  var e = Kx(), n = rF();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return nu = r, nu;
}
var tu, Ag;
function aF() {
  if (Ag) return tu;
  Ag = 1;
  var e = ta(), n = tF(), r = iF(), i = il(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return tu = s, tu;
}
var ru, Pg;
function oF() {
  if (Pg) return ru;
  Pg = 1;
  var e = ea(), n = xp(), r = Ni(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return ru = m, ru;
}
var iu, Lg;
function sF() {
  if (Lg) return iu;
  Lg = 1;
  var e = oF();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return iu = n, iu;
}
var au, Vg;
function lF() {
  if (Vg) return au;
  Vg = 1;
  var e = Wx(), n = nF(), r = aF(), i = ta(), a = So(), o = sF(), s = Jx(), l = l_(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var C = {};
    if (h == null)
      return C;
    var S = !1;
    v = e(v, function(F) {
      return F = i(F, h), S || (S = F.length > 1), F;
    }), a(h, l(h), C), S && (C = n(C, d | m | u, o));
    for (var N = v.length; N--; )
      r(C, v[N]);
    return C;
  });
  return au = f, au;
}
lF();
const jr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = e_(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ ki.jsx(bn, { ...a, children: /* @__PURE__ */ ki.jsx(
    ei,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: bn.getStatus(a.meta),
      children: e
    }
  ) });
};
var cF = Qx();
const dF = /* @__PURE__ */ zx(cF), Ft = ({
  transformValue: e = dF,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = Zx(a);
  return /* @__PURE__ */ ki.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ ki.jsx(
      tm,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ ki.jsx(b0, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, tt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = e_(e);
  return /* @__PURE__ */ ki.jsx(bn, { ...i, children: /* @__PURE__ */ ki.jsx(
    Nr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: bn.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ou = { exports: {} }, fa = {}, zg;
function uF() {
  if (zg) return fa;
  zg = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return fa.Fragment = r, fa.jsx = s, fa.jsxs = s, fa;
}
var Oo = {}, Ug;
function mF() {
  return Ug || (Ug = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Oo.Fragment = i, Oo.jsx = Rn, Oo.jsxs = Mn;
  })()), Oo;
}
var Mg;
function pF() {
  return Mg || (Mg = 1, process.env.NODE_ENV === "production" ? ou.exports = uF() : ou.exports = mF()), ou.exports;
}
var pe = pF();
const fF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, hF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, yF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, gF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, vF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, kF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, bF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, xF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, _F = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": yF,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": gF,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": vF,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": fF,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": hF,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": kF,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": bF,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": xF
};
function ra(e) {
  return _F[e] ?? {};
}
const SF = ra(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), NF = ra(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), jF = ra(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Bg = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, dr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, wF = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), qg = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, um = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ pe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ pe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ pe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ pe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ pe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ pe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ pe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ pe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ pe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ pe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ pe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ pe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function CF({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: C, executeQuery: S } = pn(), { track: N } = _n(), {
    loading: F,
    data: y,
    error: M,
    store: T
  } = Vm(e ?? null), E = y?.github?.issues || [], D = y?.github?.pullRequests || [], [B, ee] = se(!1), [X, ae] = se();
  He(
    () => h(M || X || void 0),
    [M, X]
  ), He(
    () => {
      !F && (E?.length || D?.length) ? (a(E), s(D), z(E, D)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const Q = async (me, H) => {
    await T(me).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: H.success.title,
        text: H.success.text
      });
    }).catch((_e) => {
      v({
        title: H.error.title,
        text: `${H.error.text} ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, z = (me, H) => {
    if (!me?.length && !H?.length) {
      d([]), u([]);
      return;
    }
    const _e = (me || []).map(
      (qe) => S(NF, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), Ee = (H || []).map(
      (qe) => S(jF, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), K = [..._e, ...Ee];
    ee(!0), Promise.all(K).then((qe) => {
      const Be = [], Pe = [];
      qe.forEach((Me) => {
        const Fe = Me?.data?.GitHub;
        if (!Fe) {
          d([]), u([]);
          return;
        }
        Object.keys(Fe).forEach((Le) => {
          if (Le.startsWith("repository")) {
            const De = Fe[Le];
            Object.keys(De).forEach((tn) => {
              const Ie = De[tn], We = {
                number: Ie?.number,
                owner: Ie?.repository?.owner?.login,
                repository: Ie?.repository?.name
              };
              tn.startsWith("issue") && Be.push({
                ...Ie,
                type: "ISSUE",
                key: We
              }), tn.startsWith("pullRequest") && Pe.push({
                ...Ie,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), d(Be), u(Pe);
    }).catch(ae).finally(() => {
      ee(!1);
    });
  }, O = ({ key: me, type: H }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = y && (E.length || D.length) ? y : r, Ee = H === "ISSUE" ? "issues" : "pullRequests";
    _e.github[Ee] = Array.from(
      new Set(_e.github[Ee]).add(me)
    ), Q(_e, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${dr(
          me
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${dr(me)} failed. Please try again.`
      }
    });
  }, q = async ({ key: me, type: H }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = y && (E.length || D.length) ? y : r, Ee = H === "ISSUE" ? "issues" : "pullRequests";
    _e.github[Ee] = Array.from(
      new Set(_e.github[Ee]).add(me)
    ), await T(_e).catch((K) => {
      v({
        title: "Linking failed",
        text: `Linking ${me} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Z = ({ key: me, type: H }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const _e = H === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${_e} ${dr(me)}?`,
      text: `You are about to unlink the ${_e} ${dr(
        me
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${_e}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ee = H === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Ee]: y?.github?.[Ee].filter(
              (qe) => qe.number !== me.number || qe.owner !== me.owner || qe.repository !== me.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), Q(K, {
          success: {
            title: `GitHub ${_e} unlinked`,
            text: `You unlinked the GitHub ${_e} ${dr(
              me
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${dr(me)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), Q(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ce = E.filter(
    (me) => !i?.includes(me)
  ) || [], le = D.filter(
    (me) => !o?.includes(me)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: q,
    unlinkGithubItem: Z,
    loadGithubItems: z,
    removeDanglingGithubItemLinks: () => {
      const me = {
        ...y,
        github: {
          ...y?.github,
          issues: E.filter(
            (H) => !ce.includes(H)
          ) || [],
          pullRequests: D.filter(
            (H) => !le.includes(H)
          ) || []
        }
      };
      T(me);
    },
    unlinkAllGithubItems: ve,
    isLoadingGithubItemLinks: F,
    danglingIssueLinks: ce,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: B,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const FF = "_contentWrapper_1vx3c_1", IF = "_contentWrapperHeadline_1vx3c_4", EF = "_contentWrapperBody_1vx3c_11", TF = "_contentWrapperAssigneeIcon_1vx3c_15", $F = "_contentWrapperStatusTag_1vx3c_20", Ur = {
  contentWrapper: FF,
  contentWrapperHeadline: IF,
  contentWrapperBody: EF,
  contentWrapperAssigneeIcon: TF,
  contentWrapperStatusTag: $F
}, c_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
  e && /* @__PURE__ */ pe.jsxs(Zn, { className: Ur.contentWrapper, children: [
    /* @__PURE__ */ pe.jsx(Zn, { className: Ur.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ pe.jsx(Zn, { className: Ur.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ pe.jsxs(Zn, { className: Ur.contentWrapper, children: [
    /* @__PURE__ */ pe.jsx(Zn, { className: Ur.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ pe.jsx(Zn, { className: Ur.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ pe.jsxs(Zn, { margin: "100 0", children: [
        /* @__PURE__ */ pe.jsx(
          "img",
          {
            className: Ur.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ pe.jsx(Zn, { className: Ur.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ pe.jsx(
      Pn,
      {
        className: Ur.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), DF = "_collapse_1bdjy_1", RF = "_collapseHeader_1bdjy_10", OF = "_collapseHeaderKey_1bdjy_31", AF = "_collapseHeaderKeyIcon_1bdjy_36", PF = "_collapseHeaderKeyLink_1bdjy_41", LF = "_collapseHeaderIcon_1bdjy_44", VF = "_collapseHeaderTitle_1bdjy_49", zF = "_collapseContent_1bdjy_57", UF = "_collapseContentButtonSpacer_1bdjy_60", MF = "_collapseContentButtonLink_1bdjy_63", Fr = {
  collapse: DF,
  collapseHeader: RF,
  collapseHeaderKey: OF,
  collapseHeaderKeyIcon: AF,
  collapseHeaderKeyLink: PF,
  collapseHeaderIcon: LF,
  collapseHeaderTitle: VF,
  collapseContent: zF,
  collapseContentButtonSpacer: UF,
  collapseContentButtonLink: MF
}, BF = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ pe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: C,
      type: S,
      state: N,
      assignees: F,
      labels: y
    } = d, M = a[m];
    return /* @__PURE__ */ pe.jsxs(
      mr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: M,
        className: Fr.collapse,
        children: [
          /* @__PURE__ */ pe.jsx(mr.Header, { className: Fr.collapseHeader, children: /* @__PURE__ */ pe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ pe.jsx(Zn, { children: /* @__PURE__ */ pe.jsxs(Zn, { as: "span", className: Fr.collapseHeaderKey, children: [
                  um(
                    S,
                    N,
                    Fr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ pe.jsxs(
                    "a",
                    {
                      href: Bg(f),
                      className: Fr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        dr(f),
                        /* @__PURE__ */ pe.jsx(
                          fe,
                          {
                            className: Fr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ pe.jsx(Zn, { className: Fr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ pe.jsx(mr.Content, { className: Fr.collapseContent, children: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ pe.jsx(
              c_,
              {
                description: v,
                assignees: F,
                labels: y
              }
            ),
            /* @__PURE__ */ pe.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Fr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  qg(S)
                ]
              }
            ),
            /* @__PURE__ */ pe.jsxs(
              It,
              {
                slotEnd: /* @__PURE__ */ pe.jsx(fe, { name: "external-link" }),
                variant: "tertiary",
                className: Fr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Bg(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  qg(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ pe.jsx(pe.Fragment, {}) });
}, qF = "_result_1uaom_1", HF = "_resultName_1uaom_21", WF = "_resultItemIcon_1uaom_29", KF = "_resultDescription_1uaom_34", GF = "_resultLinkIcon_1uaom_46", YF = "_tooltip_1uaom_55", QF = "_tooltipName_1uaom_61", JF = "_tooltipTag_1uaom_71", Mr = {
  result: qF,
  resultName: HF,
  resultItemIcon: WF,
  resultDescription: KF,
  resultLinkIcon: GF,
  tooltip: YF,
  tooltipName: QF,
  tooltipTag: JF
}, XF = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ pe.jsx(
    Ye,
    {
      className: Mr.tooltip,
      content: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ pe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ pe.jsxs(Zn, { as: "span", className: Mr.tooltipName, children: [
                um(a, o, Mr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ pe.jsx(Pn, { className: Mr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ pe.jsx(
          c_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ pe.jsxs(
        "button",
        {
          className: Mr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ pe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ pe.jsxs(Zn, { as: "span", className: Mr.resultName, children: [
                    um(a, o, Mr.resultItemIcon),
                    dr(r)
                  ] }) }),
                  /* @__PURE__ */ pe.jsx(Zn, { className: Mr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ pe.jsx(
              fe,
              {
                className: Mr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, ZF = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ pe.jsx(
  It,
  {
    slotEnd: /* @__PURE__ */ pe.jsx(fe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), Fs = "[a-zA-z0-9_.-]+", d_ = "[0-9]+", eI = new RegExp(
  `(${Fs})/(${Fs})/(?:issues|pull)/(${d_})`,
  "i"
), Hg = new RegExp(`^${eI.source}$`), Wg = new RegExp(
  `https://github.com/(${Fs})/(${Fs})/(?:issues|pull)/(${d_})`,
  "i"
), nI = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Bn(() => r?.map((D) => D.id) || [], [r]), o = Bn(() => i?.map((D) => D.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = pn(), [m, u] = se(), [f, { loading: h, error: v, data: C, networkStatus: S }] = d(SF, {
    notifyOnNetworkStatusChange: !0
  });
  Si(
    () => {
      !h && m && S === er.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), He(() => {
    let D = C?.GitHub?.issues?.nodes || [], B = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((ee) => !a.includes(ee.id))), o.length > 0 && (B = B.filter(
      (ee) => !o.includes(ee.id)
    )), l([
      ...D.map((ee) => ({
        ...ee,
        type: "ISSUE",
        key: {
          number: ee.number,
          owner: ee.repository.owner.login,
          repository: ee.repository.name
        }
      })),
      ...B.map((ee) => ({
        ...ee,
        type: "PR",
        key: {
          number: ee.number,
          owner: ee.repository.owner.login,
          repository: ee.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function N(D) {
    const B = D?.trim();
    if (Hg.test(B)) {
      const [ee, X, ae, Q] = B.match(Hg) || [];
      return X !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(Q)
      };
    }
    if (Wg.test(B)) {
      const [ee, X, ae, Q] = B.match(Wg) || [];
      return X !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(Q)
      };
    }
  }
  const F = (D) => {
    e({
      key: wF(D),
      type: D.type
    }), u(void 0);
  }, y = (D) => {
    const B = N(D);
    u(
      B ? `org:${B.owner} repo:${B.repository} ${B.number}` : `org:${n} ${D}`
    );
  }, M = () => {
    u(void 0);
  }, T = ({ className: D, searched: B }) => /* @__PURE__ */ pe.jsx(
    ZF,
    {
      className: D,
      searched: B,
      githubOrganization: n
    }
  ), E = ({ item: D, onSelect: B }) => /* @__PURE__ */ pe.jsx(XF, { item: D, onSelect: B });
  return !h && v ? /* @__PURE__ */ pe.jsx(Fn, { error: v }) : /* @__PURE__ */ pe.jsx(
    wr,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: y,
      onSelect: F,
      onClear: M,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: E,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, tI = "_itemButton_3sxfy_1", rI = "_result_3sxfy_6", iI = "_resultName_3sxfy_30", aI = "_resultCheckIcon_3sxfy_38", oI = "_resultAssigneeIcon_3sxfy_41", ha = {
  itemButton: tI,
  result: rI,
  resultName: iI,
  resultCheckIcon: aI,
  resultAssigneeIcon: oI
}, u_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ pe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ pe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ha.itemButton,
        children: /* @__PURE__ */ pe.jsxs(b, { className: ha.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ pe.jsx(Zn, { margin: "100 0", children: /* @__PURE__ */ pe.jsx(
            "img",
            {
              className: ha.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ pe.jsx(Zn, { className: ha.resultName, children: e.name }),
          n && /* @__PURE__ */ pe.jsx(Zn, { className: ha.resultCheckIcon, children: /* @__PURE__ */ pe.jsx(fe, { name: "done" }) })
        ] })
      }
    )
  }
), sI = ra(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), lI = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = pn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: C }] = a(
    sI,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Si(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const S = v?.GitHub?.organization?.teams || { edges: [] }, N = [];
    S?.edges?.forEach((F) => {
      const y = F?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((M) => {
        const T = M?.node;
        T && (T?.id && N.find((E) => E.id === T.id) || N.push(T));
      });
    }), s(
      N.sort((F, y) => {
        const M = F.name?.toLowerCase() || F.login?.toLowerCase(), T = y.name?.toLowerCase() || y.login?.toLowerCase();
        return M.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ pe.jsx(Fn, { error: h }) : /* @__PURE__ */ pe.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: N, login: F, avatarUrl: y }) => ({
        id: S,
        name: N || F,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, N) => {
        const F = S.id;
        i ? (N && !n.find(
          (y) => y.id === F
        ) && n.push(S), N || (n = n.filter(
          (y) => y.id !== F
        ))) : n = N ? [S] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: N, checked: F }) => /* @__PURE__ */ pe.jsx(
        u_,
        {
          item: S,
          checked: F,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, cI = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ pe.jsx(Nr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ pe.jsx(
        wr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ pe.jsx(
        Bs,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ pe.jsx(Nr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ pe.jsx(
        wr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ pe.jsx(Nr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ pe.jsx(rm, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ pe.jsx(
        lI,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ pe.jsx(pe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, dI = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ pe.jsx(pe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ pe.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ pe.jsx(
      bn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: cI({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), uI = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ pe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ pe.jsxs(P.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ pe.jsxs(P.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ pe.jsx(fe, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ pe.jsx(bn, { label: "GitHub issue link", children: /* @__PURE__ */ pe.jsx(
          Nr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, mI = "_modalBody_1hk1o_1", pI = "_modalBodyFormFields_1hk1o_4", su = {
  modalBody: mI,
  modalBodyFormFields: pI
}, fI = ra(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), hI = ra(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), yI = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], gI = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = pn(), { track: d } = _n(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = Dt(), [C, S] = se(""), [N, F] = se([]), [y, M] = se(), [T, E] = se(!1), [D, B] = se(!1), [ee, X] = wx(), [
    ae,
    {
      loading: Q,
      error: z,
      networkStatus: O
    }
  ] = s(fI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ee) => {
      F(
        Ee.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), F([]);
    }
  });
  Si(
    () => {
      !Q && C && O === er.ready ? ae({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : F([]);
    },
    500,
    [C]
  );
  const [q, { error: Z }] = l(
    hI,
    {
      onError: (Ee) => {
        E(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ee);
      },
      onCompleted: (Ee) => {
        E(!1);
        const K = Ee.GitHub.createIssue?.issue;
        M(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ve = (Ee) => {
    S(`org:${a} ${Ee}`);
  }, ce = (Ee, K) => {
    K(Ee), S("");
  }, le = () => {
    S("");
  }, me = (Ee) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), E(!0), q({
      variables: {
        input: {
          repositoryId: Ee.repository.id,
          title: Ee.title,
          body: Ee.body,
          assigneeIds: Ee.assignees?.length > 0 ? Ee.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  He(() => {
    const Ee = D ? window.setTimeout(() => B(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ee);
  }, [D]);
  const H = () => {
    S(""), F([]), M(void 0), E(!1), B(!1);
  }, _e = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), H(), h(), n();
  };
  return /* @__PURE__ */ pe.jsxs(
    Et,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: _e,
      children: [
        /* @__PURE__ */ pe.jsx(
          Tt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: _e
          }
        ),
        /* @__PURE__ */ pe.jsxs($t, { className: su.modalBody, children: [
          !Q && z && /* @__PURE__ */ pe.jsx(Fn, { error: z }),
          !T && Z && /* @__PURE__ */ pe.jsx(Fn, { error: Z }),
          y ? /* @__PURE__ */ pe.jsx(
            uI,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: B,
              copyToClipboard: X
            }
          ) : /* @__PURE__ */ pe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(me),
              children: /* @__PURE__ */ pe.jsxs(yt, { children: [
                /* @__PURE__ */ pe.jsx(Te, { children: /* @__PURE__ */ pe.jsx(bn, { label: "Repository", required: !0, children: /* @__PURE__ */ pe.jsx(
                  Wt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ee, value: K } }) => /* @__PURE__ */ pe.jsx(
                      wr,
                      {
                        className: su.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: Q,
                        onSearch: ve,
                        onSelect: (qe) => ce(qe, Ee),
                        onClear: le,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: z ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: qe, onSelect: Be, checked: Pe }) => /* @__PURE__ */ pe.jsx(
                          u_,
                          {
                            item: qe,
                            checked: Pe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ pe.jsx(Te, { className: su.modalBodyFormFields, children: /* @__PURE__ */ pe.jsx(
                  dI,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: yI
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ pe.jsx(
          At,
          {
            confirmOnClick: y ? _e : u(me),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ pe.jsx(dn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : _e
          }
        )
      ]
    }
  );
}, vI = "_wrapper_19v8w_1", kI = "_inputWrapper_19v8w_6", bI = "_buttonLink_19v8w_19", xI = "_noItemsFound_19v8w_23", _I = "_createIssueButton_19v8w_28", Ei = {
  wrapper: vI,
  inputWrapper: kI,
  buttonLink: bI,
  noItemsFound: xI,
  createIssueButton: _I
}, SI = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = _n(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: C,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: N,
    issues: F,
    pullRequests: y,
    error: M
  } = CF({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (X) => d({ key: X, type: "ISSUE" }), E = !(!!F?.length).valueOf() && !(!!y?.length).valueOf() && !(!!C?.length).valueOf() && !(!!S?.length).valueOf(), D = !v && !N && !!C?.length && !!S?.length && !!n?.showDanglingLinks, B = n?.enableCreateIssue, ee = !!F?.length || !!y?.length;
  return !N && M ? /* @__PURE__ */ pe.jsx(Fn, { error: M, retry: () => u() }) : /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
    /* @__PURE__ */ pe.jsxs(b, { className: Ei.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ pe.jsxs(b, { className: Ei.inputWrapper, flexDirection: "column", children: [
        B && /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
          /* @__PURE__ */ pe.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Ei.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ pe.jsx("div", { className: Ei.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ pe.jsx(
          nI,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: F,
            linkedPullRequests: y
          }
        )
      ] }),
      N ? /* @__PURE__ */ pe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ pe.jsx(dn, { "data-testid": "github-widget-item-spinner" }) }) : ee ? /* @__PURE__ */ pe.jsx(
        BF,
        {
          items: [...F, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ pe.jsx(P.Paragraph, { align: "center", className: Ei.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ pe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ pe.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ pe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((X) => /* @__PURE__ */ pe.jsx(
                Pn,
                {
                  onDelete: () => m({
                    key: X,
                    type: "ISSUE"
                  }),
                  children: dr(X)
                },
                dr(X)
              )),
              S.map((X) => /* @__PURE__ */ pe.jsx(
                Pn,
                {
                  onDelete: () => m({ key: X, type: "PR" }),
                  children: dr(X)
                },
                dr(X)
              ))
            ] }),
            /* @__PURE__ */ pe.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && ee && /* @__PURE__ */ pe.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: E,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ pe.jsx(
        It,
        {
          slotEnd: /* @__PURE__ */ pe.jsx(fe, { name: "external-link" }),
          variant: "tertiary",
          className: Ei.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ pe.jsx(
      gI,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, NI = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Gr
  }
], Kg = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], oi = "GITHUB", jI = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, wI = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a
}) => {
  const o = !e, s = Dt({
    mode: "onChange",
    defaultValues: jI
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = lo({
    integrationId: e,
    integrationType: oi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: F
  } = co({
    integrationId: e,
    fieldDefinitions: Kg,
    form: s,
    onMisconfigured: v
  }), y = (T) => mo(T, {
    fieldDefinitions: Kg,
    isCreationMode: o,
    create: l,
    update: d
  }), M = s.watch("name");
  return /* @__PURE__ */ pe.jsxs(
    uo,
    {
      form: s,
      integrationId: e,
      onValidSubmit: y,
      error: S ?? f,
      onRetry: S ? F : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ pe.jsx(po, { cause: h }),
        /* @__PURE__ */ pe.jsxs(yt, { children: [
          /* @__PURE__ */ pe.jsx(Te, { children: /* @__PURE__ */ pe.jsx(bn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pe.jsx(
            Ft,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3, children: /* @__PURE__ */ pe.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3, children: /* @__PURE__ */ pe.jsx(
            tt,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: s.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3, children: /* @__PURE__ */ pe.jsx(bn, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ pe.jsx(
            Ft,
            {
              name: "enableRemoveAllLinks",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3, children: /* @__PURE__ */ pe.jsx(bn, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ pe.jsx(
            Ft,
            {
              name: "showDanglingLinks",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3, children: /* @__PURE__ */ pe.jsx(bn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ pe.jsx(
            Ft,
            {
              name: "enableCreateIssue",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Te, { span: 3 }),
          !o && e && /* @__PURE__ */ pe.jsx(
            Gr,
            {
              configuration: n,
              integrationId: e,
              integrationType: oi,
              label: "Authorize with OAuth"
            }
          )
        ] }),
        /* @__PURE__ */ pe.jsx(
          fo,
          {
            integrationType: oi,
            integrationId: e,
            widgetName: M,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ pe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ pe.jsx(
                fe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ pe.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  oi,
                  " integration, all links between Dixa and ",
                  oi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ pe.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  oi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ pe.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  oi,
                  " ",
                  'integration "',
                  M,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var lu = { exports: {} }, ya = {}, Gg;
function CI() {
  if (Gg) return ya;
  Gg = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ya.Fragment = r, ya.jsx = s, ya.jsxs = s, ya;
}
var Ao = {}, Yg;
function FI() {
  return Yg || (Yg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ao.Fragment = i, Ao.jsx = Rn, Ao.jsxs = Mn;
  })()), Ao;
}
var Qg;
function II() {
  return Qg || (Qg = 1, process.env.NODE_ENV === "production" ? lu.exports = CI() : lu.exports = FI()), lu.exports;
}
var xe = II(), Ba = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Ba || {}), ui = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ui || {}), Gt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Gt || {});
const EI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, TI = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": EI
};
function $I(e) {
  return TI[e] ?? {};
}
const DI = $I(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Jg = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, m_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, RI = "_listItem_16pij_4", OI = "_clickableIcon_16pij_15", ao = {
  listItem: RI,
  clickableIcon: OI
}, p_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ xe.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ xe.jsx(fe, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ xe.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: ao.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ xe.jsx(
              fe,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ xe.jsx(Ge, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, C = l.currency ?? r;
      return /* @__PURE__ */ xe.jsx(
        Ge.Item,
        {
          contentLeft: /* @__PURE__ */ xe.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { children: u }),
            /* @__PURE__ */ xe.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: m_(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ xe.jsx(Xi, { src: h, alt: m ?? "Product image" }),
          className: ao.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, AI = "_boxWrapper_89s7l_1", PI = "_trackButton_89s7l_10", Xg = {
  boxWrapper: AI,
  trackButton: PI
}, LI = {
  [Gt.StepUnknown]: "Unknown",
  [Gt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Gt.StepPreparedByMerchant]: "Prepared by merchant",
  [Gt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Gt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Gt.StepOnRoute]: "On route",
  [Gt.StepDeliveredToPickupPoint]: "At pickup point",
  [Gt.StepDeliveredToConsumer]: "Delivered to customer",
  [Gt.StepDeliveredToMerchant]: "Returned to merchant",
  [Gt.StepReturnRequested]: "Return requested",
  [Gt.StepSentBack]: "Sent back",
  [Gt.StepTerminated]: "Terminated",
  [Gt.StepAwaitingSupplier]: "Awaiting supplier"
}, VI = {
  [ui.Delivery]: "Home delivery",
  [ui.Pickup]: "Pickup point",
  [ui.Instore]: "In-store pickup",
  [ui.Mailbox]: "Mailbox",
  [ui.Inwarehouse]: "Warehouse",
  [ui.Unknown]: "Unknown"
}, zI = {
  [Ba.Outbound]: "From merchant to customer",
  [Ba.Return]: "Return from customer to merchant",
  [Ba.Unspecified]: "Unspecified",
  [Ba.UnknownDirectionType]: "Unknown"
}, UI = (e) => e ? LI[e] ?? e : "", MI = (e) => e ? VI[e] ?? e : "", BI = (e) => e ? zI[e] ?? e : "", qI = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, HI = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = or();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, C = a?.filter((T) => T?.time !== ""), S = UI(C?.[0]?.step), N = MI(u), F = BI(f), y = qI(e.location?.address), M = 14;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Xg.boxWrapper,
      children: [
        /* @__PURE__ */ xe.jsx(P.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(
              fe,
              {
                size: M,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(Ye, { content: "Copy tracking ID", children: /* @__PURE__ */ xe.jsx(
            fe,
            {
              size: M,
              name: n ? "done" : "copy",
              className: ao.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(fe, { size: M, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        F && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(fe, { size: M, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: F })
          ] })
        ] }),
        h && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(fe, { size: M, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ xe.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
              Jg(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: Jg(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(fe, { size: M, name: "info", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        y && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(fe, { size: M, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ xe.jsx(p_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ xe.jsxs(
          It,
          {
            variant: "secondary",
            className: Xg.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ xe.jsx(fe, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, WI = "_order_135ze_1", KI = "_orderIsOpen_135ze_9", GI = "_orderHeader_135ze_12", cu = {
  order: WI,
  orderIsOpen: KI,
  orderHeader: GI
}, Zg = "No order number found", YI = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = or(), { isCopied: s, copy: l } = or();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), v = d?.currency || "", C = d?.prices?.total?.price ?? 0, S = m_(C / 100, v), N = 14, F = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      className: at(cu.order, {
        [cu.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: cu.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs(P.Paragraph, { variant: "4", children: [
                  "From ",
                  F
                ] }),
                h ? /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: /* @__PURE__ */ xe.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: Zg })
              ] }),
              /* @__PURE__ */ xe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ xe.jsx(fe, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ xe.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: Zg }) })
              ] })
            ] }),
            h && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(Ye, { content: "Copy order number", children: /* @__PURE__ */ xe.jsx(
              fe,
              {
                size: N,
                name: s ? "done" : "copy",
                className: ao.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ xe.jsx(
                fe,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(Ye, { content: "Copy tracking ID", children: /* @__PURE__ */ xe.jsx(
              fe,
              {
                size: N,
                name: a ? "done" : "copy",
                className: ao.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(fe, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(fe, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", children: S })
            ] })
          ] }),
          /* @__PURE__ */ xe.jsx(
            p_,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((y) => y),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ xe.jsx(P.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ xe.jsx(An, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ xe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((y, M) => /* @__PURE__ */ xe.jsx(
              HI,
              {
                parcel: y
              },
              `parcel-${M}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, QI = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, JI = ({
  customerEmail: e
}) => {
  const { useQuery: n } = pn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(DI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? i0({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? Vb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return He(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(QI(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(dn, {}) }) : m || !d && !l ? /* @__PURE__ */ xe.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ xe.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ xe.jsx(Fn, { error: l }) : /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ xe.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ xe.jsx(An, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ xe.jsx(
      YI,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, XI = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ xe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ xe.jsx(JI, { customerEmail: n })
    }
  );
}, ZI = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
], ev = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], eE = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, nE = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i
}) => {
  const a = !e, o = Dt({
    mode: "onChange",
    defaultValues: eE
  }), {
    create: s,
    update: l,
    remove: d,
    isLoading: m,
    error: u,
    misconfigurationCause: f,
    setMisconfigurationCause: h
  } = lo({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: v,
    error: C,
    isWidgetUnknown: S,
    refetch: N
  } = co({
    integrationId: e,
    fieldDefinitions: ev,
    form: o,
    onMisconfigured: h
  }), F = (M) => mo(M, {
    fieldDefinitions: ev,
    isCreationMode: a,
    create: s,
    update: l
  }), y = o.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    uo,
    {
      form: o,
      integrationId: e,
      onValidSubmit: F,
      error: C ?? u,
      onRetry: C ? N : void 0,
      isLoading: m || v,
      isWidgetUnknown: S,
      children: [
        f && /* @__PURE__ */ xe.jsx(po, { cause: f }),
        /* @__PURE__ */ xe.jsxs(yt, { children: [
          /* @__PURE__ */ xe.jsx(Te, { children: /* @__PURE__ */ xe.jsx(bn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            Ft,
            {
              name: "enabled",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3, children: /* @__PURE__ */ xe.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: o.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3, children: /* @__PURE__ */ xe.jsx(bn, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ xe.jsx(
            Ft,
            {
              name: "ingridUseStagingEnvironment",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3, children: /* @__PURE__ */ xe.jsx(
            tt,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: o.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3, children: /* @__PURE__ */ xe.jsx(
            zm,
            {
              name: "ingridApiToken",
              label: "API token",
              control: o.control,
              isCreationMode: a,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Te, { span: 3 })
        ] }),
        /* @__PURE__ */ xe.jsx(
          fo,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: y,
            isCreationMode: a,
            isSubmitting: o.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var du = { exports: {} }, ga = {}, nv;
function tE() {
  if (nv) return ga;
  nv = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ga.Fragment = r, ga.jsx = s, ga.jsxs = s, ga;
}
var Po = {}, tv;
function rE() {
  return tv || (tv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Po.Fragment = i, Po.jsx = Rn, Po.jsxs = Mn;
  })()), Po;
}
var rv;
function iE() {
  return rv || (rv = 1, process.env.NODE_ENV === "production" ? du.exports = tE() : du.exports = rE()), du.exports;
}
var ge = iE();
const Np = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Np(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, aE = "_jiraCode_h30p6_1", oE = "_jiraCodeInline_h30p6_8", uu = {
  jiraCode: aE,
  jiraCodeInline: oE
}, f_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ge.jsx(ge.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ge.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ge.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ge.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ge.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ge.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ge.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ge.jsx("pre", { children: /* @__PURE__ */ ge.jsx("code", { className: uu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ge.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ge.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ge.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ge.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ge.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ge.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ge.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ge.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ge.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ge.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ge.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ge.jsx("code", { className: at(uu.jiraCode, uu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, Is = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ge.jsx(fe, { size: r, name: "question", className: n }) : /* @__PURE__ */ ge.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, sE = "_collapse_m2gjh_1", lE = "_collapseHeader_m2gjh_10", cE = "_collapseHeaderLink_m2gjh_31", dE = "_collapseHeaderStatus_m2gjh_40", uE = "_collapseHeaderTitle_m2gjh_51", mE = "_collapseContent_m2gjh_59", pE = "_collapseContentHeadline_m2gjh_62", fE = "_collapseContentButtonSpacer_m2gjh_68", hE = "_collapseContentButtonLink_m2gjh_71", yE = "_collapseContentStatusTag_m2gjh_74", gE = "_collapseContentDescription_m2gjh_77", gr = {
  collapse: sE,
  collapseHeader: lE,
  collapseHeaderLink: cE,
  collapseHeaderStatus: dE,
  collapseHeaderTitle: uE,
  collapseContent: mE,
  collapseContentHeadline: pE,
  collapseContentButtonSpacer: fE,
  collapseContentButtonLink: hE,
  collapseContentStatusTag: yE,
  collapseContentDescription: gE
}, h_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, vE = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ge.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = h_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ge.jsxs(
      mr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: gr.collapse,
        children: [
          /* @__PURE__ */ ge.jsx(mr.Header, { className: gr.collapseHeader, children: /* @__PURE__ */ ge.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ge.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ge.jsx(Is, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ge.jsx(
                      "a",
                      {
                        className: gr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ge.jsx(fe, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ge.jsx("span", { className: gr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ge.jsx(Pn, { className: gr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ge.jsx("div", { className: gr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ge.jsx(mr.Content, { className: gr.collapseContent, children: /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ge.jsx("div", { className: gr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ge.jsx(Zn, { className: gr.collapseContentDescription, children: u ? Np(u, f_) : "" }),
            /* @__PURE__ */ ge.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: gr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ge.jsx(
              It,
              {
                slotEnd: /* @__PURE__ */ ge.jsx(fe, { name: "external-link" }),
                variant: "tertiary",
                className: gr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ge.jsx(ge.Fragment, {}) });
}, kE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, bE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, xE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, _E = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, SE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, NE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, jE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, wE = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': kE,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": bE,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": xE,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": _E,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': SE,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': NE,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": jE
};
function wi(e) {
  return wE[e] ?? {};
}
const y_ = wi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), CE = wi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), FE = wi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), IE = wi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), EE = wi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), TE = wi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), $E = wi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), jp = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), DE = new RegExp(`^${jp.source}$`), RE = new RegExp(`/${jp.source}$`), iv = new RegExp(
  `.+?[&?]selectedIssue=(${jp.source})[&?]?.*`
);
function g_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = _n(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = pn(), {
    loading: C,
    data: S,
    error: N,
    store: F
  } = Vm(e ?? null), [
    y,
    { loading: M, error: T, data: E }
  ] = h(y_, {
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    const le = E?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((me) => me?.key).filter(Boolean)));
  }, [E]), He(
    () => d(N || T || void 0),
    [N, T]
  ), He(
    () => {
      C || z();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, C]
  );
  const D = async (le, me) => {
    await F(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: me.success.title,
        text: me.success.text
      });
    }).catch((H) => {
      u({
        title: me.error.title,
        text: `${me.error.text} ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [B] = v(CE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (le, me) => {
    const H = window.location.href, _e = me ? H.replace(
      e?.toString() ?? "",
      me?.toString()
    ) : H, Ee = me ? `# ${me}` : `# ${e}`;
    B({
      variables: {
        issueKey: le,
        title: Ee,
        url: _e,
        globalId: `system=${_e}`
      }
    });
  }, [X] = v(FE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ae = (le) => {
    const me = window.location.href;
    X({
      variables: {
        issueKey: le,
        globalId: `system=${me}`
      }
    });
  }, Q = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), z = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (le, me) => {
    m("jira:issue:link:clicked", Q(le));
    const H = S?.jira?.issues ? S : r;
    H.jira.issues = Array.from(
      new Set(H.jira.issues).add(le)
    ), await F(H, me?.toString()).then(() => ee(le, me)).catch((_e) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (le) => {
    m("jira:issue:link:clicked", Q(le));
    const me = S?.jira?.issues ? S : r;
    me.jira.issues = Array.from(
      new Set(me.jira.issues).add(le)
    ), D(me, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => ee(le));
  }, Z = (le) => {
    m("jira:issue:unlink:clicked", Q(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", Q(le));
        const me = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((H) => H !== le) || []
          }
        };
        D(me, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ae(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", Q(le))
    });
  }, ve = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ae(le.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ce = S?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: O,
    unlinkIssue: Z,
    loadIssues: z,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (me) => !ce.includes(me)
          ) || []
        }
      };
      F(le);
    },
    unlinkAllIssues: ve,
    maybeExtractIssueKey: (le) => {
      const me = le.replace(/\s/g, "");
      if (DE.test(me))
        return me;
      if (iv.test(le))
        return le.match(iv)?.[1];
      if (le.startsWith(n) && RE.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ce,
    isLoadingIssues: M,
    issues: o,
    error: l
  };
}
function OE(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const AE = "_result_axxxc_48", PE = "_resultName_axxxc_68", LE = "_resultNameIcon_axxxc_76", VE = "_resultDescription_axxxc_81", zE = "_resultLinkIcon_axxxc_93", UE = "_tooltip_axxxc_102", ME = "_tooltipContent_axxxc_108", BE = "_tooltipName_axxxc_115", qE = "_tooltipNameIcon_axxxc_120", HE = "_tooltipDescription_axxxc_125", WE = "_tooltipSummary_axxxc_133", KE = "_tooltipTag_axxxc_137", cr = {
  result: AE,
  resultName: PE,
  resultNameIcon: LE,
  resultDescription: VE,
  resultLinkIcon: zE,
  tooltip: UE,
  tooltipContent: ME,
  tooltipName: BE,
  tooltipNameIcon: qE,
  tooltipDescription: HE,
  tooltipSummary: WE,
  tooltipTag: KE
}, GE = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = h_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ge.jsx(
    Ye,
    {
      disabled: i,
      className: cr.tooltip,
      content: /* @__PURE__ */ ge.jsxs("div", { className: cr.tooltipContent, children: [
        /* @__PURE__ */ ge.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ge.jsxs("span", { className: cr.tooltipName, children: [
                /* @__PURE__ */ ge.jsx(
                  Is,
                  {
                    width: 16,
                    iconUrl: h,
                    className: cr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ge.jsx(Pn, { className: cr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ge.jsx("div", { className: cr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ge.jsx("div", { className: cr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ge.jsxs(
        "button",
        {
          ...a,
          className: cr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ge.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ge.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ge.jsxs("span", { className: cr.resultName, children: [
                    /* @__PURE__ */ ge.jsx(
                      Is,
                      {
                        width: 16,
                        iconUrl: h,
                        className: cr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ge.jsx("div", { className: cr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ge.jsx(
              fe,
              {
                className: cr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, YE = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ge.jsx(
  It,
  {
    slotEnd: /* @__PURE__ */ ge.jsx(fe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), QE = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = pn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(y_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = g_(null, n);
  Si(
    () => {
      !u && l && v === er.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((E) => ({
        id: E?.key ?? "",
        name: E?.key ?? "",
        description: E?.fields.summary,
        status: E?.fields.status,
        issuetype: E?.fields.issuetype,
        text: E?.fields.description ? Np(E?.fields.description, f_) : /* @__PURE__ */ ge.jsx(ge.Fragment, {})
      }))
    );
  }, [h]);
  const S = (T) => {
    e(T.id), d("");
  }, N = (T) => {
    const E = T.trim(), D = C(E);
    if (D) {
      const B = D.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${B}'`);
    } else E !== "" && d(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, F = () => {
    d("");
  }, y = (T) => /* @__PURE__ */ ge.jsx(YE, { ...T, jiraInstanceUrl: n }), M = (T) => /* @__PURE__ */ ge.jsx(
    GE,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ge.jsx(Fn, { error: f }) : /* @__PURE__ */ ge.jsx(
    wr,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: S,
      onClear: F,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: M,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, JE = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return He(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ge.jsx(
    wr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, XE = "_itemButton_1hl53_1", ZE = "_result_1hl53_6", eT = "_resultIcon_1hl53_26", nT = "_resultName_1hl53_30", tT = "_resultCheckIcon_1hl53_38", va = {
  itemButton: XE,
  result: ZE,
  resultIcon: eT,
  resultName: nT,
  resultCheckIcon: tT
}, mm = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ge.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ge.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: va.itemButton,
          children: /* @__PURE__ */ ge.jsxs(b, { className: va.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ge.jsx(
              Is,
              {
                width: 36,
                iconUrl: o || "",
                className: va.resultIcon
              }
            ),
            /* @__PURE__ */ ge.jsx(Zn, { className: va.resultName, children: e.name }),
            n && /* @__PURE__ */ ge.jsx(Zn, { className: va.resultCheckIcon, children: /* @__PURE__ */ ge.jsx(fe, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, rT = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = pn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: C }] = a($E, {
    notifyOnNetworkStatusChange: !0
  });
  return Si(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const N = S?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), He(() => {
    const S = v?.Jira?.findUsers || [];
    s(
      S.filter(({ active: N }) => N).map(({ accountId: N, displayName: F, avatarUrls: y, active: M }) => ({
        id: N,
        name: F,
        avatarUrls: y,
        active: M
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ge.jsx(Fn, { error: h }) : /* @__PURE__ */ ge.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: N, checked: F }) => /* @__PURE__ */ ge.jsx(
        mm,
        {
          item: S,
          checked: F,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, av = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = wx();
  return He(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(fe, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ge.jsx(P.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ge.jsx(Ye, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ge.jsx(
      nr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, iT = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ge.jsx(av, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ge.jsx(Nr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ge.jsx(rm, { onChange: n, value: r }) : /* @__PURE__ */ ge.jsx(Nr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ge.jsx(rm, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ge.jsx(Nr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ge.jsx(
        rT,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ge.jsx(
        wr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ge.jsx(JE, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ge.jsx(av, { field: e });
  }
}, aT = ["description", "reporter", "summary"], oT = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ge.jsx(ge.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || aT.includes(o)
).map((o) => /* @__PURE__ */ ge.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ge.jsx(
      bn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: iT({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), sT = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ge.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ge.jsxs(P.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ge.jsxs(
          P.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ge.jsx(fe, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ge.jsx(bn, { label: "Jira issue link", children: /* @__PURE__ */ ge.jsx(
        Nr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), lT = "_modalBody_1hk1o_1", cT = "_modalBodyFormFields_1hk1o_4", ov = {
  modalBody: lT,
  modalBodyFormFields: cT
}, dT = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), uT = (e) => e?.custom?.split(":")?.[1] || null, mT = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, pT = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = mT(a, n), l = uT(s) ?? a;
        return r.includes(l) ? i[a] = dT(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, fT = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, C] = se([]), [S, N] = se([]), [F, y] = se(!1), [M, T] = se(!1), [E, D] = se({}), { track: B } = _n(), { isCopied: ee, copyToClipboard: X } = OE(), ae = Bn(() => i?.conversationId, [e]), { useMutation: Q, useLazyQuery: z, showNotification: O } = pn(), {
    control: q,
    handleSubmit: Z,
    formState: { errors: ve },
    reset: ce,
    setValue: le,
    getValues: me
  } = Dt({
    defaultValues: s
  }), H = S.length > 0, _e = `${a}/browse`, Ee = Object.keys(E).length > 0, [K, { loading: qe, error: Be }] = z(IE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ye) => {
      d(ye.Jira.getAllProjects);
    },
    onError: (ye) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ye), d([]);
    }
  }), [
    Pe,
    { loading: Me, error: Fe }
  ] = z(EE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ye) => {
      h(0);
      const $e = ye?.Jira?.getCreateIssueMeta?.projects[0];
      if ($e) {
        const Ve = $e?.issuetypes.filter(
          ({ subtask: Oe }) => !Oe
        );
        C(Ve || []), le(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), N([]);
    },
    onError: (ye) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ye), C([]), N([]), h(0);
    }
  }), [Le, { error: De }] = Q(
    TE,
    {
      onError: () => {
        y(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), B("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ye) => {
        if (y(!1), ye?.Jira && "key" in ye.Jira.createIssue)
          u(ye?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${ye.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), B("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ye.Jira.createIssue.key
          }), ae && r(
            ye.Jira.createIssue.key,
            ae
          );
        else if ("errorMessages" in ye.Jira.createIssue || "errors" in ye.Jira.createIssue) {
          const $e = ye?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", $e), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), tn = (ye) => {
    y(!0), D({}), Le({
      variables: {
        input: pT(ye, S)
      }
    });
  };
  He(() => {
    if (e)
      try {
        K();
      } catch (ye) {
        console.warn("Error when fetching initial projects", ye);
      }
  }, [e]), He(() => {
    const ye = M ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(ye);
  }, [M]), He(() => {
    if (v?.length > 0) {
      le("issuetype", v[f]);
      const ye = v[f]?.fields?.additionalProperties;
      if (ye?.length > 0) {
        const $e = ye.map(
          ({ value: w }) => w
        ), Ve = (o ? $e.sort(({ name: w }, { name: x }) => w.localeCompare(x)) : $e).sort(
          ({ required: w }, { required: x }) => Number(x) - Number(w)
        ), { project: Oe, issuetype: ln } = me();
        ce({ project: Oe, issuetype: ln }), N(Ve);
      }
    } else
      N([]), le("issuetype", void 0);
  }, [v, le, f]), He(() => {
    if (De && Kb(De)) {
      if (De?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ye } = De, $e = ye[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse($e);
          if (Ve?.errors) {
            const Oe = Object.keys(Ve.errors).reduce(
              (ln, w) => ({
                ...ln,
                [w]: {
                  type: "required",
                  message: Ve.errors[w],
                  ref: {
                    name: w
                  }
                }
              }),
              {}
            );
            D(Oe);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [De]);
  const Ie = () => {
    d([]), N([]), C([]), u(void 0), h(0), y(!1), D({});
  }, We = () => {
    Ie(), ce(s), n();
  }, en = (ye) => {
    ye && Pe({
      variables: {
        projectKey: ye
      }
    });
  }, ue = (ye) => {
    const $e = v.map((Ve) => Ve.id).indexOf(ye);
    h($e ?? 0);
  };
  return /* @__PURE__ */ ge.jsxs(
    Et,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ ge.jsx(
          Tt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ ge.jsxs($t, { className: ov.modalBody, children: [
          !qe && Be && /* @__PURE__ */ ge.jsx(Fn, { error: Be, retry: K }),
          !Me && Fe && /* @__PURE__ */ ge.jsx(
            Fn,
            {
              error: Fe,
              retry: Pe
            }
          ),
          !F && Ee && /* @__PURE__ */ ge.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ge.jsx(
            qs,
            {
              variant: "warning",
              description: /* @__PURE__ */ ge.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ge.jsx(P.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ge.jsx(
                      Kn,
                      {
                        icon: ee ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => X(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ge.jsx(
            sT,
            {
              createdIssue: m,
              issueBaseLink: _e,
              issueLinkCopied: M,
              setIssueLinkCopied: T,
              copyToClipboard: X
            }
          ) : /* @__PURE__ */ ge.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: Z(tn),
              children: /* @__PURE__ */ ge.jsxs(yt, { children: [
                /* @__PURE__ */ ge.jsx(Te, { span: 3, children: /* @__PURE__ */ ge.jsx(bn, { label: "Project", required: !0, children: /* @__PURE__ */ ge.jsx(
                  Wt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ye, value: $e } }) => /* @__PURE__ */ ge.jsx(
                      wr,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Ve) => {
                          en(Ve.key), ye(Ve);
                        },
                        selectedItems: [$e],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Oe, checked: ln }) => /* @__PURE__ */ ge.jsx(
                          mm,
                          {
                            item: Ve,
                            checked: ln,
                            onSelectItem: Oe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ge.jsx(Te, { span: 3, children: /* @__PURE__ */ ge.jsx(bn, { label: "Issue type", required: !0, children: /* @__PURE__ */ ge.jsx(
                  Wt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ye, value: $e } }) => /* @__PURE__ */ ge.jsx(
                      wr,
                      {
                        disabled: v.length === 0,
                        loading: Me,
                        onSelect: (Ve) => {
                          ue(Ve.id), ye(Ve);
                        },
                        selectedItems: [$e],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Fe ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ve, onSelect: Oe, checked: ln }) => /* @__PURE__ */ ge.jsx(
                          mm,
                          {
                            item: Ve,
                            checked: ln,
                            onSelectItem: Oe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                H && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ge.jsx(Te, { className: ov.modalBodyFormFields, children: /* @__PURE__ */ ge.jsx(
                  oT,
                  {
                    control: q,
                    errors: { ...ve, ...E },
                    getValues: me,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ge.jsx(
          At,
          {
            confirmOnClick: m ? We : Z(tn),
            confirmProps: {
              disabled: !H,
              isLoading: F,
              loadingIndicator: /* @__PURE__ */ ge.jsx(dn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, hT = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, yT = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, gT = "_wrapper_1bylq_1", vT = "_inputWrapper_1bylq_6", kT = "_inputSeparator_1bylq_18", bT = "_buttonLink_1bylq_23", xT = "_noIssuesFound_1bylq_27", ka = {
  wrapper: gT,
  inputWrapper: vT,
  inputSeparator: kT,
  buttonLink: bT,
  noIssuesFound: xT
}, _T = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = _n(), i = hT(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: C,
    isLoadingIssues: S,
    issues: N,
    error: F
  } = g_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, M = !!n?.enableSortIssueTypeByLabel, T = !!(N?.length || v?.length), E = !!n?.enableRemoveAllLinks && T, D = !C && !S && v?.length > 0 && !!n?.showDanglingLinks;
  return !S && F ? /* @__PURE__ */ ge.jsx(Fn, { error: F, retry: () => f() }) : /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsxs(b, { className: ka.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ge.jsxs(b, { className: ka.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
          /* @__PURE__ */ ge.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ge.jsx("div", { className: ka.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ge.jsx(
          QE,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(dn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ ge.jsx(
        vE,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ge.jsx(P.Paragraph, { align: "center", className: ka.noIssuesFound, children: "No linked issues found" }),
      E && N?.length > 0 && /* @__PURE__ */ ge.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !N?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ ge.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ge.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ge.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((B) => /* @__PURE__ */ ge.jsx(Pn, { onDelete: () => m(B), children: B }, B)) }),
            /* @__PURE__ */ ge.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ge.jsx(
        It,
        {
          slotEnd: /* @__PURE__ */ ge.jsx(fe, { name: "external-link" }),
          variant: "tertiary",
          className: ka.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ge.jsx(
      fT,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: M
      }
    )
  ] });
}, sv = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => yT(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Gr
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var mu = { exports: {} }, ba = {}, lv;
function ST() {
  if (lv) return ba;
  lv = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ba.Fragment = r, ba.jsx = s, ba.jsxs = s, ba;
}
var Lo = {}, cv;
function NT() {
  return cv || (cv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Lo.Fragment = i, Lo.jsx = Rn, Lo.jsxs = Mn;
  })()), Lo;
}
var dv;
function jT() {
  return dv || (dv = 1, process.env.NODE_ENV === "production" ? mu.exports = ST() : mu.exports = NT()), mu.exports;
}
var je = jT();
function wT({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = pn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return He(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const S = setTimeout(C, r);
        d([...l, S]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var v_ = /* @__PURE__ */ ((e) => (e.List = "list", e))(v_ || {}), pm = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(pm || {}), fm = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(fm || {}), hm = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(hm || {});
const CT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, FT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, IT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, ET = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, TT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, $T = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, DT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, RT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, OT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, PT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, LT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VT = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": CT,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": FT,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ET,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": TT,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": IT,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": $T,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": DT,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": RT,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": OT,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": AT,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": PT,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": LT
};
function Yr(e) {
  return VT[e] ?? {};
}
const zT = Yr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), UT = Yr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), MT = Yr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), BT = Yr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), qT = Yr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), HT = Yr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), WT = Yr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), KT = Yr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), GT = Yr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function ym(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function uv(e) {
  return ym(e) && e?.attributes?.event_properties?.$message;
}
function YT(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function mv(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function QT(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function JT(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function XT(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function ZT(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function e$(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function n$(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function pv(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function t$(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function r$(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const i$ = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function a$(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function o$(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function s$({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = pn(), { track: a } = _n(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, C] = se(
    null
  ), [S, N] = se([]), {
    data: F,
    error: y,
    loading: M,
    networkStatus: T
  } = i(MT, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    E,
    {
      data: D,
      error: B,
      loading: ee,
      networkStatus: X
    }
  ] = r(zT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return He(() => {
    if (F && !M && T === er.ready) {
      const ae = QT(F);
      s(
        ae.find((Q) => Q?.attributes?.name === "Received Email")?.id || null
      ), d(
        ae.find((Q) => Q?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ae.find((Q) => Q?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ae.find((Q) => Q?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ae.find((Q) => Q?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [F]), He(() => {
    o && l && m && f && v && !ee && X === er.ready ? E({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), He(() => {
    if (!ee && D) {
      const ae = JT(D), Q = ZT(
        D
      ).map(
        (ce) => ce?.attributes?.event_properties.$message
      ), z = e$(
        D
      ).map(
        (ce) => ce?.attributes?.event_properties.$message
      );
      ae.forEach((ce) => {
        const le = ce.attributes?.event_properties.$message;
        ce.opened = Q.includes(le), ce.clicked = z.includes(le);
      });
      const O = XT(D), q = n$(D), Z = [
        ...ae,
        ...q,
        ...O
      ].sort((ce, le) => {
        const me = mv(ce), H = mv(le);
        return me == null && H == null ? 0 : me == null ? 1 : H == null ? -1 : H - me;
      }).slice(0, n);
      N(Z);
      const ve = Z.map((ce) => ce.id);
      a("klaviyo:messages:received", {
        emailsReceived: ae.filter(
          (ce) => ve.includes(ce.id)
        ).length,
        emailsBounced: q.filter(
          (ce) => ve.includes(ce.id)
        ).length,
        smsReceived: O.filter(
          (ce) => ve.includes(ce.id)
        ).length,
        total: ve.length
      });
    } else
      N([]);
  }, [ee, D]), Bn(
    () => ({
      receivedMessages: S,
      isLoading: M || ee,
      error: y || B
    }),
    [
      S,
      M,
      ee,
      y,
      B
    ]
  );
}
function l$({ profileId: e }) {
  const { useQuery: n } = pn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(qT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  He(() => {
    l && o(l);
  }, [l]), He(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Bn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function c$({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = _n(), { useLazyQuery: i } = pn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(BT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, C);
    }
  }, [f, m]);
  const h = (v, C) => {
    const S = v?.data?.length === 1 && v.data[0]?.id || void 0, N = C?.data?.length === 1 && C.data[0]?.id || void 0, F = S || N, y = !S || !N || S === N;
    if (F && y) {
      o(S || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Bn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const fv = 800, d$ = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, u$ = 3, m$ = 1.5, p$ = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = u$,
  useDelayRange: a = !1
}) => {
  const o = (B) => Math.floor(Math.random() * (B.max - B.min) + B.min), [s, l] = se(0), [d, m] = se(n || fv), [u, f] = se(r || d$), [h, v] = se(!1), [C, S] = se(!1), N = a || !!r, F = N ? o(u) : n || fv, [y, M] = se(F);
  Qw(
    async () => {
      const B = s + 1, ee = m$ ** B;
      l(B), M(
        (N ? o(u) : d) * ee
      ), await e().then(() => {
        S(!0), D();
      });
    },
    h ? y : null
  ), Xw(() => D());
  const T = it(() => {
    l(0), M(F);
  }, [F]), E = it(
    (B = {}) => {
      const { delay: ee, delayRange: X } = B;
      S(!1), T(), X && (f(X), M(o(X))), ee && (m(ee), M(ee)), v(!0);
    },
    [T]
  ), D = it(() => {
    v(!1), T();
  }, [T]);
  return He(() => {
    s >= i && D();
  }, [s, i, D]), Bn(
    () => ({ isRunning: h, isSuccessful: C, start: E, stop: D }),
    [h, C, E, D]
  );
}, f$ = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, h$ = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function y$({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = pn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? HT : WT,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: C
  } = p$({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return He(() => {
    if (d)
      if (l0({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = f$(d);
          v({
            ...N && {
              delayRange: h$(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), He(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, F = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (F = l?.Klaviyo?.get_segments_for_profile), (N?.data || F?.data) && (C(), a(
        (n === "lists" ? N?.data : F?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Bn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, v]
  );
}
const g$ = "_notificationText_1polx_1", wp = {
  notificationText: g$
}, al = ({ error: e }) => {
  const { track: n } = _n();
  let r = e;
  if (Kb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && Vb({ error: i[0] }), o = i.length === 1 && o0({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ je.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ je.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ je.jsx(
    Ge.Item,
    {
      contentLeft: /* @__PURE__ */ je.jsx(fe, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, v$ = "_message_1vrar_48", k$ = "_messageIsOpen_1vrar_56", b$ = "_messageHeader_1vrar_59", x$ = "_messageLabel_1vrar_65", _$ = "_messageText_1vrar_68", qi = {
  message: v$,
  messageIsOpen: k$,
  messageHeader: b$,
  messageLabel: x$,
  messageText: _$
}, S$ = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && t$(e.flowMessage);
  return /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
    /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", className: qi.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ je.jsx(P.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ je.jsx(dn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ je.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ je.jsx(b, { children: /* @__PURE__ */ je.jsx(
            P.Paragraph,
            {
              variant: "4",
              className: qi.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", className: qi.messageText, children: i })
        ]
      }
    )
  ] });
}, N$ = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ je.jsx(je.Fragment, { children: /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ je.jsx(b, { children: /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ je.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, j$ = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Bn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, C = f && e.clicked, S = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], F = f ? "mail" : "sms";
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: at(qi.message, {
        [qi.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ je.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: qi.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ je.jsx(fe, { size: 16, name: F }),
                  " ",
                  i$(s),
                  u && /* @__PURE__ */ je.jsx(An, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                N && N
              ] }),
              /* @__PURE__ */ je.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ je.jsx(Mm, {}),
          YT(e) && /* @__PURE__ */ je.jsx(b, { children: /* @__PURE__ */ je.jsx(An, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ je.jsx(Pn, { children: /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ je.jsx(
                  fe,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ je.jsx(Pn, { children: /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ je.jsx(
                  fe,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ je.jsx(S$, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ je.jsx(N$, { event: e })
        ] })
      ]
    }
  );
}, w$ = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, C$ = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = s$({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = wT({
    query: UT,
    options: w$,
    delayMs: 1e3
  }), [m, u] = se([]);
  He(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => ym(v)).map((v) => uv(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), He(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && ym(h) && !h.flowMessage) {
          const v = uv(h), C = d.find((N) => (N.data && pv(N.data))?.id === v), S = C?.data && pv(C.data);
          if (S)
            return {
              ...r$(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ je.jsx(je.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ je.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ je.jsx(
    al,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
    /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ je.jsx(dn, {}) }) : /* @__PURE__ */ je.jsx(je.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ je.jsx(
      j$,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: wp.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, F$ = "_list_ld0hf_1", I$ = "_listItem_ld0hf_4", Wr = {
  list: F$,
  listItem: I$
}, E$ = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ je.jsx(Ge, { className: Wr.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Wr.listItem, children: /* @__PURE__ */ je.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: s0(a) }),
          /* @__PURE__ */ je.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: to(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, hv = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = y$({ profileId: e, query: n });
  He(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ je.jsx(al, { error: o }) : s ? /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Wr.listItem, children: /* @__PURE__ */ je.jsx(dn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ je.jsx(je.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Wr.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ je.jsx(Pn, { children: zb(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Wr.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ je.jsx(fe, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ je.jsx(Ye, { content: "Refresh lists and segments", children: /* @__PURE__ */ je.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Wr.listItem, children: /* @__PURE__ */ je.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ je.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, T$ = 0.7, $$ = 0.3, D$ = (e) => e >= T$ ? { variant: "error", label: "High risk" } : e >= $$ ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, R$ = (e) => /* @__PURE__ */ je.jsx(P.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), O$ = (e) => {
  const n = D$(e);
  return /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ je.jsx(An, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ je.jsx(P.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, A$ = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: R$(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: to(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: O$(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: to(o)
      }
    ] : []
  ];
}, P$ = ({
  profile: e
}) => {
  const n = A$(e);
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ je.jsx(Ge, { className: Wr.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Wr.listItem, children: /* @__PURE__ */ je.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ je.jsx(P.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, L$ = "_tagHover_kzbzk_1", V$ = "_channelUnsubscribed_kzbzk_6", yv = {
  tagHover: L$,
  channelUnsubscribed: V$
}, gv = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ je.jsx(
    Ye,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ je.jsx(
        Pn,
        {
          className: yv.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ je.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: at({
                [yv.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ je.jsx(dn, { size: 16 }) : /* @__PURE__ */ je.jsx(fe, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, z$ = "_subscriptionError_1qhhx_1", U$ = {
  subscriptionError: z$
}, M$ = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = _n(), [v, C] = Jw({
    channel: null,
    request: null
  }), S = a$(n), N = o$(n), F = !!e, { useMutation: y } = pn(), [M] = y(
    KT
  ), [T] = y(
    GT
  ), E = (ee) => {
    h("klaviyo:profile:subscribe:clicked", { channel: ee }), C.setAll({
      channel: ee,
      request: "subscribed"
    }), ((X) => M({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: pm.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...X === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: fm.Subscribed
                        }
                      }
                    },
                    ...X === "SMS" && {
                      sms: {
                        marketing: {
                          consent: fm.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: v_.List,
              id: e
            }
          }
        }
      }
    }))(ee).then(
      (X) => B({
        channel: ee,
        mutationResponse: X,
        isSubscriptionRequest: !0
      })
    ).catch(
      (X) => B({
        channel: ee,
        mutationErrorResponse: X,
        isSubscriptionRequest: !0
      })
    );
  }, D = (ee) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: ee }), C.setAll({
      channel: ee,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: pm.Profile,
                attributes: {
                  ...ee === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...ee === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...ee === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: hm.Unsubscribed
                        }
                      }
                    },
                    ...ee === "SMS" && {
                      sms: {
                        marketing: {
                          consent: hm.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (X) => B({
        channel: ee,
        mutationResponse: X,
        isSubscriptionRequest: !1
      })
    ).catch(
      (X) => B({
        channel: ee,
        mutationErrorResponse: X,
        isSubscriptionRequest: !1
      })
    );
  }, B = async ({
    channel: ee,
    mutationResponse: X,
    mutationErrorResponse: ae,
    isSubscriptionRequest: Q
  }) => {
    const z = ae?.networkError, O = z ? z?.statusCode : NaN, q = X?.errors, Z = !!q && Ub({
      errors: q
    });
    O === 202 ? (h(
      Q ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: ee }
    ), await o()) : Z ? (h(
      Q ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: ee,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${Q ? "opt-in" : "opt-out"}.`
    )) : (h(
      Q ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: ee,
        reason: z?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${Q ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return He(() => {
    if (v.request === "subscribed") {
      const ee = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(ee), C.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(ee), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ je.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(
            gv,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                l(!0), f(void 0), S ? D("EMAIL") : E("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ je.jsx(
            gv,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                m(!0), f(void 0), N ? D("SMS") : E("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ je.jsx(b, { className: U$.subscriptionError, children: u })
      ] })
    }
  );
}, B$ = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = l$({ profileId: e });
  return f ? /* @__PURE__ */ je.jsx(al, { error: f }) : h ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ je.jsx(dn, {}) }) : !u && !h ? /* @__PURE__ */ je.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: wp.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ je.jsxs(Ge, { className: Wr.list, children: [
        i && /* @__PURE__ */ je.jsx(hv, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ je.jsx(
          hv,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ je.jsx(
      M$,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ je.jsx(P$, { profile: u }),
    u && s && /* @__PURE__ */ je.jsx(E$, { profile: u }),
    /* @__PURE__ */ je.jsx(
      C$,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, q$ = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: C
  } = c$({ email: r, phoneNumber: i });
  return y0(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ je.jsx(dn, {}) }) : C ? /* @__PURE__ */ je.jsx(al, { error: C }) : f ? /* @__PURE__ */ je.jsx(
    B$,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ je.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: wp.notificationText,
      children: "No profile ID found"
    }
  );
}, H$ = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: a0
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], W$ = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Gr
  }
], K$ = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function G$(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const Y$ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Q$ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, J$ = {};
function vv(e, n) {
  return (J$.jsx ? Q$ : Y$).test(e);
}
const X$ = /[ \t\n\f\r]/g;
function Z$(e) {
  return typeof e == "object" ? e.type === "text" ? kv(e.value) : !1 : kv(e);
}
function kv(e) {
  return e.replace(X$, "") === "";
}
class No {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
No.prototype.property = {};
No.prototype.normal = {};
No.prototype.space = null;
function k_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new No(r, i, n);
}
function gm(e) {
  return e.toLowerCase();
}
class hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
hr.prototype.space = null;
hr.prototype.boolean = !1;
hr.prototype.booleanish = !1;
hr.prototype.overloadedBoolean = !1;
hr.prototype.number = !1;
hr.prototype.commaSeparated = !1;
hr.prototype.spaceSeparated = !1;
hr.prototype.commaOrSpaceSeparated = !1;
hr.prototype.mustUseProperty = !1;
hr.prototype.defined = !1;
let eD = 0;
const In = Ci(), ft = Ci(), b_ = Ci(), ze = Ci(), Xn = Ci(), Hi = Ci(), tr = Ci();
function Ci() {
  return 2 ** ++eD;
}
const vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: ft,
  commaOrSpaceSeparated: tr,
  commaSeparated: Hi,
  number: ze,
  overloadedBoolean: b_,
  spaceSeparated: Xn
}, Symbol.toStringTag, { value: "Module" })), pu = Object.keys(vm);
class Cp extends hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), bv(this, "space", a), typeof i == "number")
      for (; ++o < pu.length; ) {
        const s = pu[o];
        bv(this, pu[o], (i & vm[s]) === vm[s]);
      }
  }
}
Cp.prototype.defined = !0;
function bv(e, n, r) {
  r && (e[n] = r);
}
const nD = {}.hasOwnProperty;
function ia(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (nD.call(e.properties, i)) {
      const a = e.properties[i], o = new Cp(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[gm(i)] = i, r[gm(o.attribute)] = i;
    }
  return new No(n, r, e.space);
}
const x_ = ia({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), __ = ia({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function S_(e, n) {
  return n in e ? e[n] : n;
}
function N_(e, n) {
  return S_(e, n.toLowerCase());
}
const j_ = ia({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: N_,
  properties: { xmlns: null, xmlnsXLink: null }
}), w_ = ia({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ft,
    ariaAutoComplete: null,
    ariaBusy: ft,
    ariaChecked: ft,
    ariaColCount: ze,
    ariaColIndex: ze,
    ariaColSpan: ze,
    ariaControls: Xn,
    ariaCurrent: null,
    ariaDescribedBy: Xn,
    ariaDetails: null,
    ariaDisabled: ft,
    ariaDropEffect: Xn,
    ariaErrorMessage: null,
    ariaExpanded: ft,
    ariaFlowTo: Xn,
    ariaGrabbed: ft,
    ariaHasPopup: null,
    ariaHidden: ft,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xn,
    ariaLevel: ze,
    ariaLive: null,
    ariaModal: ft,
    ariaMultiLine: ft,
    ariaMultiSelectable: ft,
    ariaOrientation: null,
    ariaOwns: Xn,
    ariaPlaceholder: null,
    ariaPosInSet: ze,
    ariaPressed: ft,
    ariaReadOnly: ft,
    ariaRelevant: null,
    ariaRequired: ft,
    ariaRoleDescription: Xn,
    ariaRowCount: ze,
    ariaRowIndex: ze,
    ariaRowSpan: ze,
    ariaSelected: ft,
    ariaSetSize: ze,
    ariaSort: null,
    ariaValueMax: ze,
    ariaValueMin: ze,
    ariaValueNow: ze,
    ariaValueText: null,
    role: null
  }
}), tD = ia({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: N_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Hi,
    acceptCharset: Xn,
    accessKey: Xn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Xn,
    autoFocus: In,
    autoPlay: In,
    blocking: Xn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Xn,
    cols: ze,
    colSpan: null,
    content: null,
    contentEditable: ft,
    controls: In,
    controlsList: Xn,
    coords: ze | Hi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: b_,
    draggable: ft,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Xn,
    height: ze,
    hidden: In,
    high: ze,
    href: null,
    hrefLang: null,
    htmlFor: Xn,
    httpEquiv: Xn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Xn,
    itemRef: Xn,
    itemScope: In,
    itemType: Xn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: ze,
    manifest: null,
    max: null,
    maxLength: ze,
    media: null,
    method: null,
    min: null,
    minLength: ze,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: ze,
    pattern: null,
    ping: Xn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Xn,
    required: In,
    reversed: In,
    rows: ze,
    rowSpan: ze,
    sandbox: Xn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: ze,
    sizes: null,
    slot: null,
    span: ze,
    spellCheck: ft,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ze,
    step: null,
    style: null,
    tabIndex: ze,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: ft,
    width: ze,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ze,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ze,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ze,
    // `<img>` and `<object>`
    leftMargin: ze,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ze,
    // `<body>`
    marginWidth: ze,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ze,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ft,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ze,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ze,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: ze,
    security: null,
    unselectable: null
  }
}), rD = ia({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: S_,
  properties: {
    about: tr,
    accentHeight: ze,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ze,
    amplitude: ze,
    arabicForm: null,
    ascent: ze,
    attributeName: null,
    attributeType: null,
    azimuth: ze,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ze,
    by: null,
    calcMode: null,
    capHeight: ze,
    className: Xn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ze,
    diffuseConstant: ze,
    direction: null,
    display: null,
    dur: null,
    divisor: ze,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ze,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ze,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ze,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Hi,
    g2: Hi,
    glyphName: Hi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ze,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ze,
    horizOriginX: ze,
    horizOriginY: ze,
    id: null,
    ideographic: ze,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ze,
    k: ze,
    k1: ze,
    k2: ze,
    k3: ze,
    k4: ze,
    kernelMatrix: tr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ze,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ze,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ze,
    overlineThickness: ze,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ze,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ze,
    pointsAtY: ze,
    pointsAtZ: ze,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: tr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: tr,
    rev: tr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: tr,
    requiredFeatures: tr,
    requiredFonts: tr,
    requiredFormats: tr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ze,
    specularExponent: ze,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ze,
    strikethroughThickness: ze,
    string: null,
    stroke: null,
    strokeDashArray: tr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ze,
    strokeOpacity: ze,
    strokeWidth: null,
    style: null,
    surfaceScale: ze,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: tr,
    tabIndex: ze,
    tableValues: null,
    target: null,
    targetX: ze,
    targetY: ze,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: tr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ze,
    underlineThickness: ze,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ze,
    values: null,
    vAlphabetic: ze,
    vMathematical: ze,
    vectorEffect: null,
    vHanging: ze,
    vIdeographic: ze,
    version: null,
    vertAdvY: ze,
    vertOriginX: ze,
    vertOriginY: ze,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ze,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), iD = /^data[-\w.:]+$/i, xv = /-[a-z]/g, aD = /[A-Z]/g;
function oD(e, n) {
  const r = gm(n);
  let i = n, a = hr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && iD.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(xv, lD);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!xv.test(o)) {
        let s = o.replace(aD, sD);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Cp;
  }
  return new a(i, n);
}
function sD(e) {
  return "-" + e.toLowerCase();
}
function lD(e) {
  return e.charAt(1).toUpperCase();
}
const cD = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, dD = k_([__, x_, j_, w_, tD], "html"), Fp = k_([__, x_, j_, w_, rD], "svg");
function uD(e) {
  return e.join(" ").trim();
}
var Ti = {}, fu, _v;
function mD() {
  if (_v) return fu;
  _v = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  fu = function(S, N) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    N = N || {};
    var F = 1, y = 1;
    function M(O) {
      var q = O.match(n);
      q && (F += q.length);
      var Z = O.lastIndexOf(d);
      y = ~Z ? O.length - Z : y + O.length;
    }
    function T() {
      var O = { line: F, column: y };
      return function(q) {
        return q.position = new E(O), ee(), q;
      };
    }
    function E(O) {
      this.start = O, this.end = { line: F, column: y }, this.source = N.source;
    }
    E.prototype.content = S;
    function D(O) {
      var q = new Error(
        N.source + ":" + F + ":" + y + ": " + O
      );
      if (q.reason = O, q.filename = N.source, q.line = F, q.column = y, q.source = S, !N.silent) throw q;
    }
    function B(O) {
      var q = O.exec(S);
      if (q) {
        var Z = q[0];
        return M(Z), S = S.slice(Z.length), q;
      }
    }
    function ee() {
      B(r);
    }
    function X(O) {
      var q;
      for (O = O || []; q = ae(); )
        q !== !1 && O.push(q);
      return O;
    }
    function ae() {
      var O = T();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var q = 2; f != S.charAt(q) && (u != S.charAt(q) || m != S.charAt(q + 1)); )
          ++q;
        if (q += 2, f === S.charAt(q - 1))
          return D("End of comment missing");
        var Z = S.slice(2, q - 2);
        return y += 2, M(Z), S = S.slice(q), y += 2, O({
          type: h,
          comment: Z
        });
      }
    }
    function Q() {
      var O = T(), q = B(i);
      if (q) {
        if (ae(), !B(a)) return D("property missing ':'");
        var Z = B(o), ve = O({
          type: v,
          property: C(q[0].replace(e, f)),
          value: Z ? C(Z[0].replace(e, f)) : f
        });
        return B(s), ve;
      }
    }
    function z() {
      var O = [];
      X(O);
      for (var q; q = Q(); )
        q !== !1 && (O.push(q), X(O));
      return O;
    }
    return ee(), z();
  };
  function C(S) {
    return S ? S.replace(l, f) : f;
  }
  return fu;
}
var Sv;
function pD() {
  if (Sv) return Ti;
  Sv = 1;
  var e = Ti && Ti.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ti, "__esModule", { value: !0 }), Ti.default = r;
  var n = e(mD());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ti;
}
var fD = pD();
const Nv = /* @__PURE__ */ Hm(fD), hD = Nv.default || Nv, C_ = F_("end"), Ip = F_("start");
function F_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function yD(e) {
  const n = Ip(e), r = C_(e);
  if (n && r)
    return { start: n, end: r };
}
function Ga(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? jv(e.position) : "start" in e || "end" in e ? jv(e) : "line" in e || "column" in e ? km(e) : "";
}
function km(e) {
  return wv(e && e.line) + ":" + wv(e && e.column);
}
function jv(e) {
  return km(e && e.start) + "-" + km(e && e.end);
}
function wv(e) {
  return e && typeof e == "number" ? e : 1;
}
class Pt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ga(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Pt.prototype.file = "";
Pt.prototype.name = "";
Pt.prototype.reason = "";
Pt.prototype.message = "";
Pt.prototype.stack = "";
Pt.prototype.column = void 0;
Pt.prototype.line = void 0;
Pt.prototype.ancestors = void 0;
Pt.prototype.cause = void 0;
Pt.prototype.fatal = void 0;
Pt.prototype.place = void 0;
Pt.prototype.ruleId = void 0;
Pt.prototype.source = void 0;
const Ep = {}.hasOwnProperty, gD = /* @__PURE__ */ new Map(), vD = /[A-Z]/g, kD = /-([a-z])/g, bD = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), xD = /* @__PURE__ */ new Set(["td", "th"]), I_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function _D(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = ED(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = ID(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Fp : dD,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = E_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function E_(e, n, r) {
  if (n.type === "element")
    return SD(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return ND(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return wD(e, n, r);
  if (n.type === "mdxjsEsm")
    return jD(e, n);
  if (n.type === "root")
    return CD(e, n, r);
  if (n.type === "text")
    return FD(e, n);
}
function SD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Fp, e.schema = a), e.ancestors.push(n);
  const o = $_(e, n.tagName, !1), s = TD(e, n);
  let l = $p(e, n);
  return bD.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !Z$(d) : !0;
  })), T_(e, s, o, n), Tp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function ND(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  oo(e, n.position);
}
function jD(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  oo(e, n.position);
}
function wD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Fp, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : $_(e, n.name, !0), s = $D(e, n), l = $p(e, n);
  return T_(e, s, o, n), Tp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function CD(e, n, r) {
  const i = {};
  return Tp(i, $p(e, n)), e.create(n, e.Fragment, i, r);
}
function FD(e, n) {
  return n.value;
}
function T_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Tp(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function ID(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function ED(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Ip(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function TD(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Ep.call(n.properties, a)) {
      const o = DD(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && xD.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function $D(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        oo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          oo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function $p(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : gD;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = E_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function DD(e, n, r) {
  const i = oD(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? G$(r) : uD(r)), i.property === "style") {
      let a = typeof r == "object" ? r : RD(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = OD(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? cD[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function RD(e, n) {
  const r = {};
  try {
    hD(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Pt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = I_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(kD, PD)), r[s] = o;
  }
}
function $_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = vv(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = vv(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Ep.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  oo(e);
}
function oo(e, n) {
  const r = new Pt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = I_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function OD(e) {
  const n = {};
  let r;
  for (r in e)
    Ep.call(e, r) && (n[AD(r)] = e[r]);
  return n;
}
function AD(e) {
  let n = e.replace(vD, LD);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function PD(e, n) {
  return n.toUpperCase();
}
function LD(e) {
  return "-" + e.toLowerCase();
}
const hu = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, VD = {};
function zD(e, n) {
  const r = VD, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return D_(e, i, a);
}
function D_(e, n, r) {
  if (UD(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Cv(e.children, n, r);
  }
  return Array.isArray(e) ? Cv(e, n, r) : "";
}
function Cv(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = D_(e[a], n, r);
  return i.join("");
}
function UD(e) {
  return !!(e && typeof e == "object");
}
const Fv = document.createElement("i");
function Dp(e) {
  const n = "&" + e + ";";
  Fv.innerHTML = n;
  const r = Fv.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Ar(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ur(e, n) {
  return e.length > 0 ? (Ar(e, e.length, 0, n), e) : n;
}
const Iv = {}.hasOwnProperty;
function MD(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    BD(n, e[r]);
  return n;
}
function BD(e, n) {
  let r;
  for (r in n) {
    const a = (Iv.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Iv.call(a, s) || (a[s] = []);
        const l = o[s];
        qD(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function qD(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Ar(e, 0, 0, i);
}
function R_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Wi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Tr = ai(/[A-Za-z]/), sr = ai(/[\dA-Za-z]/), HD = ai(/[#-'*+\--9=?A-Z^-~]/);
function bm(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const xm = ai(/\d/), WD = ai(/[\dA-Fa-f]/), KD = ai(/[!-/:-@[-`{-~]/);
function kn(e) {
  return e !== null && e < -2;
}
function Zt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const GD = ai(new RegExp("\\p{P}|\\p{S}", "u")), YD = ai(/\s/);
function ai(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function aa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && sr(e.charCodeAt(r + 1)) && sr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const QD = {
  tokenize: JD
};
function JD(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return kn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const XD = {
  tokenize: ZD
}, Ev = {
  tokenize: eR
};
function ZD(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(M) {
    if (i < r.length) {
      const T = r[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, d, m)(M);
    }
    return m(M);
  }
  function d(M) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const T = n.events.length;
      let E = T, D;
      for (; E--; )
        if (n.events[E][0] === "exit" && n.events[E][1].type === "chunkFlow") {
          D = n.events[E][1].end;
          break;
        }
      F(i);
      let B = T;
      for (; B < n.events.length; )
        n.events[B][1].end = {
          ...D
        }, B++;
      return Ar(n.events, E + 1, 0, n.events.slice(T)), n.events.length = B, m(M);
    }
    return l(M);
  }
  function m(M) {
    if (i === r.length) {
      if (!a)
        return h(M);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(M);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Ev, u, f)(M);
  }
  function u(M) {
    return a && y(), F(i), h(M);
  }
  function f(M) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(M);
  }
  function h(M) {
    return n.containerState = {}, e.attempt(Ev, v, C)(M);
  }
  function v(M) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(M);
  }
  function C(M) {
    if (M === null) {
      a && y(), F(0), e.consume(M);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(M);
  }
  function S(M) {
    if (M === null) {
      N(e.exit("chunkFlow"), !0), F(0), e.consume(M);
      return;
    }
    return kn(M) ? (e.consume(M), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(M), S);
  }
  function N(M, T) {
    const E = n.sliceStream(M);
    if (T && E.push(null), M.previous = o, o && (o.next = M), o = M, a.defineSkip(M.start), a.write(E), n.parser.lazy[M.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const B = n.events.length;
      let ee = B, X, ae;
      for (; ee--; )
        if (n.events[ee][0] === "exit" && n.events[ee][1].type === "chunkFlow") {
          if (X) {
            ae = n.events[ee][1].end;
            break;
          }
          X = !0;
        }
      for (F(i), D = B; D < n.events.length; )
        n.events[D][1].end = {
          ...ae
        }, D++;
      Ar(n.events, ee + 1, 0, n.events.slice(B)), n.events.length = D;
    }
  }
  function F(M) {
    let T = r.length;
    for (; T-- > M; ) {
      const E = r[T];
      n.containerState = E[1], E[0].exit.call(n, e);
    }
    r.length = M;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function eR(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Tv(e) {
  if (e === null || Zt(e) || YD(e))
    return 1;
  if (GD(e))
    return 2;
}
function Rp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const _m = {
  name: "attention",
  resolveAll: nR,
  tokenize: tR
};
function nR(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          $v(f, -d), $v(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ur(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ur(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ur(m, Rp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = ur(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = ur(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Ar(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function tR(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Tv(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Tv(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function $v(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const rR = {
  name: "autolink",
  tokenize: iR
};
function iR(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Tr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || sr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || sr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || bm(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : HD(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return sr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || sr(v)) && i++ < 63) {
      const C = v === 45 ? h : f;
      return e.consume(v), C;
    }
    return r(v);
  }
}
const ol = {
  partial: !0,
  tokenize: aR
};
function aR(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || kn(o) ? n(o) : r(o);
  }
}
const O_ = {
  continuation: {
    tokenize: sR
  },
  exit: lR,
  name: "blockQuote",
  tokenize: oR
};
function oR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function sR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(O_, n, r)(s);
  }
}
function lR(e) {
  e.exit("blockQuote");
}
const A_ = {
  name: "characterEscape",
  tokenize: cR
};
function cR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return KD(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const P_ = {
  name: "characterReference",
  tokenize: dR
};
function dR(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = sr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = WD, u) : (e.enter("characterReferenceValue"), o = 7, s = xm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === sr && !Dp(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Dv = {
  partial: !0,
  tokenize: mR
}, Rv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: uR
};
function uR(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: E
  };
  let o = 0, s = 0, l;
  return d;
  function d(D) {
    return m(D);
  }
  function m(D) {
    const B = i.events[i.events.length - 1];
    return o = B && B[1].type === "linePrefix" ? B[2].sliceSerialize(B[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(D);
  }
  function u(D) {
    return D === l ? (s++, e.consume(D), u) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), zn(D) ? et(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || kn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(Dv, S, T)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || kn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : zn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, v, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function v(D) {
    return D === null || kn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(D));
  }
  function C(D) {
    return D === null || kn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), C);
  }
  function S(D) {
    return e.attempt(a, T, N)(D);
  }
  function N(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), F;
  }
  function F(D) {
    return o > 0 && zn(D) ? et(e, y, "linePrefix", o + 1)(D) : y(D);
  }
  function y(D) {
    return D === null || kn(D) ? e.check(Dv, S, T)(D) : (e.enter("codeFlowValue"), M(D));
  }
  function M(D) {
    return D === null || kn(D) ? (e.exit("codeFlowValue"), y(D)) : (e.consume(D), M);
  }
  function T(D) {
    return e.exit("codeFenced"), n(D);
  }
  function E(D, B, ee) {
    let X = 0;
    return ae;
    function ae(Z) {
      return D.enter("lineEnding"), D.consume(Z), D.exit("lineEnding"), Q;
    }
    function Q(Z) {
      return D.enter("codeFencedFence"), zn(Z) ? et(D, z, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(Z) : z(Z);
    }
    function z(Z) {
      return Z === l ? (D.enter("codeFencedFenceSequence"), O(Z)) : ee(Z);
    }
    function O(Z) {
      return Z === l ? (X++, D.consume(Z), O) : X >= s ? (D.exit("codeFencedFenceSequence"), zn(Z) ? et(D, q, "whitespace")(Z) : q(Z)) : ee(Z);
    }
    function q(Z) {
      return Z === null || kn(Z) ? (D.exit("codeFencedFence"), B(Z)) : ee(Z);
    }
  }
}
function mR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const yu = {
  name: "codeIndented",
  tokenize: fR
}, pR = {
  partial: !0,
  tokenize: hR
};
function fR(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : kn(m) ? e.attempt(pR, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || kn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function hR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : kn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : kn(s) ? a(s) : r(s);
  }
}
const yR = {
  name: "codeText",
  previous: vR,
  resolve: gR,
  tokenize: kR
};
function gR(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function vR(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function kR(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : kn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || kn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class bR {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && xa(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), xa(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), xa(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        xa(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        xa(this.left, r.reverse());
      }
  }
}
function xa(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function L_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new bR(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, xR(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Ar(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function xR(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, C = 0, S = 0;
  const N = [S];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, N.push(S), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const F = l.slice(N[h], N[h + 1]), y = o.pop();
    d.push([y, y + F.length - 1]), e.splice(y, 2, F);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const _R = {
  resolve: NR,
  tokenize: jR
}, SR = {
  partial: !0,
  tokenize: wR
};
function NR(e) {
  return L_(e), e;
}
function jR(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : kn(l) ? e.check(SR, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function wR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || kn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function V_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(F) {
    return F === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(F), e.exit(o), h) : F === null || F === 32 || F === 41 || bm(F) ? r(F) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(F));
  }
  function h(F) {
    return F === 62 ? (e.enter(o), e.consume(F), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(F));
  }
  function v(F) {
    return F === 62 ? (e.exit("chunkString"), e.exit(l), h(F)) : F === null || F === 60 || kn(F) ? r(F) : (e.consume(F), F === 92 ? C : v);
  }
  function C(F) {
    return F === 60 || F === 62 || F === 92 ? (e.consume(F), v) : v(F);
  }
  function S(F) {
    return !u && (F === null || F === 41 || Zt(F)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(F)) : u < m && F === 40 ? (e.consume(F), u++, S) : F === 41 ? (e.consume(F), u--, S) : F === null || F === 32 || F === 40 || bm(F) ? r(F) : (e.consume(F), F === 92 ? N : S);
  }
  function N(F) {
    return F === 40 || F === 41 || F === 92 ? (e.consume(F), S) : S(F);
  }
}
function z_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : kn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || kn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function U_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : kn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || kn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Ya(e, n) {
  let r;
  return i;
  function i(a) {
    return kn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const CR = {
  name: "definition",
  tokenize: IR
}, FR = {
  partial: !0,
  tokenize: ER
};
function IR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return z_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Wi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Zt(v) ? Ya(e, m)(v) : m(v);
  }
  function m(v) {
    return V_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(FR, f, f)(v);
  }
  function f(v) {
    return zn(v) ? et(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || kn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function ER(e, n, r) {
  return i;
  function i(l) {
    return Zt(l) ? Ya(e, a)(l) : r(l);
  }
  function a(l) {
    return U_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || kn(l) ? n(l) : r(l);
  }
}
const TR = {
  name: "hardBreakEscape",
  tokenize: $R
};
function $R(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return kn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const DR = {
  name: "headingAtx",
  resolve: RR,
  tokenize: OR
};
function RR(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Ar(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function OR(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Zt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || kn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Zt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const AR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ov = ["pre", "script", "style", "textarea"], PR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: zR,
  tokenize: UR
}, LR = {
  partial: !0,
  tokenize: BR
}, VR = {
  partial: !0,
  tokenize: MR
};
function zR(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function UR(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, S) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : H) : Tr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, v) : K === 91 ? (e.consume(K), a = 5, l = 0, C) : Tr(K) ? (e.consume(K), a = 4, i.interrupt ? n : H) : r(K);
  }
  function v(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : H) : r(K);
  }
  function C(K) {
    const qe = "CDATA[";
    return K === qe.charCodeAt(l++) ? (e.consume(K), l === qe.length ? i.interrupt ? n : z : C) : r(K);
  }
  function S(K) {
    return Tr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : r(K);
  }
  function N(K) {
    if (K === null || K === 47 || K === 62 || Zt(K)) {
      const qe = K === 47, Be = s.toLowerCase();
      return !qe && !o && Ov.includes(Be) ? (a = 1, i.interrupt ? n(K) : z(K)) : AR.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(K), F) : i.interrupt ? n(K) : z(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? y(K) : M(K));
    }
    return K === 45 || sr(K) ? (e.consume(K), s += String.fromCharCode(K), N) : r(K);
  }
  function F(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : z) : r(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ae(K);
  }
  function M(K) {
    return K === 47 ? (e.consume(K), ae) : K === 58 || K === 95 || Tr(K) ? (e.consume(K), T) : zn(K) ? (e.consume(K), M) : ae(K);
  }
  function T(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || sr(K) ? (e.consume(K), T) : E(K);
  }
  function E(K) {
    return K === 61 ? (e.consume(K), D) : zn(K) ? (e.consume(K), E) : M(K);
  }
  function D(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, B) : zn(K) ? (e.consume(K), D) : ee(K);
  }
  function B(K) {
    return K === d ? (e.consume(K), d = null, X) : K === null || kn(K) ? r(K) : (e.consume(K), B);
  }
  function ee(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Zt(K) ? E(K) : (e.consume(K), ee);
  }
  function X(K) {
    return K === 47 || K === 62 || zn(K) ? M(K) : r(K);
  }
  function ae(K) {
    return K === 62 ? (e.consume(K), Q) : r(K);
  }
  function Q(K) {
    return K === null || kn(K) ? z(K) : zn(K) ? (e.consume(K), Q) : r(K);
  }
  function z(K) {
    return K === 45 && a === 2 ? (e.consume(K), ve) : K === 60 && a === 1 ? (e.consume(K), ce) : K === 62 && a === 4 ? (e.consume(K), _e) : K === 63 && a === 3 ? (e.consume(K), H) : K === 93 && a === 5 ? (e.consume(K), me) : kn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(LR, Ee, O)(K)) : K === null || kn(K) ? (e.exit("htmlFlowData"), O(K)) : (e.consume(K), z);
  }
  function O(K) {
    return e.check(VR, q, Ee)(K);
  }
  function q(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), Z;
  }
  function Z(K) {
    return K === null || kn(K) ? O(K) : (e.enter("htmlFlowData"), z(K));
  }
  function ve(K) {
    return K === 45 ? (e.consume(K), H) : z(K);
  }
  function ce(K) {
    return K === 47 ? (e.consume(K), s = "", le) : z(K);
  }
  function le(K) {
    if (K === 62) {
      const qe = s.toLowerCase();
      return Ov.includes(qe) ? (e.consume(K), _e) : z(K);
    }
    return Tr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), le) : z(K);
  }
  function me(K) {
    return K === 93 ? (e.consume(K), H) : z(K);
  }
  function H(K) {
    return K === 62 ? (e.consume(K), _e) : K === 45 && a === 2 ? (e.consume(K), H) : z(K);
  }
  function _e(K) {
    return K === null || kn(K) ? (e.exit("htmlFlowData"), Ee(K)) : (e.consume(K), _e);
  }
  function Ee(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function MR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return kn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function BR(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(ol, n, r);
  }
}
const qR = {
  name: "htmlText",
  tokenize: HR
};
function HR(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(H) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(H), d;
  }
  function d(H) {
    return H === 33 ? (e.consume(H), m) : H === 47 ? (e.consume(H), E) : H === 63 ? (e.consume(H), M) : Tr(H) ? (e.consume(H), ee) : r(H);
  }
  function m(H) {
    return H === 45 ? (e.consume(H), u) : H === 91 ? (e.consume(H), o = 0, C) : Tr(H) ? (e.consume(H), y) : r(H);
  }
  function u(H) {
    return H === 45 ? (e.consume(H), v) : r(H);
  }
  function f(H) {
    return H === null ? r(H) : H === 45 ? (e.consume(H), h) : kn(H) ? (s = f, ce(H)) : (e.consume(H), f);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), v) : f(H);
  }
  function v(H) {
    return H === 62 ? ve(H) : H === 45 ? h(H) : f(H);
  }
  function C(H) {
    const _e = "CDATA[";
    return H === _e.charCodeAt(o++) ? (e.consume(H), o === _e.length ? S : C) : r(H);
  }
  function S(H) {
    return H === null ? r(H) : H === 93 ? (e.consume(H), N) : kn(H) ? (s = S, ce(H)) : (e.consume(H), S);
  }
  function N(H) {
    return H === 93 ? (e.consume(H), F) : S(H);
  }
  function F(H) {
    return H === 62 ? ve(H) : H === 93 ? (e.consume(H), F) : S(H);
  }
  function y(H) {
    return H === null || H === 62 ? ve(H) : kn(H) ? (s = y, ce(H)) : (e.consume(H), y);
  }
  function M(H) {
    return H === null ? r(H) : H === 63 ? (e.consume(H), T) : kn(H) ? (s = M, ce(H)) : (e.consume(H), M);
  }
  function T(H) {
    return H === 62 ? ve(H) : M(H);
  }
  function E(H) {
    return Tr(H) ? (e.consume(H), D) : r(H);
  }
  function D(H) {
    return H === 45 || sr(H) ? (e.consume(H), D) : B(H);
  }
  function B(H) {
    return kn(H) ? (s = B, ce(H)) : zn(H) ? (e.consume(H), B) : ve(H);
  }
  function ee(H) {
    return H === 45 || sr(H) ? (e.consume(H), ee) : H === 47 || H === 62 || Zt(H) ? X(H) : r(H);
  }
  function X(H) {
    return H === 47 ? (e.consume(H), ve) : H === 58 || H === 95 || Tr(H) ? (e.consume(H), ae) : kn(H) ? (s = X, ce(H)) : zn(H) ? (e.consume(H), X) : ve(H);
  }
  function ae(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || sr(H) ? (e.consume(H), ae) : Q(H);
  }
  function Q(H) {
    return H === 61 ? (e.consume(H), z) : kn(H) ? (s = Q, ce(H)) : zn(H) ? (e.consume(H), Q) : X(H);
  }
  function z(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? r(H) : H === 34 || H === 39 ? (e.consume(H), a = H, O) : kn(H) ? (s = z, ce(H)) : zn(H) ? (e.consume(H), z) : (e.consume(H), q);
  }
  function O(H) {
    return H === a ? (e.consume(H), a = void 0, Z) : H === null ? r(H) : kn(H) ? (s = O, ce(H)) : (e.consume(H), O);
  }
  function q(H) {
    return H === null || H === 34 || H === 39 || H === 60 || H === 61 || H === 96 ? r(H) : H === 47 || H === 62 || Zt(H) ? X(H) : (e.consume(H), q);
  }
  function Z(H) {
    return H === 47 || H === 62 || Zt(H) ? X(H) : r(H);
  }
  function ve(H) {
    return H === 62 ? (e.consume(H), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(H);
  }
  function ce(H) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), le;
  }
  function le(H) {
    return zn(H) ? et(e, me, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : me(H);
  }
  function me(H) {
    return e.enter("htmlTextData"), s(H);
  }
}
const Op = {
  name: "labelEnd",
  resolveAll: YR,
  resolveTo: QR,
  tokenize: JR
}, WR = {
  tokenize: XR
}, KR = {
  tokenize: ZR
}, GR = {
  tokenize: eO
};
function YR(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Ar(e, 0, e.length, r), e;
}
function QR(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ur(l, e.slice(o + 1, o + i + 3)), l = ur(l, [["enter", u, n]]), l = ur(l, Rp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ur(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ur(l, e.slice(s + 1)), l = ur(l, [["exit", d, n]]), Ar(e, o, e.length, l), e;
}
function JR(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Wi(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(WR, u, s ? u : f)(h) : h === 91 ? e.attempt(KR, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(GR, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function XR(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Zt(f) ? Ya(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : V_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Zt(f) ? Ya(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? U_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Zt(f) ? Ya(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function ZR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return z_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Wi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function eO(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const nO = {
  name: "labelStartImage",
  resolveAll: Op.resolveAll,
  tokenize: tO
};
function tO(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const rO = {
  name: "labelStartLink",
  resolveAll: Op.resolveAll,
  tokenize: iO
};
function iO(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const gu = {
  name: "lineEnding",
  tokenize: aO
};
function aO(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const ys = {
  name: "thematicBreak",
  tokenize: oO
};
function oO(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || kn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Yt = {
  continuation: {
    tokenize: dO
  },
  exit: mO,
  name: "list",
  tokenize: cO
}, sO = {
  partial: !0,
  tokenize: pO
}, lO = {
  partial: !0,
  tokenize: uO
};
function cO(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const C = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : xm(v)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(ys, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return xm(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      ol,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(sO, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function dO(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(ol, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(lO, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Yt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function uO(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function mO(e) {
  e.exit(this.containerState.type);
}
function pO(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Av = {
  name: "setextUnderline",
  resolveTo: fO,
  tokenize: hO
};
function fO(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function hO(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || kn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const yO = {
  tokenize: gO
};
function gO(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    ol,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(_R, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const vO = {
  resolveAll: B_()
}, kO = M_("string"), bO = M_("text");
function M_(e) {
  return {
    resolveAll: B_(e === "text" ? xO : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function B_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function xO(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const _O = {
  42: Yt,
  43: Yt,
  45: Yt,
  48: Yt,
  49: Yt,
  50: Yt,
  51: Yt,
  52: Yt,
  53: Yt,
  54: Yt,
  55: Yt,
  56: Yt,
  57: Yt,
  62: O_
}, SO = {
  91: CR
}, NO = {
  [-2]: yu,
  [-1]: yu,
  32: yu
}, jO = {
  35: DR,
  42: ys,
  45: [Av, ys],
  60: PR,
  61: Av,
  95: ys,
  96: Rv,
  126: Rv
}, wO = {
  38: P_,
  92: A_
}, CO = {
  [-5]: gu,
  [-4]: gu,
  [-3]: gu,
  33: nO,
  38: P_,
  42: _m,
  60: [rR, qR],
  91: rO,
  92: [TR, A_],
  93: Op,
  95: _m,
  96: yR
}, FO = {
  null: [_m, vO]
}, IO = {
  null: [42, 95]
}, EO = {
  null: []
}, TO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: IO,
  contentInitial: SO,
  disable: EO,
  document: _O,
  flow: jO,
  flowInitial: NO,
  insideSpan: FO,
  string: wO,
  text: CO
}, Symbol.toStringTag, { value: "Module" }));
function $O(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: B(E),
    check: B(D),
    consume: y,
    enter: M,
    exit: T,
    interrupt: B(D, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(Q) {
    return s = ur(s, Q), N(), s[s.length - 1] !== null ? [] : (ee(n, 0), m.events = Rp(o, m.events, m), m.events);
  }
  function h(Q, z) {
    return RO(v(Q), z);
  }
  function v(Q) {
    return DO(s, Q);
  }
  function C() {
    const {
      _bufferIndex: Q,
      _index: z,
      line: O,
      column: q,
      offset: Z
    } = i;
    return {
      _bufferIndex: Q,
      _index: z,
      line: O,
      column: q,
      offset: Z
    };
  }
  function S(Q) {
    a[Q.line] = Q.column, ae();
  }
  function N() {
    let Q;
    for (; i._index < s.length; ) {
      const z = s[i._index];
      if (typeof z == "string")
        for (Q = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === Q && i._bufferIndex < z.length; )
          F(z.charCodeAt(i._bufferIndex));
      else
        F(z);
    }
  }
  function F(Q) {
    u = u(Q);
  }
  function y(Q) {
    kn(Q) ? (i.line++, i.column = 1, i.offset += Q === -3 ? 2 : 1, ae()) : Q !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = Q;
  }
  function M(Q, z) {
    const O = z || {};
    return O.type = Q, O.start = C(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function T(Q) {
    const z = l.pop();
    return z.end = C(), m.events.push(["exit", z, m]), z;
  }
  function E(Q, z) {
    ee(Q, z.from);
  }
  function D(Q, z) {
    z.restore();
  }
  function B(Q, z) {
    return O;
    function O(q, Z, ve) {
      let ce, le, me, H;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Ee(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Ee([
          /** @type {Construct} */
          q
        ])
      ) : _e(q);
      function _e(Pe) {
        return Me;
        function Me(Fe) {
          const Le = Fe !== null && Pe[Fe], De = Fe !== null && Pe.null, tn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(De) ? De : De ? [De] : []
          ];
          return Ee(tn)(Fe);
        }
      }
      function Ee(Pe) {
        return ce = Pe, le = 0, Pe.length === 0 ? ve : K(Pe[le]);
      }
      function K(Pe) {
        return Me;
        function Me(Fe) {
          return H = X(), me = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Be() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            z ? Object.assign(Object.create(m), z) : m,
            d,
            qe,
            Be
          )(Fe);
        }
      }
      function qe(Pe) {
        return Q(me, H), Z;
      }
      function Be(Pe) {
        return H.restore(), ++le < ce.length ? K(ce[le]) : ve;
      }
    }
  }
  function ee(Q, z) {
    Q.resolveAll && !o.includes(Q) && o.push(Q), Q.resolve && Ar(m.events, z, m.events.length - z, Q.resolve(m.events.slice(z), m)), Q.resolveTo && (m.events = Q.resolveTo(m.events, m));
  }
  function X() {
    const Q = C(), z = m.previous, O = m.currentConstruct, q = m.events.length, Z = Array.from(l);
    return {
      from: q,
      restore: ve
    };
    function ve() {
      i = Q, m.previous = z, m.currentConstruct = O, m.events.length = q, l = Z, ae();
    }
  }
  function ae() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function DO(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function RO(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function OO(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      MD([TO, ...(e || {}).extensions || []])
    ),
    content: a(QD),
    defined: [],
    document: a(XD),
    flow: a(yO),
    lazy: {},
    string: a(kO),
    text: a(bO)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return $O(i, o, l);
    }
  }
}
function AO(e) {
  for (; !L_(e); )
    ;
  return e;
}
const Pv = /[\0\t\n\r]/g;
function PO() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Pv.lastIndex = f, m = Pv.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const LO = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function VO(e) {
  return e.replace(LO, zO);
}
function zO(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return R_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Dp(r) || e;
}
const q_ = {}.hasOwnProperty;
function UO(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), MO(r)(AO(OO(r).document().write(PO()(e, n, !0))));
}
function MO(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Oe),
      autolinkProtocol: X,
      autolinkEmail: X,
      atxHeading: o(ue),
      blockQuote: o(De),
      characterEscape: X,
      characterReference: X,
      codeFenced: o(tn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(tn, s),
      codeText: o(Ie, s),
      codeTextData: X,
      data: X,
      codeFlowValue: X,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(en),
      hardBreakEscape: o(ye),
      hardBreakTrailing: o(ye),
      htmlFlow: o($e, s),
      htmlFlowData: X,
      htmlText: o($e, s),
      htmlTextData: X,
      image: o(Ve),
      label: s,
      link: o(Oe),
      listItem: o(w),
      listItemValue: h,
      listOrdered: o(ln, f),
      listUnordered: o(ln),
      paragraph: o(x),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(ue),
      strong: o($),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: E,
      autolink: d(),
      autolinkEmail: Le,
      autolinkProtocol: Fe,
      blockQuote: d(),
      characterEscapeValue: ae,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Pe,
      characterReference: Me,
      codeFenced: d(N),
      codeFencedFence: S,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: C,
      codeFlowValue: ae,
      codeIndented: d(F),
      codeText: d(Z),
      codeTextData: ae,
      data: ae,
      definition: d(),
      definitionDestinationString: T,
      definitionLabelString: y,
      definitionTitleString: M,
      emphasis: d(),
      hardBreakEscape: d(z),
      hardBreakTrailing: d(z),
      htmlFlow: d(O),
      htmlFlowData: ae,
      htmlText: d(q),
      htmlTextData: ae,
      image: d(ce),
      label: me,
      labelText: le,
      lineEnding: Q,
      link: d(ve),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: qe,
      resourceDestinationString: H,
      resourceTitleString: _e,
      resource: Ee,
      setextHeading: d(ee),
      setextHeadingLineSequence: B,
      setextHeadingText: D,
      strong: d(),
      thematicBreak: d()
    }
  };
  H_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(R) {
    let V = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [V],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, he = [];
    let Ne = -1;
    for (; ++Ne < R.length; )
      if (R[Ne][1].type === "listOrdered" || R[Ne][1].type === "listUnordered")
        if (R[Ne][0] === "enter")
          he.push(Ne);
        else {
          const nn = he.pop();
          Ne = a(R, nn, Ne);
        }
    for (Ne = -1; ++Ne < R.length; ) {
      const nn = n[R[Ne][0]];
      q_.call(nn, R[Ne][1].type) && nn[R[Ne][1].type].call(Object.assign({
        sliceSerialize: R[Ne][2].sliceSerialize
      }, ie), R[Ne][1]);
    }
    if (ie.tokenStack.length > 0) {
      const nn = ie.tokenStack[ie.tokenStack.length - 1];
      (nn[1] || Lv).call(ie, void 0, nn[0]);
    }
    for (V.position = {
      start: Xr(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Xr(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ne = -1; ++Ne < n.transforms.length; )
      V = n.transforms[Ne](V) || V;
    return V;
  }
  function a(R, V, ie) {
    let he = V - 1, Ne = -1, nn = !1, mn, rn, un, fn;
    for (; ++he <= ie; ) {
      const cn = R[he];
      switch (cn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          cn[0] === "enter" ? Ne++ : Ne--, fn = void 0;
          break;
        }
        case "lineEndingBlank": {
          cn[0] === "enter" && (mn && !fn && !Ne && !un && (un = he), fn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          fn = void 0;
      }
      if (!Ne && cn[0] === "enter" && cn[1].type === "listItemPrefix" || Ne === -1 && cn[0] === "exit" && (cn[1].type === "listUnordered" || cn[1].type === "listOrdered")) {
        if (mn) {
          let xn = he;
          for (rn = void 0; xn--; ) {
            const Ze = R[xn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              rn && (R[rn][1].type = "lineEndingBlank", nn = !0), Ze[1].type = "lineEnding", rn = xn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          un && (!rn || un < rn) && (mn._spread = !0), mn.end = Object.assign({}, rn ? R[rn][1].start : cn[1].end), R.splice(rn || he, 0, ["exit", mn, cn[2]]), he++, ie++;
        }
        if (cn[1].type === "listItemPrefix") {
          const xn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, cn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          mn = xn, R.splice(he, 0, ["enter", xn, cn[2]]), he++, ie++, un = void 0, fn = !0;
        }
      }
    }
    return R[V][1]._spread = nn, ie;
  }
  function o(R, V) {
    return ie;
    function ie(he) {
      l.call(this, R(he), he), V && V.call(this, he);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, V, ie) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([V, ie || void 0]), R.position = {
      start: Xr(V.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(R) {
    return V;
    function V(ie) {
      R && R.call(this, ie), m.call(this, ie);
    }
  }
  function m(R, V) {
    const ie = this.stack.pop(), he = this.tokenStack.pop();
    if (he)
      he[0].type !== R.type && (V ? V.call(this, R, he[0]) : (he[1] || Lv).call(this, R, he[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + Ga({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    ie.position.end = Xr(R.end);
  }
  function u() {
    return zD(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const V = this.stack[this.stack.length - 2];
      V.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.lang = R;
  }
  function C() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function F() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const V = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = V, ie.identifier = Wi(this.sliceSerialize(R)).toLowerCase();
  }
  function M() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = R;
  }
  function T() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = R;
  }
  function E(R) {
    const V = this.stack[this.stack.length - 1];
    if (!V.depth) {
      const ie = this.sliceSerialize(R).length;
      V.depth = ie;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function B(R) {
    const V = this.stack[this.stack.length - 1];
    V.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function ee() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function X(R) {
    const ie = this.stack[this.stack.length - 1].children;
    let he = ie[ie.length - 1];
    (!he || he.type !== "text") && (he = G(), he.position = {
      start: Xr(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(he)), this.stack.push(he);
  }
  function ae(R) {
    const V = this.stack.pop();
    V.value += this.sliceSerialize(R), V.position.end = Xr(R.end);
  }
  function Q(R) {
    const V = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = V.children[V.children.length - 1];
      ie.position.end = Xr(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(V.type) && (X.call(this, R), ae.call(this, R));
  }
  function z() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function q() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function Z() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function ve() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = V, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ce() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = V, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function le(R) {
    const V = this.sliceSerialize(R), ie = this.stack[this.stack.length - 2];
    ie.label = VO(V), ie.identifier = Wi(V).toLowerCase();
  }
  function me() {
    const R = this.stack[this.stack.length - 1], V = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const he = R.children;
      ie.children = he;
    } else
      ie.alt = V;
  }
  function H() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = R;
  }
  function _e() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = R;
  }
  function Ee() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function qe(R) {
    const V = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = V, ie.identifier = Wi(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(R) {
    this.data.characterReferenceType = R.type;
  }
  function Pe(R) {
    const V = this.sliceSerialize(R), ie = this.data.characterReferenceType;
    let he;
    ie ? (he = R_(V, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : he = Dp(V);
    const Ne = this.stack[this.stack.length - 1];
    Ne.value += he;
  }
  function Me(R) {
    const V = this.stack.pop();
    V.position.end = Xr(R.end);
  }
  function Fe(R) {
    ae.call(this, R);
    const V = this.stack[this.stack.length - 1];
    V.url = this.sliceSerialize(R);
  }
  function Le(R) {
    ae.call(this, R);
    const V = this.stack[this.stack.length - 1];
    V.url = "mailto:" + this.sliceSerialize(R);
  }
  function De() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function tn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ie() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function en() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ue() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ye() {
    return {
      type: "break"
    };
  }
  function $e() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Oe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ln(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function w(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function x() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function $() {
    return {
      type: "strong",
      children: []
    };
  }
  function G() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function Xr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function H_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? H_(e, i) : BO(e, i);
  }
}
function BO(e, n) {
  let r;
  for (r in n)
    if (q_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Lv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ga({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ga({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ga({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function qO(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return UO(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function HO(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function WO(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function KO(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function GO(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function YO(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function QO(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = aa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function JO(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function XO(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function W_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function ZO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return W_(e, n);
  const a = { src: aa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function eA(e, n) {
  const r = { src: aa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function nA(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function tA(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return W_(e, n);
  const a = { href: aa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function rA(e, n) {
  const r = { href: aa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function iA(e, n, r) {
  const i = e.all(n), a = r ? aA(r) : K_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function aA(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = K_(r[i]);
  }
  return n;
}
function K_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function oA(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function sA(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function lA(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function cA(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function dA(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Ip(n.children[1]), d = C_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function uA(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function mA(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Vv = 9, zv = 32;
function pA(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Uv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Uv(n.slice(a), a > 0, !1)), o.join("");
}
function Uv(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Vv || o === zv; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Vv || o === zv; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function fA(e, n) {
  const r = { type: "text", value: pA(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function hA(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const yA = {
  blockquote: HO,
  break: WO,
  code: KO,
  delete: GO,
  emphasis: YO,
  footnoteReference: QO,
  heading: JO,
  html: XO,
  imageReference: ZO,
  image: eA,
  inlineCode: nA,
  linkReference: tA,
  link: rA,
  listItem: iA,
  list: oA,
  paragraph: sA,
  // @ts-expect-error: root is different, but hard to type.
  root: lA,
  strong: cA,
  table: dA,
  tableCell: mA,
  tableRow: uA,
  text: fA,
  thematicBreak: hA,
  toml: Vo,
  yaml: Vo,
  definition: Vo,
  footnoteDefinition: Vo
};
function Vo() {
}
const G_ = -1, sl = 0, Es = 1, Ts = 2, Ap = 3, Pp = 4, Lp = 5, Vp = 6, Y_ = 7, Q_ = 8, Mv = typeof self == "object" ? self : globalThis, gA = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case sl:
      case G_:
        return r(s, a);
      case Es: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case Ts: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Ap:
        return r(new Date(s), a);
      case Pp: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case Lp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Vp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case Y_: {
        const { name: l, message: d } = s;
        return r(new Mv[l](d), a);
      }
      case Q_:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Mv[o](s), a);
  };
  return i;
}, Bv = (e) => gA(/* @__PURE__ */ new Map(), e)(0), $i = "", { toString: vA } = {}, { keys: kA } = Object, _a = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [sl, n];
  const r = vA.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Es, $i];
    case "Object":
      return [Ts, $i];
    case "Date":
      return [Ap, $i];
    case "RegExp":
      return [Pp, $i];
    case "Map":
      return [Lp, $i];
    case "Set":
      return [Vp, $i];
  }
  return r.includes("Array") ? [Es, r] : r.includes("Error") ? [Y_, r] : [Ts, r];
}, zo = ([e, n]) => e === sl && (n === "function" || n === "symbol"), bA = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = _a(s);
    switch (l) {
      case sl: {
        let u = s;
        switch (d) {
          case "bigint":
            l = Q_, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([G_], s);
        }
        return a([l, u], s);
      }
      case Es: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case Ts: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of kA(s))
          (e || !zo(_a(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Ap:
        return a([l, s.toISOString()], s);
      case Pp: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case Lp: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(zo(_a(h)) || zo(_a(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case Vp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !zo(_a(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, qv = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return bA(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, $s = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Bv(qv(e, n)) : structuredClone(e)
) : (e, n) => Bv(qv(e, n));
function xA(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function _A(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function SA(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || xA, i = e.options.footnoteBackLabel || _A, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = aa(f.toLowerCase());
    let v = 0;
    const C = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++v <= S; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, v);
      typeof y == "string" && (y = { type: "text", value: y }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const y = N.children[N.children.length - 1];
      y && y.type === "text" ? y.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...C);
    } else
      u.push(...C);
    const F = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, F), l.push(F);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...$s(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const J_ = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return CA;
    if (typeof e == "function")
      return ll(e);
    if (typeof e == "object")
      return Array.isArray(e) ? NA(e) : jA(e);
    if (typeof e == "string")
      return wA(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function NA(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = J_(e[r]);
  return ll(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function jA(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return ll(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function wA(e) {
  return ll(n);
  function n(r) {
    return r && r.type === e;
  }
}
function ll(e) {
  return n;
  function n(r, i, a) {
    return !!(FA(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function CA() {
  return !0;
}
function FA(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const X_ = [], IA = !0, Hv = !1, EA = "skip";
function TA(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = J_(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = X_, C, S, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = $A(r(d, u)), v[0] === Hv))
        return v;
      if ("children" in d && d.children) {
        const F = (
          /** @type {UnistParent} */
          d
        );
        if (F.children && v[0] !== EA)
          for (S = (i ? F.children.length : -1) + s, N = u.concat(F); S > -1 && S < F.children.length; ) {
            const y = F.children[S];
            if (C = l(y, S, N)(), C[0] === Hv)
              return C;
            S = typeof C[1] == "number" ? C[1] : S + s;
          }
      }
      return v;
    }
  }
}
function $A(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [IA, e] : e == null ? X_ : [e];
}
function Z_(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), TA(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const Sm = {}.hasOwnProperty, DA = {};
function RA(e, n) {
  const r = n || DA, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...yA, ...r.handlers }, l = {
    all: m,
    applyData: AA,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: OA,
    wrap: LA
  };
  return Z_(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (Sm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...N } = u, F = $s(N);
        return F.children = l.all(u), F;
      }
      return $s(u);
    }
    return (l.options.unknownHandler || PA)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const C = l.one(h[v], u);
        if (C) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = Wv(C.value)), !Array.isArray(C) && C.type === "element")) {
            const S = C.children[0];
            S && S.type === "text" && (S.value = Wv(S.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function OA(e, n) {
  e.position && (n.position = yD(e));
}
function AA(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, $s(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function PA(e, n) {
  const r = n.data || {}, i = "value" in n && !(Sm.call(r, "hProperties") || Sm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function LA(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Wv(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Kv(e, n) {
  const r = RA(e, n), i = r.one(e, void 0), a = SA(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function VA(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Kv(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Kv(r, { file: i, ...e || n })
    );
  };
}
function Gv(e) {
  if (e)
    throw e;
}
var vu, Yv;
function zA() {
  if (Yv) return vu;
  Yv = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return vu = function d() {
    var m, u, f, h, v, C, S = arguments[0], N = 1, F = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, N = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); N < F; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(S, { name: u, newValue: d(y, C, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, vu;
}
var UA = zA();
const ku = /* @__PURE__ */ Hm(UA);
function Nm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function MA() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? BA(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function BA(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ir = { basename: qA, dirname: HA, extname: WA, join: KA, sep: "/" };
function qA(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  jo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function HA(e) {
  if (jo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function WA(e) {
  jo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function KA(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    jo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : GA(r);
}
function GA(e) {
  jo(e);
  const n = e.codePointAt(0) === 47;
  let r = YA(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function YA(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function jo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const QA = { cwd: JA };
function JA() {
  return "/";
}
function jm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function XA(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!jm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return ZA(e);
}
function ZA(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const bu = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class eS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? jm(n) ? r = { path: n } : typeof n == "string" || eP(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : QA.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < bu.length; ) {
      const o = bu[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      bu.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ir.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    _u(n, "basename"), xu(n, "basename"), this.path = Ir.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ir.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Qv(this.basename, "dirname"), this.path = Ir.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ir.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (xu(n, "extname"), Qv(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ir.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    jm(n) && (n = XA(n)), _u(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ir.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    _u(n, "stem"), xu(n, "stem"), this.path = Ir.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Pt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function xu(e, n) {
  if (e && e.includes(Ir.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ir.sep + "`"
    );
}
function _u(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Qv(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function eP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const nP = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), tP = {}.hasOwnProperty;
class zp extends nP {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = MA();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new zp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(ku(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (ju("data", this.frozen), this.namespace[n] = r, this) : tP.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (ju("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = Uo(n), i = this.parser || this.Parser;
    return Su("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Su("process", this.parser || this.Parser), Nu("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Uo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(v, h);
        aP(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Su("processSync", this.parser || this.Parser), Nu("processSync", this.compiler || this.Compiler), this.process(n, a), Xv("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Gv(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Jv(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = Uo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Xv("runSync", "run", i), a;
    function o(s, l) {
      Gv(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = Uo(r), a = this.compiler || this.Compiler;
    return Nu("stringify", a), Jv(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (ju("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = ku(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...C] = u;
        const S = i[h][1];
        Nm(S) && Nm(v) && (v = ku(!0, S, v)), i[h] = [m, v, ...C];
      }
    }
  }
}
const rP = new zp().freeze();
function Su(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Nu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function ju(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Jv(e) {
  if (!Nm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Xv(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Uo(e) {
  return iP(e) ? e : new eS(e);
}
function iP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function aP(e) {
  return typeof e == "string" || oP(e);
}
function oP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const sP = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Zv = [], ek = { allowDangerousHtml: !0 }, lP = /^(https?|ircs?|mailto|xmpp)$/i, cP = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function dP(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Zv, d = e.remarkPlugins || Zv, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...ek } : ek, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || uP, v = rP().use(qO).use(d).use(VA, m).use(l), C = new eS();
  typeof i == "string" && (C.value = i);
  for (const y of cP)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + sP + y.id, void 0);
  const S = v.parse(C);
  let N = v.runSync(S, C);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), Z_(N, F), _D(N, {
    Fragment: Ue.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ue.jsx,
    jsxs: Ue.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function F(y, M, T) {
    if (y.type === "raw" && T && typeof M == "number")
      return u ? T.children.splice(M, 1) : T.children[M] = { type: "text", value: y.value }, M;
    if (y.type === "element") {
      let E;
      for (E in hu)
        if (Object.hasOwn(hu, E) && Object.hasOwn(y.properties, E)) {
          const D = y.properties[E], B = hu[E];
          (B === null || B.includes(y.tagName)) && (y.properties[E] = h(String(D || ""), E, y));
        }
    }
    if (y.type === "element") {
      let E = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!E && r && typeof M == "number" && (E = !r(y, M, T)), E && T && typeof M == "number")
        return f && y.children ? T.children.splice(M, 1, ...y.children) : T.children.splice(M, 1), M;
    }
  }
}
function uP(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    lP.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wu = { exports: {} }, Sa = {}, nk;
function mP() {
  if (nk) return Sa;
  nk = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Sa.Fragment = r, Sa.jsx = s, Sa.jsxs = s, Sa;
}
var Mo = {}, tk;
function pP() {
  return tk || (tk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Mo.Fragment = i, Mo.jsx = Rn, Mo.jsxs = Mn;
  })()), Mo;
}
var rk;
function fP() {
  return rk || (rk = 1, process.env.NODE_ENV === "production" ? wu.exports = mP() : wu.exports = pP()), wu.exports;
}
var re = fP();
const hP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, yP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, gP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, vP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, kP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, bP = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": hP,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": yP,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": gP,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": vP,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": kP
};
function wo(e) {
  return bP[e] ?? {};
}
const xP = wo(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), _P = wo(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Bo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), SP = "_issueAvatar_kc0sw_1", NP = "_issueField_kc0sw_9", jP = "_issueDescription_kc0sw_12", qo = {
  issueAvatar: SP,
  issueField: NP,
  issueDescription: jP
}, nS = ({ issue: e }) => /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
  /* @__PURE__ */ re.jsx(Bo, { title: "Assignee", children: /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: qo.issueAvatar,
      children: [
        /* @__PURE__ */ re.jsx(
          Bm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ re.jsx(Bo, { title: "Team", children: /* @__PURE__ */ re.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: qo.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ re.jsx(Bo, { title: "Project", children: /* @__PURE__ */ re.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: qo.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ re.jsx(Bo, { title: "Description", children: /* @__PURE__ */ re.jsx(dP, { className: qo.issueDescription, children: e.description }) })
] }), wP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), CP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), FP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), IP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), EP = /* @__PURE__ */ re.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), tS = {
  0: wP,
  1: EP,
  2: IP,
  3: FP,
  4: CP
}, TP = (e) => e in tS, Ds = ({ priority: e }) => TP(e) ? tS[e] : /* @__PURE__ */ re.jsx(Pn, { "data-testid": "defaultPriorityTag", children: e }), $P = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), DP = (e, n) => /* @__PURE__ */ re.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ re.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ re.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), RP = (e, n) => /* @__PURE__ */ re.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ re.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ re.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), OP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), AP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), PP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), wm = {
  backlog: (e, n) => $P(e, n),
  unstarted: (e, n) => DP(e, n),
  started: (e, n) => RP(e, n),
  done: (e, n) => OP(e, n),
  canceled: (e, n) => AP(e, n),
  completed: (e, n) => PP(e, n)
}, LP = (e) => e in wm, Rs = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => LP(e) ? wm[e](n, r) : wm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), VP = "_wrapper_e0qj3_1", zP = "_resultTitle_e0qj3_21", UP = "_resultTooltipTitle_e0qj3_28", MP = "_resultLinkIcon_e0qj3_31", Na = {
  wrapper: VP,
  resultTitle: zP,
  resultTooltipTitle: UP,
  resultLinkIcon: MP
}, BP = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Um(S0()), o = it(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ re.jsx(
    Ye,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", className: Na.wrapper, children: [
        /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ re.jsx(
              Rs,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ re.jsx(Ds, { priority: e.priority })
          ] }),
          /* @__PURE__ */ re.jsx(Pn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ re.jsx(
            P.Heading,
            {
              variant: "heading-3",
              className: Na.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ re.jsx(nS, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ re.jsx(
        ct.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Na.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ re.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ re.jsx(
                    Rs,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ re.jsx(Ds, { priority: e.priority })
                ] }),
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", className: Na.resultTitle, children: e.title }),
                n && /* @__PURE__ */ re.jsx(
                  fe,
                  {
                    className: Na.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, qP = "_loader_13xpk_1", HP = "_dropdown_13xpk_8", WP = "_loadMore_13xpk_13", Cu = {
  loader: qP,
  dropdown: HP,
  loadMore: WP
}, KP = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = pn(), [f, { data: h, loading: v, networkStatus: C }] = u(
    xP,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Si(
    () => {
      !v && s !== "" && C === er.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), He(() => {
    v || o([]);
  }, [s]), He(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: T }) => T
      ), F = a.filter(
        (T) => !n.find((E) => E.id === T.id)
      ), y = F.filter(
        (T) => !N.find(
          (E) => E.id === T.id
        )
      ), M = N.filter(
        (T) => !n.find((E) => E.id === T.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...M] : M
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...F, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !v && s !== "" && C === er.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ re.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ re.jsxs(
    ei,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: Cu.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const F = N.target.value;
          l(F);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ re.jsx(BP, { issue: N }, N.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ re.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Cu.loadMore,
            children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ re.jsx(b, { justifyContent: "center", className: Cu.loader, children: /* @__PURE__ */ re.jsx(dn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, GP = "_collapse_su0f9_1", YP = "_collapseHeader_su0f9_8", QP = "_collapseContent_su0f9_31", JP = "_url_su0f9_35", XP = "_externalLink_su0f9_51", ZP = "_emptyState_su0f9_55", Zr = {
  collapse: GP,
  collapseHeader: YP,
  collapseContent: QP,
  url: JP,
  externalLink: XP,
  emptyState: ZP
}, e2 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = _n();
  return n ? /* @__PURE__ */ re.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ re.jsx(
          P.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Zr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ re.jsx(
          It,
          {
            slotEnd: /* @__PURE__ */ re.jsx(fe, { name: "external-link" }),
            variant: "tertiary",
            className: Zr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ re.jsxs(
            mr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Zr.collapse,
              children: [
                /* @__PURE__ */ re.jsx(mr.Header, { className: Zr.collapseHeader, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ re.jsx(Ye, { content: /* @__PURE__ */ re.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(
                        Rs,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ re.jsxs(
                        P.ExternalLink,
                        {
                          className: Zr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ re.jsx(fe, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ re.jsx(Ye, { content: /* @__PURE__ */ re.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(Ds, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ re.jsx(Pn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ re.jsx(mr.Content, { className: Zr.collapseContent, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ re.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ re.jsx(Pn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ re.jsx(nS, { issue: u }),
                  /* @__PURE__ */ re.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ re.jsx(fe, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ re.jsxs(
                    It,
                    {
                      slotEnd: /* @__PURE__ */ re.jsx(fe, { name: "external-link" }),
                      variant: "tertiary",
                      className: Zr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ re.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ re.jsx(fe, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ re.jsx(
          It,
          {
            slotEnd: /* @__PURE__ */ re.jsx(fe, { name: "external-link" }),
            variant: "tertiary",
            className: Zr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, n2 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, rS = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => rS(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, t2 = "_modalBody_iv3ua_1", r2 = "_error_iv3ua_5", i2 = "_dropdown_iv3ua_16", Di = {
  modalBody: t2,
  error: r2,
  dropdown: i2
}, a2 = wo(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), o2 = wo(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), s2 = wo(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), l2 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = pn(), { control: m, handleSubmit: u, reset: f } = Dt(), [h, v] = se([]), [C, S] = se(), [N, F] = se([]), [y, M] = se(), [T, E] = se([]), [D, B] = se(), [ee, X] = se([]), [ae, Q] = se(), [z, O] = se([]), [q, Z] = se(), [ve, ce] = se(!1), { useMutation: le } = pn(), { track: me } = _n(), [H, { loading: _e }] = le(
    a2,
    {
      onError: () => {
        ce(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ie) => {
        const We = {
          identifier: Ie.Linear?.issueCreate?.issue?.identifier,
          url: Ie.Linear?.issueCreate?.issue?.url
        };
        Ie.Linear && Ie.Linear?.issueCreate?.issue?.id && (a(Ie.Linear?.issueCreate?.issue?.id), Le(We), ce(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ie.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), me("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ee,
    { data: K, loading: qe, error: Be }
  ] = l(o2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ie) => {
      const We = Ie.Linear.teams.edges.map(
        ({ node: en }) => en
      );
      v(We), X(Ie.Linear.issuePriorityValues), s(`${g2}${Ie.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Me, loading: Fe }] = l(s2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ie) => {
      const We = Ie?.Linear?.team?.projects?.edges?.map(
        ({ node: ye }) => ye
      );
      F(We);
      const en = Ie?.Linear?.team?.states?.edges?.map(
        ({ node: ye }) => ye
      );
      E(en);
      const ue = Ie?.Linear?.team?.templates?.edges?.map(
        ({ node: ye }) => ye
      );
      O(
        ue.filter(
          (ye) => ye.type === "issue"
        )
      );
    }
  }), Le = (Ie) => {
    r(!1), M(void 0), S(void 0), B(void 0), Q(void 0), Z(void 0), Ie && (e(Ie), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, De = (Ie) => {
    K && !qe && (H({
      variables: {
        issueTitle: Ie.title,
        issueDescription: Ie?.description,
        teamId: Ie.team.id,
        projectId: Ie?.project?.id,
        statusId: Ie?.status?.id,
        priority: Ie?.priority?.priority
      }
    }), ce(!0));
  };
  He(() => {
    n && Ee();
  }, [n]);
  const tn = () => {
    me("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ re.jsxs(
    Et,
    {
      isOpen: n,
      onClose: () => {
        tn(), Le();
      },
      children: [
        /* @__PURE__ */ re.jsx(
          Tt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              tn(), Le();
            }
          }
        ),
        /* @__PURE__ */ re.jsx(
          $t,
          {
            className: Di.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ re.jsx(Fn, { error: Be }) : /* @__PURE__ */ re.jsx("form", { onSubmit: u(De), id: "issueCreationForm", children: /* @__PURE__ */ re.jsxs(yt, { children: [
              /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ie, onChange: We },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ re.jsx(
                    bn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: en?.message ?? null
                      },
                      children: /* @__PURE__ */ re.jsx(
                        ei,
                        {
                          dropdownProps: { className: Di.dropdown },
                          placeholder: "Select Linear team",
                          className: at({ [Di.error]: en }),
                          getItemTitleByValue: (ue) => ue?.name,
                          onChange: (ue) => {
                            M(void 0), B(void 0), Q(void 0), Z(void 0), S(ue.selectedValues[0]), Pe({
                              variables: { teamId: ue.selectedValues[0].id }
                            }), We(ue.selectedValues[0]);
                          },
                          value: C ? [Ie] : void 0,
                          children: h?.map((ue) => /* @__PURE__ */ re.jsx(
                            ct.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(P.Paragraph, { children: ue.name })
                            },
                            ue.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ie, onChange: We } }) => {
                    const en = Fe ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ re.jsx(bn, { label: "Project", children: /* @__PURE__ */ re.jsx(
                      ei,
                      {
                        dropdownProps: { className: Di.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ue) => ue?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (ue) => {
                          M(ue.selectedValues[0]), We(ue.selectedValues[0]);
                        },
                        value: y ? [Ie] : en,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          Fe && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
                            }
                          ),
                          Me && !Fe && N.map((ue) => /* @__PURE__ */ re.jsx(
                            ct.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(P.Paragraph, { children: ue.name })
                            },
                            ue.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(Te, { span: 6, children: /* @__PURE__ */ re.jsx(bn, { label: "Template", children: /* @__PURE__ */ re.jsx(
                ei,
                {
                  clearable: !0,
                  dropdownProps: { className: Di.dropdown },
                  disabled: !C || Fe,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ie) => Ie?.name,
                  onChange: (Ie) => {
                    if (Ie.selectedValues.length > 0) {
                      Z(Ie.selectedValues[0]);
                      const We = JSON.parse(
                        Ie.selectedValues[0].templateData
                      ), en = ee.filter(
                        (Ve) => Ve.priority === We.priority
                      );
                      Q(
                        en ? en[0] : void 0
                      );
                      const ue = T.filter(
                        (Ve) => Ve.id === We.stateId
                      );
                      B(
                        ue ? ue[0] : void 0
                      );
                      const ye = N.filter(
                        (Ve) => Ve.id === We.projectId
                      );
                      M(
                        ye ? ye[0] : void 0
                      );
                      const $e = We.description;
                      f({
                        title: We?.title,
                        priority: en[0],
                        status: ue[0],
                        project: ye[0],
                        description: $e ? rS($e, n2) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), M(void 0), Q(void 0), B(void 0), Z(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: z?.map((Ie) => /* @__PURE__ */ re.jsx(
                    ct.Item,
                    {
                      value: Ie,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ re.jsx(P.Paragraph, { children: Ie.name })
                    },
                    Ie.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ re.jsx(Te, { span: 6, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ie, value: We },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ re.jsx(
                    pr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: Ie
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ie, onChange: We } }) => {
                    const en = Fe ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(bn, { label: "Status", children: /* @__PURE__ */ re.jsx(
                      ei,
                      {
                        dropdownProps: { className: Di.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ue) => ue?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (ue) => {
                          B(ue.selectedValues[0]), We(ue.selectedValues[0]);
                        },
                        value: D ? [Ie] : en,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          Fe && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
                            }
                          ),
                          Me && !Fe && T.map((ue) => /* @__PURE__ */ re.jsx(
                            ct.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Rs,
                                      {
                                        type: ue.type,
                                        color: ue.color,
                                        name: ue.name
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(P.Paragraph, { children: ue.name })
                                  ]
                                }
                              )
                            },
                            ue.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ie, onChange: We } }) => {
                    const en = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(bn, { label: "Priority", children: /* @__PURE__ */ re.jsx(
                      ei,
                      {
                        clearable: !0,
                        getItemTitleByValue: (ue) => ue?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (ue) => {
                          Q(ue.selectedValues[0]), We(ue.selectedValues[0]);
                        },
                        value: ae ? [Ie] : en,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          Fe && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(dn, { size: 24 })
                            }
                          ),
                          K && !qe && ee.map((ue) => /* @__PURE__ */ re.jsx(
                            ct.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Ds,
                                      {
                                        priority: ue.priority
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(P.Paragraph, { children: ue.label })
                                  ]
                                }
                              )
                            },
                            ue.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(Te, { children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ie, value: We },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ re.jsx(
                    x0,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: Ie
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ re.jsx(
          At,
          {
            confirmOnClick: u(De),
            confirmProps: {
              disabled: _e || !K,
              isLoading: ve || qe || Fe,
              loadingIndicator: /* @__PURE__ */ re.jsx(dn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              tn(), Le();
            }
          }
        )
      ]
    }
  );
}, c2 = "_modalWrapper_4kh9u_1", d2 = "_copyButton_4kh9u_6", u2 = "_copyWrapper_4kh9u_15", m2 = "_copyField_4kh9u_24", p2 = "_externalLink_4kh9u_47", f2 = "_externalLinkIcon_4kh9u_52", h2 = "_textWrapper_4kh9u_56", si = {
  modalWrapper: c2,
  copyButton: d2,
  copyWrapper: u2,
  copyField: m2,
  externalLink: p2,
  externalLinkIcon: f2,
  textWrapper: h2
}, y2 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ re.jsxs(
  Et,
  {
    isOpen: !!n && e,
    className: si.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ re.jsx(
        Tt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ re.jsx($t, { children: /* @__PURE__ */ re.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ re.jsxs(P.Paragraph, { className: si.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ re.jsxs(
                P.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: si.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ re.jsx(fe, { name: "external-link", className: si.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ re.jsx(bn, { label: "Linear issue link", children: /* @__PURE__ */ re.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: si.copyWrapper,
                children: [
                  /* @__PURE__ */ re.jsx(
                    Nr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: si.copyField
                    }
                  ),
                  /* @__PURE__ */ re.jsx(
                    _0,
                    {
                      className: si.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ re.jsx(
        At,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), g2 = "https://linear.app/", v2 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: C } = pn(), [S, N] = se(""), F = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: M } = _n(), {
    loading: T,
    data: E,
    error: D,
    store: B
  } = Vm(e?.conversationId ?? null), [
    ee,
    {
      data: X,
      loading: ae,
      networkStatus: Q,
      error: z
    }
  ] = C(_P, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    !T && !D && E && E?.linear?.issues?.length > 0 ? (o(E.linear.issues), ee({
      variables: {
        linkedIssues: E.linear.issues
      }
    })) : !T && !D && (i([]), o([]));
  }, [E, T, D]), He(() => {
    X && X?.Linear && !ae && Q === er.ready && Object.keys(X).length > 0 && i(X.Linear.issues?.edges?.map(({ node: ce }) => ce));
  }, [X, ae, Q]);
  const O = (ce) => {
    ce && ce?.team?.organization?.urlKey && M("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ce.id
    });
    const le = (me) => me.id === ce?.id;
    r.some((me) => me && le(me)) || (E && a.length === 0 && o([]), B({
      linear: {
        issues: [...a, ce.id]
      }
    }));
  }, q = (ce) => {
    const le = E?.linear.issues.filter((me) => me !== ce) || [];
    M("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ce
    }), i(r.filter(({ id: me }) => me !== ce)), o(le), B({
      linear: {
        issues: le
      }
    });
  }, Z = () => {
    l(!1), i([]), o([]), B({
      linear: {
        issues: []
      }
    });
  }, ve = T || ae || !E && !D || (E?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !T && !ae && (z || D) ? /* @__PURE__ */ re.jsx(Fn, { error: z || D }) : /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ re.jsxs(
      Et,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ re.jsx(
            Tt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ re.jsx($t, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ re.jsx(
            At,
            {
              confirmOnClick: () => Z(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      l2,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ce) => m(ce),
        setIsCreationSuccessfulModalOpen: (ce) => f(ce),
        addToLinkedIssueIds: (ce) => {
          B({
            linear: {
              issues: [...a, ce]
            }
          });
        },
        setCreatedIssue: (ce) => v(ce),
        organizationUrl: S,
        setOrganizationUrl: (ce) => N(ce)
      }
    ),
    /* @__PURE__ */ re.jsx(
      y2,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ce) => f(ce),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ re.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          F && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
            /* @__PURE__ */ re.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  M("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ re.jsx(P.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ re.jsx(KP, { handleSelect: O, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      e2,
      {
        linkedIssues: r,
        isLoading: ve,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (ce) => l(ce),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, k2 = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Gr
  }
], ik = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], li = "LINEAR", b2 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, x2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a
}) => {
  const o = !e, s = Dt({
    mode: "onChange",
    defaultValues: b2
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = lo({
    integrationId: e,
    integrationType: li,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: F
  } = co({
    integrationId: e,
    fieldDefinitions: ik,
    form: s,
    onMisconfigured: v
  }), y = (T) => mo(T, {
    fieldDefinitions: ik,
    isCreationMode: o,
    create: l,
    update: d
  }), M = s.watch("name");
  return /* @__PURE__ */ re.jsxs(
    uo,
    {
      form: s,
      integrationId: e,
      onValidSubmit: y,
      error: S ?? f,
      onRetry: S ? F : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ re.jsx(po, { cause: h }),
        /* @__PURE__ */ re.jsxs(yt, { children: [
          /* @__PURE__ */ re.jsx(Te, { children: /* @__PURE__ */ re.jsx(bn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            Ft,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Te, { span: 3 }),
          /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(bn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ re.jsx(
            Ft,
            {
              name: "enableCreateIssue",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Te, { span: 3 }),
          /* @__PURE__ */ re.jsx(Te, { span: 3, children: /* @__PURE__ */ re.jsx(bn, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ re.jsx(
            Ft,
            {
              name: "enableUnlinkAll",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Te, { span: 3 }),
          !o && e && /* @__PURE__ */ re.jsx(
            Gr,
            {
              configuration: n,
              integrationId: e,
              integrationType: li,
              label: "Authorize with OAuth"
            }
          )
        ] }),
        /* @__PURE__ */ re.jsx(
          fo,
          {
            integrationType: li,
            integrationId: e,
            widgetName: M,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ re.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ re.jsx(
                fe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ re.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  li,
                  " integration, all links between Dixa and ",
                  li,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ re.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  li,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ re.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  li,
                  " ",
                  'integration "',
                  M,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Fu = { exports: {} }, ja = {}, ak;
function _2() {
  if (ak) return ja;
  ak = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ja.Fragment = r, ja.jsx = s, ja.jsxs = s, ja;
}
var Ho = {}, ok;
function S2() {
  return ok || (ok = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ho.Fragment = i, Ho.jsx = Rn, Ho.jsxs = Mn;
  })()), Ho;
}
var sk;
function N2() {
  return sk || (sk = 1, process.env.NODE_ENV === "production" ? Fu.exports = _2() : Fu.exports = S2()), Fu.exports;
}
var Re = N2();
const j2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, w2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, C2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, F2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, I2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, E2 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": j2,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": w2,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": C2,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": F2,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": I2
};
function cl(e) {
  return E2[e] ?? {};
}
const T2 = cl(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), $2 = cl(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), D2 = cl(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), R2 = cl(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Iu(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const O2 = "_wrapper_27vny_1", A2 = "_copyIcon_27vny_12", wa = {
  wrapper: O2,
  copyIcon: A2
}, P2 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Iu(), { isCopied: i, copy: a } = Iu(), { isCopied: o, copy: s } = Iu();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: C,
    referral_url: S
  } = e, N = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: F, first_name: y, last_name: M } = m ?? {}, T = F ?? (`${y} ${M}`.trim() || "A customer has no name"), E = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Re.jsxs(b, { className: wa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: wa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Re.jsx(P.Heading, { variant: "heading-2", children: T }),
          N && /* @__PURE__ */ Re.jsx(P.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Re.jsx(P.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Re.jsx(b, { gap: "200", children: /* @__PURE__ */ Re.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(fe, { size: l, name: "mail" }),
        /* @__PURE__ */ Re.jsx(P.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Re.jsx(Ye, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        fe,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: wa.copyIcon
        }
      ) })
    ] }),
    E && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(fe, { size: l, name: "link" }),
        /* @__PURE__ */ Re.jsx(Ye, { content: "Shopify shop", children: /* @__PURE__ */ Re.jsx(
          P.ExternalLink,
          {
            href: E,
            target: "_blank",
            rel: "noreferrer",
            children: E.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Re.jsx(Ye, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        fe,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(E),
          className: wa.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(fe, { size: l, name: "external-link" }),
        /* @__PURE__ */ Re.jsx(Ye, { content: "Referral link", children: /* @__PURE__ */ Re.jsx(
          P.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Re.jsx(Ye, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        fe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: wa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, L2 = "_list_1q5b5_5", V2 = "_listItem_1q5b5_8", z2 = "_listItemEdit_1q5b5_15", U2 = "_notificationText_1q5b5_19", Qi = {
  list: L2,
  listItem: V2,
  listItemEdit: z2,
  notificationText: U2
}, M2 = "_modalBody_1clhs_1", B2 = {
  modalBody: M2
}, q2 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = pn(), { track: l } = _n(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [C, { loading: S }] = o(
    D2,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), Q();
      }
    }
  ), [N, { loading: F }] = o(R2), y = S || F, M = !!h, T = n === d ? "Change the value to update the points" : "", E = isNaN(d), D = E ? "Points can not be empty" : "", B = d > n && d - n > 1e6, ee = B ? "Points can not exceed 1,000,000" : "", X = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((z) => {
      const O = z?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Q()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((z) => {
      z.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Q()) : "errors" in z && (l("loyaltylion:remove:points:failed"), v(
        z.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ae = () => {
    E && m(n), f(""), i();
  }, Q = () => {
    a(), ae();
  };
  return /* @__PURE__ */ Re.jsxs(
    Et,
    {
      isOpen: e,
      onClose: ae,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Re.jsx(Tt, { title: "Change points", onClose: ae }),
        /* @__PURE__ */ Re.jsxs($t, { className: B2.modalBody, children: [
          /* @__PURE__ */ Re.jsxs(yt, { children: [
            /* @__PURE__ */ Re.jsx(Te, { span: 6, children: /* @__PURE__ */ Re.jsx(
              pr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: ee || D,
                  warning: T
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (z) => m(z?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Re.jsx(Te, { span: 6, children: /* @__PURE__ */ Re.jsx(
              pr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (z) => f(z?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && M && /* @__PURE__ */ Re.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Re.jsx(Ge, { children: h?.map((z, O) => /* @__PURE__ */ Re.jsx(
            Ge.Item,
            {
              variant: "dense",
              title: z,
              contentLeft: /* @__PURE__ */ Re.jsx(
                fe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ Re.jsx(
          At,
          {
            confirmName: "Save",
            confirmOnClick: () => X(),
            confirmProps: {
              isLoading: y,
              disabled: E || B || n === d,
              loadingIndicator: /* @__PURE__ */ Re.jsx(dn, { size: 16 })
            },
            cancelOnClick: ae
          }
        )
      ]
    }
  );
}, H2 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Re.jsx(Ge.Text, { variant: "dense", className: Qi.listItem, children: /* @__PURE__ */ Re.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(fe, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Re.jsx(P.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Re.jsx(Ye, { content: "Edit points", children: /* @__PURE__ */ Re.jsx(
        fe,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Qi.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Re.jsx(An, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, W2 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsx(P.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Re.jsx(Ge, { className: Qi.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Re.jsx(
      H2,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ Re.jsx(
      q2,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, K2 = "_reward_1wxia_1", G2 = {
  reward: K2
}, Y2 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Re.jsx(b, { gap: "100", flexDirection: "column", className: G2.reward, children: /* @__PURE__ */ Re.jsx(Ye, { content: a ?? "No description", children: /* @__PURE__ */ Re.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Re.jsx(fe, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Re.jsxs(An, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Re.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(fe, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Re.jsx(
        P.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, Q2 = ({ customer: e }) => {
  const { useQuery: n } = pn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n($2, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (He(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return ho({ errors: d }) ? /* @__PURE__ */ Re.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Qi.notificationText,
        children: "No rewards found"
      }
    ) : Ub({ errors: d }) ? /* @__PURE__ */ Re.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Qi.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Re.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsx(P.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Re.jsx(dn, {}) }) : /* @__PURE__ */ Re.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Re.jsx(Y2, { reward: d }, d.id)) })
  ] });
}, J2 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(Pn, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(
        fe,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(Pn, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(fe, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(Ye, { content: "Insights segment", children: /* @__PURE__ */ Re.jsx(Pn, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(fe, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, X2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = pn(), { track: i } = _n(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: C,
    refetch: S
  } = r(T2, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return He(() => {
    if (C && !h) {
      const N = (C?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? v ? ho({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Re.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Qi.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Re.jsx(Fn, { error: v }) : h ? /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Re.jsx(dn, {}) }) : f ? /* @__PURE__ */ Re.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Re.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Re.jsxs(Re.Fragment, { children: [
        l && /* @__PURE__ */ Re.jsx(P2, { customer: a }),
        d && /* @__PURE__ */ Re.jsx(J2, { customer: a }),
        m && /* @__PURE__ */ Re.jsx(
          W2,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ Re.jsx(Q2, { customer: a })
      ] }) : /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Re.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Z2 = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Eu = { exports: {} }, Ca = {}, lk;
function eL() {
  if (lk) return Ca;
  lk = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ca.Fragment = r, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var Wo = {}, ck;
function nL() {
  return ck || (ck = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Wo.Fragment = i, Wo.jsx = Rn, Wo.jsxs = Mn;
  })()), Wo;
}
var dk;
function tL() {
  return dk || (dk = 1, process.env.NODE_ENV === "production" ? Eu.exports = eL() : Eu.exports = nL()), Eu.exports;
}
var an = tL();
const rL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, iL = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": rL
};
function aL(e) {
  return iL[e] ?? {};
}
const {
  entries: iS,
  setPrototypeOf: uk,
  isFrozen: oL,
  getPrototypeOf: sL,
  getOwnPropertyDescriptor: lL
} = Object;
let {
  freeze: Kt,
  seal: fr,
  create: Li
} = Object, {
  apply: Cm,
  construct: Fm
} = typeof Reflect < "u" && Reflect;
Kt || (Kt = function(e) {
  return e;
});
fr || (fr = function(e) {
  return e;
});
Cm || (Cm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Fm || (Fm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const Fa = ht(Array.prototype.forEach), cL = ht(Array.prototype.lastIndexOf), mk = ht(Array.prototype.pop), Ia = ht(Array.prototype.push), dL = ht(Array.prototype.splice), Vt = Array.isArray, qa = ht(String.prototype.toLowerCase), Tu = ht(String.prototype.toString), pk = ht(String.prototype.match), Ri = ht(String.prototype.replace), fk = ht(String.prototype.indexOf), uL = ht(String.prototype.trim), mL = ht(Number.prototype.toString), pL = ht(Boolean.prototype.toString), hk = typeof BigInt > "u" ? null : ht(BigInt.prototype.toString), yk = typeof Symbol > "u" ? null : ht(Symbol.prototype.toString), rt = ht(Object.prototype.hasOwnProperty), Ea = ht(Object.prototype.toString), St = ht(RegExp.prototype.test), Ko = fL(TypeError);
function ht(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Cm(e, n, i);
  };
}
function fL(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Fm(e, r);
  };
}
function En(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : qa;
  if (uk && uk(e, null), !Vt(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (oL(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function hL(e) {
  for (let n = 0; n < e.length; n++)
    rt(e, n) || (e[n] = null);
  return e;
}
function Qt(e) {
  const n = Li(null);
  for (const [r, i] of iS(e))
    rt(e, r) && (Vt(i) ? n[r] = hL(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = Qt(i) : n[r] = i);
  return n;
}
function yL(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return mL(e);
    case "boolean":
      return pL(e);
    case "bigint":
      return hk ? hk(e) : "0";
    case "symbol":
      return yk ? yk(e) : "Symbol()";
    case "undefined":
      return Ea(e);
    case "function":
    case "object": {
      if (e === null)
        return Ea(e);
      const n = e, r = Vi(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : Ea(i);
      }
      return Ea(e);
    }
    default:
      return Ea(e);
  }
}
function Vi(e, n) {
  for (; e !== null; ) {
    const i = lL(e, n);
    if (i) {
      if (i.get)
        return ht(i.get);
      if (typeof i.value == "function")
        return ht(i.value);
    }
    e = sL(e);
  }
  function r() {
    return null;
  }
  return r;
}
function gL(e) {
  try {
    return St(e, ""), !0;
  } catch {
    return !1;
  }
}
const gk = Kt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), $u = Kt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Du = Kt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), vL = Kt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ru = Kt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), kL = Kt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), vk = Kt(["#text"]), kk = Kt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Ou = Kt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), bk = Kt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Go = Kt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), bL = fr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), xL = fr(/<%[\w\W]*|[\w\W]*%>/gm), _L = fr(/\$\{[\w\W]*/gm), SL = fr(/^data-[\-\w.\u00B7-\uFFFF]+$/), NL = fr(/^aria-[\-\w]+$/), aS = fr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), jL = fr(/^(?:\w+script|data):/i), wL = fr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), oS = fr(/^html$/i), CL = fr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var xk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: NL,
  ATTR_WHITESPACE: wL,
  CUSTOM_ELEMENT: CL,
  DATA_ATTR: SL,
  DOCTYPE_NAME: oS,
  ERB_EXPR: xL,
  IS_ALLOWED_URI: aS,
  IS_SCRIPT_OR_DATA: jL,
  MUSTACHE_EXPR: bL,
  TMPLIT_EXPR: _L
});
const Ta = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, FL = function() {
  return typeof window > "u" ? null : window;
}, IL = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, _k = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function sS() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : FL();
  const n = (_) => sS(_);
  if (n.version = "3.4.2", n.removed = [], !e || !e.document || e.document.nodeType !== Ta.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, C = d.prototype, S = Vi(C, "cloneNode"), N = Vi(C, "remove"), F = Vi(C, "nextSibling"), y = Vi(C, "childNodes"), M = Vi(C, "parentNode");
  if (typeof s == "function") {
    const _ = r.createElement("template");
    _.content && _.content.ownerDocument && (r = _.content.ownerDocument);
  }
  let T, E = "";
  const {
    implementation: D,
    createNodeIterator: B,
    createDocumentFragment: ee,
    getElementsByTagName: X
  } = r, {
    importNode: ae
  } = i;
  let Q = _k();
  n.isSupported = typeof iS == "function" && typeof M == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: z,
    ERB_EXPR: O,
    TMPLIT_EXPR: q,
    DATA_ATTR: Z,
    ARIA_ATTR: ve,
    IS_SCRIPT_OR_DATA: ce,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: me
  } = xk;
  let {
    IS_ALLOWED_URI: H
  } = xk, _e = null;
  const Ee = En({}, [...gk, ...$u, ...Du, ...Ru, ...vk]);
  let K = null;
  const qe = En({}, [...kk, ...Ou, ...bk, ...Go]);
  let Be = Object.seal(Li(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Me = null;
  const Fe = Object.seal(Li(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Le = !0, De = !0, tn = !1, Ie = !0, We = !1, en = !0, ue = !1, ye = !1, $e = !1, Ve = !1, Oe = !1, ln = !1, w = !0, x = !1;
  const $ = "user-content-";
  let G = !0, Y = !1, R = {}, V = null;
  const ie = En({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let he = null;
  const Ne = En({}, ["audio", "video", "img", "source", "image", "track"]);
  let nn = null;
  const mn = En({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", un = "http://www.w3.org/2000/svg", fn = "http://www.w3.org/1999/xhtml";
  let cn = fn, xn = !1, Ze = null;
  const jn = En({}, [rn, un, fn], Tu);
  let Ae = En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = En({}, ["annotation-xml"]);
  const sn = En({}, ["title", "style", "font", "a", "script"]);
  let gn = null;
  const qn = ["application/xhtml+xml", "text/html"], wn = "text/html";
  let vn = null, yn = null;
  const Cn = r.createElement("form"), Un = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, Vn = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (yn && yn === _)
      return;
    (!_ || typeof _ != "object") && (_ = {}), _ = Qt(_), gn = // eslint-disable-next-line unicorn/prefer-includes
    qn.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? wn : _.PARSER_MEDIA_TYPE, vn = gn === "application/xhtml+xml" ? Tu : qa, _e = rt(_, "ALLOWED_TAGS") && Vt(_.ALLOWED_TAGS) ? En({}, _.ALLOWED_TAGS, vn) : Ee, K = rt(_, "ALLOWED_ATTR") && Vt(_.ALLOWED_ATTR) ? En({}, _.ALLOWED_ATTR, vn) : qe, Ze = rt(_, "ALLOWED_NAMESPACES") && Vt(_.ALLOWED_NAMESPACES) ? En({}, _.ALLOWED_NAMESPACES, Tu) : jn, nn = rt(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) ? En(Qt(mn), _.ADD_URI_SAFE_ATTR, vn) : mn, he = rt(_, "ADD_DATA_URI_TAGS") && Vt(_.ADD_DATA_URI_TAGS) ? En(Qt(Ne), _.ADD_DATA_URI_TAGS, vn) : Ne, V = rt(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) ? En({}, _.FORBID_CONTENTS, vn) : ie, Pe = rt(_, "FORBID_TAGS") && Vt(_.FORBID_TAGS) ? En({}, _.FORBID_TAGS, vn) : Qt({}), Me = rt(_, "FORBID_ATTR") && Vt(_.FORBID_ATTR) ? En({}, _.FORBID_ATTR, vn) : Qt({}), R = rt(_, "USE_PROFILES") ? _.USE_PROFILES && typeof _.USE_PROFILES == "object" ? Qt(_.USE_PROFILES) : _.USE_PROFILES : !1, Le = _.ALLOW_ARIA_ATTR !== !1, De = _.ALLOW_DATA_ATTR !== !1, tn = _.ALLOW_UNKNOWN_PROTOCOLS || !1, Ie = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, We = _.SAFE_FOR_TEMPLATES || !1, en = _.SAFE_FOR_XML !== !1, ue = _.WHOLE_DOCUMENT || !1, Ve = _.RETURN_DOM || !1, Oe = _.RETURN_DOM_FRAGMENT || !1, ln = _.RETURN_TRUSTED_TYPE || !1, $e = _.FORCE_BODY || !1, w = _.SANITIZE_DOM !== !1, x = _.SANITIZE_NAMED_PROPS || !1, G = _.KEEP_CONTENT !== !1, Y = _.IN_PLACE || !1, H = gL(_.ALLOWED_URI_REGEXP) ? _.ALLOWED_URI_REGEXP : aS, cn = typeof _.NAMESPACE == "string" ? _.NAMESPACE : fn, Ae = rt(_, "MATHML_TEXT_INTEGRATION_POINTS") && _.MATHML_TEXT_INTEGRATION_POINTS && typeof _.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Qt(_.MATHML_TEXT_INTEGRATION_POINTS) : En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = rt(_, "HTML_INTEGRATION_POINTS") && _.HTML_INTEGRATION_POINTS && typeof _.HTML_INTEGRATION_POINTS == "object" ? Qt(_.HTML_INTEGRATION_POINTS) : En({}, ["annotation-xml"]);
    const J = rt(_, "CUSTOM_ELEMENT_HANDLING") && _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING == "object" ? Qt(_.CUSTOM_ELEMENT_HANDLING) : Li(null);
    if (Be = Li(null), rt(J, "tagNameCheck") && Un(J.tagNameCheck) && (Be.tagNameCheck = J.tagNameCheck), rt(J, "attributeNameCheck") && Un(J.attributeNameCheck) && (Be.attributeNameCheck = J.attributeNameCheck), rt(J, "allowCustomizedBuiltInElements") && typeof J.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = J.allowCustomizedBuiltInElements), We && (De = !1), Oe && (Ve = !0), R && (_e = En({}, vk), K = Li(null), R.html === !0 && (En(_e, gk), En(K, kk)), R.svg === !0 && (En(_e, $u), En(K, Ou), En(K, Go)), R.svgFilters === !0 && (En(_e, Du), En(K, Ou), En(K, Go)), R.mathMl === !0 && (En(_e, Ru), En(K, bk), En(K, Go))), Fe.tagCheck = null, Fe.attributeCheck = null, rt(_, "ADD_TAGS") && (typeof _.ADD_TAGS == "function" ? Fe.tagCheck = _.ADD_TAGS : Vt(_.ADD_TAGS) && (_e === Ee && (_e = Qt(_e)), En(_e, _.ADD_TAGS, vn))), rt(_, "ADD_ATTR") && (typeof _.ADD_ATTR == "function" ? Fe.attributeCheck = _.ADD_ATTR : Vt(_.ADD_ATTR) && (K === qe && (K = Qt(K)), En(K, _.ADD_ATTR, vn))), rt(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) && En(nn, _.ADD_URI_SAFE_ATTR, vn), rt(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) && (V === ie && (V = Qt(V)), En(V, _.FORBID_CONTENTS, vn)), rt(_, "ADD_FORBID_CONTENTS") && Vt(_.ADD_FORBID_CONTENTS) && (V === ie && (V = Qt(V)), En(V, _.ADD_FORBID_CONTENTS, vn)), G && (_e["#text"] = !0), ue && En(_e, ["html", "head", "body"]), _e.table && (En(_e, ["tbody"]), delete Pe.tbody), _.TRUSTED_TYPES_POLICY) {
      if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Ko('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Ko('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      T = _.TRUSTED_TYPES_POLICY, E = T.createHTML("");
    } else
      T === void 0 && (T = IL(v, a)), T !== null && typeof E == "string" && (E = T.createHTML(""));
    Kt && Kt(_), yn = _;
  }, Sn = En({}, [...$u, ...Du, ...vL]), Nn = En({}, [...Ru, ...kL]), Hn = function(_) {
    let J = M(_);
    (!J || !J.tagName) && (J = {
      namespaceURI: cn,
      tagName: "template"
    });
    const de = qa(_.tagName), be = qa(J.tagName);
    return Ze[_.namespaceURI] ? _.namespaceURI === un ? J.namespaceURI === fn ? de === "svg" : J.namespaceURI === rn ? de === "svg" && (be === "annotation-xml" || Ae[be]) : !!Sn[de] : _.namespaceURI === rn ? J.namespaceURI === fn ? de === "math" : J.namespaceURI === un ? de === "math" && on[be] : !!Nn[de] : _.namespaceURI === fn ? J.namespaceURI === un && !on[be] || J.namespaceURI === rn && !Ae[be] ? !1 : !Nn[de] && (sn[de] || !Sn[de]) : !!(gn === "application/xhtml+xml" && Ze[_.namespaceURI]) : !1;
  }, Dn = function(_) {
    Ia(n.removed, {
      element: _
    });
    try {
      M(_).removeChild(_);
    } catch {
      N(_);
    }
  }, Rn = function(_, J) {
    try {
      Ia(n.removed, {
        attribute: J.getAttributeNode(_),
        from: J
      });
    } catch {
      Ia(n.removed, {
        attribute: null,
        from: J
      });
    }
    if (J.removeAttribute(_), _ === "is")
      if (Ve || Oe)
        try {
          Dn(J);
        } catch {
        }
      else
        try {
          J.setAttribute(_, "");
        } catch {
        }
  }, Mn = function(_) {
    let J = null, de = null;
    if ($e)
      _ = "<remove></remove>" + _;
    else {
      const Ke = pk(_, /^[\r\n\t ]+/);
      de = Ke && Ke[0];
    }
    gn === "application/xhtml+xml" && cn === fn && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const be = T ? T.createHTML(_) : _;
    if (cn === fn)
      try {
        J = new h().parseFromString(be, gn);
      } catch {
      }
    if (!J || !J.documentElement) {
      J = D.createDocument(cn, "template", null);
      try {
        J.documentElement.innerHTML = xn ? E : be;
      } catch {
      }
    }
    const ne = J.body || J.documentElement;
    return _ && de && ne.insertBefore(r.createTextNode(de), ne.childNodes[0] || null), cn === fn ? X.call(J, ue ? "html" : "body")[0] : ue ? J.documentElement : ne;
  }, t = function(_) {
    return B.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(_) {
    return _ instanceof f && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof u) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, p = function(_) {
    return typeof l == "function" && _ instanceof l;
  };
  function g(_, J, de) {
    Fa(_, (be) => {
      be.call(n, J, de, yn);
    });
  }
  const A = function(_) {
    let J = null;
    if (g(Q.beforeSanitizeElements, _, null), c(_))
      return Dn(_), !0;
    const de = vn(_.nodeName);
    if (g(Q.uponSanitizeElement, _, {
      tagName: de,
      allowedTags: _e
    }), en && _.hasChildNodes() && !p(_.firstElementChild) && St(/<[/\w!]/g, _.innerHTML) && St(/<[/\w!]/g, _.textContent) || en && _.namespaceURI === fn && de === "style" && p(_.firstElementChild) || _.nodeType === Ta.progressingInstruction || en && _.nodeType === Ta.comment && St(/<[/\w]/g, _.data))
      return Dn(_), !0;
    if (Pe[de] || !(Fe.tagCheck instanceof Function && Fe.tagCheck(de)) && !_e[de]) {
      if (!Pe[de] && j(de) && (Be.tagNameCheck instanceof RegExp && St(Be.tagNameCheck, de) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(de)))
        return !1;
      if (G && !V[de]) {
        const be = M(_) || _.parentNode, ne = y(_) || _.childNodes;
        if (ne && be) {
          const Ke = ne.length;
          for (let $n = Ke - 1; $n >= 0; --$n) {
            const Tn = S(ne[$n], !0);
            be.insertBefore(Tn, F(_));
          }
        }
      }
      return Dn(_), !0;
    }
    return _ instanceof d && !Hn(_) || (de === "noscript" || de === "noembed" || de === "noframes") && St(/<\/no(script|embed|frames)/i, _.innerHTML) ? (Dn(_), !0) : (We && _.nodeType === Ta.text && (J = _.textContent, Fa([z, O, q], (be) => {
      J = Ri(J, be, " ");
    }), _.textContent !== J && (Ia(n.removed, {
      element: _.cloneNode()
    }), _.textContent = J)), g(Q.afterSanitizeElements, _, null), !1);
  }, L = function(_, J, de) {
    if (Me[J] || w && (J === "id" || J === "name") && (de in r || de in Cn))
      return !1;
    const be = K[J] || Fe.attributeCheck instanceof Function && Fe.attributeCheck(J, _);
    if (!(De && !Me[J] && St(Z, J)) && !(Le && St(ve, J))) {
      if (!be || Me[J]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(j(_) && (Be.tagNameCheck instanceof RegExp && St(Be.tagNameCheck, _) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(_)) && (Be.attributeNameCheck instanceof RegExp && St(Be.attributeNameCheck, J) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(J, _)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          J === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && St(Be.tagNameCheck, de) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(de)))
        ) return !1;
      } else if (!nn[J] && !St(H, Ri(de, le, "")) && !((J === "src" || J === "xlink:href" || J === "href") && _ !== "script" && fk(de, "data:") === 0 && he[_]) && !(tn && !St(ce, Ri(de, le, ""))) && de)
        return !1;
    }
    return !0;
  }, I = En({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), j = function(_) {
    return !I[qa(_)] && St(me, _);
  }, te = function(_) {
    g(Q.beforeSanitizeAttributes, _, null);
    const {
      attributes: J
    } = _;
    if (!J || c(_))
      return;
    const de = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let be = J.length;
    for (; be--; ) {
      const ne = J[be], {
        name: Ke,
        namespaceURI: $n,
        value: Tn
      } = ne, Lt = vn(Ke), Jr = Tn;
      let xt = Ke === "value" ? Jr : uL(Jr);
      if (de.attrName = Lt, de.attrValue = xt, de.keepAttr = !0, de.forceKeepAttr = void 0, g(Q.uponSanitizeAttribute, _, de), xt = de.attrValue, x && (Lt === "id" || Lt === "name") && fk(xt, $) !== 0 && (Rn(Ke, _), xt = $ + xt), en && St(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, xt)) {
        Rn(Ke, _);
        continue;
      }
      if (Lt === "attributename" && pk(xt, "href")) {
        Rn(Ke, _);
        continue;
      }
      if (de.forceKeepAttr)
        continue;
      if (!de.keepAttr) {
        Rn(Ke, _);
        continue;
      }
      if (!Ie && St(/\/>/i, xt)) {
        Rn(Ke, _);
        continue;
      }
      We && Fa([z, O, q], (QS) => {
        xt = Ri(xt, QS, " ");
      });
      const of = vn(_.nodeName);
      if (!L(of, Lt, xt)) {
        Rn(Ke, _);
        continue;
      }
      if (T && typeof v == "object" && typeof v.getAttributeType == "function" && !$n)
        switch (v.getAttributeType(of, Lt)) {
          case "TrustedHTML": {
            xt = T.createHTML(xt);
            break;
          }
          case "TrustedScriptURL": {
            xt = T.createScriptURL(xt);
            break;
          }
        }
      if (xt !== Jr)
        try {
          $n ? _.setAttributeNS($n, Ke, xt) : _.setAttribute(Ke, xt), c(_) ? Dn(_) : mk(n.removed);
        } catch {
          Rn(Ke, _);
        }
    }
    g(Q.afterSanitizeAttributes, _, null);
  }, W = function(_) {
    let J = null;
    const de = t(_);
    for (g(Q.beforeSanitizeShadowDOM, _, null); J = de.nextNode(); )
      g(Q.uponSanitizeShadowNode, J, null), A(J), te(J), J.content instanceof o && W(J.content);
    g(Q.afterSanitizeShadowDOM, _, null);
  };
  return n.sanitize = function(_) {
    let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de = null, be = null, ne = null, Ke = null;
    if (xn = !_, xn && (_ = "<!-->"), typeof _ != "string" && !p(_) && (_ = yL(_), typeof _ != "string"))
      throw Ko("dirty is not a string, aborting");
    if (!n.isSupported)
      return _;
    if (ye || Vn(J), n.removed = [], typeof _ == "string" && (Y = !1), Y) {
      const Lt = _.nodeName;
      if (typeof Lt == "string") {
        const Jr = vn(Lt);
        if (!_e[Jr] || Pe[Jr])
          throw Ko("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (_ instanceof l)
      de = Mn("<!---->"), be = de.ownerDocument.importNode(_, !0), be.nodeType === Ta.element && be.nodeName === "BODY" || be.nodeName === "HTML" ? de = be : de.appendChild(be);
    else {
      if (!Ve && !We && !ue && // eslint-disable-next-line unicorn/prefer-includes
      _.indexOf("<") === -1)
        return T && ln ? T.createHTML(_) : _;
      if (de = Mn(_), !de)
        return Ve ? null : ln ? E : "";
    }
    de && $e && Dn(de.firstChild);
    const $n = t(Y ? _ : de);
    for (; ne = $n.nextNode(); )
      A(ne), te(ne), ne.content instanceof o && W(ne.content);
    if (Y)
      return _;
    if (Ve) {
      if (We) {
        de.normalize();
        let Lt = de.innerHTML;
        Fa([z, O, q], (Jr) => {
          Lt = Ri(Lt, Jr, " ");
        }), de.innerHTML = Lt;
      }
      if (Oe)
        for (Ke = ee.call(de.ownerDocument); de.firstChild; )
          Ke.appendChild(de.firstChild);
      else
        Ke = de;
      return (K.shadowroot || K.shadowrootmode) && (Ke = ae.call(i, Ke, !0)), Ke;
    }
    let Tn = ue ? de.outerHTML : de.innerHTML;
    return ue && _e["!doctype"] && de.ownerDocument && de.ownerDocument.doctype && de.ownerDocument.doctype.name && St(oS, de.ownerDocument.doctype.name) && (Tn = "<!DOCTYPE " + de.ownerDocument.doctype.name + `>
` + Tn), We && Fa([z, O, q], (Lt) => {
      Tn = Ri(Tn, Lt, " ");
    }), T && ln ? T.createHTML(Tn) : Tn;
  }, n.setConfig = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(_), ye = !0;
  }, n.clearConfig = function() {
    yn = null, ye = !1;
  }, n.isValidAttribute = function(_, J, de) {
    yn || Vn({});
    const be = vn(_), ne = vn(J);
    return L(be, ne, de);
  }, n.addHook = function(_, J) {
    typeof J == "function" && Ia(Q[_], J);
  }, n.removeHook = function(_, J) {
    if (J !== void 0) {
      const de = cL(Q[_], J);
      return de === -1 ? void 0 : dL(Q[_], de, 1)[0];
    }
    return mk(Q[_]);
  }, n.removeHooks = function(_) {
    Q[_] = [];
  }, n.removeAllHooks = function() {
    Q = _k();
  }, n;
}
var EL = sS();
const TL = "_messageContainer_1rxr4_1", $L = "_chip_1rxr4_7", DL = "_chipLabel_1rxr4_10", RL = "_chipValue_1rxr4_13", Yo = {
  messageContainer: TL,
  chip: $L,
  chipLabel: DL,
  chipValue: RL
}, Sk = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, OL = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  He(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ an.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ an.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ an.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ an.jsx(Ye, { content: "Conversation Attributes", children: /* @__PURE__ */ an.jsx(
        Bm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ an.jsx(b, { alignItems: "center", children: /* @__PURE__ */ an.jsx(Pn, { className: Yo.chip, children: /* @__PURE__ */ an.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ an.jsxs(Zn, { className: Yo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ an.jsx(Zn, { className: Yo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ an.jsx(
      b,
      {
        className: Yo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? Sk[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? Sk[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ an.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ an.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ an.jsx(P.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ an.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ an.jsx(N0, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ an.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: EL.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ an.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ an.jsx(
      j0,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ an.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, AL = "_conversation_1draa_1", PL = "_conversationSubLine_1draa_9", LL = "_modal_1draa_14", Au = {
  conversation: AL,
  conversationSubLine: PL,
  modal: LL
}, VL = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), zL = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), UL = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ an.jsxs(b, { className: Au.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ an.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ an.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ an.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ an.jsx(P.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ an.jsx(An, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ an.jsx(
          P.Heading,
          {
            variant: "heading-4",
            className: Au.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ an.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ an.jsx(Pn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ an.jsx(Ye, { content: "Show conversation preview", children: /* @__PURE__ */ an.jsx(
        nr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ an.jsxs(
      Et,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Au.modal,
        children: [
          /* @__PURE__ */ an.jsx(
            Tt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ an.jsx($t, { children: /* @__PURE__ */ an.jsx(
            OL,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: VL(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: zL(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, ML = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Bn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ an.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ an.jsx(
      UL,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ an.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, BL = aL(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), qL = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = pn(), { data: l, loading: d, error: m } = s(BL, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return He(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ an.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ an.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ an.jsx(dn, {}) }) : r?.length === 0 ? /* @__PURE__ */ an.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ an.jsx(
    ML,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, HL = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Gr
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
], Nk = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Pu = "MIUROS", WL = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, KL = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a
}) => {
  const o = !e, s = Dt({
    mode: "onChange",
    defaultValues: WL
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = lo({
    integrationId: e,
    integrationType: Pu,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: F
  } = co({
    integrationId: e,
    fieldDefinitions: Nk,
    form: s,
    onMisconfigured: v
  }), y = (T) => mo(T, {
    fieldDefinitions: Nk,
    isCreationMode: o,
    create: l,
    update: d
  }), M = s.watch("name");
  return /* @__PURE__ */ an.jsxs(
    uo,
    {
      form: s,
      integrationId: e,
      onValidSubmit: y,
      error: S ?? f,
      onRetry: S ? F : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ an.jsx(po, { cause: h }),
        /* @__PURE__ */ an.jsxs(yt, { children: [
          /* @__PURE__ */ an.jsx(Te, { children: /* @__PURE__ */ an.jsx(bn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ an.jsx(
            Ft,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ an.jsx(Te, { span: 3, children: /* @__PURE__ */ an.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ an.jsx(Te, { span: 3 }),
          /* @__PURE__ */ an.jsx(Te, { span: 3, children: /* @__PURE__ */ an.jsx(
            tt,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: s.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ an.jsx(Te, { span: 3 }),
          /* @__PURE__ */ an.jsx(Te, { span: 3, children: /* @__PURE__ */ an.jsx(
            zm,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ an.jsx(Te, { span: 3 }),
          /* @__PURE__ */ an.jsx(Te, { span: 3, children: /* @__PURE__ */ an.jsx(
            tt,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: s.control,
              rules: {
                required: "Please enter a number",
                validate: (T) => !Number.isNaN(Number.parseInt(T, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ an.jsx(Te, { span: 3 }),
          !o && e && /* @__PURE__ */ an.jsx(
            Gr,
            {
              configuration: n,
              integrationId: e,
              integrationType: Pu,
              label: "Authorize"
            }
          )
        ] }),
        /* @__PURE__ */ an.jsx(
          fo,
          {
            integrationType: Pu,
            integrationId: e,
            widgetName: M,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Lu = { exports: {} }, $a = {}, jk;
function GL() {
  if (jk) return $a;
  jk = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return $a.Fragment = r, $a.jsx = s, $a.jsxs = s, $a;
}
var Qo = {}, wk;
function YL() {
  return wk || (wk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Qo.Fragment = i, Qo.jsx = Rn, Qo.jsxs = Mn;
  })()), Qo;
}
var Ck;
function QL() {
  return Ck || (Ck = 1, process.env.NODE_ENV === "production" ? Lu.exports = GL() : Lu.exports = YL()), Lu.exports;
}
var Se = QL();
const JL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, XL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, ZL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, eV = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": JL,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": XL,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": ZL
};
function Up(e) {
  return eV[e] ?? {};
}
const nV = Up(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), tV = Up(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), rV = Up(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Im(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const iV = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, lS = "DD MMM YYYY @ HH:mm", aV = "_list_2c4dq_1", oV = "_listItem_2c4dq_4", sV = "_copyIcon_2c4dq_12", bi = {
  list: aV,
  listItem: oV,
  copyIcon: sV
}, Em = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Im(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: C
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, N = `${h} ${v}`.trim() || void 0, F = [S, u, f, N, C].filter(
    Boolean
  );
  return /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Se.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Se.jsx(fe, { size: l, name: n }),
      i ? /* @__PURE__ */ Se.jsx(dn, { size: l }) : /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: F.map((y, M) => /* @__PURE__ */ Se.jsx(Zn, { children: y }, M)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Se.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Se.jsx(Ye, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Se.jsx(
        fe,
        {
          size: l,
          name: "exclamation",
          className: bi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Se.jsx(Ye, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Se.jsx(
        fe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(F.join(", ")),
          className: bi.copyIcon
        }
      ) })
    ] })
  ] });
}, lV = "_wrapper_1nher_1", cV = {
  wrapper: lV
}, dV = ({
  customer: e,
  store: n
}) => {
  const { track: r } = _n(), { isCopied: i, copy: a } = Im(), { isCopied: o, copy: s } = Im(), { useQuery: l } = pn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(tV, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (He(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Se.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: N,
    email: F,
    first_name: y,
    last_name: M,
    created_at: T,
    has_valid_payment_method: E
  } = e, D = 14, B = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, ee = `${y || ""} ${M || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Se.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Se.jsxs(b, { className: cV.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Se.jsx(P.Heading, { variant: "heading-2", children: ee }),
    T && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: Ln(T).format(lS) })
    ] }),
    F && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(fe, { size: D, name: "mail" }),
        /* @__PURE__ */ Se.jsx(P.ExternalLink, { href: `mailto:${F}`, children: F })
      ] }),
      /* @__PURE__ */ Se.jsx(Ye, { content: "Copy email", children: /* @__PURE__ */ Se.jsx(
        fe,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(F),
          className: bi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(fe, { size: D, name: "phone" }),
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Se.jsx(Ye, { content: "Copy phone number", children: /* @__PURE__ */ Se.jsx(
        fe,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: bi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Se.jsx(
      Em,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(fe, { size: D, name: "credit-card" }),
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Se.jsx(
        fe,
        {
          size: D,
          name: E ? "check-circle" : "close-circle-filled",
          color: E ? "green.500" : "red.500"
        }
      )
    ] }),
    B && /* @__PURE__ */ Se.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Se.jsx(fe, { size: D, name: "external-link" }),
      /* @__PURE__ */ Se.jsx(
        P.ExternalLink,
        {
          href: B,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, uV = "_order_1dlaa_1", mV = "_orderIsOpen_1dlaa_9", pV = "_orderHeader_1dlaa_12", fV = "_note_1dlaa_16", Jo = {
  order: uV,
  orderIsOpen: mV,
  orderHeader: pV,
  note: fV
}, hV = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = _n(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: C,
    is_prepaid: S
  } = e, N = 14, F = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Se.jsxs(
    b,
    {
      className: at(Jo.order, {
        [Jo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Se.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Jo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Se.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Se.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: Ln(f).format(lS) }) }),
                /* @__PURE__ */ Se.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Se.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Se.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Se.jsx(Ye, { content: "Note", children: /* @__PURE__ */ Se.jsx(
            P.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Jo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Se.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Se.jsx(fe, { size: N, name: "activity" }),
            /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: iV(l) })
            ] })
          ] }),
          /* @__PURE__ */ Se.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Se.jsx(fe, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Se.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Se.jsx(fe, { size: N, name: "cog" }),
            /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Se.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Se.jsx(fe, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Se.jsxs(P.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Se.jsx(
            Em,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Se.jsx(
            Em,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          F && /* @__PURE__ */ Se.jsx(
            It,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(F, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Se.jsx(fe, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, yV = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = _n(), { useQuery: i } = pn(), {
    loading: a,
    error: o,
    data: s
  } = i(rV, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Se.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Se.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Se.jsx(An, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Se.jsx(dn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Se.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Se.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Se.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Se.jsx(
        hV,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Se.jsx(
        It,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Se.jsx(fe, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, gV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Se.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Se.jsxs(Ge, { className: bi.list, children: [
      /* @__PURE__ */ Se.jsx(Ge.Text, { variant: "dense", className: bi.listItem, children: /* @__PURE__ */ Se.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Se.jsx(Ge.Text, { variant: "dense", className: bi.listItem, children: /* @__PURE__ */ Se.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Se.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, vV = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = pn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(nV, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return Pm({ errors: v }) ? /* @__PURE__ */ Se.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Lm({ errors: v }) ? /* @__PURE__ */ Se.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Se.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Se.jsx(dn, {}) }) : f ? l ? /* @__PURE__ */ Se.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Se.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Se.jsx(dV, { customer: f, store: h }),
        o && /* @__PURE__ */ Se.jsx(gV, { customer: f }),
        s && /* @__PURE__ */ Se.jsx(yV, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Se.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, kV = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Fk = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], bV = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, xV = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i
}) => {
  const a = !e, o = Dt({
    mode: "onChange",
    defaultValues: bV
  }), {
    create: s,
    update: l,
    remove: d,
    isLoading: m,
    error: u,
    misconfigurationCause: f,
    setMisconfigurationCause: h
  } = lo({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: v,
    error: C,
    isWidgetUnknown: S,
    refetch: N
  } = co({
    integrationId: e,
    fieldDefinitions: Fk,
    form: o,
    onMisconfigured: h
  }), F = (M) => mo(M, {
    fieldDefinitions: Fk,
    isCreationMode: a,
    create: s,
    update: l
  }), y = o.watch("name");
  return /* @__PURE__ */ Se.jsxs(
    uo,
    {
      form: o,
      integrationId: e,
      onValidSubmit: F,
      error: C ?? u,
      onRetry: C ? N : void 0,
      isLoading: m || v,
      isWidgetUnknown: S,
      children: [
        f && /* @__PURE__ */ Se.jsx(po, { cause: f }),
        /* @__PURE__ */ Se.jsxs(yt, { children: [
          /* @__PURE__ */ Se.jsx(Te, { children: /* @__PURE__ */ Se.jsx(bn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Se.jsx(
            Ft,
            {
              name: "enabled",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3, children: /* @__PURE__ */ Se.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: o.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3, children: /* @__PURE__ */ Se.jsx(
            zm,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: o.control,
              isCreationMode: a,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3, children: /* @__PURE__ */ Se.jsx(bn, { label: "Displays details of a customer", children: /* @__PURE__ */ Se.jsx(
            Ft,
            {
              name: "displayCustomerDetails",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3, children: /* @__PURE__ */ Se.jsx(bn, { label: "Displays the subscription overview", children: /* @__PURE__ */ Se.jsx(
            Ft,
            {
              name: "displaysubscriptionOverview",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3, children: /* @__PURE__ */ Se.jsx(bn, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Se.jsx(
            Ft,
            {
              name: "displayOrders",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Te, { span: 3 })
        ] }),
        /* @__PURE__ */ Se.jsx(
          fo,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: y,
            isCreationMode: a,
            isSubmitting: o.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vu = { exports: {} }, Da = {}, Ik;
function _V() {
  if (Ik) return Da;
  Ik = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Xo = {}, Ek;
function SV() {
  return Ek || (Ek = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Xo.Fragment = i, Xo.jsx = Rn, Xo.jsxs = Mn;
  })()), Xo;
}
var Tk;
function NV() {
  return Tk || (Tk = 1, process.env.NODE_ENV === "production" ? Vu.exports = _V() : Vu.exports = SV()), Vu.exports;
}
var k = NV();
const $k = "__PairingContext__", jV = () => globalThis[$k] ?? (() => {
  const e = Bb({});
  return globalThis[$k] = e, e;
})(), wV = jV(), CV = () => Um(wV), FV = "_banner_d9pot_1", IV = "_list_d9pot_8", Dk = {
  banner: FV,
  list: IV
}, Rk = "https://apps.shopify.com/dixa-dashboard", EV = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, cS = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = CV(), [i, a] = se(!1), [o, s] = se(null), l = EV[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Rk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Rk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Dk.banner, children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(fe, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Dk.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Kn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(dn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, TV = (e) => /* @__PURE__ */ k.jsx(cS, { ...e, bannerVariant: "install" }), $V = (e) => /* @__PURE__ */ k.jsx(cS, { ...e, bannerVariant: "migration" }), DV = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], RV = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], OV = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: TV
  }
], AV = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Ok = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: $V,
    additionalProperties: { renderAboveForm: !0 }
  }
], dS = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Ak = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Lb(e)
  },
  ...dS
];
var zi = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(zi || {}), xi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(xi || {}), $r = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))($r || {}), uS = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(uS || {}), mi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(mi || {}), Hr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Hr || {}), gs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(gs || {}), mS = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(mS || {});
const PV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, VV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, zV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, UV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, MV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, BV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, qV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, HV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, WV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, KV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, GV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, YV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, QV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, JV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, XV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, ZV = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": PV,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": LV,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": VV,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": zV,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": UV,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": MV,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": BV,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": qV,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": HV,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": WV,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": KV,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": GV,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": YV,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": QV,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": JV,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": XV
};
function yr(e) {
  return ZV[e] ?? {};
}
const ez = yr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), nz = yr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), tz = yr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), rz = yr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Mp = yr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), iz = yr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), az = yr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), oz = yr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), sz = yr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), lz = yr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), cz = yr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), dz = yr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), pS = Hs`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, uz = Hs`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, mz = ({
  conversationContext: e
}) => {
  const { useQuery: n } = pn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(ez, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, pz = () => {
  const { useLazyQuery: e } = pn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(nz);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function so(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const fz = "_list_alvh6_1", hz = "_listItem_alvh6_4", yz = "_fullWidth_alvh6_15", gz = "_boxWrapper_alvh6_19", Ot = {
  list: fz,
  listItem: hz,
  fullWidth: yz,
  boxWrapper: gz
}, vz = "_modal_1vkwz_1", kz = "_disabled_1vkwz_5", zu = {
  modal: vz,
  disabled: kz
}, Pk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: xi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: xi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: xi.Unknown
  }
], Lk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: $r.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: $r.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: $r.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: $r.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: $r.Unsubscribed
  }
], bz = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = _n(), { useMutation: l, showNotification: d } = pn(), [m, u] = se(), [f, h] = se(), [v, C] = Mf(!0), [S, N] = Mf(!0), F = !!m, y = e.customer?.email, M = e.customer?.phone_number, T = e.customer?.given_name, E = e.customer?.family_name, D = {
    email: y ?? "",
    phone: M ?? "",
    firstName: T ?? "",
    lastName: E ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, B = Dt({
    defaultValues: D
  });
  He(() => {
    f?.forEach((O) => {
      const q = O?.field?.[0];
      q && (B.setError(q, {
        type: "server",
        message: O.message
      }), B.setFocus(q));
    });
  }, [f, B]);
  const [ee, { error: X, reset: ae }] = l(cz, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const q = O?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), Q = it(
    (O) => {
      a(!0), u(void 0), ee({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...v && { email: O.email },
            ...S && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [ee, a, S, v]
  ), z = () => {
    r(!1), ae(), u(void 0), B.reset(D);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: n, onClose: z, className: zu.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Create new customer", onClose: z }),
    /* @__PURE__ */ k.jsx($t, { children: /* @__PURE__ */ k.jsxs(yt, { children: [
      /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "First name",
          name: "firstName",
          control: B.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Last name",
          name: "lastName",
          control: B.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Email",
          name: "email",
          control: B.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: at({
              [zu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                tm,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Phone",
          name: "phone",
          control: B.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: at({
              [zu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                tm,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: B.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = Lk.find(
                (Z) => Z.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Lk.map((O) => /* @__PURE__ */ k.jsx(ct.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: B.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = Pk.find(
                (Z) => Z.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Pk.map((O) => /* @__PURE__ */ k.jsx(ct.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      F && /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(fe, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          disabled: !(B.formState.isValid && B.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: B.handleSubmit(Q),
        cancelOnClick: z,
        confirmName: X ? "Close" : "Save",
        cancelName: X ? void 0 : "Cancel"
      }
    )
  ] });
}, xz = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(fe, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ot.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      bz,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Bp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Tm = "DD MMM YYYY @ HH:mm", _z = "_wrapper_10fld_1", Sz = "_copyIcon_10fld_7", Zo = {
  wrapper: _z,
  copyIcon: Sz
}, Nz = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = so(), { isCopied: l, copy: d } = so(), { track: m } = _n();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: C = [],
    verifiedEmail: S
  } = e, N = h?.emailAddress, F = v?.phoneNumber, y = Bp(u), M = `https://${n}/admin/customers/${y ?? ""}`, T = i && a === er.refetch, E = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Zo.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(dn, { size: E }) : /* @__PURE__ */ k.jsx(Ye, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: E,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Zo.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(fe, { size: E, name: "mail" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ k.jsx(
            Ye,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                fe,
                {
                  size: E,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ye, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: E,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: Zo.copyIcon
          }
        ) })
      ] }),
      F && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(fe, { size: E, name: "phone" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `tel:${F}`, children: F })
        ] }),
        /* @__PURE__ */ k.jsx(Ye, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: E,
            name: l ? "done" : "copy",
            onClick: () => d(F),
            className: Zo.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(fe, { size: E, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          P.ExternalLink,
          {
            href: M,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((D) => /* @__PURE__ */ k.jsx(Pn, { children: D }, `${u}-${D}`)) })
    ] })
  ] });
}, jz = "_creationModal_pbe64_1", wz = "_detailsModal_pbe64_5", Cz = "_percentageSuffix_pbe64_9", Uu = {
  creationModal: jz,
  detailsModal: wz,
  percentageSuffix: Cz
}, Fz = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, Iz = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: uS.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Vk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], zk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Uk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], Ez = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = or(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Ge, { children: [
      /* @__PURE__ */ k.jsx(Ge.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ge.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            fe,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ge.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ge.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ge.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(bt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(bn, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      Nr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, Tz = "shopify-discount-code-form", Mk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, $z = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = _n(), { useMutation: i, showNotification: a } = pn(), [o, s] = se(
    []
  ), [l, d] = se(), m = Dt({
    mode: "all",
    defaultValues: Mk
  });
  He(() => {
    o?.forEach((E) => {
      const D = E?.field?.[1];
      D && m.setError(D, {
        type: "server",
        message: E.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = Bn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: S,
      error: N,
      reset: F
    }
  ] = i(dz, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (E) => {
      const D = E?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const B = E?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        B && "codes" in B && d(B), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", Fz(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, M = (E) => {
    C({
      variables: {
        input: Iz(E)
      }
    });
  }, T = () => {
    m.reset(Mk), s([]), F(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: e,
      onClose: T,
      className: at({
        [Uu.creationModal]: !u,
        [Uu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs($t, { children: [
          u && /* @__PURE__ */ k.jsx(Ez, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Tz, onSubmit: m.handleSubmit(M), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              qs,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(yt, { children: [
              /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (E) => {
                      const D = Vk.find(
                        (B) => B.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Vk.map((E) => /* @__PURE__ */ k.jsx(ct.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (E) => {
                      if (E) {
                        if (h === "percentage" && (E < 0 || E > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && E < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Uu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (E) => {
                      const D = zk.find(
                        (B) => B.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: zk.map((E) => /* @__PURE__ */ k.jsx(ct.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (E) => {
                      if (E && f !== "none" && E < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (E, D) => E === D,
                    getItemTitleByValue: (E) => {
                      const D = Uk.find(
                        (B) => B.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Uk.map((E) => /* @__PURE__ */ k.jsx(ct.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ k.jsx(Fn, { error: N })
        ] }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? T : m.handleSubmit(M),
            cancelOnClick: u ? void 0 : T
          }
        )
      ]
    }
  );
}, Dz = ({ code: e }) => {
  const { isCopied: n, copy: r } = so();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(fe, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          nr,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, Rz = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Ge, { children: i.map((a) => /* @__PURE__ */ k.jsx(Ge.Item, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(Dz, { code: a.code }, a.id) }, a.id)) })
  ] });
}, Oz = "_modal_11d6e_1", Az = "_modalBody_11d6e_4", Pz = "_codeContainer_11d6e_9", Mu = {
  modal: Oz,
  modalBody: Az,
  codeContainer: Pz
}, Lz = [50, 100, 250], fS = 50, Vz = {
  maxNumberOfCodesToDisplay: fS
}, zz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = pn(), [i, a] = se(
    fS
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = Dt({
    mode: "all",
    defaultValues: Vz
  }), { loading: u, error: f } = r(iz, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const C = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: e, onClose: h, className: Mu.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs($t, { className: Mu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(yt, { children: /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: v }) })
          },
          children: Lz.map((v) => /* @__PURE__ */ k.jsx(ct.Item, { value: v, children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        xs,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: Mu.codeContainer, children: /* @__PURE__ */ k.jsx(Rz, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(At, { confirmName: "Close", confirmOnClick: h })
  ] });
}, Uz = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      zz,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      $z,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, Mz = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? zb(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case zi.Invalid:
      case zi.NotSubscribed:
      case $r.NotSubscribed:
        return "red.500";
      case zi.Pending:
      case $r.Pending:
      case zi.Unsubscribed:
      case $r.Unsubscribed:
        return "orange.500";
      case zi.Subscribed:
      case $r.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case xi.SingleOptIn:
      case xi.ConfirmedOptIn:
        return "green.500";
      case xi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(fe, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ye, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(An, { size: "small", variant: "info", children: Ln(l).format(Tm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ye, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ye, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(fe, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ye, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(An, { size: "small", variant: "info", children: Ln(u).format(Tm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ye, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ye, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, Bz = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: mS.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, Bk = [
  {
    value: Hr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Hr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Hr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Hr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Hr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Hr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Hr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], qk = [
  {
    value: gs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: gs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: gs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], hS = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Ui = (e) => qz(Hz(e)), qz = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), Hz = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ci = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Wt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      pr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), Wz = "_modal_1wlra_1", Kz = {
  modal: Wz
};
function Hk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Wk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Kk = "shopify-shiping-address-form", Gz = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = pn(), { track: f } = _n(), [h, v] = se(!1), [C, S] = se({}), N = !l, [
    F,
    { error: y, reset: M }
  ] = m(az, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (Q) => {
      v(!1);
      const z = Q?.Shopify?.orderUpdate?.userErrors;
      if (z != null && z.length > 0) {
        const O = z.reduce(
          (q, Z) => {
            const ve = Z.field;
            if (ve == null || ve.length === 0)
              return q;
            const ce = ve[ve.length - 1];
            return ce != null && (q[ce] = Z.message), q;
          },
          {}
        );
        S(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ae();
    }
  }), T = it(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Wk.find(
        (Q) => Q === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: E, handleSubmit: D, formState: B, reset: ee } = Dt({
    mode: "all",
    defaultValues: T()
  }), X = D((Q) => {
    if (N) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: z, ...O } = Q, q = {
        ...O,
        countryCode: z
      };
      F({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(Q), ae();
  });
  He(() => {
    r && ee(T());
  }, [r, n, ee, T]);
  const ae = () => {
    ee(T()), S({}), M(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: r,
      onClose: ae,
      className: Kz.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: e, onClose: () => ae() }),
        /* @__PURE__ */ k.jsx($t, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Kk, onSubmit: X, children: [
          y && /* @__PURE__ */ k.jsx(Fn, { error: y }),
          /* @__PURE__ */ k.jsxs(yt, { children: [
            /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                required: !0,
                control: E,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                required: !0,
                control: E,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 6, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                control: E,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 6, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                required: !0,
                control: E,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 6, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                control: E,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                required: !0,
                control: E,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 3, children: /* @__PURE__ */ k.jsx(
              ci,
              {
                required: !0,
                control: E,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 6, children: /* @__PURE__ */ k.jsx(
              jr,
              {
                name: "countryCodeV2",
                control: E,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (Q) => Q ? Hk(Q) : ""
                },
                children: Wk.filter((Q) => s.includes(Q)).map((Q) => /* @__PURE__ */ k.jsx(ct.Item, { value: Q, children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: Hk(Q) }) }, Q))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              disabled: !(B.isValid && B.isDirty),
              type: "submit",
              form: Kk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ae();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ae();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, Yz = "_clickableIcon_33mqm_1", Bu = {
  clickableIcon: Yz
}, Gk = ({
  formFieldName: e,
  ...n
}) => {
  const r = Pr(), { field: i } = ap({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    $m,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, $m = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: C, copy: S } = so(), { track: N } = _n(), F = 14, y = o && (!!r || !!l), M = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), E = n?.countryCodeV2 && c0(n.countryCodeV2), D = it(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    M,
    n?.province,
    E
  ].filter(Boolean).join(`
`), [n, T, M, E]);
  if (!n)
    return null;
  const B = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(fe, { size: F, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Bu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  fe,
                  {
                    size: F,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address2 }),
            M && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: M }),
            n?.province && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.province }),
            E && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: E })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Ye, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: F,
            name: "pen",
            onClick: () => B(),
            className: Bu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ye, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: F,
            name: C ? "done" : "copy",
            onClick: () => S(D()),
            className: Bu.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      Gz,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, qp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Pr(), i = us({ control: r.control, name: "lineItems" }), a = us({
    control: r.control,
    name: "billingAddress"
  }), o = us({
    control: r.control,
    name: "shippingAddress"
  }), s = Bn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Bn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Gk,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Gk,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, Qz = "_productTableHeader_6h6pl_1", Jz = "_productImage_6h6pl_5", Qa = {
  productTableHeader: Qz,
  productImage: Jz
}, Hp = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, Xz = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Pr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Hp(e);
  return /* @__PURE__ */ k.jsxs(Jn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Xi,
        {
          src: d,
          alt: e.title,
          className: Qa.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
      tt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(nr, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, Zz = 300, Ra = 2, e3 = 25, n3 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = pn(), [i, a] = se(""), [o, s] = se([]), l = Pr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Mp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const N = S?.Shopify?.products?.nodes || [];
      s(
        N.filter((F) => !!F).sort((F, y) => F.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  Si(
    () => {
      i.trim().length >= Ra && !u && f === er.ready ? m({
        variables: {
          query: i.trim(),
          productCount: e3,
          mediaCount: 1
        }
      }) : i.trim().length < Ra && s([]);
    },
    Zz,
    [i]
  ), He(() => {
    if (!d) return;
    const S = o.find(
      (N) => N.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== er.ready, v = i.trim().length >= Ra, C = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Ra} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const N = o.find(
            (F) => F.id === S
          );
          return N ? /* @__PURE__ */ k.jsx(P.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(ct.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }) }),
        !h && o.map((S) => {
          const N = S.totalInventory <= 0, F = Hp(S);
          return /* @__PURE__ */ k.jsx(
            ct.Item,
            {
              value: S.id,
              isDisabled: N,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  F && /* @__PURE__ */ k.jsx(
                    Xi,
                    {
                      src: F,
                      alt: S.title,
                      className: Qa.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    w0,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: N ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        C && /* @__PURE__ */ k.jsx(ct.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          xs,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(ct.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          xs,
          {
            title: "Search for products",
            description: `Type at least ${Ra} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Wp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Pr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], v = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), C = h.some(
    (N) => a.includes(N?.id)
  ) && !v, S = it(
    (N) => {
      const F = m.getValues("lineItems"), y = F.findIndex(
        (M) => M?.id === N.id
      );
      if (y > -1) {
        const M = m.getValues(`lineItems.${y}.quantity`) || 0, T = [...F];
        T[y] = {
          ...T[y],
          quantity: M + 1
        }, m.setValue("lineItems", T);
      } else
        m.setValue("lineItems", [
          ...F,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(n3, { onProductSelected: S }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(dn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          xs,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Jn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Qa.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Jn.Thead, { className: Qa.productTableHeader, children: /* @__PURE__ */ k.jsxs(Jn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Jn.Th, { children: /* @__PURE__ */ k.jsx(
              sf,
              {
                checked: v,
                indeterminate: C,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Jn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Jn.Tbody, { children: u?.map((N, F) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                Xz,
                {
                  product: N,
                  index: F,
                  onRemove: () => {
                    const z = u.filter(
                      (O, q) => q !== F
                    );
                    m.setValue("lineItems", z);
                  }
                },
                `${N?.id}-${F}`
              );
            const y = N, M = y.priceRangeV2.minVariantPrice.amount, T = y.priceRangeV2.minVariantPrice.currencyCode, E = `lineItems.${F}.quantity`, D = m.watch(E) || 0, B = M * D, ee = Hp(y), X = a.includes(y.id), ae = o.includes(y.id), Q = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Jn.Tr,
              {
                style: ae ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
                    sf,
                    {
                      checked: X,
                      disabled: ae,
                      onChange: () => l?.(y.id, !X)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    ee && /* @__PURE__ */ k.jsx(
                      Xi,
                      {
                        src: ee,
                        alt: y.title,
                        className: Qa.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.title }),
                      ae && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${M} ${T}` }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
                    tt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ae || Q <= 1,
                      name: E,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: Q,
                        tabIndex: 0
                      }
                    },
                    `${E}-${m.watch(E)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${B} ${T}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    nr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const z = u.filter(
                          (O, q) => q !== F
                        );
                        m.setValue("lineItems", z), X && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${F}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, yS = ({
  previousOrderStatus: e
} = {}) => {
  const n = Pr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Bk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Bk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(ct.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, gS = () => {
  const e = Pr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = qk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: qk.map((n) => /* @__PURE__ */ k.jsx(ct.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, t3 = "_modal_1mprq_1", r3 = {
  modal: t3
}, qu = "create-shopify-order-form", i3 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = pn(), { track: l } = _n(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Hr.Pending,
    fulfillmentStatus: void 0
  }, [C, S] = se([]), N = Dt({
    mode: "all",
    defaultValues: v
  }), F = N.watch("lineItems").length > 0, y = () => {
    N.reset(v), S([]), i(!1);
  };
  He(() => {
    C.length > 0 && N.setValue("tags", C, { shouldDirty: !0 });
  }, [C, N]);
  const [M, { error: T }] = o(
    pS,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [E, { error: D }] = o(
    uz,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), B = (X) => {
    const ae = X.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const Q = Ui(X?.billingAddress), z = Ui(
      X?.shippingAddress
    );
    M({
      variables: {
        order: {
          lineItems: ae,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: X.customNote,
          tags: X.tags,
          financialStatus: X.financialStatus,
          fulfillmentStatus: X.fulfillmentStatus,
          shippingAddress: z,
          billingAddress: Q
        }
      }
    });
  }, ee = (X) => {
    const ae = X.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const Q = Ui(X?.billingAddress), z = Ui(
      X?.shippingAddress
    );
    E({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: X.customNote,
          tags: X.tags,
          lineItems: ae,
          shippingAddress: z,
          billingAddress: Q
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: e,
      onClose: y,
      className: r3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs($t, { children: [
          /* @__PURE__ */ k.jsx(ip, { ...N, children: /* @__PURE__ */ k.jsx("form", { id: qu, children: /* @__PURE__ */ k.jsxs(yt, { children: [
            /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(Wp, {}) }),
            /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: X } }) => /* @__PURE__ */ k.jsx(
                  bn,
                  {
                    label: "Tags",
                    meta: {
                      error: X?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ae) => {
                          ae.key === "Enter" && (ae.preventDefault(), ae.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Bs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ae) => {
                              S(ae);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(yS, {}),
              /* @__PURE__ */ k.jsx(gS, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(Te, { span: 2, children: /* @__PURE__ */ k.jsx(bn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(qp, {})
              }
            ) }) })
          ] }) }) }),
          (T || D) && /* @__PURE__ */ k.jsx(Fn, { error: T || D })
        ] }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              type: "submit",
              form: qu,
              disabled: !F || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(B),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(ee)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: qu,
                disabled: !F || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, a3 = "_modal_al73g_1", o3 = {
  modal: a3
}, Yk = [
  {
    label: "Customer",
    value: mi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: mi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: mi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: mi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: mi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: mi.Staff,
    description: "Staff made an error."
  }
], s3 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = _n(), { useMutation: d, showNotification: m } = pn(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = Dt({
    defaultValues: v
  }), [S, { error: N, reset: F }] = d(sz, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const E = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (E.length > 0)
        o(!1), f(E), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), m({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = it(
    (T) => {
      T.reason != null && (o(!0), S({
        variables: {
          orderId: T.orderId,
          reason: T.reason,
          refundMethod: T.refundMethod,
          restock: T.restock,
          notifyCustomer: T.notifyCustomer,
          staffNote: T.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), M = () => {
    i(!1), F(), f([]), C.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: n, onClose: M, className: o3.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: `Cancel order ${r}`, onClose: M }),
    /* @__PURE__ */ k.jsx($t, { children: /* @__PURE__ */ k.jsxs(yt, { children: [
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, E) => T === E,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const E = Yk.find(
                (D) => D.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: E.label }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: E.description })
              ] });
            }
          },
          children: Yk.map((T) => /* @__PURE__ */ k.jsx(ct.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(bn, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Ft,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(bn, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Ft, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(bn, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Ft, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(fe, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(y),
        cancelOnClick: M,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, l3 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ot.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      s3,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, c3 = "_modal_1mprq_1", d3 = {
  modal: c3
}, u3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = pn(), { track: m } = _n(), [u, f] = se(!1), [h, v] = se(e?.tags || []), C = "duplicate-shopify-order-form", S = (z) => ({
    firstName: z?.firstName,
    lastName: z?.lastName,
    company: z?.company,
    address1: z?.address1,
    address2: z?.address2,
    city: z?.city,
    provinceCode: z?.provinceCode,
    zip: z?.zip,
    countryCode: z?.countryCodeV2,
    phone: z?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, F = Dt({
    mode: "all",
    defaultValues: N
  }), y = F.watch("lineItems").length > 0, M = Bn(
    () => (e?.lineItems || []).map((z) => z.product?.id).filter((z) => !!z),
    [e]
  ), T = Bn(
    () => hS(M),
    [M]
  ), {
    data: E,
    loading: D,
    error: B
  } = d(Mp, {
    skip: !T,
    variables: {
      query: T,
      productCount: M.length,
      mediaCount: 1
    }
  });
  He(() => {
    B && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [B, l]), He(() => {
    if (!r || D || !E || F.getValues("lineItems")?.length)
      return;
    const z = E?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const Z = z.find(
        (ve) => ve.id === q.product?.id
      );
      Z && O.push({
        ...Z,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && F.setValue("lineItems", O, { shouldDirty: !0 });
  }, [r, E, D, e, F]), He(() => {
    (h.length > 0 || (F.getValues("tags") || []).length > 0) && F.setValue("tags", h, { shouldDirty: !0 });
  }, [h, F]);
  const [ee, { error: X }] = s(
    pS,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Q();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Q();
      }
    }
  ), ae = (z) => {
    const O = z.lineItems.map((Z) => ({
      productId: Z.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: Z.discountedUnitPrice?.amount ?? Z.priceRangeV2.maxVariantPrice.amount,
          currencyCode: Z.discountedUnitPrice?.currencyCode ?? Z.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: Z.quantity,
      sku: Z.sku
    })), q = (e?.shippingLines ?? []).map(
      (Z) => ({
        title: Z.title,
        code: Z.code,
        source: Z.source,
        priceSet: {
          shopMoney: {
            amount: Z.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: Z.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), ee({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: q,
          note: z.customNote,
          tags: z.tags,
          financialStatus: z.financialStatus,
          fulfillmentStatus: z.fulfillmentStatus,
          shippingAddress: Ui(z?.shippingAddress),
          billingAddress: Ui(z?.billingAddress)
        }
      }
    });
  }, Q = () => {
    F.reset(N), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: r,
      onClose: Q,
      className: d3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: `Duplicate order ${n}`, onClose: Q }),
        /* @__PURE__ */ k.jsxs($t, { children: [
          /* @__PURE__ */ k.jsx(ip, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: C, children: /* @__PURE__ */ k.jsxs(yt, { children: [
            /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(Wp, { loading: D }) }),
            /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: z } }) => /* @__PURE__ */ k.jsx(
                  bn,
                  {
                    label: "Tags",
                    meta: {
                      error: z?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Bs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              v(O);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(Te, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                yS,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(gS, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(Te, { span: 2, children: /* @__PURE__ */ k.jsx(bn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(qp, {})
              }
            ) }) })
          ] }) }) }),
          X && /* @__PURE__ */ k.jsx(Fn, { error: X })
        ] }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !y || u || D,
              isLoading: u || D,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: F.handleSubmit(ae)
          }
        )
      ]
    }
  );
}, m3 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(fe, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Pn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Ge, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Ge.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Xi, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, p3 = Hs`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, f3 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, vS = (e) => {
  const n = {}, r = f3(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, h3 = "_modal_21e62_1", y3 = {
  modal: h3
}, Qk = "partial-refund-shopify-order-form", g3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = pn(), { track: l } = _n(), { useQuery: d } = pn(), [m, u] = se(!1), [f, h] = se([]), v = Bn(
    () => e?.refunds ? vS(e) : {},
    [e]
  ), C = Bn(
    () => (e?.lineItems || []).filter((z) => (v[z.id] || 0) >= (z.quantity || 0)).map((z) => z.product?.id).filter((z) => !!z),
    [e, v]
  ), S = Bn(() => {
    const z = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const q = v[O.id] || 0, Z = Math.max(
          0,
          (O.quantity || 0) - q
        );
        z[O.product.id] = Z;
      }
    }), z;
  }, [e, v]), N = Bn(
    () => (e?.lineItems || []).map((z) => z.product?.id).filter((z) => !!z),
    [e]
  ), F = Bn(
    () => hS(N),
    [N]
  ), {
    data: y,
    loading: M,
    error: T
  } = d(Mp, {
    skip: !F,
    variables: {
      query: F,
      productCount: N.length,
      mediaCount: 1
    }
  });
  He(() => {
    T && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [T, s]);
  const E = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, D = Dt({
    mode: "all",
    defaultValues: E
  }), B = f.length > 0, [ee, { error: X }] = o(
    p3,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), Q();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), Q();
      }
    }
  );
  He(() => {
    if (!r || M || !y || D.getValues("lineItems")?.length)
      return;
    const z = y?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const Z = z.find(
        (ve) => ve.id === q.product?.id
      );
      if (Z) {
        const ve = v[q.id] || 0, ce = (q.quantity || 1) - ve;
        O.push({
          ...Z,
          quantity: ce > 0 ? ce : q.quantity || 1
        });
      }
    }), O.length > 0 && (D.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    M,
    e,
    D,
    v
  ]);
  const ae = (z) => {
    u(!0);
    const O = (z.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const Z = e?.lineItems?.find(
        (me) => me.product?.id === q.id
      ), ve = v[Z?.id || ""] || 0, ce = (Z?.quantity || 0) - ve, le = Math.max(
        0,
        Math.min(ce, q.quantity || 0)
      );
      return Z && le > 0 ? { lineItemId: Z.id, quantity: le } : void 0;
    }).filter((q) => !!q);
    ee({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: z.customNote || void 0,
          notify: !0
        }
      }
    });
  }, Q = () => {
    D.reset(E), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: r, onClose: Q, className: y3.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: `Refund order ${n}`, onClose: Q }),
    /* @__PURE__ */ k.jsxs($t, { children: [
      /* @__PURE__ */ k.jsx(ip, { ...D, children: /* @__PURE__ */ k.jsx("form", { id: Qk, children: /* @__PURE__ */ k.jsxs(yt, { children: [
        /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
          Wp,
          {
            loading: M,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: S,
            onToggleSelect: (z, O) => {
              h((q) => O ? Array.from(/* @__PURE__ */ new Set([...q, z])) : q.filter((Z) => Z !== z));
            },
            onToggleSelectAll: (z) => {
              const O = (D.getValues("lineItems") || []).map((q) => q.id).filter((q) => !C.includes(q));
              h(z ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(Te, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          tt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(Te, { span: 2, children: /* @__PURE__ */ k.jsx(bn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ot.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              qp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      X && /* @__PURE__ */ k.jsx(Fn, { error: X })
    ] }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          type: "submit",
          form: Qk,
          disabled: !B || m || M,
          isLoading: m || M,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: D.handleSubmit(ae)
      }
    )
  ] });
}, v3 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = pn(), { track: l } = _n(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), v = !isNaN(h) && h > 0, [C] = a(oz, {
    onError: (F) => {
      setTimeout(() => N(F), 500);
    },
    onCompleted: (F) => {
      const y = F.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? N(
        new Gb({
          graphQLErrors: y.map((M) => ({
            message: M.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = it(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: F, ...y } = d;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
        "You are about to refund ",
        F,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), C({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    v,
    s,
    C,
    l
  ]), N = it(
    (F) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Fn, { error: F }),
          /* @__PURE__ */ k.jsx(
            It,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: S,
      disabled: d?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(fe, { size: 14, name: "undo" }),
      className: Ot.fullWidth,
      children: "Full refund"
    }
  ) });
}, k3 = "_modal_al73g_1", b3 = {
  modal: k3
}, x3 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = _n(), { useMutation: s, showNotification: l } = pn(), [d, m] = se(n), [u, f] = se(!1), h = Dt({
    defaultValues: {
      tags: n
    }
  });
  He(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: C, reset: S }] = s(lz, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = it(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((M) => {
        const T = M.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: T });
      });
    },
    [e, h, v]
  ), F = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: r, onClose: F, className: b3.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Manage tags for order", onClose: F }),
    /* @__PURE__ */ k.jsxs($t, { children: [
      /* @__PURE__ */ k.jsx(yt, { children: /* @__PURE__ */ k.jsx(Te, { children: /* @__PURE__ */ k.jsx(
        Wt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            bn,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Bs,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (M) => m(M)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ k.jsx(Fn, { error: C })
    ] }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: F,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, _3 = "_editIcon_1dntr_1", S3 = {
  editIcon: _3
}, N3 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(fe, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(An, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ye, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        fe,
        {
          size: o,
          name: "pen",
          className: S3.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      x3,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, j3 = "_icon_cddi1_1", w3 = "_link_cddi1_6", Jk = {
  icon: j3,
  link: w3
}, C3 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = so(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Ge.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        P.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Jk.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ye, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        fe,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Jk.icon
        }
      ) })
    }
  );
}, F3 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(fe, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Ge, { children: e.map((n) => /* @__PURE__ */ k.jsx(C3, { trackingInfo: n }, n.number)) })
] }), I3 = "_order_135ze_1", E3 = "_orderIsOpen_135ze_9", T3 = "_orderHeader_135ze_12", Hu = {
  order: I3,
  orderIsOpen: E3,
  orderHeader: T3
}, $3 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = _n(), [h, v] = se(!1), [C, S] = se(!1), [N, F] = se(r), {
    id: y,
    name: M,
    createdAt: T,
    status: E,
    currentTotalPriceSet: D,
    currencyCode: B,
    lineItems: ee,
    billingAddress: X,
    shippingAddress: ae,
    trackingInfos: Q,
    tags: z
  } = e, O = !!ae, q = Bp(y), Z = `https://${l}/admin/orders/${q ?? ""}`, ve = D?.shopMoney?.amount ?? 0, ce = E.includes("cancelled"), le = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: B
  }).format(ve), me = e?.refunds ? vS(e) : {}, H = !!ee?.length && ee.every((_e) => (me[_e.id] || 0) >= (_e.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: at(Hu.order, {
        [Hu.orderIsOpen]: N
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Hu.orderHeader,
            onClick: () => F(!N),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                T && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Ln(T).format(Tm) }) }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order ",
                  M
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: N ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        N && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(fe, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: E })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(fe, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: le })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            N3,
            {
              orderId: y,
              tags: z,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            $m,
            {
              openByDefault: !O,
              labelText: "Billing address",
              address: X,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            $m,
            {
              openByDefault: O,
              shopifyId: n,
              orderId: y,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ae,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            m3,
            {
              orderId: y,
              lineItems: ee,
              refundedQuantities: me
            }
          ),
          /* @__PURE__ */ k.jsx(F3, { trackingInfos: Q }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              v3,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: Z
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => S(!0),
                className: Ot.fullWidth,
                disabled: ce || H,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: Ot.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              l3,
              {
                orderId: y,
                orderName: M,
                disabled: ce,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            It,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(Z, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: y
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          u3,
          {
            order: e,
            shopifyId: n,
            orderName: M,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        C && /* @__PURE__ */ k.jsx(
          g3,
          {
            order: e,
            orderName: M,
            isOpen: C,
            setIsOpen: S,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, D3 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = _n(), [f, h] = se([]), [v, C] = se(!1), S = Bp(m?.id), N = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: F,
    isCustomerOrdersLoading: y,
    customerOrdersError: M,
    customerOrders: T,
    refetchCustomerOrders: E
  } = pz();
  return He(() => {
    !y && S && F({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), He(() => {
    const D = T?.Shopify?.orders?.edges;
    D && h(Bz({ ordersData: D }));
  }, [T]), m ? M ? /* @__PURE__ */ k.jsx(Fn, { error: M }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(An, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, B) => /* @__PURE__ */ k.jsx(
        $3,
        {
          order: D,
          openByDefault: B === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: E,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${B}-${D.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        It,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      i3,
      {
        isOpen: v,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: E,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, R3 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Ge, { className: Ot.list, children: [
      /* @__PURE__ */ k.jsx(Ge.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ge.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, O3 = "_segmentName_1dkhk_1", A3 = {
  segmentName: O3
}, P3 = 100, es = 10, L3 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = pn(), [i, a] = se([]), [o, s] = se(es), [l, d] = se(!1), m = Bn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    tz,
    {
      skip: !e,
      variables: {
        first: P3
      },
      onCompleted: (S) => {
        const N = S?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const F = N.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, M) => y.name.localeCompare(M.name));
          a(F), h({
            variables: {
              customerId: e,
              segmentIds: F.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: C }
  ] = r(rz, {
    onCompleted: (S) => {
      const N = S?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const F = i.map((y) => {
          const M = N.find(
            (T) => T.segmentId === y.id
          );
          return {
            ...y,
            ...M?.isMember && { isMember: M.isMember }
          };
        }).sort(
          (y, M) => y.isMember === M.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(F);
      }
    }
  });
  return He(() => {
    s(l ? i.length : es);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(An, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Fn, { error: f }),
    C && /* @__PURE__ */ k.jsx(Fn, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Ge, { className: Ot.list, children: [
      i.slice(0, o).map(({ id: S, name: N, isMember: F }) => /* @__PURE__ */ k.jsx(Ge.Text, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(
        Ye,
        {
          content: `${F ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", className: A3.segmentName, children: N }),
            v && /* @__PURE__ */ k.jsx(dn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              fe,
              {
                color: F ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > es && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - es} more`
        }
      ) })
    ] })
  ] }) : null;
}, V3 = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = mz({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, C = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, N = n.displayOrdersOverview ?? !1, F = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, M = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, E = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, B = n.displayPartialRefundOrder ?? !1;
  if (He(() => {
    const ee = a?.Shopify?.customers?.edges[0]?.node;
    ee && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(ee)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(Fn, { error: i, retry: o });
  if (!r && !i && !l) {
    const ee = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              xz,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              It,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(ee, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== er.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(dn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          Nz,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          R3,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        F && /* @__PURE__ */ k.jsx(L3, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(Mz, { customer: l }),
        M && /* @__PURE__ */ k.jsx(
          Uz,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          D3,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: T,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: C,
            customerCountryCodes: m,
            displayDuplicateOrder: E,
            displayPartialRefundOrder: B
          }
        )
      ]
    }
  );
}, Nt = [];
for (let e = 0; e < 256; ++e)
  Nt.push((e + 256).toString(16).slice(1));
function z3(e, n = 0) {
  return (Nt[e[n + 0]] + Nt[e[n + 1]] + Nt[e[n + 2]] + Nt[e[n + 3]] + "-" + Nt[e[n + 4]] + Nt[e[n + 5]] + "-" + Nt[e[n + 6]] + Nt[e[n + 7]] + "-" + Nt[e[n + 8]] + Nt[e[n + 9]] + "-" + Nt[e[n + 10]] + Nt[e[n + 11]] + Nt[e[n + 12]] + Nt[e[n + 13]] + Nt[e[n + 14]] + Nt[e[n + 15]]).toLowerCase();
}
const U3 = new Uint8Array(16);
function M3() {
  return crypto.getRandomValues(U3);
}
function B3(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : q3(e);
}
function q3(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? M3();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, z3(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Wu = { exports: {} }, Oa = {}, Xk;
function H3() {
  if (Xk) return Oa;
  Xk = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Oa.Fragment = r, Oa.jsx = s, Oa.jsxs = s, Oa;
}
var ns = {}, Zk;
function W3() {
  return Zk || (Zk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ns.Fragment = i, ns.jsx = Rn, ns.jsxs = Mn;
  })()), ns;
}
var eb;
function K3() {
  return eb || (eb = 1, process.env.NODE_ENV === "production" ? Wu.exports = H3() : Wu.exports = W3()), Wu.exports;
}
var U = K3(), kS = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(kS || {}), Dm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Dm || {});
const G3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Y3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Q3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, J3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, X3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, Z3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, eU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, nU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, tU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, rU = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": G3,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Y3,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": Q3,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": J3,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": X3,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": Z3,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": eU,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": nU,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": tU
};
function Qr(e) {
  return rU[e] ?? {};
}
const iU = Qr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), aU = Qr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), oU = Qr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), sU = Qr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), lU = Qr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), cU = Qr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), dU = Qr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), uU = Qr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), mU = Qr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), pU = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), { track: r } = _n(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(iU, {
    skip: !e,
    variables: { contactId: e }
  });
  return He(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Bn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function vs(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const fU = {
  count: 0,
  items: []
}, hU = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), { track: r } = _n(), [i, a] = se(fU), {
    loading: o,
    error: s,
    data: l
  } = n(sU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, yU = {
  count: 0,
  totalCount: 0,
  items: []
}, gU = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), { track: r } = _n(), [i, a] = se(
    yU
  ), {
    loading: o,
    error: s,
    data: l
  } = n(lU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, vU = ({
  conversationContext: e
}) => {
  const { useQuery: n } = pn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(oU, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return He(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, kU = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = pn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(aU, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return He(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Bn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, bU = "_pointer_ls8kj_48", xU = "_list_ls8kj_53", _U = "_listItem_ls8kj_63", nt = {
  pointer: bU,
  list: xU,
  listItem: _U
};
var Co = (e) => e.type === "checkbox", hi = (e) => e instanceof Date, qt = (e) => e == null;
const bS = (e) => typeof e == "object";
var ut = (e) => !qt(e) && !Array.isArray(e) && bS(e) && !hi(e), xS = (e) => ut(e) && e.target ? Co(e.target) ? e.target.checked : e.target.value : e, SU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, _S = (e, n) => e.has(SU(n)), NU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ut(n) && n.hasOwnProperty("isPrototypeOf");
}, Kp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function wt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Kp && (e instanceof Blob || i)) && (r || ut(e)))
    if (n = r ? [] : {}, !r && !NU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = wt(e[a]));
  else
    return e;
  return n;
}
var dl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], st = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !ut(e))
    return r;
  const i = dl(n.split(/[,[\].]+?/)).reduce((a, o) => qt(a) ? a : a[o], e);
  return st(i) || i === e ? st(e[n]) ? r : e[n] : i;
}, ir = (e) => typeof e == "boolean", Gp = (e) => /^\w*$/.test(e), SS = (e) => dl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Gp(n) ? [n] : SS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ut(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Os = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, br = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Br = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, jU = we.createContext(null), Yp = () => we.useContext(jU);
var NS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== br.all && (n._proxyFormState[s] = !i || br.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function wU(e) {
  const n = Yp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = we.useState(r._formState), d = we.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = we.useRef(a);
  return m.current = a, we.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), we.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), we.useMemo(() => NS(s, r, d.current, !1), [s, r]);
}
var Rr = (e) => typeof e == "string", jS = (e, n, r, i, a) => Rr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function wS(e) {
  const n = Yp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = we.useRef(i), d = we.useRef(a);
  l.current = i, we.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(jS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = we.useState(r._getWatch(i, a));
  return we.useEffect(() => r._removeUnmounted()), m;
}
function CU(e) {
  const n = Yp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = _S(a._names.array, r), l = wS({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = wU({
    control: a,
    name: r,
    exact: !0
  }), m = we.useRef(e), u = we.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...ir(e.disabled) ? { disabled: e.disabled } : {}
  })), f = we.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = we.useCallback((N) => u.current.onChange({
    target: {
      value: xS(N),
      name: r
    },
    type: Os.CHANGE
  }), [r]), v = we.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: Os.BLUR
  }), [r, a._formValues]), C = we.useCallback((N) => {
    const F = Je(a._fields, r);
    F && N && (F._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = we.useMemo(() => ({
    name: r,
    value: l,
    ...ir(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return we.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...ir(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, M) => {
      const T = Je(a._fields, y);
      T && T._f && (T._f.mount = M);
    };
    if (F(r, !0), N) {
      const y = wt(Je(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), st(Je(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), we.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), we.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const nb = (e) => e.render(CU(e));
var FU = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ja = (e) => Array.isArray(e) ? e : [e], tb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Rm = (e) => qt(e) || !bS(e);
function ti(e, n) {
  if (Rm(e) || Rm(n))
    return e === n;
  if (hi(e) && hi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (hi(o) && hi(s) || ut(o) && ut(s) || Array.isArray(o) && Array.isArray(s) ? !ti(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ut = (e) => ut(e) && !Object.keys(e).length, Qp = (e) => e.type === "file", xr = (e) => typeof e == "function", As = (e) => {
  if (!Kp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, CS = (e) => e.type === "select-multiple", Jp = (e) => e.type === "radio", IU = (e) => Jp(e) || Co(e), Ku = (e) => As(e) && e.isConnected;
function EU(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = st(e) ? i++ : e[n[i++]];
  return e;
}
function TU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !st(e[n]))
      return !1;
  return !0;
}
function vt(e, n) {
  const r = Array.isArray(n) ? n : Gp(n) ? [n] : SS(n), i = r.length === 1 ? e : EU(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ut(i) && Ut(i) || Array.isArray(i) && TU(i)) && vt(e, r.slice(0, -1)), e;
}
var FS = (e) => {
  for (const n in e)
    if (xr(e[n]))
      return !0;
  return !1;
};
function Ps(e, n = {}) {
  const r = Array.isArray(e);
  if (ut(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ut(e[i]) && !FS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ps(e[i], n[i])) : qt(e[i]) || (n[i] = !0);
  return n;
}
function IS(e, n, r) {
  const i = Array.isArray(e);
  if (ut(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ut(e[a]) && !FS(e[a]) ? st(n) || Rm(r[a]) ? r[a] = Array.isArray(e[a]) ? Ps(e[a], []) : { ...Ps(e[a]) } : IS(e[a], qt(n) ? {} : n[a], r[a]) : r[a] = !ti(e[a], n[a]);
  return r;
}
var Aa = (e, n) => IS(e, n, Ps(n));
const rb = {
  value: !1,
  isValid: !1
}, ib = { value: !0, isValid: !0 };
var ES = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !st(e[0].attributes.value) ? st(e[0].value) || e[0].value === "" ? ib : { value: e[0].value, isValid: !0 } : ib
    ) : rb;
  }
  return rb;
}, TS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => st(e) ? e : n ? e === "" ? NaN : e && +e : r && Rr(e) ? new Date(e) : i ? i(e) : e;
const ab = {
  isValid: !1,
  value: null
};
var $S = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ab) : ab;
function ob(e) {
  const n = e.ref;
  return Qp(n) ? n.files : Jp(n) ? $S(e.refs).value : CS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Co(n) ? ES(e.refs).value : TS(st(n.value) ? e.ref.value : n.value, e);
}
var $U = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Ls = (e) => e instanceof RegExp, Pa = (e) => st(e) ? e : Ls(e) ? e.source : ut(e) ? Ls(e.value) ? e.value.source : e.value : e, sb = (e) => ({
  isOnSubmit: !e || e === br.onSubmit,
  isOnBlur: e === br.onBlur,
  isOnChange: e === br.onChange,
  isOnAll: e === br.all,
  isOnTouch: e === br.onTouched
});
const lb = "AsyncFunction";
var DU = (e) => !!e && !!e.validate && !!(xr(e.validate) && e.validate.constructor.name === lb || ut(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === lb)), RU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), cb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Xa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Xa(l, n))
          break;
      } else if (ut(l) && Xa(l, n))
        break;
    }
  }
};
function db(e, n, r) {
  const i = Je(e, r);
  if (i || Gp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var OU = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ut(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || br.all));
}, AU = (e, n, r) => !e || !n || e === n || Ja(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), PU = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, LU = (e, n) => !dl(Je(e, n)).length && vt(e, n), VU = (e, n, r) => {
  const i = Ja(Je(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, ks = (e) => Rr(e);
function ub(e, n, r = "validate") {
  if (ks(e) || Array.isArray(e) && e.every(ks) || ir(e) && !e)
    return {
      type: r,
      message: ks(e) ? e : "",
      ref: n
    };
}
var Oi = (e) => ut(e) && !Ls(e) ? e : {
  value: e,
  message: ""
}, mb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: S, valueAsNumber: N, mount: F } = e._f, y = Je(r, S);
  if (!F || n.has(S))
    return {};
  const M = l ? l[0] : s, T = (z) => {
    a && M.reportValidity && (M.setCustomValidity(ir(z) ? "" : z || ""), M.reportValidity());
  }, E = {}, D = Jp(s), B = Co(s), ee = D || B, X = (N || Qp(s)) && st(s.value) && st(y) || As(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = FU.bind(null, S, i, E), Q = (z, O, q, Z = Br.maxLength, ve = Br.minLength) => {
    const ce = z ? O : q;
    E[S] = {
      type: z ? Z : ve,
      message: ce,
      ref: s,
      ...ae(z ? Z : ve, ce)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!ee && (X || qt(y)) || ir(y) && !y || B && !ES(l).isValid || D && !$S(l).isValid)) {
    const { value: z, message: O } = ks(d) ? { value: !!d, message: d } : Oi(d);
    if (z && (E[S] = {
      type: Br.required,
      message: O,
      ref: M,
      ...ae(Br.required, O)
    }, !i))
      return T(O), E;
  }
  if (!X && (!qt(f) || !qt(h))) {
    let z, O;
    const q = Oi(h), Z = Oi(f);
    if (!qt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      qt(q.value) || (z = ve > q.value), qt(Z.value) || (O = ve < Z.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ce = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), le = s.type == "time", me = s.type == "week";
      Rr(q.value) && y && (z = le ? ce(y) > ce(q.value) : me ? y > q.value : ve > new Date(q.value)), Rr(Z.value) && y && (O = le ? ce(y) < ce(Z.value) : me ? y < Z.value : ve < new Date(Z.value));
    }
    if ((z || O) && (Q(!!z, q.message, Z.message, Br.max, Br.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !X && (Rr(y) || o && Array.isArray(y))) {
    const z = Oi(m), O = Oi(u), q = !qt(z.value) && y.length > +z.value, Z = !qt(O.value) && y.length < +O.value;
    if ((q || Z) && (Q(q, z.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !X && Rr(y)) {
    const { value: z, message: O } = Oi(v);
    if (Ls(z) && !y.match(z) && (E[S] = {
      type: Br.pattern,
      message: O,
      ref: s,
      ...ae(Br.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (C) {
    if (xr(C)) {
      const z = await C(y, r), O = ub(z, M);
      if (O && (E[S] = {
        ...O,
        ...ae(Br.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (ut(C)) {
      let z = {};
      for (const O in C) {
        if (!Ut(z) && !i)
          break;
        const q = ub(await C[O](y, r), M, O);
        q && (z = {
          ...q,
          ...ae(O, q.message)
        }, T(q.message), i && (E[S] = z));
      }
      if (!Ut(z) && (E[S] = {
        ref: M,
        ...z
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const zU = {
  mode: br.onSubmit,
  reValidateMode: br.onChange,
  shouldFocusError: !0
};
function UU(e = {}) {
  let n = {
    ...zU,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: xr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ut(n.defaultValues) || ut(n.values) ? wt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : wt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: tb(),
    state: tb()
  }, v = sb(n.mode), C = sb(n.reValidateMode), S = n.criteriaMode === br.all, N = (w) => (x) => {
    clearTimeout(m), m = setTimeout(w, x);
  }, F = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const x = n.resolver ? Ut((await X()).errors) : await Q(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (w, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach(($) => {
      $ && (x ? Yn(r.validatingFields, $, x) : vt(r.validatingFields, $));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ut(r.validatingFields)
    }));
  }, M = (w, x = [], $, G, Y = !0, R = !0) => {
    if (G && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Je(i, w))) {
        const V = $(Je(i, w), G.argA, G.argB);
        Y && Yn(i, w, V);
      }
      if (R && Array.isArray(Je(r.errors, w))) {
        const V = $(Je(r.errors, w), G.argA, G.argB);
        Y && Yn(r.errors, w, V), LU(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Je(r.touchedFields, w))) {
        const V = $(Je(r.touchedFields, w), G.argA, G.argB);
        Y && Yn(r.touchedFields, w, V);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Aa(a, o)), h.state.next({
        name: w,
        isDirty: O(w, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, w, x);
  }, T = (w, x) => {
    Yn(r.errors, w, x), h.state.next({
      errors: r.errors
    });
  }, E = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (w, x, $, G) => {
    const Y = Je(i, w);
    if (Y) {
      const R = Je(o, w, st($) ? Je(a, w) : $);
      st(R) || G && G.defaultChecked || x ? Yn(o, w, x ? R : ob(Y._f)) : ve(w, R), s.mount && F();
    }
  }, B = (w, x, $, G, Y) => {
    let R = !1, V = !1;
    const ie = {
      name: w
    };
    if (!n.disabled) {
      if (!$ || G) {
        (u.isDirty || f.isDirty) && (V = r.isDirty, r.isDirty = ie.isDirty = O(), R = V !== ie.isDirty);
        const he = ti(Je(a, w), x);
        V = !!Je(r.dirtyFields, w), he ? vt(r.dirtyFields, w) : Yn(r.dirtyFields, w, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && V !== !he;
      }
      if ($) {
        const he = Je(r.touchedFields, w);
        he || (Yn(r.touchedFields, w, $), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && he !== $);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, ee = (w, x, $, G) => {
    const Y = Je(r.errors, w), R = (u.isValid || f.isValid) && ir(x) && r.isValid !== x;
    if (n.delayError && $ ? (d = N(() => T(w, $)), d(n.delayError)) : (clearTimeout(m), d = null, $ ? Yn(r.errors, w, $) : vt(r.errors, w)), ($ ? !ti(Y, $) : Y) || !Ut(G) || R) {
      const V = {
        ...G,
        ...R && ir(x) ? { isValid: x } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...V
      }, h.state.next(V);
    }
  }, X = async (w) => {
    y(w, !0);
    const x = await n.resolver(o, n.context, $U(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(w), x;
  }, ae = async (w) => {
    const { errors: x } = await X(w);
    if (w)
      for (const $ of w) {
        const G = Je(x, $);
        G ? Yn(r.errors, $, G) : vt(r.errors, $);
      }
    else
      r.errors = x;
    return x;
  }, Q = async (w, x, $ = {
    valid: !0
  }) => {
    for (const G in w) {
      const Y = w[G];
      if (Y) {
        const { _f: R, ...V } = Y;
        if (R) {
          const ie = l.array.has(R.name), he = Y._f && DU(Y._f);
          he && u.validatingFields && y([G], !0);
          const Ne = await mb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ie);
          if (he && u.validatingFields && y([G]), Ne[R.name] && ($.valid = !1, x))
            break;
          !x && (Je(Ne, R.name) ? ie ? VU(r.errors, Ne, R.name) : Yn(r.errors, R.name, Ne[R.name]) : vt(r.errors, R.name));
        }
        !Ut(V) && await Q(V, x, $);
      }
    }
    return $.valid;
  }, z = () => {
    for (const w of l.unMount) {
      const x = Je(i, w);
      x && (x._f.refs ? x._f.refs.every(($) => !Ku($)) : !Ku(x._f.ref)) && Le(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (w, x) => !n.disabled && (w && x && Yn(o, w, x), !ti(Ee(), a)), q = (w, x, $) => jS(w, l, {
    ...s.mount ? o : st(x) ? a : Rr(w) ? { [w]: x } : x
  }, $, x), Z = (w) => dl(Je(s.mount ? o : a, w, n.shouldUnregister ? Je(a, w, []) : [])), ve = (w, x, $ = {}) => {
    const G = Je(i, w);
    let Y = x;
    if (G) {
      const R = G._f;
      R && (!R.disabled && Yn(o, w, TS(x, R)), Y = As(R.ref) && qt(x) ? "" : x, CS(R.ref) ? [...R.ref.options].forEach((V) => V.selected = Y.includes(V.value)) : R.refs ? Co(R.ref) ? R.refs.length > 1 ? R.refs.forEach((V) => (!V.defaultChecked || !V.disabled) && (V.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === V.value) : Y === V.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((V) => V.checked = V.value === Y) : Qp(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: w,
        values: wt(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && B(w, Y, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && _e(w);
  }, ce = (w, x, $) => {
    for (const G in x) {
      const Y = x[G], R = `${w}.${G}`, V = Je(i, R);
      (l.array.has(w) || ut(Y) || V && !V._f) && !hi(Y) ? ce(R, Y, $) : ve(R, Y, $);
    }
  }, le = (w, x, $ = {}) => {
    const G = Je(i, w), Y = l.array.has(w), R = wt(x);
    Yn(o, w, R), Y ? (h.array.next({
      name: w,
      values: wt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: w,
      dirtyFields: Aa(a, o),
      isDirty: O(w, R)
    })) : G && !G._f && !qt(R) ? ce(w, R, $) : ve(w, R, $), cb(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: wt(o)
    });
  }, me = async (w) => {
    s.mount = !0;
    const x = w.target;
    let $ = x.name, G = !0;
    const Y = Je(i, $), R = (V) => {
      G = Number.isNaN(V) || hi(V) && isNaN(V.getTime()) || ti(V, Je(o, $, V));
    };
    if (Y) {
      let V, ie;
      const he = x.type ? ob(Y._f) : xS(w), Ne = w.type === Os.BLUR || w.type === Os.FOCUS_OUT, nn = !RU(Y._f) && !n.resolver && !Je(r.errors, $) && !Y._f.deps || PU(Ne, Je(r.touchedFields, $), r.isSubmitted, C, v), mn = cb($, l, Ne);
      Yn(o, $, he), Ne ? (Y._f.onBlur && Y._f.onBlur(w), d && d(0)) : Y._f.onChange && Y._f.onChange(w);
      const rn = B($, he, Ne), un = !Ut(rn) || mn;
      if (!Ne && h.state.next({
        name: $,
        type: w.type,
        values: wt(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && F() : Ne || F()), un && h.state.next({ name: $, ...mn ? {} : rn });
      if (!Ne && mn && h.state.next({ ...r }), n.resolver) {
        const { errors: fn } = await X([$]);
        if (R(he), G) {
          const cn = db(r.errors, i, $), xn = db(fn, i, cn.name || $);
          V = xn.error, $ = xn.name, ie = Ut(fn);
        }
      } else
        y([$], !0), V = (await mb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(he), G && (V ? ie = !1 : (u.isValid || f.isValid) && (ie = await Q(i, !0)));
      G && (Y._f.deps && _e(Y._f.deps), ee($, ie, V, rn));
    }
  }, H = (w, x) => {
    if (Je(r.errors, x) && w.focus)
      return w.focus(), 1;
  }, _e = async (w, x = {}) => {
    let $, G;
    const Y = Ja(w);
    if (n.resolver) {
      const R = await ae(st(w) ? w : Y);
      $ = Ut(R), G = w ? !Y.some((V) => Je(R, V)) : $;
    } else w ? (G = (await Promise.all(Y.map(async (R) => {
      const V = Je(i, R);
      return await Q(V && V._f ? { [R]: V } : V);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = $ = await Q(i);
    return h.state.next({
      ...!Rr(w) || (u.isValid || f.isValid) && $ !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: $ } : {},
      errors: r.errors
    }), x.shouldFocus && !G && Xa(i, H, w ? Y : l.mount), G;
  }, Ee = (w) => {
    const x = {
      ...s.mount ? o : a
    };
    return st(w) ? x : Rr(w) ? Je(x, w) : w.map(($) => Je(x, $));
  }, K = (w, x) => ({
    invalid: !!Je((x || r).errors, w),
    isDirty: !!Je((x || r).dirtyFields, w),
    error: Je((x || r).errors, w),
    isValidating: !!Je(r.validatingFields, w),
    isTouched: !!Je((x || r).touchedFields, w)
  }), qe = (w) => {
    w && Ja(w).forEach((x) => vt(r.errors, x)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Be = (w, x, $) => {
    const G = (Je(i, w, { _f: {} })._f || {}).ref, Y = Je(r.errors, w) || {}, { ref: R, message: V, type: ie, ...he } = Y;
    Yn(r.errors, w, {
      ...he,
      ...x,
      ref: G
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), $ && $.shouldFocus && G && G.focus && G.focus();
  }, Pe = (w, x) => xr(w) ? h.state.subscribe({
    next: ($) => w(q(void 0, x), $)
  }) : q(w, x, !0), Me = (w) => h.state.subscribe({
    next: (x) => {
      AU(w.name, x.name, w.exact) && OU(x, w.formState || u, Oe, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, Fe = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Me({
    ...w,
    formState: f
  })), Le = (w, x = {}) => {
    for (const $ of w ? Ja(w) : l.mount)
      l.mount.delete($), l.array.delete($), x.keepValue || (vt(i, $), vt(o, $)), !x.keepError && vt(r.errors, $), !x.keepDirty && vt(r.dirtyFields, $), !x.keepTouched && vt(r.touchedFields, $), !x.keepIsValidating && vt(r.validatingFields, $), !n.shouldUnregister && !x.keepDefaultValue && vt(a, $);
    h.state.next({
      values: wt(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && F();
  }, De = ({ disabled: w, name: x }) => {
    (ir(w) && s.mount || w || l.disabled.has(x)) && (w ? l.disabled.add(x) : l.disabled.delete(x));
  }, tn = (w, x = {}) => {
    let $ = Je(i, w);
    const G = ir(x.disabled) || ir(n.disabled);
    return Yn(i, w, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ...x
      }
    }), l.mount.add(w), $ ? De({
      disabled: ir(x.disabled) ? x.disabled : n.disabled,
      name: w
    }) : D(w, !0, x.value), {
      ...G ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Pa(x.min),
        max: Pa(x.max),
        minLength: Pa(x.minLength),
        maxLength: Pa(x.maxLength),
        pattern: Pa(x.pattern)
      } : {},
      name: w,
      onChange: me,
      onBlur: me,
      ref: (Y) => {
        if (Y) {
          tn(w, x), $ = Je(i, w);
          const R = st(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, V = IU(R), ie = $._f.refs || [];
          if (V ? ie.find((he) => he === R) : R === $._f.ref)
            return;
          Yn(i, w, {
            _f: {
              ...$._f,
              ...V ? {
                refs: [
                  ...ie.filter(Ku),
                  R,
                  ...Array.isArray(Je(a, w)) ? [{}] : []
                ],
                ref: { type: R.type, name: w }
              } : { ref: R }
            }
          }), D(w, !1, void 0, R);
        } else
          $ = Je(i, w, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(_S(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, Ie = () => n.shouldFocusError && Xa(i, H, l.mount), We = (w) => {
    ir(w) && (h.state.next({ disabled: w }), Xa(i, (x, $) => {
      const G = Je(i, $);
      G && (x.disabled = G._f.disabled || w, Array.isArray(G._f.refs) && G._f.refs.forEach((Y) => {
        Y.disabled = G._f.disabled || w;
      }));
    }, 0, !1));
  }, en = (w, x) => async ($) => {
    let G;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let Y = wt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: V } = await X();
      r.errors = R, Y = V;
    } else
      await Q(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Yn(Y, R, void 0);
    if (vt(r.errors, "root"), Ut(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(Y, $);
      } catch (R) {
        G = R;
      }
    } else
      x && await x({ ...r.errors }, $), Ie(), setTimeout(Ie);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ut(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, ue = (w, x = {}) => {
    Je(i, w) && (st(x.defaultValue) ? le(w, wt(Je(a, w))) : (le(w, x.defaultValue), Yn(a, w, wt(x.defaultValue))), x.keepTouched || vt(r.touchedFields, w), x.keepDirty || (vt(r.dirtyFields, w), r.isDirty = x.defaultValue ? O(w, wt(Je(a, w))) : O()), x.keepError || (vt(r.errors, w), u.isValid && F()), h.state.next({ ...r }));
  }, ye = (w, x = {}) => {
    const $ = w ? wt(w) : a, G = wt($), Y = Ut(w), R = Y ? a : G;
    if (x.keepDefaultValues || (a = $), !x.keepValues) {
      if (x.keepDirtyValues) {
        const V = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Aa(a, o))
        ]);
        for (const ie of Array.from(V))
          Je(r.dirtyFields, ie) ? Yn(R, ie, Je(o, ie)) : le(ie, Je(R, ie));
      } else {
        if (Kp && st(w))
          for (const V of l.mount) {
            const ie = Je(i, V);
            if (ie && ie._f) {
              const he = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (As(he)) {
                const Ne = he.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const V of l.mount)
          le(V, Je(R, V));
      }
      o = wt(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ti(w, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Aa(a, o) : r.dirtyFields : x.keepDefaultValues && w ? Aa(a, w) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, $e = (w, x) => ye(xr(w) ? w(o) : w, x), Ve = (w, x = {}) => {
    const $ = Je(i, w), G = $ && $._f;
    if (G) {
      const Y = G.refs ? G.refs[0] : G.ref;
      Y.focus && (Y.focus(), x.shouldSelect && xr(Y.select) && Y.select());
    }
  }, Oe = (w) => {
    r = {
      ...r,
      ...w
    };
  }, ln = {
    control: {
      register: tn,
      unregister: Le,
      getFieldState: K,
      handleSubmit: en,
      setError: Be,
      _subscribe: Me,
      _runSchema: X,
      _getWatch: q,
      _getDirty: O,
      _setValid: F,
      _setFieldArray: M,
      _setDisabledField: De,
      _setErrors: E,
      _getFieldArray: Z,
      _reset: ye,
      _resetDefaultValues: () => xr(n.defaultValues) && n.defaultValues().then((w) => {
        $e(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: z,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: Fe,
    trigger: _e,
    register: tn,
    handleSubmit: en,
    watch: Pe,
    setValue: le,
    getValues: Ee,
    reset: $e,
    resetField: ue,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ve,
    getFieldState: K
  };
  return {
    ...ln,
    formControl: ln
  };
}
function MU(e = {}) {
  const n = we.useRef(void 0), r = we.useRef(void 0), [i, a] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: xr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: xr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : UU(e),
    formState: i
  }, e.formControl && e.defaultValues && !xr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, we.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), we.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), we.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), we.useEffect(() => {
    e.values && !ti(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), we.useEffect(() => {
    e.errors && !Ut(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), we.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), we.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = NS(i, o), n.current;
}
const BU = "_modalBody_1clhs_1", qU = {
  modalBody: BU
}, HU = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = pn(), { track: l } = _n(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = MU({
    defaultValues: u,
    mode: "onChange"
  }), C = wS({ control: f }), S = parseInt(C?.balance ?? "0", 10), N = m === S, F = N ? "Change the value to update the points" : "", y = S < 0, M = y ? "Points can not be negative" : "", T = C.description === "", E = T ? "Description can not be empty" : "";
  He(() => {
    S > m ? h(
      "transactionType",
      Dm.Addition
    ) : S < m && h(
      "transactionType",
      Dm.Deduction
    );
  }, [m, S, h]);
  const [D, { loading: B, error: ee, reset: X }] = o(mU, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ae = () => {
    if (d) {
      const z = B3();
      D({
        variables: {
          input: {
            accountId: d,
            transactionId: z,
            amount: Math.abs(S - m),
            transactionType: C.transactionType,
            description: C.description,
            source: kS.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), Q());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, Q = () => {
    v(u), X(), n();
  };
  return /* @__PURE__ */ U.jsxs(
    Et,
    {
      isOpen: e,
      onClose: Q,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ U.jsx(Tt, { title: "Update points balance", onClose: Q }),
        /* @__PURE__ */ U.jsxs($t, { className: qU.modalBody, children: [
          /* @__PURE__ */ U.jsxs(yt, { children: [
            /* @__PURE__ */ U.jsx(Te, { span: 6, children: /* @__PURE__ */ U.jsx(
              nb,
              {
                name: "balance",
                control: f,
                render: ({ field: z }) => /* @__PURE__ */ U.jsx(
                  pr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: F || M
                    },
                    input: {
                      ...z,
                      value: z.value.toString(),
                      onChange: (O) => z.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ U.jsx(Te, { span: 6, children: /* @__PURE__ */ U.jsx(
              nb,
              {
                name: "description",
                control: f,
                render: ({ field: z }) => /* @__PURE__ */ U.jsx(
                  pr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: z,
                    meta: {
                      warning: E
                    }
                  }
                )
              }
            ) })
          ] }),
          ee && /* @__PURE__ */ U.jsx(Fn, { error: ee })
        ] }),
        /* @__PURE__ */ U.jsx(
          At,
          {
            confirmName: "Save",
            confirmOnClick: () => ae(),
            confirmProps: {
              isLoading: B,
              disabled: N || y || T,
              loadingIndicator: /* @__PURE__ */ U.jsx(dn, { size: 16 })
            },
            cancelOnClick: Q
          }
        )
      ]
    }
  );
}, WU = "_wrapper_1ge6c_1", KU = "_block_1ge6c_12", pb = {
  wrapper: WU,
  block: KU
}, GU = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = pn(), { isCopied: i, copy: a } = vs(), { isCopied: o, copy: s } = vs(), { isCopied: l, copy: d } = vs(), [m, u] = se(!1), [f, h] = se(), [v, C] = se(!1), {
    loading: S,
    data: N,
    refetch: F
  } = r(dU, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  He(() => {
    if (N) {
      const Z = N?.Voyado?.PointAccountV_GetPointAccounts;
      Z && Z?.length > 0 && h(Z[0]);
    }
  }, [N]);
  const y = !!f?.id, M = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: E,
    street: D,
    zipCode: B,
    city: ee,
    country: X,
    isRegistrationCompleted: ae,
    email: Q,
    mobilePhone: z
  } = e, O = 14, q = `${T || ""} ${E || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", className: pb.wrapper, children: [
    /* @__PURE__ */ U.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: pb.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-2", children: q }),
          S && /* @__PURE__ */ U.jsx(dn, { size: 12 }),
          y && !S && /* @__PURE__ */ U.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ U.jsxs(An, { size: "small", variant: "warning", children: [
              M,
              " points"
            ] }),
            /* @__PURE__ */ U.jsx(Ye, { content: "Update points balance", children: /* @__PURE__ */ U.jsx(
              fe,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ U.jsx(Ye, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ U.jsx(
              fe,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || ee || B || X || z || Q) && /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
      z && /* @__PURE__ */ U.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ U.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ U.jsx(fe, { size: O, name: "phone" }),
          /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: z })
        ] }),
        /* @__PURE__ */ U.jsx(
          fe,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(z),
            className: nt.pointer
          }
        )
      ] }),
      Q && /* @__PURE__ */ U.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ U.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ U.jsx(fe, { size: O, name: "mail" }),
          /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: Q })
        ] }),
        /* @__PURE__ */ U.jsx(
          fe,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(Q),
            className: nt.pointer
          }
        )
      ] }),
      (D || ee || B || X) && /* @__PURE__ */ U.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ U.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ U.jsx(fe, { size: O, name: "home" }),
          /* @__PURE__ */ U.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ U.jsx(Zn, { children: D }),
            /* @__PURE__ */ U.jsxs(Zn, { children: [
              B,
              " ",
              ee
            ] }),
            /* @__PURE__ */ U.jsx(Zn, { children: X })
          ] })
        ] }),
        /* @__PURE__ */ U.jsx(
          fe,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${D}, ${B} ${ee}, ${X}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ U.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ U.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ U.jsx(fe, { size: O, name: "sign-in" }),
          /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ U.jsx(
          fe,
          {
            name: ae ? "check-circle-filled" : "close-circle-filled",
            color: ae ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ U.jsx(
      HU,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: F
      }
    )
  ] });
}, YU = "_list_yud4a_7", QU = "_listItem_yud4a_11", JU = "_listItemTooltip_yud4a_15", XU = "_listItemTimestamp_yud4a_18", ts = {
  list: YU,
  listItem: QU,
  listItemTooltip: JU,
  listItemTimestamp: XU
}, ZU = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ U.jsx(Ge, { className: ts.list, children: e.map((n, r) => /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: ts.listItem, children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ U.jsx(Ye, { content: n?.comment, children: /* @__PURE__ */ U.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: at({
          [ts.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ U.jsx(P.Paragraph, { className: ts.listItemTimestamp, children: Ln(n.date).format(bt) }),
          n?.comment && /* @__PURE__ */ U.jsx(fe, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ U.jsx(
      fe,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), eM = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(bt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(bt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ U.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ U.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ U.jsx(Ye, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ U.jsx(
        fe,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ U.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ U.jsxs(Ge, { className: nt.list, children: [
      s && /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ U.jsx(Ye, { content: "", children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ U.jsx(An, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ U.jsx(Ye, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ U.jsx(An, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ U.jsx(Ye, { content: "", children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ U.jsx(An, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ U.jsx(Ye, { content: "", children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ U.jsx(Ye, { content: "", children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, nM = "_tagHover_kzbzk_1", tM = "_channelUnsubscribed_kzbzk_6", fb = {
  tagHover: nM,
  channelUnsubscribed: tM
}, Gu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = _n(), { useMutation: l } = pn(), [d, m] = se(!1), [u, { loading: f }] = l(uU), h = async ({
    newPreference: C,
    isSubscribed: S,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : S ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ U.jsx(Ye, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ U.jsx(
    Pn,
    {
      className: fb.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ U.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: at({
            [fb.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ U.jsx(dn, { size: 16 }) : /* @__PURE__ */ U.jsx(fe, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, rM = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ U.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ U.jsx(
        Gu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ U.jsx(
        Gu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ U.jsx(
        Gu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, iM = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = pU({ contactId: e }), {
    isLoading: v,
    error: C,
    memberLevel: S
  } = kU({ contactId: e, skip: !s }), N = v || l, F = Bn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || C ? ho({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ U.jsx(P.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ U.jsx(Fn, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ U.jsx(P.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ U.jsx(dn, {}) }) : /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
    r && /* @__PURE__ */ U.jsx(
      GU,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ U.jsx(eM, { memberLevel: S }),
    i && /* @__PURE__ */ U.jsx(
      rM,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ U.jsx(ZU, { contactConsents: F })
  ] });
}, Om = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, aM = "_list_zu4s7_1", oM = "_listItem_zu4s7_4", sM = "_listSum_zu4s7_7", rs = {
  list: aM,
  listItem: oM,
  listSum: sM
}, lM = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ U.jsxs(Ge, { className: rs.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ U.jsx(Ge.Text, { variant: "dense", className: rs.listItem, children: /* @__PURE__ */ U.jsx(Ye, { content: s, children: /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ U.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ U.jsx(b, { flex: "auto", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ U.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: Om(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ U.jsx(
    Ge.Text,
    {
      variant: "dense",
      className: at(rs.listItem, rs.listSum),
      children: /* @__PURE__ */ U.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: Om(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), cM = "_transaction_1kr8d_1", dM = "_transactionIsOpen_1kr8d_9", uM = "_transactionHeader_1kr8d_12", mM = "_transactionHeaderSubLine_1kr8d_15", pM = "_transactionHeaderAlignItemRight_1kr8d_19", Ai = {
  transaction: cM,
  transactionIsOpen: dM,
  transactionHeader: uM,
  transactionHeaderSubLine: mM,
  transactionHeaderAlignItemRight: pM
}, fM = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ U.jsxs(
    b,
    {
      className: at(Ai.transaction, {
        [Ai.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ U.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ai.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ U.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ U.jsx(An, { size: "small", variant: "info", children: Ln(o).format(bt) }),
                  /* @__PURE__ */ U.jsxs(
                    P.Heading,
                    {
                      variant: "heading-4",
                      className: Ai.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ U.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Ai.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-4", children: Om(v, h) }),
                      /* @__PURE__ */ U.jsxs(
                        P.Heading,
                        {
                          variant: "heading-4",
                          className: Ai.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ U.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ U.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ U.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ U.jsx(Mm, {}),
              /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ U.jsx(Pn, { children: /* @__PURE__ */ U.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ U.jsx(
                  lM,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, hM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = gU({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ U.jsx(Fn, { error: r }) : /* @__PURE__ */ U.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ U.jsx(An, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ U.jsx(dn, {}) }) : /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
          s === 0 && /* @__PURE__ */ U.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ U.jsx(
            fM,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, yM = "_message_unsvt_48", gM = "_messageIsOpen_unsvt_56", vM = "_messageHeader_unsvt_60", kM = "_messageText_unsvt_64", bM = "_buttonLink_unsvt_86", La = {
  message: yM,
  messageIsOpen: gM,
  messageHeader: vM,
  messageText: kM,
  buttonLink: bM
}, Yu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Qu = (e, n) => n && e in Yu && n in Yu[e] ? Yu[e][n] : null, xM = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = _n();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Qu("type", l) : null, C = d ? Qu("source", d) : null, S = u ? Qu("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ U.jsxs(
    b,
    {
      className: at(La.message, {
        [La.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ U.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: La.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ U.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
                    /* @__PURE__ */ U.jsx(fe, { name: v, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ U.jsx(An, { size: "small", variant: "info", children: Ln(s).format(bt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ U.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ U.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ U.jsx(Mm, {}),
          /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ U.jsx(Pn, { children: /* @__PURE__ */ U.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ U.jsx(fe, { name: S }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ U.jsx(Pn, { children: /* @__PURE__ */ U.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ U.jsx(fe, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ U.jsx(Pn, { children: /* @__PURE__ */ U.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ U.jsx(fe, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", className: La.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ U.jsx(
            It,
            {
              slotEnd: /* @__PURE__ */ U.jsx(fe, { name: "external-link" }),
              variant: "tertiary",
              className: La.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, _M = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = hU({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ U.jsx(Fn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ U.jsx(An, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ U.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ U.jsx(dn, {}) }) : /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ U.jsx(
        xM,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, ul = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, hb = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = vs(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = it(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ U.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ U.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ U.jsx(fe, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ U.jsx(Ye, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ U.jsx(
      fe,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, SM = "_order_19t4p_1", NM = "_orderIsOpen_19t4p_9", jM = "_orderHeader_19t4p_12", wM = "_orderIconColor_19t4p_15", Er = {
  order: SM,
  orderIsOpen: NM,
  orderHeader: jM,
  orderIconColor: wM
}, CM = "_delivery_1m9nb_1", FM = "_deliveryCode_1m9nb_4", Ju = {
  delivery: CM,
  deliveryCode: FM
}, IM = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = or();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ U.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ U.jsx(
      fe,
      {
        size: l,
        name: "eye",
        className: Er.orderIconColor
      }
    ),
    /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ U.jsx(
        Ye,
        {
          content: /* @__PURE__ */ U.jsxs(P.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(bt)
          ] }),
          children: /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ U.jsx(
              P.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ U.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Ju.delivery,
                    children: [
                      /* @__PURE__ */ U.jsx(fe, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ U.jsx(
              P.Paragraph,
              {
                variant: "4",
                className: at(Ju.delivery, Ju.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ U.jsx(Ye, { content: "Copy tracking code", children: /* @__PURE__ */ U.jsx(
      fe,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, EM = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ U.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ U.jsx(
        fe,
        {
          size: 14,
          name: "file-text",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ U.jsx(Ge, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ U.jsx(Ge.Item, { className: nt.listItem, children: /* @__PURE__ */ U.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ U.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ U.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: ul({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, TM = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ U.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ U.jsx(
        fe,
        {
          size: 14,
          name: "tag",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ U.jsx(Ge, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ U.jsx(
      Ge.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ U.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ U.jsx(
          Ye,
          {
            content: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ U.jsx(b, { children: /* @__PURE__ */ U.jsx(An, { size: "small", variant: "info", children: ul({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ U.jsx(
          Xi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, $M = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ U.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ U.jsx(
        fe,
        {
          size: 14,
          name: "credit-card",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ U.jsx(Ge, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ U.jsx(
      Ge.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ U.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ U.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(bt) }),
                    /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: ul({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, DM = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: C
  } = e, S = 14;
  return /* @__PURE__ */ U.jsxs(
    b,
    {
      className: at(Er.order, {
        [Er.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ U.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Er.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ U.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ U.jsx(b, { alignItems: "center", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: Ln(m).format(bt) }) }),
                /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ U.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ U.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ U.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ U.jsx(
              fe,
              {
                size: S,
                name: "activity",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ U.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ U.jsx(Ye, { content: "Internal status", children: /* @__PURE__ */ U.jsx(An, { size: "small", variant: "info", children: /* @__PURE__ */ U.jsx(U.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ U.jsx(Ye, { content: "External status", children: /* @__PURE__ */ U.jsx(An, { size: "small", variant: "info", children: /* @__PURE__ */ U.jsx(U.Fragment, { children: s }) }) }),
                /* @__PURE__ */ U.jsx(Ye, { content: "Last updated at", children: /* @__PURE__ */ U.jsx(P.Paragraph, { as: "span", variant: "5", children: Ln(u).format(bt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ U.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ U.jsx(
              fe,
              {
                size: S,
                name: "chart-bar",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: ul({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ U.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ U.jsx(
              fe,
              {
                size: S,
                name: "channels",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ U.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ U.jsx(An, { size: "small", variant: "info", children: /* @__PURE__ */ U.jsx(U.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ U.jsx(hb, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ U.jsx(
            hb,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ U.jsx(IM, { delivery: e.delivery }),
          /* @__PURE__ */ U.jsx(TM, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ U.jsx(EM, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ U.jsx(
            $M,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, RM = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || ho({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ U.jsx(Fn, { error: e }) : /* @__PURE__ */ U.jsx(U.Fragment, { children: r }), OM = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), [r, i] = se([]), { track: a } = _n(), {
    loading: o,
    error: s,
    data: l
  } = n(cU, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return He(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ U.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ U.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ U.jsx(An, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ U.jsx(dn, {}) }) : /* @__PURE__ */ U.jsx(RM, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ U.jsx(
      DM,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, AM = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = vU({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ U.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ U.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? ho({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ U.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ U.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ U.jsx(dn, {}) }) : /* @__PURE__ */ U.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ U.jsx(iM, { contactId: i, settings: n }),
        h && /* @__PURE__ */ U.jsx(_M, { contactId: i }),
        v && /* @__PURE__ */ U.jsx(hM, { contactId: i }),
        C && /* @__PURE__ */ U.jsx(OM, { contactId: i }),
        !l && /* @__PURE__ */ U.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ U.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, PM = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Xu = { exports: {} }, Va = {}, yb;
function LM() {
  if (yb) return Va;
  yb = 1;
  var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Va.Fragment = r, Va.jsx = s, Va.jsxs = s, Va;
}
var is = {}, gb;
function VM() {
  return gb || (gb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = we, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        M("error", t, p);
      }
    }
    function M(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, A = g.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, X;
    X = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function z(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return z(c) + ".Consumer";
          case s:
            var p = t;
            return z(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, I = A._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Z = 0, ve, ce, le, me, H, _e, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ve = console.log, ce = console.info, le = console.warn, me = console.error, H = console.group, _e = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ce
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: me
            }),
            group: q({}, t, {
              value: H
            }),
            groupCollapsed: q({}, t, {
              value: _e
            }),
            groupEnd: q({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var g = A.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new tn();
    }
    function Ie(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = g.stack.split(`
`), W = j.length - 1, _ = te.length - 1; W >= 1 && _ >= 0 && j[W] !== te[_]; )
            _--;
          for (; W >= 1 && _ >= 0; W--, _--)
            if (j[W] !== te[_]) {
              if (W !== 1 || _ !== 1)
                do
                  if (W--, _--, _ < 0 || j[W] !== te[_]) {
                    var J = `
` + j[W].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, J), J;
                  }
                while (W >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", be = de ? Fe(de) : "";
      return typeof t == "function" && De.set(t, be), be;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, en(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return ue(t.type, c, p);
          case h: {
            var g = t, A = g._payload, L = g._init;
            try {
              return ue(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, $e = {}, Ve = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function ln(t, c, p, g, A) {
      {
        var L = Function.call.bind(ye);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              j = W;
            }
            j && !(j instanceof Error) && (Oe(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof j), Oe(null)), j instanceof Error && !(j.message in $e) && ($e[j.message] = !0, Oe(A), y("Failed %s type: %s", p, j.message), Oe(null));
          }
      }
    }
    var w = Array.isArray;
    function x(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var V = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function un(t, c) {
      {
        var p = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var cn = function(t, c, p, g, A, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, g, A) {
      {
        var L, I = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), mn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, rn(c));
        for (L in c)
          ye.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var W = t.defaultProps;
          for (L in W)
            I[L] === void 0 && (I[L] = W[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && un(I, _), te && fn(I, _);
        }
        return cn(t, j, te, A, g, V.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, jn = F.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = ue(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Ze.current) {
          var t = O(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Ae(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Ae(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && yn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), I; !(I = L.next()).done; )
              sn(I.value) && yn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          ln(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Ae(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, g, A, L) {
      {
        var I = ae(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += gn();
          var W;
          t === null ? W = "null" : x(t) ? W = "array" : t !== void 0 && t.$$typeof === n ? (W = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : W = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (I) {
          var J = c.children;
          if (J !== void 0)
            if (g)
              if (x(J)) {
                for (var de = 0; de < J.length; de++)
                  Cn(J[de], t);
                Object.freeze && Object.freeze(J);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(J, t);
        }
        if (ye.call(c, "key")) {
          var be = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[be + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, be, $n, be), Sn[be + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    is.Fragment = i, is.jsx = Rn, is.jsxs = Mn;
  })()), is;
}
var vb;
function zM() {
  return vb || (vb = 1, process.env.NODE_ENV === "production" ? Xu.exports = LM() : Xu.exports = VM()), Xu.exports;
}
var Ce = zM();
const UM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, MM = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": UM
};
function BM(e) {
  return MM[e] ?? {};
}
const qM = BM(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), HM = "_copyIcon_11mz1_48", WM = "_list_11mz1_53", KM = "_listItem_11mz1_63", GM = "_listItemHighlighted_11mz1_72", Ji = {
  copyIcon: HM,
  list: WM,
  listItem: KM,
  listItemHighlighted: GM
}, YM = "_wrapper_1xucg_1", QM = "_externalLink_1xucg_7", Zu = {
  wrapper: YM,
  externalLink: QM
}, JM = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = or(), { isCopied: i, copy: a } = or();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { className: Zu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Zu.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", children: Ln(m).format(bt) })
    ] }),
    l && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(fe, { size: u, name: "mail" }),
        /* @__PURE__ */ Ce.jsx("span", { className: Zu.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ye, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(
        fe,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: Ji.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(fe, { size: u, name: "phone" }),
        /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ye, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(
        fe,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Ji.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Wn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = g0(n);
  return /* @__PURE__ */ Ce.jsx(
    Ge.Text,
    {
      variant: "dense",
      className: at(Ji.listItem, {
        [Ji.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ce.jsx(Ye, { content: r, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", children: e }),
        a ? n : to(n)
      ] }) })
    }
  );
}, XM = ({
  loyalty: e
}) => /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ce.jsxs(Ge, { className: Ji.list, children: [
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), ZM = 0.8, e4 = 0.4, kb = (e) => {
  if (e != null)
    return e >= ZM ? /* @__PURE__ */ Ce.jsx(An, { variant: "success", size: "small", children: "Positive" }) : e <= e4 ? /* @__PURE__ */ Ce.jsx(An, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ce.jsx(An, { variant: "warning", size: "small", children: "Neutral" });
}, n4 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ce.jsxs(Ge, { className: Ji.list, children: [
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: kb(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: kb(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          bt
        )
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Wn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ce.jsx(An, { variant: "info", size: "small", children: /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), t4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = pn(), { track: i } = _n(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, S = n?.displaySubscriptions ?? !1, N = !f, F = !h && !v && !C && !S, {
    loading: y,
    error: M,
    data: T
  } = r(qM, {
    skip: u || N,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (He(() => {
    const E = T?.Yotpo?.getCustomers?.customers?.[0];
    E ? (o(E), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [T?.Yotpo, y]), N)
    return /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ce.jsx(
      Fn,
      {
        error: new Gb({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (F)
    return /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(dn, {}) });
  if (s)
    return /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (M) {
    const E = M.graphQLErrors;
    return Pm({ errors: E }) ? /* @__PURE__ */ Ce.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Lm({ errors: E }) ? /* @__PURE__ */ Ce.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ce.jsx(Fn, { error: M });
  }
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ce.jsx(JM, { customerDetails: a }),
        v && /* @__PURE__ */ Ce.jsx(
          n4,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Ce.jsx(XM, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var Fo = (e) => e.type === "checkbox", yi = (e) => e instanceof Date, Ht = (e) => e == null;
const DS = (e) => typeof e == "object";
var mt = (e) => !Ht(e) && !Array.isArray(e) && DS(e) && !yi(e), RS = (e) => mt(e) && e.target ? Fo(e.target) ? e.target.checked : e.target.value : e, r4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, OS = (e, n) => e.has(r4(n)), i4 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return mt(n) && n.hasOwnProperty("isPrototypeOf");
}, Xp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ct(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Xp && (e instanceof Blob || i)) && (r || mt(e)))
    if (n = r ? [] : {}, !r && !i4(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ct(e[a]));
  else
    return e;
  return n;
}
var ml = (e) => Array.isArray(e) ? e.filter(Boolean) : [], lt = (e) => e === void 0, Xe = (e, n, r) => {
  if (!n || !mt(e))
    return r;
  const i = ml(n.split(/[,[\].]+?/)).reduce((a, o) => Ht(a) ? a : a[o], e);
  return lt(i) || i === e ? lt(e[n]) ? r : e[n] : i;
}, ar = (e) => typeof e == "boolean", Zp = (e) => /^\w*$/.test(e), AS = (e) => ml(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qn = (e, n, r) => {
  let i = -1;
  const a = Zp(n) ? [n] : AS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = mt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Vs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, _r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, a4 = we.createContext(null), ef = () => we.useContext(a4);
var PS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== _r.all && (n._proxyFormState[s] = !i || _r.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function o4(e) {
  const n = ef(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = we.useState(r._formState), d = we.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = we.useRef(a);
  return m.current = a, we.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), we.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), we.useMemo(() => PS(s, r, d.current, !1), [s, r]);
}
var Or = (e) => typeof e == "string", LS = (e, n, r, i, a) => Or(e) ? (i && n.watch.add(e), Xe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Xe(r, o))) : (i && (n.watchAll = !0), r);
function VS(e) {
  const n = ef(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = we.useRef(i), d = we.useRef(a);
  l.current = i, we.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(LS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = we.useState(r._getWatch(i, a));
  return we.useEffect(() => r._removeUnmounted()), m;
}
function s4(e) {
  const n = ef(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = OS(a._names.array, r), l = VS({
    control: a,
    name: r,
    defaultValue: Xe(a._formValues, r, Xe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = o4({
    control: a,
    name: r,
    exact: !0
  }), m = we.useRef(e), u = we.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...ar(e.disabled) ? { disabled: e.disabled } : {}
  })), f = we.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Xe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Xe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Xe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Xe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Xe(d.errors, r)
    }
  }), [d, r]), h = we.useCallback((N) => u.current.onChange({
    target: {
      value: RS(N),
      name: r
    },
    type: Vs.CHANGE
  }), [r]), v = we.useCallback(() => u.current.onBlur({
    target: {
      value: Xe(a._formValues, r),
      name: r
    },
    type: Vs.BLUR
  }), [r, a._formValues]), C = we.useCallback((N) => {
    const F = Xe(a._fields, r);
    F && N && (F._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = we.useMemo(() => ({
    name: r,
    value: l,
    ...ar(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return we.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...ar(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, M) => {
      const T = Xe(a._fields, y);
      T && T._f && (T._f.mount = M);
    };
    if (F(r, !0), N) {
      const y = Ct(Xe(a._options.defaultValues, r));
      Qn(a._defaultValues, r, y), lt(Xe(a._formValues, r)) && Qn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), we.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), we.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const bb = (e) => e.render(s4(e));
var l4 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Za = (e) => Array.isArray(e) ? e : [e], xb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Am = (e) => Ht(e) || !DS(e);
function ri(e, n) {
  if (Am(e) || Am(n))
    return e === n;
  if (yi(e) && yi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (yi(o) && yi(s) || mt(o) && mt(s) || Array.isArray(o) && Array.isArray(s) ? !ri(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Mt = (e) => mt(e) && !Object.keys(e).length, nf = (e) => e.type === "file", Sr = (e) => typeof e == "function", zs = (e) => {
  if (!Xp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, zS = (e) => e.type === "select-multiple", tf = (e) => e.type === "radio", c4 = (e) => tf(e) || Fo(e), em = (e) => zs(e) && e.isConnected;
function d4(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = lt(e) ? i++ : e[n[i++]];
  return e;
}
function u4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !lt(e[n]))
      return !1;
  return !0;
}
function kt(e, n) {
  const r = Array.isArray(n) ? n : Zp(n) ? [n] : AS(n), i = r.length === 1 ? e : d4(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (mt(i) && Mt(i) || Array.isArray(i) && u4(i)) && kt(e, r.slice(0, -1)), e;
}
var US = (e) => {
  for (const n in e)
    if (Sr(e[n]))
      return !0;
  return !1;
};
function Us(e, n = {}) {
  const r = Array.isArray(e);
  if (mt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || mt(e[i]) && !US(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Us(e[i], n[i])) : Ht(e[i]) || (n[i] = !0);
  return n;
}
function MS(e, n, r) {
  const i = Array.isArray(e);
  if (mt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || mt(e[a]) && !US(e[a]) ? lt(n) || Am(r[a]) ? r[a] = Array.isArray(e[a]) ? Us(e[a], []) : { ...Us(e[a]) } : MS(e[a], Ht(n) ? {} : n[a], r[a]) : r[a] = !ri(e[a], n[a]);
  return r;
}
var za = (e, n) => MS(e, n, Us(n));
const _b = {
  value: !1,
  isValid: !1
}, Sb = { value: !0, isValid: !0 };
var BS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !lt(e[0].attributes.value) ? lt(e[0].value) || e[0].value === "" ? Sb : { value: e[0].value, isValid: !0 } : Sb
    ) : _b;
  }
  return _b;
}, qS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => lt(e) ? e : n ? e === "" ? NaN : e && +e : r && Or(e) ? new Date(e) : i ? i(e) : e;
const Nb = {
  isValid: !1,
  value: null
};
var HS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Nb) : Nb;
function jb(e) {
  const n = e.ref;
  return nf(n) ? n.files : tf(n) ? HS(e.refs).value : zS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Fo(n) ? BS(e.refs).value : qS(lt(n.value) ? e.ref.value : n.value, e);
}
var m4 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Xe(n, o);
    s && Qn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Ms = (e) => e instanceof RegExp, Ua = (e) => lt(e) ? e : Ms(e) ? e.source : mt(e) ? Ms(e.value) ? e.value.source : e.value : e, wb = (e) => ({
  isOnSubmit: !e || e === _r.onSubmit,
  isOnBlur: e === _r.onBlur,
  isOnChange: e === _r.onChange,
  isOnAll: e === _r.all,
  isOnTouch: e === _r.onTouched
});
const Cb = "AsyncFunction";
var p4 = (e) => !!e && !!e.validate && !!(Sr(e.validate) && e.validate.constructor.name === Cb || mt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Cb)), f4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Fb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const eo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Xe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (eo(l, n))
          break;
      } else if (mt(l) && eo(l, n))
        break;
    }
  }
};
function Ib(e, n, r) {
  const i = Xe(e, r);
  if (i || Zp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Xe(n, o), l = Xe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var h4 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Mt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || _r.all));
}, y4 = (e, n, r) => !e || !n || e === n || Za(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), g4 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, v4 = (e, n) => !ml(Xe(e, n)).length && kt(e, n), k4 = (e, n, r) => {
  const i = Za(Xe(e, r));
  return Qn(i, "root", n[r]), Qn(e, r, i), e;
}, bs = (e) => Or(e);
function Eb(e, n, r = "validate") {
  if (bs(e) || Array.isArray(e) && e.every(bs) || ar(e) && !e)
    return {
      type: r,
      message: bs(e) ? e : "",
      ref: n
    };
}
var Pi = (e) => mt(e) && !Ms(e) ? e : {
  value: e,
  message: ""
}, Tb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: S, valueAsNumber: N, mount: F } = e._f, y = Xe(r, S);
  if (!F || n.has(S))
    return {};
  const M = l ? l[0] : s, T = (z) => {
    a && M.reportValidity && (M.setCustomValidity(ar(z) ? "" : z || ""), M.reportValidity());
  }, E = {}, D = tf(s), B = Fo(s), ee = D || B, X = (N || nf(s)) && lt(s.value) && lt(y) || zs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = l4.bind(null, S, i, E), Q = (z, O, q, Z = qr.maxLength, ve = qr.minLength) => {
    const ce = z ? O : q;
    E[S] = {
      type: z ? Z : ve,
      message: ce,
      ref: s,
      ...ae(z ? Z : ve, ce)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!ee && (X || Ht(y)) || ar(y) && !y || B && !BS(l).isValid || D && !HS(l).isValid)) {
    const { value: z, message: O } = bs(d) ? { value: !!d, message: d } : Pi(d);
    if (z && (E[S] = {
      type: qr.required,
      message: O,
      ref: M,
      ...ae(qr.required, O)
    }, !i))
      return T(O), E;
  }
  if (!X && (!Ht(f) || !Ht(h))) {
    let z, O;
    const q = Pi(h), Z = Pi(f);
    if (!Ht(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Ht(q.value) || (z = ve > q.value), Ht(Z.value) || (O = ve < Z.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ce = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), le = s.type == "time", me = s.type == "week";
      Or(q.value) && y && (z = le ? ce(y) > ce(q.value) : me ? y > q.value : ve > new Date(q.value)), Or(Z.value) && y && (O = le ? ce(y) < ce(Z.value) : me ? y < Z.value : ve < new Date(Z.value));
    }
    if ((z || O) && (Q(!!z, q.message, Z.message, qr.max, qr.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !X && (Or(y) || o && Array.isArray(y))) {
    const z = Pi(m), O = Pi(u), q = !Ht(z.value) && y.length > +z.value, Z = !Ht(O.value) && y.length < +O.value;
    if ((q || Z) && (Q(q, z.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !X && Or(y)) {
    const { value: z, message: O } = Pi(v);
    if (Ms(z) && !y.match(z) && (E[S] = {
      type: qr.pattern,
      message: O,
      ref: s,
      ...ae(qr.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (C) {
    if (Sr(C)) {
      const z = await C(y, r), O = Eb(z, M);
      if (O && (E[S] = {
        ...O,
        ...ae(qr.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (mt(C)) {
      let z = {};
      for (const O in C) {
        if (!Mt(z) && !i)
          break;
        const q = Eb(await C[O](y, r), M, O);
        q && (z = {
          ...q,
          ...ae(O, q.message)
        }, T(q.message), i && (E[S] = z));
      }
      if (!Mt(z) && (E[S] = {
        ref: M,
        ...z
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const b4 = {
  mode: _r.onSubmit,
  reValidateMode: _r.onChange,
  shouldFocusError: !0
};
function x4(e = {}) {
  let n = {
    ...b4,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Sr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = mt(n.defaultValues) || mt(n.values) ? Ct(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ct(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: xb(),
    state: xb()
  }, v = wb(n.mode), C = wb(n.reValidateMode), S = n.criteriaMode === _r.all, N = (w) => (x) => {
    clearTimeout(m), m = setTimeout(w, x);
  }, F = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const x = n.resolver ? Mt((await X()).errors) : await Q(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (w, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach(($) => {
      $ && (x ? Qn(r.validatingFields, $, x) : kt(r.validatingFields, $));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Mt(r.validatingFields)
    }));
  }, M = (w, x = [], $, G, Y = !0, R = !0) => {
    if (G && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Xe(i, w))) {
        const V = $(Xe(i, w), G.argA, G.argB);
        Y && Qn(i, w, V);
      }
      if (R && Array.isArray(Xe(r.errors, w))) {
        const V = $(Xe(r.errors, w), G.argA, G.argB);
        Y && Qn(r.errors, w, V), v4(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Xe(r.touchedFields, w))) {
        const V = $(Xe(r.touchedFields, w), G.argA, G.argB);
        Y && Qn(r.touchedFields, w, V);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = za(a, o)), h.state.next({
        name: w,
        isDirty: O(w, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Qn(o, w, x);
  }, T = (w, x) => {
    Qn(r.errors, w, x), h.state.next({
      errors: r.errors
    });
  }, E = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (w, x, $, G) => {
    const Y = Xe(i, w);
    if (Y) {
      const R = Xe(o, w, lt($) ? Xe(a, w) : $);
      lt(R) || G && G.defaultChecked || x ? Qn(o, w, x ? R : jb(Y._f)) : ve(w, R), s.mount && F();
    }
  }, B = (w, x, $, G, Y) => {
    let R = !1, V = !1;
    const ie = {
      name: w
    };
    if (!n.disabled) {
      if (!$ || G) {
        (u.isDirty || f.isDirty) && (V = r.isDirty, r.isDirty = ie.isDirty = O(), R = V !== ie.isDirty);
        const he = ri(Xe(a, w), x);
        V = !!Xe(r.dirtyFields, w), he ? kt(r.dirtyFields, w) : Qn(r.dirtyFields, w, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && V !== !he;
      }
      if ($) {
        const he = Xe(r.touchedFields, w);
        he || (Qn(r.touchedFields, w, $), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && he !== $);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, ee = (w, x, $, G) => {
    const Y = Xe(r.errors, w), R = (u.isValid || f.isValid) && ar(x) && r.isValid !== x;
    if (n.delayError && $ ? (d = N(() => T(w, $)), d(n.delayError)) : (clearTimeout(m), d = null, $ ? Qn(r.errors, w, $) : kt(r.errors, w)), ($ ? !ri(Y, $) : Y) || !Mt(G) || R) {
      const V = {
        ...G,
        ...R && ar(x) ? { isValid: x } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...V
      }, h.state.next(V);
    }
  }, X = async (w) => {
    y(w, !0);
    const x = await n.resolver(o, n.context, m4(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(w), x;
  }, ae = async (w) => {
    const { errors: x } = await X(w);
    if (w)
      for (const $ of w) {
        const G = Xe(x, $);
        G ? Qn(r.errors, $, G) : kt(r.errors, $);
      }
    else
      r.errors = x;
    return x;
  }, Q = async (w, x, $ = {
    valid: !0
  }) => {
    for (const G in w) {
      const Y = w[G];
      if (Y) {
        const { _f: R, ...V } = Y;
        if (R) {
          const ie = l.array.has(R.name), he = Y._f && p4(Y._f);
          he && u.validatingFields && y([G], !0);
          const Ne = await Tb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ie);
          if (he && u.validatingFields && y([G]), Ne[R.name] && ($.valid = !1, x))
            break;
          !x && (Xe(Ne, R.name) ? ie ? k4(r.errors, Ne, R.name) : Qn(r.errors, R.name, Ne[R.name]) : kt(r.errors, R.name));
        }
        !Mt(V) && await Q(V, x, $);
      }
    }
    return $.valid;
  }, z = () => {
    for (const w of l.unMount) {
      const x = Xe(i, w);
      x && (x._f.refs ? x._f.refs.every(($) => !em($)) : !em(x._f.ref)) && Le(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (w, x) => !n.disabled && (w && x && Qn(o, w, x), !ri(Ee(), a)), q = (w, x, $) => LS(w, l, {
    ...s.mount ? o : lt(x) ? a : Or(w) ? { [w]: x } : x
  }, $, x), Z = (w) => ml(Xe(s.mount ? o : a, w, n.shouldUnregister ? Xe(a, w, []) : [])), ve = (w, x, $ = {}) => {
    const G = Xe(i, w);
    let Y = x;
    if (G) {
      const R = G._f;
      R && (!R.disabled && Qn(o, w, qS(x, R)), Y = zs(R.ref) && Ht(x) ? "" : x, zS(R.ref) ? [...R.ref.options].forEach((V) => V.selected = Y.includes(V.value)) : R.refs ? Fo(R.ref) ? R.refs.length > 1 ? R.refs.forEach((V) => (!V.defaultChecked || !V.disabled) && (V.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === V.value) : Y === V.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((V) => V.checked = V.value === Y) : nf(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: w,
        values: Ct(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && B(w, Y, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && _e(w);
  }, ce = (w, x, $) => {
    for (const G in x) {
      const Y = x[G], R = `${w}.${G}`, V = Xe(i, R);
      (l.array.has(w) || mt(Y) || V && !V._f) && !yi(Y) ? ce(R, Y, $) : ve(R, Y, $);
    }
  }, le = (w, x, $ = {}) => {
    const G = Xe(i, w), Y = l.array.has(w), R = Ct(x);
    Qn(o, w, R), Y ? (h.array.next({
      name: w,
      values: Ct(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: w,
      dirtyFields: za(a, o),
      isDirty: O(w, R)
    })) : G && !G._f && !Ht(R) ? ce(w, R, $) : ve(w, R, $), Fb(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: Ct(o)
    });
  }, me = async (w) => {
    s.mount = !0;
    const x = w.target;
    let $ = x.name, G = !0;
    const Y = Xe(i, $), R = (V) => {
      G = Number.isNaN(V) || yi(V) && isNaN(V.getTime()) || ri(V, Xe(o, $, V));
    };
    if (Y) {
      let V, ie;
      const he = x.type ? jb(Y._f) : RS(w), Ne = w.type === Vs.BLUR || w.type === Vs.FOCUS_OUT, nn = !f4(Y._f) && !n.resolver && !Xe(r.errors, $) && !Y._f.deps || g4(Ne, Xe(r.touchedFields, $), r.isSubmitted, C, v), mn = Fb($, l, Ne);
      Qn(o, $, he), Ne ? (Y._f.onBlur && Y._f.onBlur(w), d && d(0)) : Y._f.onChange && Y._f.onChange(w);
      const rn = B($, he, Ne), un = !Mt(rn) || mn;
      if (!Ne && h.state.next({
        name: $,
        type: w.type,
        values: Ct(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && F() : Ne || F()), un && h.state.next({ name: $, ...mn ? {} : rn });
      if (!Ne && mn && h.state.next({ ...r }), n.resolver) {
        const { errors: fn } = await X([$]);
        if (R(he), G) {
          const cn = Ib(r.errors, i, $), xn = Ib(fn, i, cn.name || $);
          V = xn.error, $ = xn.name, ie = Mt(fn);
        }
      } else
        y([$], !0), V = (await Tb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(he), G && (V ? ie = !1 : (u.isValid || f.isValid) && (ie = await Q(i, !0)));
      G && (Y._f.deps && _e(Y._f.deps), ee($, ie, V, rn));
    }
  }, H = (w, x) => {
    if (Xe(r.errors, x) && w.focus)
      return w.focus(), 1;
  }, _e = async (w, x = {}) => {
    let $, G;
    const Y = Za(w);
    if (n.resolver) {
      const R = await ae(lt(w) ? w : Y);
      $ = Mt(R), G = w ? !Y.some((V) => Xe(R, V)) : $;
    } else w ? (G = (await Promise.all(Y.map(async (R) => {
      const V = Xe(i, R);
      return await Q(V && V._f ? { [R]: V } : V);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = $ = await Q(i);
    return h.state.next({
      ...!Or(w) || (u.isValid || f.isValid) && $ !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: $ } : {},
      errors: r.errors
    }), x.shouldFocus && !G && eo(i, H, w ? Y : l.mount), G;
  }, Ee = (w) => {
    const x = {
      ...s.mount ? o : a
    };
    return lt(w) ? x : Or(w) ? Xe(x, w) : w.map(($) => Xe(x, $));
  }, K = (w, x) => ({
    invalid: !!Xe((x || r).errors, w),
    isDirty: !!Xe((x || r).dirtyFields, w),
    error: Xe((x || r).errors, w),
    isValidating: !!Xe(r.validatingFields, w),
    isTouched: !!Xe((x || r).touchedFields, w)
  }), qe = (w) => {
    w && Za(w).forEach((x) => kt(r.errors, x)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Be = (w, x, $) => {
    const G = (Xe(i, w, { _f: {} })._f || {}).ref, Y = Xe(r.errors, w) || {}, { ref: R, message: V, type: ie, ...he } = Y;
    Qn(r.errors, w, {
      ...he,
      ...x,
      ref: G
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), $ && $.shouldFocus && G && G.focus && G.focus();
  }, Pe = (w, x) => Sr(w) ? h.state.subscribe({
    next: ($) => w(q(void 0, x), $)
  }) : q(w, x, !0), Me = (w) => h.state.subscribe({
    next: (x) => {
      y4(w.name, x.name, w.exact) && h4(x, w.formState || u, Oe, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, Fe = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Me({
    ...w,
    formState: f
  })), Le = (w, x = {}) => {
    for (const $ of w ? Za(w) : l.mount)
      l.mount.delete($), l.array.delete($), x.keepValue || (kt(i, $), kt(o, $)), !x.keepError && kt(r.errors, $), !x.keepDirty && kt(r.dirtyFields, $), !x.keepTouched && kt(r.touchedFields, $), !x.keepIsValidating && kt(r.validatingFields, $), !n.shouldUnregister && !x.keepDefaultValue && kt(a, $);
    h.state.next({
      values: Ct(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && F();
  }, De = ({ disabled: w, name: x }) => {
    (ar(w) && s.mount || w || l.disabled.has(x)) && (w ? l.disabled.add(x) : l.disabled.delete(x));
  }, tn = (w, x = {}) => {
    let $ = Xe(i, w);
    const G = ar(x.disabled) || ar(n.disabled);
    return Qn(i, w, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ...x
      }
    }), l.mount.add(w), $ ? De({
      disabled: ar(x.disabled) ? x.disabled : n.disabled,
      name: w
    }) : D(w, !0, x.value), {
      ...G ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ua(x.min),
        max: Ua(x.max),
        minLength: Ua(x.minLength),
        maxLength: Ua(x.maxLength),
        pattern: Ua(x.pattern)
      } : {},
      name: w,
      onChange: me,
      onBlur: me,
      ref: (Y) => {
        if (Y) {
          tn(w, x), $ = Xe(i, w);
          const R = lt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, V = c4(R), ie = $._f.refs || [];
          if (V ? ie.find((he) => he === R) : R === $._f.ref)
            return;
          Qn(i, w, {
            _f: {
              ...$._f,
              ...V ? {
                refs: [
                  ...ie.filter(em),
                  R,
                  ...Array.isArray(Xe(a, w)) ? [{}] : []
                ],
                ref: { type: R.type, name: w }
              } : { ref: R }
            }
          }), D(w, !1, void 0, R);
        } else
          $ = Xe(i, w, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(OS(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, Ie = () => n.shouldFocusError && eo(i, H, l.mount), We = (w) => {
    ar(w) && (h.state.next({ disabled: w }), eo(i, (x, $) => {
      const G = Xe(i, $);
      G && (x.disabled = G._f.disabled || w, Array.isArray(G._f.refs) && G._f.refs.forEach((Y) => {
        Y.disabled = G._f.disabled || w;
      }));
    }, 0, !1));
  }, en = (w, x) => async ($) => {
    let G;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let Y = Ct(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: V } = await X();
      r.errors = R, Y = V;
    } else
      await Q(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Qn(Y, R, void 0);
    if (kt(r.errors, "root"), Mt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(Y, $);
      } catch (R) {
        G = R;
      }
    } else
      x && await x({ ...r.errors }, $), Ie(), setTimeout(Ie);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Mt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, ue = (w, x = {}) => {
    Xe(i, w) && (lt(x.defaultValue) ? le(w, Ct(Xe(a, w))) : (le(w, x.defaultValue), Qn(a, w, Ct(x.defaultValue))), x.keepTouched || kt(r.touchedFields, w), x.keepDirty || (kt(r.dirtyFields, w), r.isDirty = x.defaultValue ? O(w, Ct(Xe(a, w))) : O()), x.keepError || (kt(r.errors, w), u.isValid && F()), h.state.next({ ...r }));
  }, ye = (w, x = {}) => {
    const $ = w ? Ct(w) : a, G = Ct($), Y = Mt(w), R = Y ? a : G;
    if (x.keepDefaultValues || (a = $), !x.keepValues) {
      if (x.keepDirtyValues) {
        const V = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(za(a, o))
        ]);
        for (const ie of Array.from(V))
          Xe(r.dirtyFields, ie) ? Qn(R, ie, Xe(o, ie)) : le(ie, Xe(R, ie));
      } else {
        if (Xp && lt(w))
          for (const V of l.mount) {
            const ie = Xe(i, V);
            if (ie && ie._f) {
              const he = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (zs(he)) {
                const Ne = he.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const V of l.mount)
          le(V, Xe(R, V));
      }
      o = Ct(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ri(w, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? za(a, o) : r.dirtyFields : x.keepDefaultValues && w ? za(a, w) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, $e = (w, x) => ye(Sr(w) ? w(o) : w, x), Ve = (w, x = {}) => {
    const $ = Xe(i, w), G = $ && $._f;
    if (G) {
      const Y = G.refs ? G.refs[0] : G.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Sr(Y.select) && Y.select());
    }
  }, Oe = (w) => {
    r = {
      ...r,
      ...w
    };
  }, ln = {
    control: {
      register: tn,
      unregister: Le,
      getFieldState: K,
      handleSubmit: en,
      setError: Be,
      _subscribe: Me,
      _runSchema: X,
      _getWatch: q,
      _getDirty: O,
      _setValid: F,
      _setFieldArray: M,
      _setDisabledField: De,
      _setErrors: E,
      _getFieldArray: Z,
      _reset: ye,
      _resetDefaultValues: () => Sr(n.defaultValues) && n.defaultValues().then((w) => {
        $e(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: z,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: Fe,
    trigger: _e,
    register: tn,
    handleSubmit: en,
    watch: Pe,
    setValue: le,
    getValues: Ee,
    reset: $e,
    resetField: ue,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ve,
    getFieldState: K
  };
  return {
    ...ln,
    formControl: ln
  };
}
function _4(e = {}) {
  const n = we.useRef(void 0), r = we.useRef(void 0), [i, a] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Sr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Sr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : x4(e),
    formState: i
  }, e.formControl && e.defaultValues && !Sr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, we.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), we.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), we.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), we.useEffect(() => {
    e.values && !ri(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), we.useEffect(() => {
    e.errors && !Mt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), we.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), we.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = PS(i, o), n.current;
}
const S4 = "_settingsWrapper_1ycvy_1", N4 = "_settingsWrapperHeader_1ycvy_6", j4 = "_settingsWrapperContent_1ycvy_10", w4 = "_settingsWrapperContentCode_1ycvy_18", C4 = "_settingsWrapperContentCURL_1ycvy_26", Ma = {
  settingsWrapper: S4,
  settingsWrapperHeader: N4,
  settingsWrapperContent: j4,
  settingsWrapperContentCode: w4,
  settingsWrapperContentCURL: C4
}, F4 = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = or(), { control: o } = _4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = VS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = it(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: /* @__PURE__ */ Ce.jsx(Te, { span: 6, children: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", className: Ma.settingsWrapper, children: [
    /* @__PURE__ */ Ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Ma.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ce.jsx(fe, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: Ma.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ce.jsx(
            qs,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ce.jsxs("ol", { children: [
                /* @__PURE__ */ Ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ce.jsx("span", { className: Ma.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(
            bb,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ce.jsx(
                pr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            bb,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ce.jsx(
                pr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
            /* @__PURE__ */ Ce.jsx(bn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Ma.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ce.jsx(
              Ye,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ce.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, I4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], E4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Gr
  }
], T4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: F4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], $4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, D4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, R4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: OV,
  featureSettings: []
} : n ? {
  authSettings: AV,
  featureSettings: [...dS]
} : e ? {
  authSettings: [
    ...Ok,
    ...DV
  ],
  featureSettings: [...Ak]
} : {
  authSettings: [
    ...Ok,
    ...RV
  ],
  featureSettings: [...Ak]
}, WS = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, O4 = WS(
  E4,
  T4
), A4 = WS(
  W$,
  K$
), KS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = D4(a?.value, r), s = i !== void 0 ? i : $4(
    r
  );
  return o !== void 0 ? o : s;
}, rf = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = R4(n), s = O4(r), l = A4(i);
  return {
    SHOPIFY: {
      widget: V3,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: _T,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...sv ? [...sv] : []
      ]
    },
    GITHUB: {
      widget: SI,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...NI],
      WidgetSettings: wI
    },
    MIUROS: {
      widget: qL,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...HL],
      WidgetSettings: KL
    },
    KLAVIYO: {
      widget: q$,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...H$]
    },
    LINEAR: {
      widget: v2,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...k2],
      WidgetSettings: x2
    },
    VOYADO: {
      widget: AM,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...PM]
    },
    LOYALTYLION: {
      widget: X2,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...Z2]
    },
    RECHARGE: {
      widget: vV,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...kV],
      WidgetSettings: xV
    },
    BRAZE: {
      widget: Vw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...zw]
    },
    YOTPO: {
      widget: t4,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...I4]
    },
    INGRID: {
      widget: XI,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...ZI],
      WidgetSettings: nE
    }
  };
}, P4 = (e) => {
  const n = rf();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      integrationKey: l
    }) => {
      const m = n[i], { settingsConfiguration: u } = m, f = u?.filter(({ secret: h }) => !h)?.map(
        ({
          key: h,
          type: v,
          defaultValue: C
        }) => ({
          key: h,
          value: KS({
            key: h,
            configuration: o,
            settingType: v,
            settingDefault: C
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: f,
        misconfigured: s,
        icon: m.icon,
        iconColors: m.iconColors,
        widget: m.widget,
        integrationKey: l
      };
    }
  );
}, $B = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d
}) => {
  const m = gi(
    {}
  ), u = (T) => (m.current[T] || (m.current[T] = { current: null }), m.current[T]), { track: f } = _n(), h = Bn(
    () => P4(e),
    [e]
  ), v = {
    headline: "",
    text: "",
    onConfirm: () => M(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [C, S] = se(v), [N, F] = se(!1), y = (T) => {
    F(!0), S(T);
  }, M = () => {
    F(!1), S(v);
  };
  return /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    h.map(
      ({
        id: T,
        name: E,
        type: D,
        widget: B,
        settings: ee,
        misconfigured: X,
        icon: ae,
        iconColors: Q,
        integrationKey: z
      }, O) => {
        const q = `partner-integration-${D}`, Z = /* @__PURE__ */ Ue.jsx(Bm, { icon: ae, color: Q }), ve = ee?.reduce(
          (ce, le) => (ce[le.key] = le.value, ce),
          {}
        );
        return s ? /* @__PURE__ */ Ue.jsx("div", { className: "icon-holder", children: Z }, `partner-icon-${T}`) : /* @__PURE__ */ Ue.jsxs(
          mr,
          {
            onToggle: () => {
              f(
                o(z) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: T,
                  widgetType: D.toLowerCase()
                }
              ), a(z);
            },
            isOpen: o(z),
            className: q,
            containerRef: (ce) => {
              u(z).current = ce;
            },
            children: [
              /* @__PURE__ */ Ue.jsx(
                mr.Header,
                {
                  wrap: "normal",
                  avatar: Z,
                  slotBeforeTitle: d?.(
                    z,
                    O,
                    u(z)
                  ),
                  slotAfterTitle: l?.(z),
                  children: E
                }
              ),
              /* @__PURE__ */ Ue.jsx(mr.Content, { children: X ? /* @__PURE__ */ Ue.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ue.jsx(
                qb.Provider,
                {
                  value: {
                    onError: (ce, le) => console.warn(
                      `Something went wrong with a partner widget of type '${D}' and id '${T}'`,
                      ce,
                      le
                    )
                  },
                  children: /* @__PURE__ */ Ue.jsx(
                    Nx,
                    {
                      integrationId: T,
                      type: D,
                      configuration: n,
                      showNotification: i,
                      showModal: y,
                      children: v0(B, {
                        conversationContext: r,
                        settings: ve
                      })
                    }
                  )
                }
              ) })
            ]
          },
          z
        );
      }
    ),
    /* @__PURE__ */ Ue.jsx(
      Mb,
      {
        isOpen: N,
        setIsOpen: F,
        headline: C.headline,
        text: C.text,
        confirmLabel: C.confirmLabel,
        confirmVariant: C.confirmVariant,
        cancelLabel: C.cancelLabel,
        cancelVariant: C.cancelVariant,
        onConfirm: C.onConfirm ? () => {
          try {
            C.onConfirm && C.onConfirm();
          } finally {
            F(!1), S(v);
          }
        } : void 0,
        onCancel: C.onCancel ? () => {
          try {
            C.onCancel && C.onCancel();
          } finally {
            F(!1), S(v);
          }
        } : void 0,
        children: C.children
      }
    )
  ] });
}, L4 = Hs`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function DB(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return He(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Sx(e).query({
      query: L4
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const V4 = ({
  widgetConfiguration: e
}) => {
  const n = Bn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Bn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, z4 = "FULL_ACCESS", U4 = "2", M4 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [z4],
        version: U4
      })
    }).then((l) => l.json())
  };
}, B4 = "dixaApiToken", af = "dixaApiTokenId", GS = "dixaApiTokenName", $b = (e) => [af, GS].every(
  (r) => e.find((i) => i?.key === r)
);
function q4({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = H4(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const H4 = (e) => [
  {
    key: B4,
    value: e.value,
    secret: !0
  },
  {
    key: af,
    value: e.id,
    secret: !1
  },
  {
    key: GS,
    value: e.name,
    secret: !1
  }
], W4 = "_wrapper_1lmim_1", K4 = "_wrapperBox_1lmim_4", G4 = "_wrapperBoxErrorBorder_1lmim_9", nm = {
  wrapper: W4,
  wrapperBox: K4,
  wrapperBoxErrorBorder: G4
}, Y4 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (M) => M.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, C = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${v.label.toLowerCase()}`, [N, F] = se({
    username: "",
    password: ""
  }), y = it(
    (M) => {
      m({
        target: {
          name: s,
          value: M
        }
      });
    },
    [s, m]
  );
  return He(() => {
    y(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ Ue.jsx(
    bn,
    {
      required: e,
      label: a,
      meta: l,
      className: nm.wrapper,
      children: /* @__PURE__ */ Ue.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: at(nm.wrapperBox, {
            [nm.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ue.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (M) => F({
                    username: M?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ue.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (M) => F({
                    username: N.username,
                    password: M?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function Db({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: C,
  prefix: S,
  integrationId: N,
  integrationType: F,
  configuration: y,
  settings: M,
  otherProps: T
}) {
  const E = v === "custom" && T?.component, D = u(n)?.value;
  return E ? /* @__PURE__ */ Ue.jsx(
    E,
    {
      configuration: y,
      integrationId: N,
      integrationType: F,
      label: r,
      settings: M,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    /* @__PURE__ */ Ue.jsx(Te, { span: 3, children: /* @__PURE__ */ Ue.jsx(
      Q4,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: C,
        children: v === "input" ? /* @__PURE__ */ Ue.jsx(
          pr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ue.jsx(
          Y4,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: r,
            widgetSettingsKey: n,
            settings: M,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ue.jsx(bn, { label: r, children: /* @__PURE__ */ Ue.jsx(
          Hb,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ue.jsx(bn, { label: r, children: /* @__PURE__ */ Ue.jsx(
          ei,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (B) => d(n, B),
            getItemTitleByValue: (B) => B ? /* @__PURE__ */ Ue.jsx(P.Paragraph, { children: B.label }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {}),
            value: D ? [
              {
                label: (T?.selectItems || []).find(
                  (B) => B.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (B, ee) => B.value === ee.value,
            children: (T?.selectItems || []).map((B) => /* @__PURE__ */ Ue.jsx(ct.Item, { value: B, children: B.label }, B.value))
          }
        ) }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ue.jsx(Te, { span: 3 })
  ] });
}
function Q4({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ue.jsx(bn, { label: n, children: /* @__PURE__ */ Ue.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const no = "partner-integrations-widget-name-form-field", Rb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: KS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), J4 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (T) => i(T), l = (T) => !T || T === "", d = (T) => {
    const { [T]: E, ...D } = a;
    o(D);
  }, m = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: E }) => E).map(({ key: E, value: D, secret: B }) => ({
      key: E,
      value: D,
      secret: B
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, value: D }
    } = T;
    a[E] && !l(D) && d(E), i({
      ...r,
      settings: r.settings.map(
        (B) => B.key === E ? { ...B, value: D } : B
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, checked: D }
    } = T;
    i({
      ...r,
      settings: r.settings.map(
        (B) => B.key === E ? { ...B, value: D } : B
      )
    });
  }, v = (T, E) => {
    if (!E)
      return;
    const { selectedValues: D } = E, B = D?.[0];
    if (B) {
      const ee = r.settings.map(
        (X) => X.key === T ? { ...X, value: B?.value } : X
      );
      i({
        ...r,
        settings: ee
      });
    } else {
      const ee = r.settings.filter(
        (X) => X.key !== T
      );
      i({
        ...r,
        settings: ee
      });
    }
  }, C = (T) => {
    i({
      ...r,
      enabled: T
    });
  }, S = (T) => {
    if (!T)
      return;
    const {
      target: { value: E }
    } = T;
    a[no] && !l(E) && d(no), i({
      ...r,
      name: E
    });
  }, N = (T, E) => {
    const { settings: D } = r, B = D.map((ee) => ee.key === E ? {
      ...ee,
      isEditing: T,
      ...!T && { value: "" }
    } : ee);
    a[E] && !T && d(E), i({
      ...r,
      settings: B
    });
  }, F = (T) => r.settings.find(
    (E) => E.key === T
  ), y = async (T) => {
    T.preventDefault(), M() && n(m(r));
  }, M = () => {
    const T = {}, { name: E, settings: D } = r;
    return l(E) && (T[no] = u.input), D.forEach(
      ({ key: B, value: ee, required: X, isEditing: ae, type: Q, customValidation: z }) => {
        if (X && ae)
          if (z) {
            const O = z(ee);
            typeof O == "string" && (T[B] = O);
          } else
            typeof ee == "string" && l(ee) && (T[B] = u[Q]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: N,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: F,
    initializeFormData: s,
    validate: M
  };
}, X4 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Ob = "The configuration of the integration is not correct. Please check the settings.", Z4 = (e) => {
  const n = rf()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ue.jsx(n, { ...e }) : /* @__PURE__ */ Ue.jsx(eB, { ...e });
}, eB = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = _n(), { deleteDixaApiToken: l, createDixaApiToken: d } = M4({
    type: n,
    baseUrl: a.baseUrl
  }), u = A0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = X4.includes(n), [v, C] = se(), [S, N] = se(!1), [F, y] = se(!1), [M, T] = se(!1), [E, D] = se(null), [B, ee] = se(), { isInboundOAuth: X } = d0(), ae = X && f ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: Q,
    isShopifyMarketplaceApp: z,
    initialValuesForShopify: O
  } = V4({
    featureFlags: a.featureFlags,
    widgetConfiguration: B
  }), q = n === "YOTPO" && !!B?.additionalProperties?.isUsingOAuth, Z = n === "KLAVIYO" && !!B?.additionalProperties?.isUsingOAuth, ve = f && n === "SHOPIFY", me = rf({
    SHOPIFY: {
      hasShopifyOAuth: Q,
      isShopifyMarketplaceApp: z,
      isCreationMode: f
    },
    YOTPO: {
      hasOAuth: q,
      isCreationMode: f
    },
    KLAVIYO: {
      hasOAuth: Z,
      isCreationMode: f
    }
  })[n].settingsConfiguration, H = me.filter(({ type: w }) => w !== "hidden").filter(({ hideOnCreate: w }) => f ? !w : !0), _e = H.filter(
    ({ additionalProperties: w }) => w?.renderAboveForm === !0
  ), Ee = H.filter(
    ({ additionalProperties: w }) => w?.renderAboveForm !== !0
  ), {
    error: K,
    loading: qe,
    refetch: Be
  } = D0(u0, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (w) => {
      if (Object.keys(w).length === 0)
        T(!0);
      else {
        T(!1);
        const x = w?.Management?.widgetConfigurations?.[0];
        x && ee({
          ...x,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${x.id}`,
          additionalProperties: x.additionalProperties ?? void 0
        });
      }
    }
  }), [Pe, { error: Me }] = lf(
    f ? m0 : p0,
    {
      onError: (w) => {
        C(w), N(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (w) => {
        if (N(!1), Object.keys(w).length !== 0) {
          if (f && r(
            w.Management?.createWidgetConfiguration?.id
          ), !f) {
            const $ = w.Management?.updateWidgetConfiguration;
            $?.misconfigured ? D(
              $.misconfigurationCause ?? Ob
            ) : D(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Fe] = lf(f0, {
    onError: (w) => {
      C(w), N(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      N(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Le,
    handleIsEnabled: De,
    errors: tn,
    handleChangeText: Ie,
    handleChangeBoolean: We,
    handleChangeSelect: en,
    handleEditSecret: ue,
    handleChangeName: ye,
    handleSubmit: $e,
    getSettingValueByKey: Ve,
    initializeFormData: Oe
  } = J4({
    onSubmit: async (w) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), N(!0);
      const x = w.settings.map(
        (R) => typeof R.value == "boolean" ? { ...R, value: R.value.toString() } : R
      ), $ = $b(x) && f;
      let G = [];
      if ($) {
        const R = await d().catch(
          (V) => {
            N(!1), console.warn("API-Token (creation) error resonse", V), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        R?.data && (G = q4({
          token: R.data,
          settings: x
        }));
      }
      const Y = {
        ...w,
        settings: [
          ...G.length > 0 ? G : x
        ]
      };
      ($ && G.length > 1 || !$ && G.length === 0) && (Pe({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...Y
        }
      }), x.forEach(
        (R) => R.secret && ue(!1, R.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: Rb({
          settingsFromBackend: O,
          settingsConfiguration: me,
          creating: !0
        })
      }
    }
  });
  He(() => {
    if (B) {
      const w = Rb({
        settingsFromBackend: B.settings,
        settingsConfiguration: me
      });
      Oe({
        enabled: !!B.enabled,
        name: B.name,
        settings: w
      }), B.misconfigured ? D(
        B?.misconfigurationCause ?? Ob
      ) : D(null);
    }
  }, [B]);
  const ln = Bn(() => o ? !o.isCoupled : !0, [o]);
  return K || Me || v ? /* @__PURE__ */ Ue.jsx(
    Fn,
    {
      error: K || v,
      retry: K ? Be : void 0
    }
  ) : S || qe ? /* @__PURE__ */ Ue.jsx(dn, { "data-testid": "widget-settings-loading" }) : M ? /* @__PURE__ */ Ue.jsxs(P.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ue.jsx(Pn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ue.jsxs("form", { children: [
    E && /* @__PURE__ */ Ue.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ue.jsx(
      qs,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ue.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ue.jsx(P.Paragraph, { children: E }),
          /* @__PURE__ */ Ue.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ue.jsx(P.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ue.jsx(P.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ue.jsxs(
      yt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          _e.map(
            ({ key: w, label: x, ...$ }) => /* @__PURE__ */ Ue.jsx(
              Db,
              {
                widgetSettingsKey: w,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Ve,
                isSecret: !1,
                label: x,
                placeholder: "",
                required: !1,
                errors: tn,
                type: "custom",
                isCreationMode: f,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: me,
                otherProps: $
              },
              w
            )
          ),
          !ve && /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
            /* @__PURE__ */ Ue.jsx(Te, { children: /* @__PURE__ */ Ue.jsx(bn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ue.jsx(
              Hb,
              {
                input: {
                  name: "enabled",
                  checked: Le.enabled,
                  value: "dummy",
                  onChange: (w) => De(w.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ue.jsx(Te, { span: 3, children: /* @__PURE__ */ Ue.jsx(
              pr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: no,
                  value: Le.name,
                  onChange: ye
                },
                meta: {
                  error: tn[no]
                }
              }
            ) }),
            /* @__PURE__ */ Ue.jsx(Te, { span: 3 })
          ] }),
          Ee?.map(
            ({
              key: w,
              secret: x,
              label: $,
              placeholder: G = "",
              required: Y = !1,
              type: R,
              prefix: V,
              readOnly: ie,
              ...he
            }) => {
              const { settings: Ne } = Le, nn = Ne.find(
                (mn) => mn.key === w
              );
              return /* @__PURE__ */ Ue.jsx(k0, { children: /* @__PURE__ */ Ue.jsx(
                Db,
                {
                  widgetSettingsKey: w,
                  isEditingField: !!nn?.isEditing,
                  handleEditSecret: ue,
                  handleChangeText: Ie,
                  handleChangeBoolean: We,
                  handleChangeSelect: en,
                  getValueByKey: Ve,
                  isSecret: x,
                  label: $,
                  placeholder: G,
                  required: Y,
                  errors: tn,
                  type: R,
                  isCreationMode: f,
                  prefix: V,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: ie,
                  settings: me,
                  otherProps: he
                }
              ) }, w);
            }
          )
        ]
      }
    ),
    !ve && /* @__PURE__ */ Ue.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ue.jsx(Kn, { onClick: $e, children: ae }),
      !f && /* @__PURE__ */ Ue.jsx(
        Ye,
        {
          content: "The widget is used in automations",
          disabled: ln,
          children: /* @__PURE__ */ Ue.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), y(!0);
              },
              disabled: !ln,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ue.jsx(
      Mb,
      {
        isOpen: F,
        setIsOpen: y,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), $b(Le.settings)) {
            const w = Le.settings.find(
              ({ key: x }) => x === af
            )?.value;
            w && l(w).catch((x) => {
              console.warn("API-Token (deletion) error response", x), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Fe({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ue.jsx(b, { children: h ? /* @__PURE__ */ Ue.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ue.jsx(
            fe,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ue.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ue.jsxs(P.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ue.jsxs(P.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ue.jsxs(P.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Le.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Le.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, RB = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ Ue.jsx(
  qb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ Ue.jsx(
      Nx,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ue.jsx(
          Z4,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
), Ab = "__PairingContext__", YS = globalThis[Ab] ?? (() => {
  const e = Bb({});
  return globalThis[Ab] = e, e;
})(), OB = () => Um(YS), AB = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ue.jsx(YS.Provider, { value: e, children: n });
var as = { exports: {} }, Pb;
function nB() {
  if (Pb) return as.exports;
  Pb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(E, D, B) {
    return Function.prototype.apply.call(E, D, B);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : r = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  as.exports = o, as.exports.once = F, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || a(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function d(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(E) {
    for (var D = [], B = 1; B < arguments.length; B++) D.push(arguments[B]);
    var ee = E === "error", X = this._events;
    if (X !== void 0)
      ee = ee && X.error === void 0;
    else if (!ee)
      return !1;
    if (ee) {
      var ae;
      if (D.length > 0 && (ae = D[0]), ae instanceof Error)
        throw ae;
      var Q = new Error("Unhandled error." + (ae ? " (" + ae.message + ")" : ""));
      throw Q.context = ae, Q;
    }
    var z = X[E];
    if (z === void 0)
      return !1;
    if (typeof z == "function")
      n(z, this, D);
    else
      for (var O = z.length, q = C(z, O), B = 0; B < O; ++B)
        n(q[B], this, D);
    return !0;
  };
  function m(T, E, D, B) {
    var ee, X, ae;
    if (l(D), X = T._events, X === void 0 ? (X = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (X.newListener !== void 0 && (T.emit(
      "newListener",
      E,
      D.listener ? D.listener : D
    ), X = T._events), ae = X[E]), ae === void 0)
      ae = X[E] = D, ++T._eventsCount;
    else if (typeof ae == "function" ? ae = X[E] = B ? [D, ae] : [ae, D] : B ? ae.unshift(D) : ae.push(D), ee = d(T), ee > 0 && ae.length > ee && !ae.warned) {
      ae.warned = !0;
      var Q = new Error("Possible EventEmitter memory leak detected. " + ae.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Q.name = "MaxListenersExceededWarning", Q.emitter = T, Q.type = E, Q.count = ae.length, i(Q);
    }
    return T;
  }
  o.prototype.addListener = function(E, D) {
    return m(this, E, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, D) {
    return m(this, E, D, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, E, D) {
    var B = { fired: !1, wrapFn: void 0, target: T, type: E, listener: D }, ee = u.bind(B);
    return ee.listener = D, B.wrapFn = ee, ee;
  }
  o.prototype.once = function(E, D) {
    return l(D), this.on(E, f(this, E, D)), this;
  }, o.prototype.prependOnceListener = function(E, D) {
    return l(D), this.prependListener(E, f(this, E, D)), this;
  }, o.prototype.removeListener = function(E, D) {
    var B, ee, X, ae, Q;
    if (l(D), ee = this._events, ee === void 0)
      return this;
    if (B = ee[E], B === void 0)
      return this;
    if (B === D || B.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete ee[E], ee.removeListener && this.emit("removeListener", E, B.listener || D));
    else if (typeof B != "function") {
      for (X = -1, ae = B.length - 1; ae >= 0; ae--)
        if (B[ae] === D || B[ae].listener === D) {
          Q = B[ae].listener, X = ae;
          break;
        }
      if (X < 0)
        return this;
      X === 0 ? B.shift() : S(B, X), B.length === 1 && (ee[E] = B[0]), ee.removeListener !== void 0 && this.emit("removeListener", E, Q || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var D, B, ee;
    if (B = this._events, B === void 0)
      return this;
    if (B.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : B[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete B[E]), this;
    if (arguments.length === 0) {
      var X = Object.keys(B), ae;
      for (ee = 0; ee < X.length; ++ee)
        ae = X[ee], ae !== "removeListener" && this.removeAllListeners(ae);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = B[E], typeof D == "function")
      this.removeListener(E, D);
    else if (D !== void 0)
      for (ee = D.length - 1; ee >= 0; ee--)
        this.removeListener(E, D[ee]);
    return this;
  };
  function h(T, E, D) {
    var B = T._events;
    if (B === void 0)
      return [];
    var ee = B[E];
    return ee === void 0 ? [] : typeof ee == "function" ? D ? [ee.listener || ee] : [ee] : D ? N(ee) : C(ee, ee.length);
  }
  o.prototype.listeners = function(E) {
    return h(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return h(this, E, !1);
  }, o.listenerCount = function(T, E) {
    return typeof T.listenerCount == "function" ? T.listenerCount(E) : v.call(T, E);
  }, o.prototype.listenerCount = v;
  function v(T) {
    var E = this._events;
    if (E !== void 0) {
      var D = E[T];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(T, E) {
    for (var D = new Array(E), B = 0; B < E; ++B)
      D[B] = T[B];
    return D;
  }
  function S(T, E) {
    for (; E + 1 < T.length; E++)
      T[E] = T[E + 1];
    T.pop();
  }
  function N(T) {
    for (var E = new Array(T.length), D = 0; D < E.length; ++D)
      E[D] = T[D].listener || T[D];
    return E;
  }
  function F(T, E) {
    return new Promise(function(D, B) {
      function ee(ae) {
        T.removeListener(E, X), B(ae);
      }
      function X() {
        typeof T.removeListener == "function" && T.removeListener("error", ee), D([].slice.call(arguments));
      }
      M(T, E, X, { once: !0 }), E !== "error" && y(T, ee, { once: !0 });
    });
  }
  function y(T, E, D) {
    typeof T.on == "function" && M(T, "error", E, D);
  }
  function M(T, E, D, B) {
    if (typeof T.on == "function")
      B.once ? T.once(E, D) : T.on(E, D);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(E, function ee(X) {
        B.once && T.removeEventListener(E, ee), D(X);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return as.exports;
}
var tB = nB();
function PB() {
  const e = new tB.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  lw as GraphQLClientProvider,
  YS as PairingContext,
  AB as PairingProvider,
  $B as PartnerIntegrations,
  RB as PartnerIntegrationsSettings,
  rf as getWidgetDefinitions,
  PB as initializePartnerEventEmitter,
  OB as usePairing,
  DB as usePartnerIntegrationWidgetConfigurations,
  V4 as useShopifyConfiguration
};
